    <template>
        <!-- <Backer /> -->

        <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <div :style="{background: ((invoice.edit ? '#fcfcc6' : 'white'))}">
            <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">

                <b-modal id="modal-deliveries" scrollable title="Scheduled Deliveries" size="sm" hide-footer>
                    <Deliveries :viewdata="scheduled_deliveries" />
                </b-modal>
                <b-modal id="modal-image-viewer" size="lg" hide-footer centered title="Product Image">
    <div class="text-center">
        <b-img
            :src="currentFullSizeImage"
            fluid
            alt="Full size product image"
            style="max-height: 70vh; object-fit: contain;"
        />
        <div class="mt-3">
            <strong>{{ currentProductName }}</strong>
        </div>
    </div>
    <template #modal-footer>
        <b-button size="sm" variant="secondary" @click="$bvModal.hide('modal-image-viewer')">
            Close
        </b-button>
    </template>


</b-modal>

<b-modal 
    id="modal-delivery-calendar" 
    size="xl" 
    title="Delivery Calendar" 
    hide-footer
    style='min-width: 1600px !important;'
    scrollable
    centered
    @shown="onDeliveryCalendarShown"
>
    <DeliveryCalendar 
        ref="deliveryCalendar"
      
        :selected-location-id="getSelectedLocationId()"
        :location-name="getSelectedLocationName()"
    />
</b-modal>

<b-modal 
  id="modal-barcode-scanner" 
  title="Scan Barcode" 
  size="lg" 
  hide-footer
  @shown="startScanner"
  @hidden="stopScanner"
>
  <div class="scanner-container">
    <!-- Replace your video/canvas with QuaggaScanner component -->
    <QuaggaScanner 
      ref="quaggaScanner"
      @scan="handleScannedBarcode"
      :facingMode="currentCamera"
    />
    
    <div class="mt-3 text-center">
      <div class="mt-2">
        <b-button 
          size="sm" 
          variant="outline-secondary" 
          @click="toggleCamera"
        >
          Switch Camera
        </b-button>
        <b-button 
          size="sm" 
          variant="outline-danger" 
          @click="stopScanner" 
          class="ml-2"
        >
          Cancel
        </b-button>
      </div>
    </div>
  </div>
</b-modal>
<!-- Signature Modal -->
<b-modal 
  id="modal-signature" 
  size="lg" 
  hide-footer 
  centered 
  title="Customer Signature"
  @hidden="resetSignatureModal"
>
  <div class="signature-section">
    <div v-if="signatureItem" class="mb-3">
      <h6>Item: {{ signatureItem.product_name || signatureItem.product_sku }}</h6>
      <div class="d-flex justify-content-between align-items-center">
        <p class="text-muted small mb-0">Please have the customer sign below</p>
        <b-badge v-if="signatureItem.has_signature" variant="success">
          Already Signed
        </b-badge>
      </div>
    </div>
    
    <SignaturePad 
      ref="signaturePad"
      :width="600"
      :height="250"
      :disabled="signatureUploading"
    />
    
    <div class="mt-3 d-flex justify-content-between">
      <div>
        <b-button 
          variant="outline-secondary" 
          size="sm" 
          @click="$bvModal.hide('modal-signature')"
          :disabled="signatureUploading"
        >
          Cancel
        </b-button>
      </div>
      <div>
        <b-button 
          variant="success" 
          size="sm" 
          @click="saveSignature"
         
        >
          <b-spinner small v-if="signatureUploading"></b-spinner>
          {{ signatureUploading ? 'Saving...' : 'Save Signature' }}
        </b-button>
      </div>
    </div>
  </div>
</b-modal>

<!-- Customer Info & Signature Modal -->
<b-modal 
  id="modal-customer-info" 
  size="lg" 
  hide-footer 
  centered 
  title="Customer Information & Agreement"
  @hidden="resetCustomerInfoModal"
  ref="customerInfoModal"
>
  <div class="customer-info-modal">
    <!-- Read-only Products Summary -->
    <div class="section-header">
      <h6>SELECTED PRODUCTS</h6>
      <small class="text-muted">(View Only - Not Editable)</small>
    </div>
    
    <div class="products-summary">
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in invoice.items" :key="item.product_sku">
            <td>{{ item.product_sku }}</td>
            <td>{{ item.product_name || 'N/A' }}</td>
            <td>{{ item.quantity }}</td>
            <td>${{ getDisplayPrice(item).toFixed(2) }}</td>
            <td>${{ (getDisplayPrice(item) * item.quantity).toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Read-only Charges Summary -->
    <div class="section-header mt-3">
      <h6>CHARGES SUMMARY</h6>
      <small class="text-muted">(View Only - Not Editable)</small>
    </div>
    
    <div class="charges-summary">
      <div class="summary-row">
        <span>Subtotal:</span>
        <span>${{ getSubTotal().toFixed(2) }}</span>
      </div>
      <div class="summary-row">
        <span>Delivery:</span>
        <span>${{ (invoice.delivery_charges || 0) }}</span>
      </div>
      <div class="summary-row">
        <span>Setup:</span>
        <span>${{ (invoice.setup_charges || 0)}}</span>
      </div>
      <div class="summary-row">
        <span>Warranty:</span>
        <span>${{ (invoice.warranty_charges || 0) }}</span>
      </div>
      <div class="summary-row">
        <span>Sales Tax:</span>
        <span>${{ getSalesTax().toFixed(2) }}</span>
      </div>
      <div class="summary-row total-row">
        <span><strong>GRAND TOTAL:</strong></span>
        <span><strong>${{ getGrandTotal().toFixed(2) }}</strong></span>
      </div>
    </div>

    <!-- Divider -->
    <hr class="my-3">

    <!-- Customer Information Form -->
    <div class="section-header">
      <h6>CUSTOMER INFORMATION</h6>
    </div>

    <b-form @submit.prevent="saveCustomerInfo">
      <!-- Name -->
      <b-form-group label="Full Name *" label-for="modal-fullname">
        <b-input
          id="modal-fullname"
          v-model="modalCustomer.fullname"
          required
          placeholder="Enter customer full name"
        ></b-input>
      </b-form-group>

      <!-- Email and Phone Row -->
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Email *" label-for="modal-email">
            <b-input
              id="modal-email"
              v-model="modalCustomer.email"
              type="email"
              required
              placeholder="customer@example.com"
            ></b-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Phone *" label-for="modal-phone">
            <VuePhoneNumberInput v-model="modalCustomer.phone" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Address -->
      <b-form-group label="Address Line 1" label-for="modal-address1">
        <b-input
          id="modal-address1"
          v-model="modalCustomer.address_line_1"
          placeholder="Street address"
        ></b-input>
      </b-form-group>

      <b-form-group label="Address Line 2" label-for="modal-address2">
        <b-input
          id="modal-address2"
          v-model="modalCustomer.address_line_2"
          placeholder="Apt, Suite, etc."
        ></b-input>
      </b-form-group>
  <b-row>
    <b-col cols="12" md="6">
        <b-form-group label="Floor" label-for="modal-floor">
            <b-form-select
                id="modal-floor"
                v-model="modalCustomer.floor"
                :options="floor_options"
                size="sm"
            >
                <template #first>
                    <b-form-select-option :value="null" disabled>Select Floor</b-form-select-option>
                </template>
            </b-form-select>
        </b-form-group>
    </b-col>
</b-row>

<!-- Custom floor inputs -->
<b-row v-if="modalShowCustomFloor">
    <b-col cols="12" md="6">
        <b-form-group label="Custom Floor Display" label-for="modal-custom-floor-display">
            <b-input
                id="modal-custom-floor-display"
                v-model="modalCustomFloorDisplay"
                size="sm"
                placeholder="e.g., Basement, Penthouse, etc."
            ></b-input>
        </b-form-group>
    </b-col>
    <b-col cols="12" md="6">
        <b-form-group label="Custom Floor Number" label-for="modal-custom-floor-number">
            <b-input
                id="modal-custom-floor-number"
                v-model="modalCustomFloorNumber"
                type="number"
                size="sm"
                placeholder="Enter floor number"
            ></b-input>
        </b-form-group>
    </b-col>
</b-row>

      <!-- City, State, Zip Row -->
      <b-row>
        <b-col cols="12" md="5">
          <b-form-group label="City" label-for="modal-city">
            <b-input
              id="modal-city"
              v-model="modalCustomer.city"
              placeholder="City"
            ></b-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="State" label-for="modal-state">
            <b-form-select
              v-model="modalCustomer.state"
              :options="allowed_states"
              placeholder="State"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>State</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Zip Code" label-for="modal-zip">
            <vue-simple-suggest
              v-model="modalCustomer.zipcode"
              display-attribute="zip_code"
              value-attribute="zip_code"
              :list="zipcodes"
              :filter-by-query="true"
              @select="setModalZipcode"
              :filter="filter_zipcodes"
              placeholder="Zipcode"
            >
              <div slot="suggestion-item" slot-scope="{ suggestion }">
                <span>{{ suggestion.zip_code }} ({{ suggestion.city }}, {{ suggestion.state }})</span>
              </div>
            </vue-simple-suggest>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Language Toggle for Terms -->
      <div class="d-flex align-items-center justify-content-between mt-3 mb-2">
        <h6 class="mb-0">TERMS & CONDITIONS</h6>
        <div class="btn-group btn-group-sm" role="group">
          <b-button 
            :variant="modalPolicyLanguage === 'en' ? 'primary' : 'outline-secondary'"
            @click="modalPolicyLanguage = 'en'"
            size="sm"
          >
            🇺🇸 English
          </b-button>
          <b-button 
            :variant="modalPolicyLanguage === 'es' ? 'primary' : 'outline-secondary'"
            @click="modalPolicyLanguage = 'es'"
            size="sm"
          >
            🇪🇸 Español
          </b-button>
        </div>
      </div>

      <!-- Terms and Conditions Text (Scrollable) -->
      <div class="policy-scroll-box">
        <div v-html="modalPolicyLanguage === 'es' ? policyTextSpanish : policyText" class="policy-content"></div>
      </div>

      <!-- Agreement Checkbox -->
      <b-form-checkbox
        v-model="modalTermsAgreed"
        class="mt-3 mb-3"
      >
        <strong v-if="modalPolicyLanguage === 'es'">
          He leído y acepto los Términos y Condiciones
        </strong>
        <strong v-else>
          I have read and agree to the Terms & Conditions
        </strong>
      </b-form-checkbox>

      <!-- Warranty Refusal Checkbox (if no warranty charges) -->
      <b-form-checkbox
        v-if="!hasWarrantyCharges"
        v-model="modalWarrantyRefused"
        class="mb-3"
        :disabled="hasWarrantyCharges"
      >
        <strong v-if="modalPolicyLanguage === 'es'">
          El cliente se negó a comprar garantías extendidas
        </strong>
        <strong v-else>
          Customer refused to purchase extended warranties
        </strong>
      </b-form-checkbox>

      <!-- Signature Pad Section -->
      <div class="signature-section mt-3">
        <h6>CUSTOMER SIGNATURE</h6>
        <p class="text-muted small">Please have the customer sign below</p>
        
        <SignaturePad 
          ref="modalSignaturePad"
          :width="600"
          :height="200"
          :disabled="signatureUploading"
        />
        
        <div class="mt-2 d-flex justify-content-end">
          <b-button 
            variant="outline-secondary" 
            size="sm" 
            @click="clearSignature"
          >
            Clear Signature
          </b-button>
        </div>
      </div>

      <!-- Modal Footer Buttons -->
      <div class="modal-footer-actions mt-4">
        <b-button 
          variant="secondary" 
          @click="$bvModal.hide('modal-customer-info')"
          :disabled="signatureUploading"
        >
          Cancel
        </b-button>
        <b-button 
          variant="success" 
          @click="saveCustomerInfo"
          :disabled="!isModalSubmitEnabled || signatureUploading"
        >
          <b-spinner small v-if="signatureUploading"></b-spinner>
          {{ signatureUploading ? 'Saving...' : 'Save Customer Info & Continue' }}
        </b-button>
      </div>
    </b-form>
  </div>
</b-modal>

                <div>
                    <div v-if="invoice.edit">
                        <div><h3>EDIT SALE: <b>{{invoice.invoice_id}}</b></h3></div>
                    </div>
                    <div v-else>
                        <div><h3>NEW SALE</h3></div>
                    </div>
                </div>
                <b-card header="STORE" style="margin-bottom: 5px;">
                    <div style="display: inline-block; margin: 5px; width: 170px;">

                             <!-- <div style="display: inline-block; margin: 5px; width: 250px;">
                        <div>
                            LOCATION
                        </div>

                        <b-form-select
                            v-model="invoice.selected_locsub"
                            size="sm"
                            v-on:change="set_location"
                            style="max-width: 250px;"
                            :disabled="invoice.edit == true"
                        >
                            <b-form-select-option
                                v-for="locsub, lidx in packet.locsubs.filter(function(d){return d.sublocation_type_id == 1}).filter(function(d){  if (userDetails.properties.location_id){  return d.location_id ==  userDetails.properties.location_id} else { return true }  })"
                                :value="locsub.value"
                                v-bind:key="locsub.value"

                            >
                                {{locsub.text}}
                            </b-form-select-option>
                        </b-form-select>
                    </div> -->


                                    <div>
                                        LOCATION
                                    </div>

                                    <b-form-select
                                        v-model="invoice.selected_locsub"
                                        size="sm"
                                        v-on:change="set_location"
                                        style="max-width: 170px;"
                                        :disabled="invoice.edit == true"
                                    >
                                        <b-form-select-option
                                            v-for="locsub, lidx in packet.locsubs.filter(function(d){return d.sublocation_type_id == 1}).filter(function(d){  if (userDetails.properties.location_id){  return d.location_id ==  userDetails.properties.location_id} else { return true }  })"
                                            :value="locsub.value"
                                            v-bind:key="locsub.value"
                                        >
                                            <!-- Show only the part before the first '|' character -->
                                            {{ locsub.text.split('|')[0].trim() }}
                                        </b-form-select-option>
                                    </b-form-select>
                                        <b-spinner small v-if="locationLoading" variant="primary" class="ml-2" style="vertical-align: middle;"></b-spinner>
                                </div>

                    <div style="display: inline-block; margin: 5px; width: 220px;">
                        <div>
                        SALES PERSON
                        </div>
                       <div style="padding: 5px; background: #f2f2f2; text-align: center;">
                            {{ (invoice.username || userDetails.username).toUpperCase() }}
                        </div>
                    </div>

                    <div style="display: inline-block; margin: 5px; width: 200px;">
                        <div>
                        DATE
                        </div>
                        <div style="padding: 5px; background: #f2f2f2;">
                            {{ (invoice.ts  || ts) }}
                        </div>
                    </div>

                    <div style="display: inline-block; margin: 5px; width: 200px;">
                        <div>
                            SOLD FROM (STATE)
                        </div>
                        <b-form-select
                            v-model="invoice.sold_from_state"
                            size="sm"
                            style="max-width: 175px;"
                            :options="allowed_states"
                            :disabled="invoice.edit == true"
                        >
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; margin: 5px; width: 180px;">
    <b-button size="sm" variant="primary" @click="get_scheduled_deliveries">SCHEDULED DELIVERIES</b-button>
</div>
<div style="display: inline-block; margin: 5px; width: 170px;">
    <b-button size="sm" variant="info" @click="openDeliveryCalendar">
       
        DELIVERY CALENDAR
    </b-button>
</div>
                </b-card>

                <div >
                    <div v-if="invoice.selected_locsub && invoice.sold_from_state">
                        <b-card-group style="">
                           <b-card header="CUSTOMER INFO">
    <b-form autocomplete="off">
        <div>
            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-input size="sm" v-model="invoice.customer.fullname" autocomplete="new-password" placeholder="Fullname" style="width: 300px; height: 40px;"></b-input>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-input size="sm" v-model="invoice.customer.email" autocomplete="new-password" placeholder="Email" type="email" style="max-width: 250px; height: 40px;"></b-input>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <VuePhoneNumberInput v-model="invoice.customer.phone" size="sm"/>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <VuePhoneNumberInput v-model="invoice.customer.phone_2" size="sm"/>
            </b-card-text>
        </div>

        <div class="mt-3 mt-md-0">
            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-input size="sm" v-model="invoice.customer.address_line_1" autocomplete="new-password" placeholder="Address Line 1" style="max-width: 250px; height: 40px;"></b-input>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-input size="sm" v-model="invoice.customer.address_line_2" autocomplete="new-password" placeholder="Address Line 2" style="max-width: 250px; height: 40px;"></b-input>
            </b-card-text>

            <!-- Floor Fields - Inline like other fields -->
          <!-- Floor Field - Single Dropdown -->
<b-card-text style="display: inline-block; vertical-align: top;">
    <b-form-select
        v-model="invoice.customer.floor"
        :options="floor_options"
        size="sm"
        
        style="height: 40px; width: 180px;"
    >
        <template #first>
            <b-form-select-option :value="null" disabled>Select Floor</b-form-select-option>
        </template>
    </b-form-select>
</b-card-text>




            <!-- Custom Floor Input (shows when 'Other' is selected) -->
            <div v-if="show_custom_floor" style="display: inline-block; vertical-align: top;">
                <b-card-text style="display: inline-block; vertical-align: top;">
                    <b-input
                        v-model="custom_floor_display"
                        size="sm"
                        placeholder="Custom Floor"
                        style="height: 40px; width: 150px;"
                    ></b-input>
                </b-card-text>

                <b-card-text style="display: inline-block; vertical-align: top;">
                    <b-input
                        v-model="custom_floor_number"
                        type="number"
                        size="sm"
                        placeholder="Floor #"
                        style="height: 40px; width: 100px;"
                    ></b-input>
                </b-card-text>
            </div>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <vue-simple-suggest
                    v-model="invoice.customer.zipcode"
                    display-attribute="zip_code"
                    value-attribute="zip_code"
                    :list="zipcodes"
                    :filter-by-query="true"
                    @select="set_zipcode_and_state_city"
                    :filter="filter_zipcodes"
                    ref="zip_code"
                    style="padding: 0px !important; font-size: 12px; height: auto;"
                    class="input-field"
                    placeholder="Zipcode"
                >
                    <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }">
                        <span>{{ suggestion.zip_code }} ({{suggestion.city}}, {{suggestion.state}})</span>
                    </div>
                </vue-simple-suggest>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-form-select v-model="invoice.customer.state" :options="allowed_states" style="width: 150px; font-size: 12px; height: 40px;">
                    <template #first>
                        <b-form-select-option :value="null" disabled :selected="true">State</b-form-select-option>
                    </template>
                </b-form-select>
            </b-card-text>

            <b-card-text style="display: inline-block; vertical-align: top;">
                <b-input size="sm" v-model="invoice.customer.city" autocomplete="new-password" placeholder="City" style="max-width: 250px; height: 40px; font-size: 12px;"></b-input>
            </b-card-text>

            <b-card-text style="display: block; margin-top: 15px;">
   
</b-card-text>

            <b-card-text style="display: block; margin-top: 10px;">
                <b-form-checkbox
                    v-model="invoice.address_confirmation_agreed"
                    size="sm"
                    class="mb-2"
                >
                    <strong>I confirm that my shipping address and phone number are correct and I understand that a $200 redelivery fee applies for incorrect information</strong>
                </b-form-checkbox>
            </b-card-text>
        </div>
    </b-form>
</b-card>
                        </b-card-group>

                        <b-card header="PRODUCTS" style="margin-top: 10px;">
    <b-alert show variant="warning" v-if="invoice.items.length == 0">No items added</b-alert>
    <div v-else style="padding: 0px; overflow-x: auto">
        <!-- Existing Items Section -->
        <div v-if="hasExistingItems">
            <h5 style="margin: 15px 0 10px 0; color: #666; border-bottom: 1px solid #ddd; padding-bottom: 5px;">
                EXISTING ITEMS
            </h5>
            <table style="width: 100%; border-collapse: separate; border-spacing: 0px 5px;">
                <thead>
                    <tr v-if="existingItems.length > 1">
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                   
                        <th></th>
                        <th class="ipt_tdr" style="width: 85px;">
                            <date-picker
                                v-model="commonDeliveryDate"
                                format="MM-DD-YYYY"
                                valueType="format"
                                :disabled-date="disablePreviousDates"
                                v-on:change="setCommonDeliveryDate"
                                style="padding: 4px; font-size: 12px; text-align: center; border: 1px solid gray; width: 125px;"
                            ></date-picker>
                        </th>
                    </tr>
                    <tr style="background: white; color: black;">
                        <th class="ipt_tdhr" style="min-width: 50px">#</th>
                        <th class="ipt_tdhr" style="min-width: 50px">IMAGE</th>
                        <th class="ipt_tdhr" style="min-width: 100px">PRD DESC</th>
                        <th class="ipt_tdhr" style="min-width: 70px">SOURCE</th>
                        <th class="ipt_tdhr" style="min-width: 50px">PRICE</th>
                        <th class="ipt_tdhr" style="min-width: 50px">QTY</th>
                        <th class="ipt_tdhr" style="min-width: 50px">DISCNT</th>
                        <th class="ipt_tdhr" style="min-width: 50px">TYPE</th>
                        <!-- After the TYPE column (order_type) -->
                     
                        <th class="ipt_tdhr" style="min-width: 50px">REQ DATE</th>
                        <th class="ipt_tdhr" style="min-width: 200px; width: 220px;">FULFILL/DELIVERY FROM</th>
                        <th class="ipt_tdhr" style="min-width: 50px">ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in existingItems" v-bind:key="'existing-'+idx" style="background: #F0F4C3;" v-if="show_item(item)">
                        <!-- Your existing item row content here -->
                        <td class="ipt_tdr">{{ getExistingItemNumber(idx) }}</td>

                        <td class="ipt_tdr" style="text-align: center; padding: 5px;">
                            <div style="text-align: center; margin-bottom: 10px; height: 60px; display: flex; align-items: center; justify-content: center;">
                                <div v-if="getProductImage(item)" class="image-container">
                                    <img
                                        :src="getProductImage(item)"
                                        :alt="item.product_name || item.product_sku"
                                        style="max-width: 100%; max-height: 70px; object-fit: contain; cursor: pointer;"
                                        @error="handleImageError($event, item)"
                                        @load="handleImageLoad($event, item)"
                                        @click="showFullImage(item)"
                                        class="product-image"
                                    />
                                    <div class="image-overlay" @click="showFullImage(item)">
                                        🔍
                                    </div>
                                </div>
                                <div v-else class="no-image-placeholder">

                                    <div style="color: #999; font-size: 10px;">No Image</div>

                                </div>
                            </div>
                        </td>

                                    <td class="ipt_tdr" style="max-width: 220px;">
                                                <b-card-text>
                                                    <span v-if="invoice.edit && item.parent_product_sku">
                                                        ({{ item.parent_product_sku }})
                                                    </span>
                                                    
                                                    <!-- SKU with Damage Badge -->
                                                    <div style="display: flex; justify-content:center; align-items: center; gap: 5px; flex-wrap: wrap;">
                                                        <span>{{ item.product_name || item.product_sku }}</span>
                                                        
                                                        <!-- Damage ID Badge - Only show for damaged items -->
                                                        <b-badge 
                                                            v-if="item.is_damaged && item.damage_info && item.damage_info.damage_id"
                                                            variant="danger"
                                                            style="font-size: 10px; padding: 2px 5px;"
                                                            title="Damage ID"
                                                        >
                                                            D-{{ item.damage_info.damage_id }}
                                                        </b-badge>
                                                        
                                                        <!-- Original Damage Indicator -->
                                                        <div v-if="item.is_damaged" 
                                                            style="color: #dc3545; font-weight: bold; font-size: 11px; margin-top: 2px; width: 100%;">
                                                            ⚠️AS IS ITEM - CANNOT BE RETURNED OR REFUNDED
                                                        </div>
                                                        
                                                        <!-- Discount Indicator -->
                                                        <div v-if="hasActiveDiscount(item)"
                                                            style="color: #28a745; font-weight: bold; font-size: 11px; margin-top: 2px; width: 100%;">
                                                            🏷️ SPECIAL PRICE: ${{ getDisplayPrice(item) }}
                                                            <small>(Reg: ${{ item.selling_price }})</small>
                                                        </div>
                                                        
                                                        <!-- Backorder Indicator -->
                                                        <div v-if="shouldShowBackorder(item)"
                                                            class="backorder-indicator"
                                                            style="color: red; font-weight: bold; font-size: 11px; width: 100%;">
                                                            BACKORDER
                                                        </div>
                                                    </div>
                                                </b-card-text>
                                            </td>

                                            <!-- Context Column -->
                                        <td class="ipt_tdr" style="max-width: 180px;">
                                        <b-card-text>
                                            <!-- Fulfillment context -->
                                            <div class="fulfillment-context"
                                                :style="{color: (item.sourceContext || (item.existing ? 'warehouse' : 'store')) === 'store' ? 'green' : 'blue', fontSize: '11px'}">
                                                {{ (item.sourceContext || (item.existing ? 'warehouse' : 'store')) === 'store' ? 'STORE' : 'WAREHOUSE' }}
                                            </div>
                                        </b-card-text>
                                    </td>

                                            <!-- <td class="ipt_tdr">
                                                    <b-input
                                                        size="sm"
                                                        v-model="item.new_selling_price"
                                                    
                                                        style="width: 70px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
                                                        :disabled="item.existing"
                                                    ></b-input>

                                                   
                                                    <div v-if="hasActiveDiscount(item)" style="margin-top: 2px;">
                                                        <b-badge variant="success" style="font-size: 9px;">
                                                            DISCOUNT APPLIED
                                                        </b-badge>
                                                    </div>
                                                </td> -->
                                                <!-- Existing Items - Price Column -->
<td class="ipt_tdr">
    <b-input
        size="sm"
        v-model="item.new_selling_price"
        style="width: 70px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
        :disabled="item.existing"
        @blur="validatePriceChange(item, $event)"
     
        :min="item.selling_price"
    ></b-input>

    <!-- Show discount badge if applicable -->
    <div v-if="hasActiveDiscount(item)" style="margin-top: 2px;">
        <b-badge variant="success" style="font-size: 9px;">
            DISCOUNT APPLIED
        </b-badge>
    </div>
</td>

                                            <td class="ipt_tdr">
                                                <b-card-text>
                                                    <div v-if="item.existing">
                                                        <b-input style="width: 35px; text-align: center; margin: auto;" :value="item.quantity - item.refunded_so_far_quantity" :disabled="item.existing" size="sm" ></b-input>
                                                    </div>
                                                    <div v-else>
                                                        <b-input style="width: 35px; text-align: center; margin: auto;" v-model="item.quantity" :disabled="item.existing" size="sm"></b-input>
                                                    </div>
                                                </b-card-text>
                                            </td>

                                        <td class="ipt_tdr">
                                                    <b-card-text>
                                                        <b-input
                                                            style="width: 50px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
                                                            v-model="item.discount_offered"
                                                            size="sm"
                                                            :disabled="item.existing || !canApplyManualDiscount(item)"
                                                            @input="onDiscountChange(item)"
                                                            @blur="onDiscountChange(item)"
                                                            type="number"
                                                            :min="0"
                                                            :max="((item.new_selling_price || item.selling_price) * (item.quantity || 1)) * 0.10"
                                                            :class="{'discount-disabled': !canApplyManualDiscount(item)}"
                                                            :title="!canApplyManualDiscount(item) ? 'Manual discount not allowed for specially discounted items' : `Enter discount amount (max: $${(((item.new_selling_price || item.selling_price) * (item.quantity || 1)) * 0.10).toFixed(2)})`"
                                                        ></b-input>

                                                        <!-- Show message if discount is disabled -->
                                                        <!-- <div v-if="!canApplyManualDiscount(item)" style="color: #6c757d; font-size: 9px; margin-top: 2px;">
                                                            Special discount active
                                                        </div> -->
                                                    </b-card-text>
                                                </td>

                                            <td class="ipt_tdr" style="width: 115px;">
                                                <b-form-select
                                                    v-model="item.order_type"
                                                    :options="get_order_types(item)"
                                                    size="sm"
                                                    style="width: 115px; font-size: 13px;"
                                                    @change="del_date_set(item)"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>PICK ORDER TYPE</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </td>
                                            <!-- <td class="ipt_tdr" style="width: 115px;">
                                                <b-form-select
                                                    v-model="item.home_delivery_type"
                                                    :options="home_delivery_type_options"
                                                    size="sm"
                                                    style="width: 115px; font-size: 13px;"
                                                    :disabled="item.order_type !== 'home_delivery' || item.existing"
                                                    @change="onHomeDeliveryTypeChange(item)"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>SELECT TYPE</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </td> -->

                                            <td class="ipt_tdr" style="width: 85px;">
                                                <span v-if="item.order_type == 'customer_takes'">
                                                    {{ today_date }}
                                                </span>
                                                <span v-else>
                                                   <date-picker
    v-model="item.delivery_date"
    format="MM-DD-YYYY"
    valueType="format"
    :disabled-date="disablePreviousDates"
    @change="(date) => onDeliveryDateChange(item, date)"
    style="padding: 4px; font-size: 12px; text-align: center; border: 1px solid gray; width: 125px;"
></date-picker>
                                                </span>
                                            </td>

                                            <td class="ipt_tdr">
                                                <!-- Your existing fulfillment logic here -->
                                                <span v-if="item.order_type == 'customer_takes'">
                                                    <div>
                                                        <div>FULFILL FROM</div>
                                                        <b-form-select
                                                            size="sm"
                                                            style="font-size: 11px;"
                                                            :options="packet.locsubs
                                                            .filter(function(d){ return d.location_id == invoice.location_id })
                                                            .filter(function(d){ return d.sublocation_type_id == 2 })"
                                                            v-model="item.locsub"
                                                            :disabled="item.existing || !search_in_my_location"
                                                        >
                                                        </b-form-select>
                                                    </div>
                                                </span>

                                                <span v-else-if="item.order_type == 'store_pickup'">
                                                    <div>
                                                        <div>CUSTOMER PICKUP FROM</div>
                                                        <b-form-select
                                                            size="sm"
                                                    
                                                            :options="get_pickup_locations(item)"
                                                            v-model="item.drop_locsub"
                                                            :disabled="item.existing"
                                                        >
                                                        </b-form-select>
                                                    </div>

                                                    <div style="margin-top: 2px;">
                                                        <div>FULFILL FROM (OPTIONAL)</div>
                                                        <b-form-select
                                                            size="sm"
                                                        
                                                            :options="get_locations(item)"
                                                            v-model="item.locsub"
                                                            :disabled="item.existing || !search_in_my_location">
                                                        </b-form-select>
                                                    </div>
                                                </span>
                                                  <!-- Home Delivery - ONLY Mecca Shipping Customer Deliveries -->
<span v-else-if="item.order_type == 'home_delivery'">
    <div>
        <div>DELIVERY FROM</div>
        <b-form-select
            size="sm"
            :options="getDeliveryLocations(item)"
            v-model="item.drop_locsub"
            :disabled="item.existing"
        ></b-form-select>
    </div> 

    <div style="margin-top: 2px;">
        <div>FULFILL FROM (OPTIONAL)</div>
        <b-form-select
            size="sm"
            :options="getFulfillLocations(item)"
            v-model="item.locsub"
            :disabled="item.existing || !search_in_my_location"
        ></b-form-select>
    </div>
</span>

<!-- Store Delivery - Mecca Shipping Customer Deliveries + Store Locations -->
<span v-else-if="item.order_type == 'delivery_from_store'">
    <div>
        <div>DELIVERY FROM</div>
        <b-form-select
            size="sm"
            :options="getDeliveryLocations(item)"
            v-model="item.drop_locsub"
            :disabled="item.existing"
        ></b-form-select>
    </div>

    <div style="margin-top: 2px;">
        <div>FULFILL FROM (OPTIONAL)</div>
        <b-form-select
            size="sm"
            :options="getFulfillLocations(item)"
            v-model="item.locsub"
            :disabled="item.existing || !search_in_my_location"
        ></b-form-select>
    </div>
</span>
                                            </td>
                                            <td class="ipt_tdr">
                                                <b-button
                                                    variant="danger"
                                                    size="sm"
                                                    style="font-size: 11px; padding: 3px;"
                                                    @click="removeItem(getItemOriginalIndex(item))"
                                                    v-if="item.existing"
                                                >
                                                    <b-badge
                                                        variant="warning"
                                                        v-if="refund_items.some(ri => ri.itemid === item.itemid)">
                                                        ADDED TO CANCELLED/RETURNED
                                                    </b-badge>

                                                    <b-badge
                                                        size="lg"
                                                        variant="danger"
                                                        v-else-if="get_item_status(item) === 'refundable'">
                                                        CANCEL
                                                    </b-badge>

                                                    <b-badge
                                                        size="lg"
                                                        variant=""
                                                        v-else-if="get_item_status(item) === 'delivered'">
                                                        RETURNED
                                                    </b-badge>
                                                </b-button>
                                                    <b-button
                                                    v-if="invoice.is_layaway "
                                                    variant="warning"
                                                    size="sm"
                                                    style="font-size: 11px; padding: 3px;"
                                                    @click="removeLayawayItem(item)"
                                                    title="Remove item from layaway (no refund, just remove)"
                                                >
                                                    <b-icon-trash></b-icon-trash> REMOVE
                                                </b-button>
                                                
                                                <!-- Existing remove for new items -->
                                                <b-button
                                                    v-if="!item.existing"
                                                    variant="primary"
                                                    style="font-size: 11px; padding: 3px; width: 80px;"
                                                    @click="removeItem(getItemOriginalIndex(item))"
                                                >
                                                    REMOVE
                                                </b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

        <!-- Newly Added Items Section -->
                        `<div v-if="hasNewItems">
                            <h5 style="margin: 25px 0 10px 0; color: #2c5aa0; border-bottom: 1px solid #2c5aa0; padding-bottom: 5px;">
                                RESELECTED ITEMS
                            </h5>
                            
                            <!-- Common Delivery Date for New Items - Only show on larger screens -->
                            <!-- <div class="d-none d-md-block" v-if="newItems.length > 1">
                                <div style="text-align: right; margin-bottom: 10px;">
                                
                                </div>
                            </div> -->


                            <div style="padding: 0px; overflow-x: auto">
                                <table style="width: 100%; border-collapse: separate; border-spacing: 0px 5px; min-width: 800px;">
                                    <thead>
                                        <tr v-if="newItems.length > 1">
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                          
                                                <th></th>
                                                <th class="ipt_tdr" style="width: 85px;">
                                                <date-picker
                                                            v-model="commonDeliveryDate"
                                                            format="MM-DD-YYYY"
                                                            valueType="format"
                                                            :disabled-date="disablePreviousDates"
                                                            v-on:change="setCommonDeliveryDateForNewItems"
                                                            style="padding: 4px; font-size: 12px; text-align: center; border: 1px solid gray; width: 125px;"
                                                        ></date-picker>
                                                </th>
                                            </tr>
                                        <tr style="background: white; color: black;">
                                            <th class="ipt_tdhr" style="min-width: 40px">#</th>
                                            <th class="ipt_tdhr d-none d-md-table-cell" style="min-width: 60px">IMAGE</th>
                                            <th class="ipt_tdhr" style="min-width: 120px">PRD DESC</th>
                                            <th class="ipt_tdhr d-none d-lg-table-cell" style="min-width: 80px">SOURCE</th>
                                            <th class="ipt_tdhr" style="min-width: 70px">PRICE</th>
                                            <th class="ipt_tdhr" style="min-width: 50px">QTY</th>
                                            <th class="ipt_tdhr d-none d-sm-table-cell" style="min-width: 60px">DISCNT</th>
                                            <th class="ipt_tdhr" style="min-width: 100px">TYPE</th>
                                  
                                            <th class="ipt_tdhr d-none d-md-table-cell" style="min-width: 90px">REQ DATE</th>
                                            <th class="ipt_tdhr d-none d-lg-table-cell" style="min-width: 200px;">FULFILL/DELIVERY FROM</th>
                                            <th class="ipt_tdhr" style="min-width: 100px">ACTION</th>
                                            <!-- <th class="ipt_tdhr" 
                                                style="min-width: 80px" 
                                                :class="{'d-none': !hasAsIsItems}"
                                                v-if="hasAsIsItems">
                                                AS IS
                                            </th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in newItems" v-bind:key="'new-'+idx" style="background: #E8F5E8;" v-if="show_item(item)">
                                            <!-- Item Number -->
                                            <td class="ipt_tdr">{{ getNewItemNumber(idx) }}</td>

                                            <!-- Image Column - Hidden on mobile -->
                                            <td class="ipt_tdr d-none d-md-table-cell" style="text-align: center; padding: 5px;">
                                                <div style="text-align: center; margin-bottom: 10px; height: 60px; display: flex; align-items: center; justify-content: center;">
                                                    <div v-if="getProductImage(item)" class="image-container">
                                                        <img
                                                            :src="getProductImage(item)"
                                                            :alt="item.product_name || item.product_sku"
                                                            style="max-width: 100%; max-height: 70px; object-fit: contain; cursor: pointer;"
                                                            @error="handleImageError($event, item)"
                                                            @load="handleImageLoad($event, item)"
                                                            @click="showFullImage(item)"
                                                            class="product-image"
                                                        />
                                                        <div class="image-overlay" @click="showFullImage(item)">
                                                            🔍
                                                        </div>
                                                    </div>
                                                    <div v-else class="no-image-placeholder">
                                                        <div style="color: #999; font-size: 10px;">No Image</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Product Description - Always visible -->
                                        <td class="ipt_tdr" style="max-width: 220px;">
                                                    <b-card-text>
                                                        <span v-if="invoice.edit && item.parent_product_sku">
                                                            ({{ item.parent_product_sku }})
                                                        </span>
                                                        
                                                        <!-- SKU with Damage Badge -->
                                                        <div style="display: flex; justify-content:center; align-items: center; gap: 5px; flex-wrap: wrap;">
                                                            <span>{{ item.product_name || item.product_sku }}</span>
                                                            
                                                            <!-- Damage ID Badge - Only show for damaged items -->
                                                            <b-badge 
                                                                v-if="item.is_damaged && item.damage_info && item.damage_info.damage_id"
                                                                variant="danger"
                                                                style="font-size: 10px; padding: 2px 5px;"
                                                                title="Damage ID"
                                                            >
                                                                D-{{ item.damage_info.damage_id }}
                                                            </b-badge>
                                                            
                                                            <!-- Original Damage Indicator -->
                                                            <div v-if="item.is_damaged" 
                                                                style="color: #dc3545; font-weight: bold; font-size: 11px; margin-top: 2px; width: 100%;">
                                                                ⚠️ AS IS ITEM - CANNOT BE RETURNED OR REFUNDED
                                                            </div>
                                                            
                                                            <!-- Discount Indicator -->
                                                            <div v-if="hasActiveDiscount(item)"
                                                                style="color: #28a745; font-weight: bold; font-size: 11px; margin-top: 2px; width: 100%;">
                                                                🏷️ SPECIAL PRICE: ${{ getDisplayPrice(item) }}
                                                                <small>(Reg: ${{ item.selling_price }})</small>
                                                            </div>
                                                            
                                                            <!-- Backorder Indicator -->
                                                            <div v-if="shouldShowBackorder(item)"
                                                                class="backorder-indicator"
                                                                style="color: red; font-weight: bold; font-size: 11px; width: 100%;">
                                                                BACKORDER
                                                            </div>
                                                        </div>
                                                    </b-card-text>
                                                </td>

                                            <!-- Source Column - Hidden on mobile and tablet -->
                                            <td class="ipt_tdr d-none d-lg-table-cell" style="max-width: 180px;">
                                                <b-card-text>
                                                    <div v-if="item.sourceContext" class="fulfillment-context"
                                                        :style="{color: item.sourceContext === 'store' ? 'green' : 'blue', fontSize: '11px'}">
                                                        {{ item.sourceContext === 'store' ? 'STORE' : 'WAREHOUSE' }}
                                                    </div>
                                                </b-card-text>
                                            </td>

                                            <!-- Price Column -->
                                            <!-- <td class="ipt_tdr">
                                                <b-input
                                                    size="sm"
                                                    v-model="item.new_selling_price"
                                                    style="width: 70px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
                                                    :disabled="item.existing"
                                                ></b-input>
                                            </td> -->
                                            <!-- New Items - Price Column -->
<td class="ipt_tdr">
    <b-input
        size="sm"
        v-model="item.new_selling_price"
        style="width: 70px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
        :disabled="item.existing"
        @blur="validatePriceChange(item, $event)"
    
        :min="item.selling_price"
    ></b-input>
</td>

                                            <!-- Quantity Column -->
                                            <td class="ipt_tdr">
                                                <b-card-text>
                                                    <div>
                                                        <b-input style="width: 35px; text-align: center; margin: auto;" v-model="item.quantity" :disabled="item.existing" size="sm"></b-input>
                                                    </div>
                                                </b-card-text>
                                            </td>

                                            <!-- Discount Column - Hidden on mobile -->
                                            <td class="ipt_tdr d-none d-sm-table-cell">
                                                <b-card-text>
                                                    <b-input
                                                        style="width: 50px; text-align: center; margin: auto; background: aliceblue; font-size: 12px;"
                                                        v-model="item.discount_offered"
                                                        size="sm"
                                                        :disabled="item.existing || !canApplyManualDiscount(item)"
                                                        @input="onDiscountChange(item)"
                                                        @blur="onDiscountChange(item)"
                                                        type="number"
                                                        :min="0"
                                                        :max="((item.new_selling_price || item.selling_price) * (item.quantity || 1)) * 0.10"
                                                        :class="{'discount-disabled': !canApplyManualDiscount(item)}"
                                                    ></b-input>
                                                </b-card-text>
                                            </td>

                                            <!-- Order Type Column -->
                                            <td class="ipt_tdr" style="width: 115px;">
                                                <b-form-select
                                                    v-model="item.order_type"
                                                    :options="get_order_types(item)"
                                                    size="sm"
                                                    style="width: 115px; font-size: 13px;"
                                                    @change="del_date_set(item)"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>PICK ORDER TYPE</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </td>

                                            <!-- <td class="ipt_tdr" style="width: 115px;">
                                                <b-form-select
                                                    v-model="item.home_delivery_type"
                                                    :options="home_delivery_type_options"
                                                    size="sm"
                                                    style="width: 115px; font-size: 13px;"
                                                    :disabled="item.order_type !== 'home_delivery'"
                                                    @change="onHomeDeliveryTypeChange(item)"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>SELECT TYPE</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </td> -->

                                            <!-- Request Date Column - Hidden on mobile -->
                                            <td class="ipt_tdr d-none d-md-table-cell" style="width: 85px;">
                                                <span v-if="item.order_type == 'customer_takes'">
                                                    {{ today_date }}
                                                </span>
                                                <span v-else>
                                                 <date-picker
    v-model="item.delivery_date"
    format="MM-DD-YYYY"
    valueType="format"
    :disabled-date="disablePreviousDates"
    @change="(date) => onDeliveryDateChange(item, date)"
    style="padding: 4px; font-size: 12px; text-align: center; border: 1px solid gray; width: 125px;"
></date-picker>
                                                </span>
                                            </td>

                                            <!-- Fulfill Column - Hidden on mobile and tablet -->
                                            <td class="ipt_tdr d-none d-lg-table-cell">
                                                <!-- Your existing fulfillment logic here -->
                                                <span v-if="item.order_type == 'customer_takes'">
                                                    <div>
                                                        <div>FULFILL FROM</div>
                                                        <b-form-select
                                                            size="sm"
                                                            style="font-size: 11px;"
                                                            :options="packet.locsubs
                                                            .filter(function(d){ return d.location_id == invoice.location_id })
                                                            .filter(function(d){ return d.sublocation_type_id == 2 })"
                                                            v-model="item.locsub"
                                                            :disabled="item.existing || !search_in_my_location"
                                                        >
                                                        </b-form-select>
                                                    </div>
                                                </span>

                                                <span v-else-if="item.order_type == 'store_pickup'">
                                                    <div>
                                                        <div>CUSTOMER PICKUP FROM</div>
                                                        <b-form-select
                                                            size="sm"
                                                            style="font-size: 11px;"
                                                            :options="get_pickup_locations(item)"
                                                            v-model="item.drop_locsub"
                                                            :disabled="item.existing"
                                                        >
                                                        </b-form-select>
                                                    </div>

                                                    <div style="margin-top: 2px;">
                                                        <div>FULFILL FROM (OPTIONAL)</div>
                                                        <b-form-select
                                                            size="sm"
                                                            style="font-size: 11px;"
                                                            :options="get_locations(item)"
                                                            v-model="item.locsub"
                                                            :disabled="item.existing || !search_in_my_location">
                                                        </b-form-select>
                                                    </div>
                                                </span>

       <!-- Home Delivery - ONLY Mecca Shipping Customer Deliveries -->
<span v-else-if="item.order_type == 'home_delivery'">
    <div>
        <div>DELIVERY FROM</div>
        <b-form-select
            size="sm"
            :options="getDeliveryLocations(item)"
            v-model="item.drop_locsub"
            :disabled="item.existing"
        ></b-form-select>
    </div>

    <div style="margin-top: 2px;">
        <div>FULFILL FROM (OPTIONAL)</div>
        <b-form-select
            size="sm"
            :options="getFulfillLocations(item)"
            v-model="item.locsub"
            :disabled="item.existing || !search_in_my_location"
        ></b-form-select>
    </div>
</span>

<!-- Store Delivery - Mecca Shipping Customer Deliveries + Store Locations -->
<span v-else-if="item.order_type == 'delivery_from_store'">
    <div>
        <div>DELIVERY FROM</div>
        <b-form-select
            size="sm"
            :options="getDeliveryLocations(item)"
            v-model="item.drop_locsub"
            :disabled="item.existing"
        ></b-form-select>
    </div>

    <div style="margin-top: 2px;">
        <div>FULFILL FROM (OPTIONAL)</div>
        <b-form-select
            size="sm"
            :options="getFulfillLocations(item)"
            v-model="item.locsub"
            :disabled="item.existing || !search_in_my_location"
        ></b-form-select>
    </div>
</span>
                                            </td>

                                            <!-- Action Column -->
                                            <td class="ipt_tdr">
                                                <div style="display: flex; flex-direction: column; gap: 5px; align-items: center;">
                                                    <b-button
                                                        variant="primary"
                                                        style="font-size: 11px; padding: 3px; width: 80px;"
                                                        @click="removeItem(getItemOriginalIndex(item))">
                                                        REMOVE
                                                    </b-button>
                                                
                                                    <!-- <b-form-checkbox
                                                        v-model="item.is_as_is"
                                                        @change="handleAsIsChange(item)"
                                                        size="sm"
                                                        style="margin: 0; padding: 0;"
                                                        title="Mark as 'As Is' item"
                                                    >
                                                        <span class="d-none d-sm-inline">AS IS</span>
                                                        <span class="d-sm-none">AS IS</span>
                                                    </b-form-checkbox> -->
                                                </div>
                                            </td>

                                            <!-- AS IS Image Column - Conditionally shown and responsive -->
                                            <td class="ipt_tdr" 
                                                style="text-align: center; padding: 5px;"  
                                                :class="{'d-none': !item.is_as_is}"
                                                v-if="hasAsIsItems">
                                                
                                                <div style="text-align: center; margin-bottom: 10px; height: 60px; display: flex; align-items: center; justify-content: center;">
                                                    <!-- Image Preview -->
                                                    <div v-if="getProductImagedamage(item)" class="image-container">
                                                        <img
                                                            :src="getProductImagedamage(item)"
                                                            :alt="item.product_name || item.product_sku"
                                                            style="max-width: 100%; max-height: 70px; object-fit: contain; cursor: pointer;"
                                                            @error="handleImageError($event, item)"
                                                            @load="handleImageLoad($event, item)"
                                                            @click="showFullImagedamage(item)"
                                                            class="product-image"
                                                        />
                                                        <div class="image-overlay" @click="showFullImagedamage(item)">
                                                            🔍
                                                        </div>
                                                        <!-- Remove Image Button -->
                                                        <b-button 
                                                            v-if="!imageUpload.currentItem || imageUpload.currentItem !== item"
                                                            variant="outline-danger" 
                                                            size="sm" 
                                                            style="position: absolute; top: -5px; right: -5px; width: 20px; height: 20px; padding: 0; font-size: 10px;"
                                                            @click="removeItemImage(item)"
                                                            title="Remove image"
                                                        >
                                                            ×
                                                        </b-button>
                                                    </div>
                                                    
                                                    <!-- Upload Interface -->
                                                    <div v-else class="no-image-placeholder">
                                                        <!-- Upload Preview -->
                                                        <div v-if="imageUpload.currentItem === item && imageUpload.previewUrl" 
                                                            class="image-upload-preview">
                                                            <img 
                                                                :src="imageUpload.previewUrl" 
                                                                style="max-width: 100%; max-height: 50px; object-fit: contain;"
                                                                alt="Preview"
                                                            />
                                                            <div class="upload-actions mt-1">
                                                                <b-button 
                                                                    size="sm" 
                                                                    variant="success" 
                                                                    @click="uploadItemImage"
                                                                    :disabled="imageUpload.uploading"
                                                                >
                                                                    <b-spinner small v-if="imageUpload.uploading"></b-spinner>
                                                                    {{ imageUpload.uploading ? 'Uploading...' : 'Add' }}
                                                                </b-button>
                                                                <b-button 
                                                                    size="sm" 
                                                                    variant="outline-secondary" 
                                                                    @click="cancelImageUpload"
                                                                    :disabled="imageUpload.uploading"
                                                                >
                                                                    Cancel
                                                                </b-button>
                                                            </div>
                                                        </div>
                                                        
                                                        <!-- Upload Trigger -->
                                                        <div v-else>
                                                            <div style="color: #999; font-size: 10px; margin-bottom: 5px;">No Image</div>
                                                            <b-button 
                                                                variant="outline-primary" 
                                                                size="sm" 
                                                                @click="$refs[`fileInput-${getItemOriginalIndex(item)}`][0].click()"
                                                                :disabled="imageUpload.currentItem !== null"
                                                            >
                                                                Upload
                                                            </b-button>
                                                            <input 
                                                                :ref="`fileInput-${getItemOriginalIndex(item)}`"
                                                                type="file" 
                                                                accept="image/*" 
                                                                style="display: none" 
                                                                @change="handleImageUpload(item, $event)"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                            </div>
                        </b-card>`

                        <b-card header="CANCELLED/RETURNED" v-if="invoice.edit" style="margin-top: 10px;" border-variant="warning">
                            <div>
                                <b-card-text style="margin-top: 10px; padding: 10px;">
                                <div style="display: inline-block; vertical-align: top; width: 200px;">
                                    <div>REFUND WARRANTY</div>
                                    <div>

                                        <b-input size="sm"
                                        style="width: 70px; display: inline-block; vertical-align: top;"
                                        v-model="refund_charges.warranty_refunded_currently"
                                        type="number" v-on:keyup="current_refund_validated = false"
                                        :disabled="invoice.warranty_charges - refund_charges.warranty_refunded_sofar == 0"
                                        ></b-input>

                                        <b-input size="sm" :disabled="true" style="width: 70px; display: inline-block; vertical-align: top;" :value=" '/ $'+(invoice.warranty_charges - refund_charges.warranty_refunded_sofar)">

                                        </b-input>

                                    </div>
                                </div>

                                <div style="display: inline-block; vertical-align: top; width: 200px;">
                                    <div>REFUND SETUP</div>
                                    <div>

                                        <b-input size="sm"
                                        style="width: 70px; display: inline-block; vertical-align: top;"
                                        v-model="refund_charges.setup_refunded_currently"
                                        type="number" v-on:keyup="current_refund_validated = false"
                                        :disabled="invoice.setup_charges - refund_charges.setup_refunded_sofar == 0"
                                        ></b-input>

                                        <b-input size="sm" :disabled="true" style="width: 70px; display: inline-block; vertical-align: top;" :value=" '/ $'+(invoice.setup_charges - refund_charges.setup_refunded_sofar)">

                                        </b-input>
                                    </div>
                                </div>

                                <div style="display: inline-block; vertical-align: top; width: 200px;">
                                    <div>REFUND DELIVERY</div>
                                    <div>

                                        <b-input size="sm"
                                        style="width: 70px; display: inline-block; vertical-align: top;"
                                        v-model="refund_charges.delivery_refunded_currently"
                                        type="number"
                                        v-on:keyup="current_refund_validated = false"
                                        :disabled="invoice.delivery_charges - refund_charges.delivery_refunded_sofar == 0"
                                        ></b-input>

                                        <b-input size="sm" :disabled="true" style="width: 70px; display: inline-block; vertical-align: top;" :value=" '/ $'+(invoice.delivery_charges - refund_charges.delivery_refunded_sofar)">

                                        </b-input>
                                    </div>
                                </div>
                                </b-card-text>
                            </div>

                            <table style="width: 100%;" v-if="refund_items.length > 0">
                                <thead>
                                    <tr>
                                          <td class="rtdh">
                ITEM ID
            </td>
                                        <td class="rtdh">
                                            PARENT PRODUCT SKU
                                        </td>
                                        <td class="rtdh">
                                            PRODUCT SKU
                                        </td>

                                        <td class="rtdh" style="width: 150px;">
                                            RETURN QTY
                                        </td>

                                        <td class="rtdh" style="width: 100px;">
                                            ITEM CREDIT AMOUNT
                                        </td>


                                        <td class="rtdh">
                                            ACTION
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="ritem,ridx in refund_items" v-bind:key="ridx">
                                         <td class="rtd" style="text-align: left; padding: 5px;">
                {{ ritem.itemid || 'N/A' }}
            </td>
                                        <td class="rtd" style="text-align: left; padding: 5px;">
                                            {{ ritem.parent_product_sku }}
                                        </td>
                                        <td class="rtd" style="text-align: left; padding: 5px;">
                                            {{ ritem.product_sku }}
                                        </td>

                                        <td class="rtd">
                                            <div style="display: inline-block; vertical-align: top;"><b-input size="sm" v-model="ritem.return_quantity" type="number"  style="width: 80px;" v-on:keyup="current_refund_validated = false"></b-input></div>  <div style="display: inline-block; vertical-align: top; font-size: 20px;"> / {{ritem.quantity - ritem.refunded_so_far_quantity}}</div>
                                        </td>

                                        <td class="rtd" style="text-align: center;">
                                            {{ ((ritem.selling_price - (ritem.unit_discount_value * ritem.quantity)) * (parseInt(ritem.return_quantity) || 0 )).toFixed(2) }}
                                        </td>

                                        <!-- <td class="rtd">
                                            <b-button size="sm" variant="primary" @click="refund_items=refund_items.filter(function(d){ return d.product_sku != ritem.product_sku}); current_refund_validated = false;">CANCELLED</b-button>
                                        </td> -->
                                        <td class="rtd">
                                            <b-button 
                                                size="sm" 
                                                variant="primary" 
                                                @click="refund_items = refund_items.filter(function(d) { 
                                                    return d.itemid !== ritem.itemid 
                                                }); 
                                                current_refund_validated = false;"
                                            >
                                                CANCEL
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div style="display: inline-block; vertical-align: top; width: 150px;" v-if="current_refund_validated == true">
                                    <div>TAX REFUND</div>

                                    <div><b-input size="sm" style="width: 100px; text-align: center;" :disabled="true"  v-model="refund_charges.tax_refunded_currently">


                                    </b-input></div>
                            </div>

                            <div style="display: inline-block; vertical-align: top; width: 150px;" v-if="current_refund_validated == true">
                                <div>TOTAL CREDIT AMOUNT</div>

                                <div v-if="invoice.is_layaway">

                                    <b-input size="sm" style="width: 100px; text-align: center;" :disabled="true"  v-model="refund_charges.total_refunded_currently">
                                    </b-input>
                                </div>
                                <div v-else>
                                    <b-input size="sm" style="width: 100px; text-align: center;" :disabled="true"  v-model="refund_charges.total_refunded_currently">

                                    </b-input>
                                </div>
                            </div>

                            <div v-if="invoice.is_layaway">
                                <sub>RETURNS FOR THE LAYAWAY INVOICES ARE CAPPED AT WHAT THE CUSTOMER HAS PAID SO FAR.</sub>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                                <div style="display: inline-block; vertical-align: top;" v-if="current_refund_validated == false">
                                    <div>&nbsp;</div>
                                    <div><b-button size="sm" variant="success" @click="validate_refund">VALIDATE</b-button></div>
                                </div>

                                <div style="display: inline-block; vertical-align: top;" v-else>
                                    <div>&nbsp;</div>
                                    <b-button size="sm" variant="danger" @click="submit_refund_wrapper">ADD TO STORE CREDIT</b-button>
                                </div>
                            </div>
                        </b-card>

    <b-card header="DEBUG - PAYMENT METHODS" style="margin-top: 10px;" v-if="false"> <!-- Set to true temporarily to debug -->
        <div style="padding: 15px;">
            <div><strong>Invoice Edit Mode:</strong> {{ invoice.edit }}</div>
            <div><strong>Payment Methods Count:</strong> {{ getPaymentMethods().length }}</div>
            <div><strong>Payment Methods Data:</strong></div>
            <pre>{{ JSON.stringify(getPaymentMethods(), null, 2) }}</pre>
            <div><strong>Total Payments:</strong> ${{ getTotalPayments().toFixed(2) }}</div>
        </div>
    </b-card>

  
   <b-card header="PAYMENT HISTORY" style="margin-top: 10px;" v-if="invoice.edit">
    <div style="padding: 15px;">
        <!-- Load Data Button -->
        <div v-if="invoice.invoice_id && payment_history.length === 0"
            style="margin-bottom: 15px; text-align: center;">
            <b-button
                variant="info"
                size="sm"
                @click="loadPaymentMethodsOnly"
                :disabled="loading"
            >
                <b-spinner small v-if="loading"></b-spinner>
                LOAD PAYMENT HISTORY
            </b-button>
        </div>

        <!-- Payment History Display -->
        <div v-if="payment_history.length === 0" class="text-center text-muted">
            No payment history found
        </div>

        <b-container v-else class="bv-example-row" id="payment_history">
            <b-row>
                <b-col v-for="pm,pmidx in payment_history" v-bind:key="pmidx" style="font-size: 13px; margin-bottom: 15px;">
                    <div style="border: 1px solid #ddd; padding: 10px; border-radius: 5px; background: #f8f9fa;">
                        <div style="font-weight: bold; margin-bottom: 5px;">PAYMENT # {{ pmidx+1 }}</div>
                        <div><b>{{ (pm.value || '').toUpperCase() }}</b></div>
                        <div><b>$ {{ parseFloat(pm.amount || 0).toFixed(2)}}</b></div>

                        <!-- Additional details -->
                        <div v-if="pm.value == 'cc' && pm.name">LAST 4 # {{ pm.name }}</div>
                        <div v-if="pm.value == 'store_credit' && pm.store_credit_invoice_id">INVOICE # {{ pm.store_credit_invoice_id }}</div>
                        <div v-if="pm.value == 'finance' && pm.lease_id"># {{ pm.lease_id }}</div>
                        <div v-if="pm.value == 'finance' && pm.name">{{ pm.name }}</div>
                        <div v-if="pm.value == 'tax_exempt' && pm.name">{{ pm.name }}</div>
                        <div v-if="pm.value == 'tax_exempt' && pm.ein">EIN # {{ pm.ein }}</div>
                        <div v-if="pm.value == 'tax_exempt' && pm.certificate">CERTIFICATE # {{ pm.certificate }}</div>

                        <div>AT: {{ pm.ts ? payment_ts_format(pm.ts) : 'PENDING' }}</div>

                        <sub v-if="pm.layaway_sls_tax">THIS IS SALES TAX PAYMENT</sub>
                        <sub v-if="pm.value == 'finance' && pm.charged_tax_itself == true && pm.name != 'TAX EXEMPT'">THIS FINANCE COMPANY CHARGES TAX ITSELF</sub>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!-- Payment Summary -->
        <hr style="margin: 20px 0;" v-if="payment_history.length > 0" />

        <b-row v-if="payment_history.length > 0">
            <b-col>
                <div style="font-size: 14px; text-align: right; font-weight: bold;">
                    <div>TOTAL PAID: ${{ (getTotalPaymentsFromHistory() || 0.0).toFixed(2) }}</div>
                    <div v-if="getAvailableStoreCredit() > 0" style="color: #28a745;">
                        AVAILABLE STORE CREDIT: ${{ (getAvailableStoreCredit() || 0.0).toFixed(2) }}
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</b-card>

                <!-- REFUNDS CARD -->
                    <b-card header="REFUNDS" style="margin-top: 10px;" v-if="invoice.edit">
                        <div class="separate3" style="display: block; margin-left: auto; margin-right: auto;">
                            <div style="border: 2px solid #dc3545; margin-top: 5px; padding: 10px; background: #f8f9fa;">
                                <Refundsummarysales
                                    v-on:refunds-history="summarize_refunds_history"
                                    :viewdata="{invoice_id: invoice.invoice_id, packet: packet, filterType: 'refund'}"
                                    :key="'refunds-'+refundsSummaryKey"
                                />
                            </div>
                        </div>
                    </b-card>

                    <!-- STORE CREDITS CARD -->
                    <b-card header="STORE CREDITS" style="margin-top: 10px;" v-if="invoice.edit">
                        <div class="separate3" style="display: block; margin-left: auto; margin-right: auto;">
                            <div style="border: 2px solid #28a745; margin-top: 5px; padding: 10px; background: #f0fff4;">
                                <Refundsummarysales
                                    v-on:refunds-history="summarize_refunds_history"
                                    :viewdata="{invoice_id: invoice.invoice_id, packet: packet, filterType: 'return'}"
                                    :key="'store-credits-'+refundsSummaryKey"
                                />
                            </div>
                        </div>
                    </b-card>

                    <!-- Replace the entire SEARCH PRODUCTS, SCAN BARCODE, SPECIAL ORDER, and NON-INVENTORY ITEM cards with this single card -->
<b-card header="PRODUCT MANAGEMENT" style="margin-top: 10px;">
    <!-- Tabs Navigation -->
    <b-tabs card pills>
        <!-- Tab 1: Search Products -->
        <b-tab title="SEARCH PRODUCTS" active>
            <template #title>
                <b-icon-search class="mr-1"></b-icon-search> SEARCH PRODUCTS
            </template>
            
            <!-- Toggle Button for Search Results Collapse - EXACTLY as original -->
            <b-button 
                v-b-toggle.collapse-1 
                variant="primary" 
                size="sm" 
                style="margin: 10px;"
                :title="!hasSearched ? 'Please perform a search first before collapsing' : ''"
            >
                {{ searchCollapseOpen ? 'CLOSE' : 'OPEN' }}
            </b-button>

            <b-collapse 
                id="collapse-1" 
                class="mt-2"    
                v-model="searchCollapseOpen"
                @hidden="onCollapseHidden"
                @shown="onCollapseShown"
            >
                <b-card-body style="padding: 5px;">
                    <b-form @submit="search" autocomplete="off">
                        <b-card-text>
                            <b-form-input
                                style="max-width: 300px; display: inline-block; margin: 3px;"
                                v-model="searchitems.keyword"
                                required
                                size="sm"
                            ></b-form-input>

                            <b-button
                                variant="warning"
                                style="display: inline-block; vertical-align: top; margin: 3px;"
                                size="sm"
                                type="submit">SEARCH
                            </b-button>

                            <b-form-checkbox
                                style="display: inline-block; vertical-align: top; margin: 3px;"
                                size="sm"
                                v-model="search_in_my_location"
                                @change="handleOnlyInMyLocationChange"
                            >ONLY IN MY LOCATION
                            </b-form-checkbox>
                            
                            <!-- AS IS checkbox - EXACTLY as original -->
                            <b-form-checkbox
                                style="display: inline-block; vertical-align: top; margin: 3px;"
                                size="sm"
                                v-model="search_only_from_damages"
                                @change="handleOnlyFromDamagesChange"
                                :disabled="!search_in_my_location"
                            >AS IS
                            </b-form-checkbox>
                        </b-card-text>
                    </b-form>

                    <b-overlay
                        :show="searchitems.search_being_loaded"
                        variant="white"
                        opacity="0.85"
                        blur="1px"
                        rounded="sm"
                        class="search-loading-overlay"
                    >
                        <template #overlay>
                            <div class="product-search-loader">
                                <div class="loader-card">
                                    <div class="loader-icon">
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
                                            <path d="M16 21V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V21" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
                                            <path d="M12 7V9" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
                                            <path d="M12 13V15" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <div class="loader-text">Searching products...</div>
                                    <div class="loader-progress">
                                        <div class="loader-progress-bar"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        
                        <div v-if="searchitems.result.length > 0" style="overflow-x: auto;">
                            <table hover small bordered style="width: 100%;">
                                <thead>
                                    <tr style="background: slategray; color: white;">
                                        <td class="ipt_tdhr" style="min-width: 100px" @click="sortby('image')">Image</td>
                                        <td class="ipt_tdhr" @click="sortby('product_sku')">SKU</td>
                                        <td class="ipt_tdhr" style="min-width: 150px" @click="sortby('product_name')">PRD DESC</td>
                                        <td class="ipt_tdhr" style="min-width: 30px">QTY/BOX</td>
                                        <td class="ipt_tdhr" style="min-width: 50px" @click="sortby('selling_price')">UNIT PRICE</td>
                                        <td class="ipt_tdhr">QTY</td>
                                        <td class="ipt_tdhr" style="min-width: 50px" @click="sortby('selling_price')">TOTAL PRICE</td>
                                        <td class="ipt_tdr" style="min-width: 150px" v-if="showLocationBreakdown">LOCATION BREAKDOWN</td>
                                        <td class="ipt_tdhr" style="min-width: 30px" @click="sortby('in_stock')">IN STOCK</td>
                                        <td class="ipt_tdhr" style="min-width: 30px" @click="sortby('reserved')">RSRVD</td>
                                        <td class="ipt_tdhr" style="min-width: 30px" @click="sortby('available')">AVLBLE</td>
                                        <td class="ipt_tdhr">ACTION</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sitem, sidx in searchitems.result" v-bind:key="sitem.product_sku">
                                        <td class="ipt_tdr" style="text-align: center; padding: 5px;">
                                            <div style="text-align: center; height: 60px; display: flex; align-items: center; justify-content: center;">
                                                <div v-if="getProductImage(sitem)" class="image-container">
                                                    <img
                                                        :src="getProductImage(sitem)"
                                                        style="max-width: 100%; max-height: 70px; object-fit: contain; cursor: pointer;"
                                                        @error="handleImageError($event, sitem)"
                                                        @load="handleImageLoad($event, sitem)"
                                                        @click="showFullImage(sitem)"
                                                        class="product-image"
                                                    />
                                                    <div class="image-overlay" @click="showFullImage(sitem)">
                                                        🔍
                                                    </div>
                                                </div>
                                                <div v-else class="no-image-placeholder">
                                                    <div style="color: #999; font-size: 10px;">No Image</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="ipt_tdr">
                                            {{sitem.product_sku}}
                                            <!-- Damage ID Badge in Search Results -->
                                            <b-badge 
                                                v-if="sitem.is_damaged && sitem.damage_info && sitem.damage_info.damage_id"
                                                variant="danger"
                                                style="font-size: 9px; padding: 1px 4px; margin-left: 5px;"
                                                title="Damage ID"
                                            >
                                                D-{{ sitem.damage_info.damage_id }}
                                            </b-badge>
                                        </td>
                                        <td class="ipt_tdr">{{sitem.product_name}}</td>
                                        <td class="ipt_tdr" style="text-align: center;">
                                            <b-card-text>
                                                <span v-if="sitem.quantity_per_box && sitem.quantity_per_box > 1"
                                                      style="font-weight: bold; color: #2c5aa0;">
                                                    {{sitem.quantity_per_box}}
                                                </span>
                                                <span v-else style="color: #666;">
                                                    {{sitem.quantity_per_box || 1}}
                                                </span>
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr">
                                            <div v-if="hasActiveDiscount(sitem)" style="text-align: center;">
                                                <div style="color: #dc3545; font-weight: bold; font-size: 14px;">
                                                    ${{ getDisplayPrice(sitem) }}
                                                </div>
                                                <div style="text-decoration: line-through; color: #6c757d; font-size: 12px;">
                                                    ${{ sitem.selling_price }}
                                                </div>
                                            </div>
                                            <div v-else style="font-weight: bold;">
                                                ${{ sitem.selling_price }}
                                            </div>
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-card-text>
                                                <b-input
                                                    size="sm"
                                                    style="width: 50px; text-align: center;"
                                                    v-model="sitem.quantity"
                                                    type="number"
                                                    min="1"
                                                    :class="{'is-invalid': hasQuantityError(sitem)}"
                                                    @blur="validateQuantityPerBox(sitem)"
                                                ></b-input>
                                                <div v-if="hasQuantityError(sitem)"
                                                     style="color: red; font-size: 10px; margin-top: 2px;">
                                                </div>
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-card-text>
                                                ${{ (getDisplayPrice(sitem) * (parseInt(sitem.quantity) || 0)).toFixed(2) }}
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr location-breakdown-cell" v-if="showLocationBreakdown">
                                            <div v-if="sitem.sublocation_breakdown && sitem.sublocation_breakdown.length > 0" 
                                                 class="location-breakdown-container">
                                                <div v-for="loc in getFilteredSublocationBreakdown(sitem)" 
                                                     :key="loc.sublocation_id"
                                                     class="location-item">
                                                    <span class="location-name">
                                                        <span class="location-dot" :class="getLocationClass(loc.sublocation_name)"></span>
                                                        {{ getShortLocationName(loc.sublocation_name) }}
                                                    </span>
                                                    <span class="location-quantity" :class="{'low-stock': loc.available < 3}">
                                                        {{ loc.available }}
                                                    </span>
                                                </div>
                                                <div v-if="getFilteredSublocationBreakdown(sitem).length === 0" 
                                                     class="no-stock-message">
                                                    <span class="location-dot out-of-stock"></span>
                                                    No stock available
                                                </div>
                                            </div>
                                            <div v-else class="no-location-data">
                                                <span class="location-dot unknown"></span>
                                                No location data
                                            </div>
                                        </td>
                                        <td class="ipt_tdr" :style="{background: ((sitem.in_stock < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                            <b-card-text>
                                                {{sitem.in_stock}}
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr" :style="{background: ((sitem.reserved < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                            <b-card-text>
                                                {{sitem.reserved}}
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr" :style="{background: ((sitem.available < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                            <b-card-text>
                                                {{sitem.available}}
                                            </b-card-text>
                                        </td>
                                        <td class="ipt_tdr">
                                            <b-button
                                                variant="success"
                                                size="sm"
                                                @click="addProduct(sitem)"
                                                :disabled="hasQuantityError(sitem)"
                                                style="align-items: center;"
                                            >
                                                Add
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else>
                            <b-alert variant="light" show>No Products To Show</b-alert>
                        </div>
                    </b-overlay>
                </b-card-body>
            </b-collapse>
        </b-tab>

        <!-- Tab 2: Scan Barcode -->
        <b-tab title="SCAN BARCODE">
            <template #title>
                <b-icon-upc-scan class="mr-1"></b-icon-upc-scan> SCAN BARCODE
            </template>
            
            <b-form @submit.prevent="handleBarcodeScan">
                <b-input-group>
                    <b-form-input
                        v-model="barcodeInput"
                        placeholder="Scan barcode or type SKU..."
                        size="sm"
                        style="max-width: 300px;"
                        ref="barcodeInput"
                        autofocus
                        @keyup.enter="handleBarcodeScan"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button 
                            variant="primary" 
                            size="sm" 
                            type="submit"
                            @click="handleBarcodeScan"
                        >
                            <b-icon-upc-scan></b-icon-upc-scan> SCAN
                        </b-button>
                        <b-button 
                            variant="success" 
                            size="sm" 
                            @click="openCameraScanner"
                            title="Use camera to scan barcode"
                        >
                            <b-icon-camera></b-icon-camera>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form>
        </b-tab>

        <!-- Tab 3: Special Order -->
      <!-- Tab 3: Special Order -->
      <!-- Tab 3: Special Order -->
<b-tab title="SPECIAL ORDER">
    <template #title>
        <b-icon-plus-circle class="mr-1"></b-icon-plus-circle> SPECIAL ORDER
    </template>
    
    <template v-if="refund_items.length <= 0 && !hasDeliveredItems">
        <b-card-body style="padding: 20px; background: #f8f9fa; border-radius: 8px;">
            <!-- Image Upload Section - Compact -->
            <div class="special-order-image-section mb-3">
                <div class="d-flex align-items-center gap-3 flex-wrap">
                    <div class="image-upload-wrapper" style="width: 80px; height: 80px;">
                        <div class="position-relative" style="width: 80px; height: 80px;">
                            <div v-if="nonInventoryImage.previewUrl" 
                                class="image-preview-wrapper"
                                style="width: 80px; height: 80px; border: 2px solid #dee2e6; border-radius: 8px; overflow: hidden; background: white; display: flex; align-items: center; justify-content: center;">
                                <img 
                                    :src="nonInventoryImage.previewUrl" 
                                    style="width: 100%; height: 100%; object-fit: contain;"
                                    alt="Product preview"
                                />
                                <b-button 
                                    v-if="nonInventoryImage.previewUrl"
                                    variant="danger" 
                                    size="sm" 
                                    class="remove-image-btn"
                                    style="position: absolute; top: -6px; right: -6px; width: 22px; height: 22px; padding: 0; border-radius: 50%; font-size: 12px; line-height: 1;"
                                    @click="clearNonInventoryImage"
                                    title="Remove image"
                                >
                                    <b-icon-x font-scale="1"></b-icon-x>
                                </b-button>
                            </div>
                            <div v-else 
                                class="upload-placeholder"
                                style="width: 80px; height: 80px; border: 2px dashed #ced4da; border-radius: 8px; background: white; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                                @click="$refs.nonInventoryFileInput.click()">
                                <b-icon-camera font-scale="1.5" variant="secondary"></b-icon-camera>
                                <div class="small text-muted" style="font-size: 8px;">Upload</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="upload-controls">
                        <div class="d-flex align-items-center gap-2">
                            <b-button 
                                variant="outline-primary" 
                                size="sm" 
                                @click="$refs.nonInventoryFileInput.click()"
                                :disabled="nonInventoryImage.uploading"
                            >
                                <b-icon-upload class="mr-1"></b-icon-upload>
                                Choose
                            </b-button>
                            
                            <b-button 
                                variant="outline-success" 
                                size="sm" 
                                @click="openCamera"
                                :disabled="nonInventoryImage.uploading || !isCameraSupported"
                                title="Take photo with camera"
                            >
                                <b-icon-camera class="mr-1"></b-icon-camera>
                                Camera
                            </b-button>
                            
                            <b-spinner small v-if="nonInventoryImage.uploading" variant="primary"></b-spinner>
                            <small v-if="nonInventoryImage.uploadedUrl" class="text-success">
                                <b-icon-check-circle></b-icon-check-circle> Uploaded
                            </small>
                        </div>
                        
                        <input 
                            ref="nonInventoryFileInput"
                            type="file" 
                            accept="image/*" 
                            style="display: none" 
                            @change="handleNonInventoryImageUpload"
                        />
                        
                        <input 
                            ref="cameraInput"
                            type="file" 
                            accept="image/*" 
                            capture="environment"
                            style="display: none" 
                            @change="handleNonInventoryImageUpload"
                        />
                    </div>
                </div>
            </div>

            <!-- Form Fields - More Compact Layout -->
            <b-row class="g-2">
                <!-- CATEGORY -->
                <b-col cols="12" sm="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        CATEGORY <span class="text-danger">*</span>
                    </label>
                    <b-form-select 
                        :options="categoryOptions" 
                        v-model="special_item.category_id" 
                        size="sm"
                        :state="special_item.category_id ? null : false"
                        class="border-primary"
                        @change="onSpecialCategoryChange"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Select Category</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <!-- SUB CATEGORY -->
                <b-col cols="12" sm="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        SUB CATEGORY <span class="text-danger">*</span>
                    </label>
                    <b-form-select 
                        :options="specialSubcategoryOptions" 
                        v-model="special_item.subcategory_id" 
                        size="sm"
                        :state="special_item.subcategory_id ? null : false"
                        class="border-primary"
                        :disabled="!special_item.category_id"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Select Sub Category</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <!-- COLOR -->
                <b-col cols="6" md="3" lg="1" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        COLOR
                    </label>
                    <b-form-select 
                        :options="colorOptions" 
                        v-model="special_item.color_id" 
                        size="sm"
                        class="border-primary"
                    >
                        <template #first>
                            <b-form-select-option :value="null">Select</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <!-- SIZE -->
                <b-col cols="6" md="3" lg="1" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        SIZE
                    </label>
                    <b-form-select 
                        :options="sizeOptions" 
                        v-model="special_item.size_id" 
                        size="sm"
                        class="border-primary"
                    >
                        <template #first>
                            <b-form-select-option :value="null">Select</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <!-- SKU -->
                <b-col cols="12" sm="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        SKU <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        v-model="special_item.product_sku" 
                        placeholder="Enter SKU"
                        :state="special_item.product_sku ? null : false"
                        class="border-primary"
                    ></b-input>
                </b-col>

                <!-- DESCRIPTION - NEW FIELD -->
                <b-col cols="12" sm="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        DESCRIPTION <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        v-model="special_item.product_name" 
                        placeholder="Enter description"
                        :state="special_item.product_name ? null : false"
                        class="border-primary"
                    ></b-input>
                </b-col>

                <!-- VENDOR -->
                <b-col cols="12" sm="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        VENDOR <span class="text-danger">*</span>
                    </label>
                    <b-form-select 
                        :options="sortedVendors" 
                        v-model="special_item.vendor" 
                        size="sm"
                        :state="special_item.vendor ? null : false"
                        class="border-primary"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <!-- QUANTITY -->
                <b-col cols="6" md="3" lg="1" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        QTY <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        type="number" 
                        min="1" 
                        step="1"
                        v-model="special_item.quantity"
                        :state="special_item.quantity > 0 ? null : false"
                        class="border-primary"
                        placeholder="0"
                    ></b-input>
                </b-col>

                <!-- PRICE -->
                <b-col cols="6" md="4" lg="2" class="mb-2">
                    <label class="form-label font-weight-bold mb-1" style="font-size: 12px;">
                        PRICE <span class="text-danger">*</span>
                    </label>
                    <b-input-group size="sm">
                        <b-input-group-prepend>
                            <span class="input-group-text">$</span>
                        </b-input-group-prepend>
                        <b-input 
                            size="sm" 
                            type="number" 
                            min="0.01" 
                            step="0.01"
                            v-model="special_item.selling_price"
                            :state="special_item.selling_price > 0 ? null : false"
                            class="border-primary"
                            placeholder="0.00"
                        ></b-input>
                    </b-input-group>
                </b-col>

                <!-- ADD BUTTON -->
                <b-col cols="12" lg="1" class="mb-2 d-flex align-items-end">
                    <b-button 
                        size="sm" 
                        variant="success" 
                        @click="addNonInventoryItem"
                        :disabled="!canAddNonInventoryItem"
                        class="w-100 py-2 font-weight-bold"
                        style="white-space: nowrap;"
                    >
                        <b-icon-plus-circle class="mr-1"></b-icon-plus-circle>
                        ADD
                    </b-button>
                </b-col>
            </b-row>

            <!-- Validation Summary - More compact -->
            <div v-if="!canAddNonInventoryItem" class="mt-2 p-2 bg-light rounded small">
                <div class="text-muted">
                    <b-icon-exclamation-circle class="mr-1 text-warning"></b-icon-exclamation-circle>
                    Please fill all required fields:
                </div>
                <div class="d-flex flex-wrap gap-2 mt-1">
                    <span v-if="!special_item.category_id" class="text-danger">• Category</span>
                    <span v-if="!special_item.subcategory_id && special_item.category_id" class="text-danger">• Sub Category</span>
                    <span v-if="!special_item.product_sku" class="text-danger">• SKU</span>
                    <span v-if="!special_item.product_name" class="text-danger">• Description</span>
                    <span v-if="!special_item.vendor" class="text-danger">• Vendor</span>
                    <span v-if="!special_item.quantity || special_item.quantity <= 0" class="text-danger">• Quantity</span>
                    <span v-if="!special_item.selling_price || special_item.selling_price <= 0" class="text-danger">• Price</span>
                </div>
            </div>
        </b-card-body>
    </template>
    
    <!-- Show message when items are delivered -->
    <div v-else-if="hasDeliveredItems" class="text-center p-4">
        <b-alert variant="info" show>
            <b-icon-info-circle class="mr-2"></b-icon-info-circle>
            Cannot add special order items after items have been delivered.
        </b-alert>
    </div>
    
    <!-- Show message when refund items exist -->
    <div v-else-if="refund_items.length > 0" class="text-center p-4">
        <b-alert variant="info" show>
            <b-icon-info-circle class="mr-2"></b-icon-info-circle>
            Cannot add special order items while there are pending refunds.
        </b-alert>
    </div>
</b-tab>
        <!-- Tab 4: Non-Inventory Item -->
        <b-tab title="NON-INVENTORY">
            <template #title>
                <b-icon-box class="mr-1"></b-icon-box> NON-INVENTORY
            </template>
            
            <template v-if="refund_items.length <= 0 && ['admin', 'officemanager', 'locationmanager','locationadmin'].includes(userDetails.userrole) && !hasDeliveredItems">
                <b-card-body style="padding: 20px; background: #f8f9fa; border-radius: 8px;">
                    <!-- Image Upload Section - EXACTLY as original -->
                    <div class="non-inventory-section mb-4">
                        <label class="form-label font-weight-bold mb-2">PRODUCT IMAGE</label>
                        <div class="d-flex flex-wrap align-items-start gap-4">
                            <div class="image-upload-area mr-3 mb-3" style="width: 120px;">
                                <div class="position-relative">
                                    <div v-if="nonInventoryImage.previewUrl" 
                                         class="image-preview-container text-center"
                                         style="width: 120px; height: 120px; border: 2px solid #dee2e6; border-radius: 8px; overflow: hidden; background: white;">
                                        <img 
                                            :src="nonInventoryImage.previewUrl" 
                                            style="width: 100%; height: 100%; object-fit: contain;"
                                            alt="Product preview"
                                        />
                                        <b-button 
                                            v-if="nonInventoryImage.previewUrl"
                                            variant="danger" 
                                            size="sm" 
                                            class="remove-image-btn"
                                            style="position: absolute; top: -8px; right: -8px; width: 24px; height: 24px; padding: 0; border-radius: 50%;"
                                            @click="clearNonInventoryImage"
                                            title="Remove image"
                                        >
                                            <b-icon-x font-scale="1.2"></b-icon-x>
                                        </b-button>
                                    </div>
                                    <div v-else 
                                         class="upload-placeholder text-center p-3"
                                         style="width: 120px; height: 120px; border: 2px dashed #ced4da; border-radius: 8px; background: white; cursor: pointer;"
                                         @click="$refs.nonInventoryFileInput.click()">
                                        <b-icon-camera font-scale="2.5" variant="secondary" class="mb-2"></b-icon-camera>
                                        <div class="small text-muted">Click to upload</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="upload-controls flex-grow-1">
                                <div class="d-flex align-items-center mb-2">
                                    <b-button 
                                        variant="outline-primary" 
                                        size="sm" 
                                        @click="$refs.nonInventoryFileInput.click()"
                                        :disabled="nonInventoryImage.uploading"
                                        class="mr-2"
                                    >
                                        <b-icon-upload class="mr-1"></b-icon-upload>
                                        Choose File
                                    </b-button>
                                    
                                    <b-button 
                                        variant="outline-success" 
                                        size="sm" 
                                        @click="openCamera"
                                        :disabled="nonInventoryImage.uploading || !isCameraSupported"
                                        class="mr-2"
                                        title="Take photo with camera"
                                    >
                                        <b-icon-camera class="mr-1"></b-icon-camera>
                                        Camera
                                    </b-button>
                                    
                                    <b-spinner small v-if="nonInventoryImage.uploading" variant="primary"></b-spinner>
                                </div>
                                
                                <input 
                                    ref="nonInventoryFileInput"
                                    type="file" 
                                    accept="image/*" 
                                    style="display: none" 
                                    @change="handleNonInventoryImageUpload"
                                />
                                
                                <input 
                                    ref="cameraInput"
                                    type="file" 
                                    accept="image/*" 
                                    capture="environment"
                                    style="display: none" 
                                    @change="handleNonInventoryImageUpload"
                                />
                                
                                <small class="text-muted d-block">
                                    <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                                    Max size: 5MB (JPG, PNG, GIF)
                                </small>
                                <small v-if="nonInventoryImage.uploadedUrl" class="text-success d-block mt-1">
                                    <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                                    Image ready for upload
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Form Fields - EXACTLY as original -->
                    <b-row>
                        <b-col cols="12" md="6" lg="3" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                CATEGORY <span class="text-danger">*</span>
                            </label>
                            <b-form-select 
                                :options="categoryOptions" 
                                v-model="nonInventoryItem.category_id" 
                                size="sm"
                                :state="nonInventoryItem.category_id ? null : false"
                                class="border-primary"
                                @change="onCategoryChange"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Select Category</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" md="6" lg="3" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                SKU <span class="text-danger">*</span>
                            </label>
                            <b-input 
                                size="sm" 
                                v-model="nonInventoryItem.product_sku" 
                                placeholder="Enter SKU"
                                :state="nonInventoryItem.product_sku ? null : false"
                                class="border-primary"
                            ></b-input>
                            <small class="text-muted">Unique identifier for item</small>
                        </b-col>

                        <b-col cols="12" md="6" lg="3" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                DESCRIPTION <span class="text-danger">*</span>
                            </label>
                            <b-input 
                                size="sm" 
                                v-model="nonInventoryItem.product_name" 
                                placeholder="Enter description"
                                :state="nonInventoryItem.product_name ? null : false"
                                class="border-primary"
                            ></b-input>
                        </b-col>

                        <b-col cols="12" md="6" lg="3" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                VENDOR <span class="text-danger">*</span>
                            </label>
                            <b-form-select 
                                :options="sortedVendors" 
                                v-model="nonInventoryItem.vendor" 
                                size="sm"
                                :state="nonInventoryItem.vendor ? null : false"
                                class="border-primary"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="6" md="3" lg="2" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                QUANTITY <span class="text-danger">*</span>
                            </label>
                            <b-input 
                                size="sm" 
                                type="number" 
                                min="1" 
                                step="1"
                                v-model="nonInventoryItem.quantity"
                                :state="nonInventoryItem.quantity > 0 ? null : false"
                                class="border-primary"
                                placeholder="Qty"
                            ></b-input>
                        </b-col>

                        <b-col cols="6" md="3" lg="2" class="mb-3">
                            <label class="form-label font-weight-bold mb-1">
                                PRICE <span class="text-danger">*</span>
                            </label>
                            <b-input-group size="sm" prepend="$">
                                <b-input 
                                    size="sm" 
                                    type="number" 
                                    min="0.01" 
                                    step="0.01"
                                    v-model="nonInventoryItem.selling_price"
                                    :state="nonInventoryItem.selling_price > 0 ? null : false"
                                    class="border-primary"
                                    placeholder="0.00"
                                ></b-input>
                            </b-input-group>
                        </b-col>

                        <b-col cols="12" lg="2" class="mb-3 d-flex align-items-end">
                            <b-button 
                                size="sm" 
                                variant="success" 
                                @click="addNonInventoryItemToSale"
                                :disabled="!canAddNonInventoryItemToSale"
                                class="w-100 py-2 font-weight-bold"
                            >
                                <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
                                ADD ITEM
                            </b-button>
                        </b-col>
                    </b-row>

                    <!-- Validation Summary - EXACTLY as original -->
                    <!-- <div v-if="!canAddNonInventoryItemToSale" class="mt-3 p-2 bg-light rounded small">
                        <div class="text-muted">
                            <b-icon-exclamation-circle class="mr-1 text-warning"></b-icon-exclamation-circle>
                            Please fill all required fields:
                        </div>
                        <ul class="mt-1 mb-0 pl-3">
                            <li v-if="!nonInventoryItem.category_id" class="text-danger">Category is required</li>
                            <li v-if="!nonInventoryItem.product_sku" class="text-danger">SKU is required</li>
                            <li v-if="!nonInventoryItem.product_name" class="text-danger">Description is required</li>
                            <li v-if="!nonInventoryItem.vendor" class="text-danger">Vendor is required</li>
                            <li v-if="!nonInventoryItem.quantity || nonInventoryItem.quantity <= 0" class="text-danger">Quantity must be greater than 0</li>
                            <li v-if="!nonInventoryItem.selling_price || nonInventoryItem.selling_price <= 0" class="text-danger">Price must be greater than 0</li>
                        </ul>
                    </div> -->
                </b-card-body>
            </template>
            
            <!-- Show message if user doesn't have permission -->
            <div v-else-if="!['admin', 'officemanager', 'locationmanager','locationadmin'].includes(userDetails.userrole)" class="text-center p-4">
                <b-alert variant="warning" show>
                    <b-icon-exclamation-triangle class="mr-2"></b-icon-exclamation-triangle>
                    You don't have permission to add non-inventory items. Please contact an administrator.
                </b-alert>
            </div>
            
            <div v-else-if="refund_items.length > 0" class="text-center p-4">
                <b-alert variant="info" show>
                    <b-icon-info-circle class="mr-2"></b-icon-info-circle>
                    Cannot add non-inventory items while there are pending refunds.
                </b-alert>
            </div>
            
            <div v-else-if="hasDeliveredItems" class="text-center p-4">
                <b-alert variant="info" show>
                    <b-icon-info-circle class="mr-2"></b-icon-info-circle>
                    Cannot add non-inventory items after items have been delivered.
                </b-alert>
            </div>
        </b-tab>
    </b-tabs>
</b-card>

<!-- <b-card header="SEARCH PRODUCTS"  style="margin-top: 10px;">
                        

     <b-button 
    v-b-toggle.collapse-1 
    variant="primary" 
    size="sm" 
    style="margin: 10px;"
    :title="!hasSearched ? 'Please perform a search first before collapsing' : ''"
>
    {{ searchCollapseOpen ? 'CLOSE' : 'OPEN' }}
</b-button>

<b-collapse 
    id="collapse-1" 
    class="mt-2"    
    v-model="searchCollapseOpen"
    @hidden="onCollapseHidden"
    @shown="onCollapseShown"
>
        <b-card-body style="padding: 5px;">
            <b-form @submit="search" autocomplete="off">
                <b-card-text>
                    <b-form-input
                        style="max-width: 300px; display: inline-block; margin: 3px;"
                        v-model="searchitems.keyword"
                        required
                        size="sm"
                    ></b-form-input>

                    <b-button
                        variant="warning"
                        style="display: inline-block; vertical-align: top; margin: 3px;"
                        size="sm"
                        type="submit">SEARCH
                    </b-button>

                    <b-form-checkbox
    style="display: inline-block; vertical-align: top; margin: 3px;"
    size="sm"
    v-model="search_in_my_location"
    @change="handleOnlyInMyLocationChange"
>ONLY IN MY LOCATION
</b-form-checkbox>
                   
<b-form-checkbox
    style="display: inline-block; vertical-align: top; margin: 3px;"
    size="sm"
    v-model="search_only_from_damages"
    @change="handleOnlyFromDamagesChange"
    :disabled="!search_in_my_location"
>AS IS
</b-form-checkbox>
                </b-card-text>
            </b-form>

            <b-overlay
                :show="searchitems.search_being_loaded"
                variant="white"
                opacity="0.85"
                blur="1px"
                rounded="sm"
                 class="search-loading-overlay"
>
    <template #overlay>
        <div class="product-search-loader">
            <div class="loader-card">
                <div class="loader-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
                        <path d="M16 21V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V21" stroke="#2c5aa0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="white"/>
                        <path d="M12 7V9" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
                        <path d="M12 13V15" stroke="#2c5aa0" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
                <div class="loader-text">Searching products...</div>
                <div class="loader-progress">
                    <div class="loader-progress-bar"></div>
                </div>
            </div>
        </div>
    </template>
                <div v-if="searchitems.result.length > 0" style="overflow-x: auto;">
                    <table hover small bordered style="width: 100%;">
                        <thead>
                            <tr style="background: slategray; color: white;">
                                <td class="ipt_tdhr" style="min-width: 100px" @click="sortby('image')">Image</td>
                                <td class="ipt_tdhr" @click="sortby('product_sku')">SKU</td>
                                <td class="ipt_tdhr" style="min-width: 150px" @click="sortby('product_name')">PRD DESC</td>
                            
                                <td class="ipt_tdhr" style="min-width: 30px">QTY/BOX</td>
                                <td class="ipt_tdhr" style="min-width: 50px" @click="sortby('selling_price')">UNIT PRICE</td>
                                <td class="ipt_tdhr">QTY</td>
                                  <td class="ipt_tdhr" style="min-width: 50px" @click="sortby('selling_price')">TOTAL PRICE</td>
                                   <td class="ipt_tdr" style="min-width: 150px" v-if="showLocationBreakdown">LOCATION BREAKDOWN</td>
                                <td class="ipt_tdhr"  style="min-width: 30px" @click="sortby('in_stock')">IN STOCK</td>
                                <td class="ipt_tdhr"  style="min-width: 30px" @click="sortby('reserved')">RSRVD</td>
                                <td class="ipt_tdhr"  style="min-width: 30px"  @click="sortby('available')">AVLBLE</td>
                                <td class="ipt_tdhr">ACTION</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sitem, sidx in searchitems.result" v-bind:key="sitem.product_sku">
                                <td class="ipt_tdr" style="text-align: center; padding: 5px;">
    <div style="text-align: center; height: 60px; display: flex; align-items: center; justify-content: center;">
        <div v-if="getProductImage(sitem)" class="image-container">
            <img
                :src="getProductImage(sitem)"
                style="max-width: 100%; max-height: 70px; object-fit: contain; cursor: pointer;"
                @error="handleImageError($event, sitem)"
                @load="handleImageLoad($event, sitem)"
                @click="showFullImage(sitem)"
                class="product-image"
            />
            <div class="image-overlay" @click="showFullImage(sitem)">
                🔍
            </div>
        </div>
        <div v-else class="no-image-placeholder">
            <div style="color: #999; font-size: 10px;">No Image</div>

        </div>
    </div>
</td>
                               <td class="ipt_tdr">{{sitem.product_sku}}
                                     
                                        <b-badge 
                                            v-if="sitem.is_damaged && sitem.damage_info && sitem.damage_info.damage_id"
                                            variant="danger"
                                            style="font-size: 9px; padding: 1px 4px; margin-left: 5px;"
                                            title="Damage ID"
                                        >
                                            D-{{ sitem.damage_info.damage_id }}
                                        </b-badge>
                                    </td>
                                <td class="ipt_tdr">{{sitem.product_name}}</td>

                             
                                <td class="ipt_tdr" style="text-align: center;">
                                    <b-card-text>
                                        <span v-if="sitem.quantity_per_box && sitem.quantity_per_box > 1"
                                              style="font-weight: bold; color: #2c5aa0;">
                                            {{sitem.quantity_per_box}}
                                        </span>
                                        <span v-else style="color: #666;">
                                            {{sitem.quantity_per_box || 1}}
                                        </span>
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr">
                                        <div v-if="hasActiveDiscount(sitem)" style="text-align: center;">
                                            <div style="color: #dc3545; font-weight: bold; font-size: 14px;">
                                                ${{ getDisplayPrice(sitem) }}
                                            </div>
                                            <div style="text-decoration: line-through; color: #6c757d; font-size: 12px;">
                                                ${{ sitem.selling_price }}
                                            </div>
                                         
                                        </div>
                                        <div v-else style="font-weight: bold;">
                                            ${{ sitem.selling_price }}
                                        </div>
                                    </td>

                                <td class="ipt_tdr">
                                    <b-card-text>
                                        <b-input
                                            size="sm"
                                            style="width: 50px; text-align: center;"
                                            v-model="sitem.quantity"
                                            type="number"
                                            min="1"
                                            :class="{'is-invalid': hasQuantityError(sitem)}"
                                            @blur="validateQuantityPerBox(sitem)"
                                        ></b-input>
                                    
                                        <div v-if="hasQuantityError(sitem)"
                                             style="color: red; font-size: 10px; margin-top: 2px;">
                                        </div>
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr">
                                    <b-card-text>
                                        ${{ (getDisplayPrice(sitem) * (parseInt(sitem.quantity) || 0)).toFixed(2) }}
                                    </b-card-text>
                                    </td>
              <td class="ipt_tdr location-breakdown-cell" v-if="showLocationBreakdown">
    <div v-if="sitem.sublocation_breakdown && sitem.sublocation_breakdown.length > 0" 
         class="location-breakdown-container">
        <div v-for="loc in getFilteredSublocationBreakdown(sitem)" 
             :key="loc.sublocation_id"
             class="location-item">
            <span class="location-name">
                <span class="location-dot" :class="getLocationClass(loc.sublocation_name)"></span>
                {{ getShortLocationName(loc.sublocation_name) }}
            </span>
            <span class="location-quantity" :class="{'low-stock': loc.available < 3}">
                {{ loc.available }}
            </span>
        </div>
        <div v-if="getFilteredSublocationBreakdown(sitem).length === 0" 
             class="no-stock-message">
            <span class="location-dot out-of-stock"></span>
            No stock available
        </div>
    </div>
    <div v-else class="no-location-data">
        <span class="location-dot unknown"></span>
        No location data
    </div>
</td>
                                <td class="ipt_tdr" :style="{background: ((sitem.in_stock < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                    <b-card-text>
                                        {{sitem.in_stock}}
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr" :style="{background: ((sitem.reserved < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                    <b-card-text>
                                        {{sitem.reserved}}
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr" :style="{background: ((sitem.available < 5) ? '#ffa64145' : 'rgb(233, 255, 214)')}">
                                    <b-card-text>
                                        {{sitem.available}}
                                    </b-card-text>
                                </td>

                                <td class="ipt_tdr">
                                    <b-button
                                        variant="success"
                                        size="sm"
                                        @click="addProduct(sitem)"
                                        :disabled="hasQuantityError(sitem)"
                                        style="align-items: center;"
                                    >
                                        Add
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert variant="light" show>No Products To Show</b-alert>
                </div>
            </b-overlay>
        </b-card-body>
    </b-collapse>

    
</b-card> -->
<!-- <b-card header="SCAN BARCODE" style="margin-top: 10px;">
  <b-form @submit.prevent="handleBarcodeScan">
    <b-input-group>
      <b-form-input
        v-model="barcodeInput"
        placeholder="Scan barcode or type SKU..."
        size="sm"
        style="max-width: 300px;"
        ref="barcodeInput"
        autofocus
        @keyup.enter="handleBarcodeScan"
      ></b-form-input>
      <b-input-group-append>
        <b-button 
          variant="primary" 
          size="sm" 
          type="submit"
          @click="handleBarcodeScan"
        >
          <b-icon-upc-scan></b-icon-upc-scan> SCAN
        </b-button>
        <b-button 
          variant="success" 
          size="sm" 
          @click="openCameraScanner"
          title="Use camera to scan barcode"
        >
          <b-icon-camera></b-icon-camera>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</b-card> -->

<!-- <b-card header="NON-INVENTORY ITEM" style="margin-top: 10px;" v-if="refund_items.length <= 0 && ['admin', 'officemanager', 'locationmanager','locationadmin'].includes(userDetails.userrole) && !hasDeliveredItems">
    <b-button v-b-toggle.collapse-2 variant="primary" size="sm" class="mb-2">
        <b-icon-plus-circle class="mr-1"></b-icon-plus-circle>
        ADD NON-INVENTORY ITEM
    </b-button>

    <b-collapse id="collapse-2" class="mt-3">
        <b-card-body style="padding: 20px; background: #f8f9fa; border-radius: 8px;">
          
            <div class="non-inventory-section mb-4">
                <label class="form-label font-weight-bold mb-2">PRODUCT IMAGE</label>
                <div class="d-flex flex-wrap align-items-start gap-4">
                  
                    <div class="image-upload-area mr-3 mb-3" style="width: 120px;">
                        <div class="position-relative">
                            <div v-if="nonInventoryImage.previewUrl" 
                                 class="image-preview-container text-center"
                                 style="width: 120px; height: 120px; border: 2px solid #dee2e6; border-radius: 8px; overflow: hidden; background: white;">
                                <img 
                                    :src="nonInventoryImage.previewUrl" 
                                    style="width: 100%; height: 100%; object-fit: contain;"
                                    alt="Product preview"
                                />
                                <b-button 
                                    v-if="nonInventoryImage.previewUrl"
                                    variant="danger" 
                                    size="sm" 
                                    class="remove-image-btn"
                                    style="position: absolute; top: -8px; right: -8px; width: 24px; height: 24px; padding: 0; border-radius: 50%;"
                                    @click="clearNonInventoryImage"
                                    title="Remove image"
                                >
                                    <b-icon-x font-scale="1.2"></b-icon-x>
                                </b-button>
                            </div>
                            <div v-else 
                                 class="upload-placeholder text-center p-3"
                                 style="width: 120px; height: 120px; border: 2px dashed #ced4da; border-radius: 8px; background: white; cursor: pointer;"
                                 @click="$refs.nonInventoryFileInput.click()">
                                <b-icon-camera font-scale="2.5" variant="secondary" class="mb-2"></b-icon-camera>
                                <div class="small text-muted">Click to upload</div>
                            </div>
                        </div>
                    </div>
                    
                    
             
                        <div class="upload-controls flex-grow-1">
                            <div class="d-flex align-items-center mb-2">
                                <b-button 
                                    variant="outline-primary" 
                                    size="sm" 
                                    @click="$refs.nonInventoryFileInput.click()"
                                    :disabled="nonInventoryImage.uploading"
                                    class="mr-2"
                                >
                                    <b-icon-upload class="mr-1"></b-icon-upload>
                                    Choose File
                                </b-button>
                                
                                <b-button 
                                    variant="outline-success" 
                                    size="sm" 
                                    @click="openCamera"
                                    :disabled="nonInventoryImage.uploading || !isCameraSupported"
                                    class="mr-2"
                                    title="Take photo with camera"
                                >
                                    <b-icon-camera class="mr-1"></b-icon-camera>
                                    Camera
                                </b-button>
                                
                                <b-spinner small v-if="nonInventoryImage.uploading" variant="primary"></b-spinner>
                            </div>
                            
                         
                            <input 
                                ref="nonInventoryFileInput"
                                type="file" 
                                accept="image/*" 
                                style="display: none" 
                                @change="handleNonInventoryImageUpload"
                            />
                            
                            
                            <input 
                                ref="cameraInput"
                                type="file" 
                                accept="image/*" 
                                capture="environment"
                                style="display: none" 
                                @change="handleNonInventoryImageUpload"
                            />
                            
                            <small class="text-muted d-block">
                                <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                                Max size: 5MB (JPG, PNG, GIF)
                            </small>
                            <small v-if="nonInventoryImage.uploadedUrl" class="text-success d-block mt-1">
                                <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                                Image ready for upload
                            </small>
                        </div>
                </div>
            </div>

   
            <b-row>
                <b-col cols="12" md="6" lg="3" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        SKU <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        v-model="special_item.product_sku" 
                        placeholder="Enter SKU"
                        :state="special_item.product_sku ? null : false"
                        class="border-primary"
                    ></b-input>
                    <small class="text-muted">Unique identifier for item</small>
                </b-col>
<b-col cols="12" md="6" lg="3" class="mb-3">
    <label class="form-label font-weight-bold mb-1">
        VENDOR <span class="text-danger">*</span>
    </label>
    <b-form-select 
        :options="sortedVendors" 
        v-model="special_item.vendor" 
        size="sm"
        :state="special_item.vendor ? null : false"
        class="border-primary"
    >
        <template #first>
            <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
        </template>
    </b-form-select>
</b-col>

                <b-col cols="6" md="3" lg="2" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        QUANTITY <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        type="number" 
                        min="1" 
                        step="1"
                        v-model="special_item.quantity"
                        :state="special_item.quantity > 0 ? null : false"
                        class="border-primary"
                        placeholder="Qty"
                    ></b-input>
                </b-col>

                <b-col cols="6" md="3" lg="2" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        PRICE <span class="text-danger">*</span>
                    </label>
                    <b-input-group size="sm" prepend="$">
                        <b-input 
                            size="sm" 
                            type="number" 
                            min="0.01" 
                            step="0.01"
                            v-model="special_item.selling_price"
                            :state="special_item.selling_price > 0 ? null : false"
                            class="border-primary"
                            placeholder="0.00"
                        ></b-input>
                    </b-input-group>
                </b-col>

                <b-col cols="12" lg="2" class="mb-3 d-flex align-items-end">
                    <b-button 
                        size="sm" 
                        variant="success" 
                        @click="addNonInventoryItem"
                        :disabled="!canAddNonInventoryItem"
                        class="w-100 py-2 font-weight-bold"
                    >
                        <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
                        ADD ITEM
                    </b-button>
                </b-col>
            </b-row>

     
            <div v-if="!canAddNonInventoryItem" class="mt-3 p-2 bg-light rounded small">
                <div class="text-muted">
                    <b-icon-exclamation-circle class="mr-1 text-warning"></b-icon-exclamation-circle>
                    Please fill all required fields:
                </div>
                <ul class="mt-1 mb-0 pl-3">
                    <li v-if="!special_item.product_sku" class="text-danger">SKU is required</li>
                    <li v-if="!special_item.vendor" class="text-danger">Vendor is required</li>
                    <li v-if="!special_item.quantity || special_item.quantity <= 0" class="text-danger">Quantity must be greater than 0</li>
                    <li v-if="!special_item.selling_price || special_item.selling_price <= 0" class="text-danger">Price must be greater than 0</li>
                </ul>
            </div>
        </b-card-body>
    </b-collapse>
</b-card> -->



<!-- <b-card header="SPECIAL ORDER" style="margin-top: 10px;">

    <template>
        <b-button 
            v-b-toggle.collapse-2 
            variant="primary" 
            size="sm" 
            class="mb-2"
            :disabled="refund_items.length > 0 || hasDeliveredItems"
        >
            <b-icon-plus-circle class="mr-1"></b-icon-plus-circle>
            ADD SPECIAL ORDER
        </b-button>

        <b-collapse id="collapse-2" class="mt-3">
            <b-card-body style="padding: 20px; background: #f8f9fa; border-radius: 8px;">
          
                <div class="non-inventory-section mb-4">
                    <label class="form-label font-weight-bold mb-2">PRODUCT IMAGE</label>
                    <div class="d-flex flex-wrap align-items-start gap-4">
                        <div class="image-upload-area mr-3 mb-3" style="width: 120px;">
                            <div class="position-relative">
                                <div v-if="nonInventoryImage.previewUrl" 
                                     class="image-preview-container text-center"
                                     style="width: 120px; height: 120px; border: 2px solid #dee2e6; border-radius: 8px; overflow: hidden; background: white;">
                                    <img 
                                        :src="nonInventoryImage.previewUrl" 
                                        style="width: 100%; height: 100%; object-fit: contain;"
                                        alt="Product preview"
                                    />
                                    <b-button 
                                        v-if="nonInventoryImage.previewUrl"
                                        variant="danger" 
                                        size="sm" 
                                        class="remove-image-btn"
                                        style="position: absolute; top: -8px; right: -8px; width: 24px; height: 24px; padding: 0; border-radius: 50%;"
                                        @click="clearNonInventoryImage"
                                        title="Remove image"
                                    >
                                        <b-icon-x font-scale="1.2"></b-icon-x>
                                    </b-button>
                                </div>
                                <div v-else 
                                     class="upload-placeholder text-center p-3"
                                     style="width: 120px; height: 120px; border: 2px dashed #ced4da; border-radius: 8px; background: white; cursor: pointer;"
                                     @click="$refs.nonInventoryFileInput.click()">
                                    <b-icon-camera font-scale="2.5" variant="secondary" class="mb-2"></b-icon-camera>
                                    <div class="small text-muted">Click to upload</div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="upload-controls flex-grow-1">
                            <div class="d-flex align-items-center mb-2">
                                <b-button 
                                    variant="outline-primary" 
                                    size="sm" 
                                    @click="$refs.nonInventoryFileInput.click()"
                                    :disabled="nonInventoryImage.uploading"
                                    class="mr-2"
                                >
                                    <b-icon-upload class="mr-1"></b-icon-upload>
                                    Choose File
                                </b-button>
                                
                                <b-button 
                                    variant="outline-success" 
                                    size="sm" 
                                    @click="openCamera"
                                    :disabled="nonInventoryImage.uploading || !isCameraSupported"
                                    class="mr-2"
                                    title="Take photo with camera"
                                >
                                    <b-icon-camera class="mr-1"></b-icon-camera>
                                    Camera
                                </b-button>
                                
                                <b-spinner small v-if="nonInventoryImage.uploading" variant="primary"></b-spinner>
                            </div>
                            
                            <input 
                                ref="nonInventoryFileInput"
                                type="file" 
                                accept="image/*" 
                                style="display: none" 
                                @change="handleNonInventoryImageUpload"
                            />
                            
                            <input 
                                ref="cameraInput"
                                type="file" 
                                accept="image/*" 
                                capture="environment"
                                style="display: none" 
                                @change="handleNonInventoryImageUpload"
                            />
                            
                            <small class="text-muted d-block">
                                <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                                Max size: 5MB (JPG, PNG, GIF)
                            </small>
                            <small v-if="nonInventoryImage.uploadedUrl" class="text-success d-block mt-1">
                                <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                                Image ready for upload
                            </small>
                        </div>
                    </div>
                </div>

          
                <b-row>
                    <b-col cols="12" md="6" lg="3" class="mb-3">
                        <label class="form-label font-weight-bold mb-1">
                            SKU <span class="text-danger">*</span>
                        </label>
                        <b-input 
                            size="sm" 
                            v-model="special_item.product_sku" 
                            placeholder="Enter SKU"
                            :state="special_item.product_sku ? null : false"
                            class="border-primary"
                        ></b-input>
                        <small class="text-muted">Unique identifier for item</small>
                    </b-col>
                    
                    <b-col cols="12" md="6" lg="3" class="mb-3">
                        <label class="form-label font-weight-bold mb-1">
                            VENDOR <span class="text-danger">*</span>
                        </label>
                        <b-form-select 
                            :options="sortedVendors" 
                            v-model="special_item.vendor" 
                            size="sm"
                            :state="special_item.vendor ? null : false"
                            class="border-primary"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="6" md="3" lg="2" class="mb-3">
                        <label class="form-label font-weight-bold mb-1">
                            QUANTITY <span class="text-danger">*</span>
                        </label>
                        <b-input 
                            size="sm" 
                            type="number" 
                            min="1" 
                            step="1"
                            v-model="special_item.quantity"
                            :state="special_item.quantity > 0 ? null : false"
                            class="border-primary"
                            placeholder="Qty"
                        ></b-input>
                    </b-col>

                    <b-col cols="6" md="3" lg="2" class="mb-3">
                        <label class="form-label font-weight-bold mb-1">
                            PRICE <span class="text-danger">*</span>
                        </label>
                        <b-input-group size="sm" prepend="$">
                            <b-input 
                                size="sm" 
                                type="number" 
                                min="0.01" 
                                step="0.01"
                                v-model="special_item.selling_price"
                                :state="special_item.selling_price > 0 ? null : false"
                                class="border-primary"
                                placeholder="0.00"
                            ></b-input>
                        </b-input-group>
                    </b-col>

                    <b-col cols="12" lg="2" class="mb-3 d-flex align-items-end">
                        <b-button 
                            size="sm" 
                            variant="success" 
                            @click="addNonInventoryItem"
                            :disabled="!canAddNonInventoryItem"
                            class="w-100 py-2 font-weight-bold"
                        >
                            <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
                            ADD ITEM
                        </b-button>
                    </b-col>
                </b-row>

            
                <div v-if="!canAddNonInventoryItem" class="mt-3 p-2 bg-light rounded small">
                    <div class="text-muted">
                        <b-icon-exclamation-circle class="mr-1 text-warning"></b-icon-exclamation-circle>
                        Please fill all required fields:
                    </div>
                    <ul class="mt-1 mb-0 pl-3">
                        <li v-if="!special_item.product_sku" class="text-danger">SKU is required</li>
                        <li v-if="!special_item.vendor" class="text-danger">Vendor is required</li>
                        <li v-if="!special_item.quantity || special_item.quantity <= 0" class="text-danger">Quantity must be greater than 0</li>
                        <li v-if="!special_item.selling_price || special_item.selling_price <= 0" class="text-danger">Price must be greater than 0</li>
                    </ul>
                </div>
            </b-card-body>
        </b-collapse>
    </template>

   
<template v-else>
    <div class="non-inventory-request-section">
        <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <div>
                <b-button 
                    variant="warning" 
                    size="sm"
                    @click="openNonInventoryRequestModal"
                    :disabled="asPendingNonInventoryRequest"
                    class="mr-2 mb-2"
                >
                    <b-icon-envelope class="mr-1"></b-icon-envelope>
                    {{ hasPendingNonInventoryRequest && pendingNonInventoryRequest.status === 'pending' ? 'REQUEST PENDING' : 'REQUEST NON-INVENTORY ITEM' }}
                </b-button>
                
                <b-badge 
                    v-if="hasPendingNonInventoryRequest && pendingNonInventoryRequest.status === 'pending'" 
                    variant="warning" 
                    pill
                    class="ml-2"
                >
                    <b-icon-clock-history class="mr-1"></b-icon-clock-history>
                    Awaiting Admin Approval
                </b-badge>
                
                <b-badge 
                    v-if="hasPendingNonInventoryRequest && pendingNonInventoryRequest.status === 'approved'" 
                    variant="success" 
                    pill
                    class="ml-2"
                >
                    <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                    Approved!
                </b-badge>
            </div>
            
            <div v-if="hasPendingNonInventoryRequest && pendingNonInventoryRequest.status === 'pending'" class="text-muted small">
                <b-icon-info-circle></b-icon-info-circle>
                An admin has been notified. You'll receive an update once approved.
            </div>
        </div>
        
    
  <div v-if="pendingNonInventoryRequest" class="pending-request-card mt-3">
    <b-card 
        :border-variant="pendingNonInventoryRequest.status === 'pending' ? 'warning' : 'success'"
        class="request-card shadow-sm"
        :class="pendingNonInventoryRequest.status === 'pending' ? 'card-pending' : 'card-approved'"
        no-body
    >
        
        <div class="request-card-header d-flex justify-content-between align-items-center p-3"
            :class="pendingNonInventoryRequest.status === 'pending' ? 'header-pending' : 'header-approved'"
        >
            <div class="d-flex align-items-center">
                <b-icon 
                    :icon="pendingNonInventoryRequest.status === 'pending' ? 'clock-history' : 'check-circle-fill'"
                    :variant="pendingNonInventoryRequest.status === 'pending' ? 'warning' : 'success'"
                    font-scale="1.5"
                    class="mr-2"
                ></b-icon>
                <h5 class="mb-0 font-weight-bold">
                    {{ pendingNonInventoryRequest.status === 'pending' ? 'Non-Inventory Item Request' : 'Request Approved!' }}
                </h5>
            </div>
            <b-badge 
                :variant="pendingNonInventoryRequest.status === 'pending' ? 'warning' : 'success'" 
                pill
                class="status-badge px-3 py-2"
            >
                <b-icon 
                    :icon="pendingNonInventoryRequest.status === 'pending' ? 'clock' : 'check'"
                    class="mr-1"
                ></b-icon>
                {{ pendingNonInventoryRequest.status === 'pending' ? 'PENDING' : 'APPROVED' }}
            </b-badge>
        </div>
        
     
        <b-card-body class="p-4">
            <div class="row">
              
                <div class="col-md-7">
                    <div class="request-details">
                     
                        <div v-if="pendingNonInventoryRequest.image_url" class="mb-3">
                            <span class="detail-label">Image</span>
                            <div class="mt-2">
                                <img 
                                    :src="pendingNonInventoryRequest.image_url" 
                                    style="max-width: 100px; max-height: 100px; border-radius: 8px; border: 1px solid #ddd; padding: 5px;"
                                    alt="Product image"
                                    @click="showFullImage(pendingNonInventoryRequest.image_url)"
                                    class="cursor-pointer"
                                />
                            </div>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">SKU</span>
                            <span class="detail-value"><strong>{{ pendingNonInventoryRequest.product_sku }}</strong></span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Vendor</span>
                            <span class="detail-value">
                                {{ getVendorName(pendingNonInventoryRequest.vendor) }}
                            </span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Quantity</span>
                            <span class="detail-value">
                                <b-badge variant="info" pill>{{ pendingNonInventoryRequest.quantity }}</b-badge>
                            </span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Price</span>
                            <span class="detail-value price-tag">
                                ${{ parseFloat(pendingNonInventoryRequest.selling_price).toFixed(2) }}
                            </span>
                        </div>
                        <div class="detail-row">
                            <span class="detail-label">Requested</span>
                            <span class="detail-value">{{ formatDate(pendingNonInventoryRequest.request_date) }}</span>
                        </div>
                        <div v-if="pendingNonInventoryRequest.status === 'approved'" class="detail-row approved-info">
                            <span class="detail-label">Approved By</span>
                            <span class="detail-value text-success">
                                <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                                {{ pendingNonInventoryRequest.approved_by || 'Admin' }}
                                <span v-if="pendingNonInventoryRequest.approved_date" class="text-muted small">
                                    on {{ formatDate(pendingNonInventoryRequest.approved_date) }}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                
           
                <div class="col-md-5">
                    <div class="status-section text-center h-100 d-flex flex-column justify-content-center align-items-center">
                        <div v-if="pendingNonInventoryRequest.status === 'pending'" class="status-indicator pending">
                            <b-icon-clock-history font-scale="3" variant="warning" class="mb-2"></b-icon-clock-history>
                            <h6 class="text-warning font-weight-bold">AWAITING APPROVAL</h6>
                            <p class="text-muted small mb-0">An admin has been notified. You'll receive an update once approved.</p>
                            <div class="spinner-container mt-3">
                                <b-spinner variant="warning" small class="mr-2"></b-spinner>
                                <span class="text-muted small">Waiting for admin response...</span>
                            </div>
                        </div>
                        
                        <div v-else class="status-indicator approved">
                            <b-icon-check-circle-fill font-scale="3" variant="success" class="mb-2"></b-icon-check-circle-fill>
                            <h6 class="text-success font-weight-bold">READY TO ADD</h6>
                            <p class="text-muted small mb-0">This item has been approved and is ready to be added to your sale.</p>
                            <div class="mt-3">
                                <b-button 
                                    variant="success"
                                    @click="addApprovedNonInventoryItem"
                                    class="add-to-sale-btn px-4"
                                    size="md"
                                >
                                    <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
                                    ADD TO SALE
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
          
            <div class="action-footer mt-3 pt-3 border-top">
                <div class="d-flex justify-content-end gap-2">
                    <b-button 
                        v-if="pendingNonInventoryRequest.status === 'pending'"
                        size="sm" 
                        variant="outline-danger"
                        @click="cancelNonInventoryRequest"
                        class="cancel-btn"
                    >
                        <b-icon-x-circle class="mr-1"></b-icon-x-circle>
                        Cancel Request
                    </b-button>
                    
                    <b-button 
                        v-if="pendingNonInventoryRequest.status === 'approved'"
                        size="sm" 
                        variant="outline-secondary"
                        @click="pendingNonInventoryRequest = null"
                    >
                        <b-icon-x class="mr-1"></b-icon-x>
                        Dismiss
                    </b-button>
                </div>
            </div>
        </b-card-body>
    </b-card>
</div>
    </div>
</template>
</b-card> -->

<!-- <b-card header="NON-INVENTORY ITEM" style="margin-top: 10px;" v-if="refund_items.length <= 0 && ['admin', 'officemanager', 'locationmanager','locationadmin'].includes(userDetails.userrole) && !hasDeliveredItems">
    <b-button 
        v-b-toggle.collapse-non-inventory 
        variant="info" 
        size="sm" 
        class="mb-2"
    >
        <b-icon-plus-circle class="mr-1"></b-icon-plus-circle>
        ADD NON-INVENTORY ITEM
    </b-button>

    <b-collapse id="collapse-non-inventory" class="mt-3">
        <b-card-body style="padding: 20px; background: #f8f9fa; border-radius: 8px;">
        
            <div class="non-inventory-section mb-4">
                <label class="form-label font-weight-bold mb-2">PRODUCT IMAGE</label>
                <div class="d-flex flex-wrap align-items-start gap-4">
                    <div class="image-upload-area mr-3 mb-3" style="width: 120px;">
                        <div class="position-relative">
                            <div v-if="nonInventoryImage.previewUrl" 
                                 class="image-preview-container text-center"
                                 style="width: 120px; height: 120px; border: 2px solid #dee2e6; border-radius: 8px; overflow: hidden; background: white;">
                                <img 
                                    :src="nonInventoryImage.previewUrl" 
                                    style="width: 100%; height: 100%; object-fit: contain;"
                                    alt="Product preview"
                                />
                                <b-button 
                                    v-if="nonInventoryImage.previewUrl"
                                    variant="danger" 
                                    size="sm" 
                                    class="remove-image-btn"
                                    style="position: absolute; top: -8px; right: -8px; width: 24px; height: 24px; padding: 0; border-radius: 50%;"
                                    @click="clearNonInventoryImage"
                                    title="Remove image"
                                >
                                    <b-icon-x font-scale="1.2"></b-icon-x>
                                </b-button>
                            </div>
                            <div v-else 
                                 class="upload-placeholder text-center p-3"
                                 style="width: 120px; height: 120px; border: 2px dashed #ced4da; border-radius: 8px; background: white; cursor: pointer;"
                                 @click="$refs.nonInventoryFileInput.click()">
                                <b-icon-camera font-scale="2.5" variant="secondary" class="mb-2"></b-icon-camera>
                                <div class="small text-muted">Click to upload</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="upload-controls flex-grow-1">
                        <div class="d-flex align-items-center mb-2">
                            <b-button 
                                variant="outline-primary" 
                                size="sm" 
                                @click="$refs.nonInventoryFileInput.click()"
                                :disabled="nonInventoryImage.uploading"
                                class="mr-2"
                            >
                                <b-icon-upload class="mr-1"></b-icon-upload>
                                Choose File
                            </b-button>
                            
                            <b-button 
                                variant="outline-success" 
                                size="sm" 
                                @click="openCamera"
                                :disabled="nonInventoryImage.uploading || !isCameraSupported"
                                class="mr-2"
                                title="Take photo with camera"
                            >
                                <b-icon-camera class="mr-1"></b-icon-camera>
                                Camera
                            </b-button>
                            
                            <b-spinner small v-if="nonInventoryImage.uploading" variant="primary"></b-spinner>
                        </div>
                        
                        <input 
                            ref="nonInventoryFileInput"
                            type="file" 
                            accept="image/*" 
                            style="display: none" 
                            @change="handleNonInventoryImageUpload"
                        />
                        
                        <input 
                            ref="cameraInput"
                            type="file" 
                            accept="image/*" 
                            capture="environment"
                            style="display: none" 
                            @change="handleNonInventoryImageUpload"
                        />
                        
                        <small class="text-muted d-block">
                            <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                            Max size: 5MB (JPG, PNG, GIF)
                        </small>
                        <small v-if="nonInventoryImage.uploadedUrl" class="text-success d-block mt-1">
                            <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                            Image ready for upload
                        </small>
                    </div>
                </div>
            </div>

       
            <b-row>
                <b-col cols="12" md="6" lg="3" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        CATEGORY <span class="text-danger">*</span>
                    </label>
                  <b-form-select 
                        :options="categoryOptions" 
                        v-model="nonInventoryItem.category_id" 
                        size="sm"
                        :state="nonInventoryItem.category_id ? null : false"
                        class="border-primary"
                        @change="onCategoryChange"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Select Category</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="12" md="6" lg="3" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        SKU <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        v-model="nonInventoryItem.product_sku" 
                        placeholder="Enter SKU"
                        :state="nonInventoryItem.product_sku ? null : false"
                        class="border-primary"
                    ></b-input>
                    <small class="text-muted">Unique identifier for item</small>
                </b-col>

                <b-col cols="12" md="6" lg="3" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        DESCRIPTION <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        v-model="nonInventoryItem.product_name" 
                        placeholder="Enter description"
                        :state="nonInventoryItem.product_name ? null : false"
                        class="border-primary"
                    ></b-input>
                </b-col>

                <b-col cols="12" md="6" lg="3" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        VENDOR <span class="text-danger">*</span>
                    </label>
                    <b-form-select 
                        :options="sortedVendors" 
                        v-model="nonInventoryItem.vendor" 
                        size="sm"
                        :state="nonInventoryItem.vendor ? null : false"
                        class="border-primary"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col cols="6" md="3" lg="2" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        QUANTITY <span class="text-danger">*</span>
                    </label>
                    <b-input 
                        size="sm" 
                        type="number" 
                        min="1" 
                        step="1"
                        v-model="nonInventoryItem.quantity"
                        :state="nonInventoryItem.quantity > 0 ? null : false"
                        class="border-primary"
                        placeholder="Qty"
                    ></b-input>
                </b-col>

                <b-col cols="6" md="3" lg="2" class="mb-3">
                    <label class="form-label font-weight-bold mb-1">
                        PRICE <span class="text-danger">*</span>
                    </label>
                    <b-input-group size="sm" prepend="$">
                        <b-input 
                            size="sm" 
                            type="number" 
                            min="0.01" 
                            step="0.01"
                            v-model="nonInventoryItem.selling_price"
                            :state="nonInventoryItem.selling_price > 0 ? null : false"
                            class="border-primary"
                            placeholder="0.00"
                        ></b-input>
                    </b-input-group>
                </b-col>

                <b-col cols="12" lg="2" class="mb-3 d-flex align-items-end">
                    <b-button 
                        size="sm" 
                        variant="success" 
                        @click="addNonInventoryItemToSale"
                        :disabled="!canAddNonInventoryItemToSale"
                        class="w-100 py-2 font-weight-bold"
                    >
                        <b-icon-plus-circle class="mr-2"></b-icon-plus-circle>
                        ADD ITEM
                    </b-button>
                </b-col>
            </b-row>

          
      
        </b-card-body>
    </b-collapse>
</b-card> -->

<!-- Non-Inventory Request Modal -->
<!-- Non-Inventory Request Modal -->
<!-- <b-modal 
    id="modal-request-non-inventory" 
    title="Request Non-Inventory Item" 
    size="lg" 
    hide-footer
    centered
    @hidden="resetRequestModal"
>
    <div class="request-modal-content">
        <b-alert show variant="info" class="mb-4">
            <b-icon-info-circle class="mr-2"></b-icon-info-circle>
            <strong>How it works:</strong> 
            Submit this request with an image and an admin will receive a notification with a link to approve it. 
            Once approved, the item will be automatically added to your sale.
        </b-alert>

        Image Upload Section
        <div class="image-upload-section mb-4">
            <label class="form-label font-weight-bold mb-2">
                PRODUCT IMAGE <span class="text-muted">(Recommended)</span>
            </label>
            <div class="d-flex flex-wrap align-items-start gap-3">
                Image Preview/Upload Area
                <div class="image-upload-area" style="width: 150px;">
                    <div class="position-relative">
                        <div v-if="requestItem.imagePreview" 
                             class="image-preview-container text-center"
                             style="width: 120px; height: 120px; border: 2px solid #dee2e6; border-radius: 12px; overflow: hidden; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"
                        >
                            <img 
                                :src="requestItem.imagePreview" 
                                style="width: 100%; height: 100%; object-fit: contain;"
                                alt="Product preview"
                            />
                            <b-button 
                                variant="danger" 
                                size="sm" 
                                class="remove-image-btn"
                                style="position: absolute; top: -8px; right: -8px; width: 28px; height: 28px; padding: 0; border-radius: 50%;"
                                @click="removeRequestImage"
                                title="Remove image"
                            >
                                <b-icon-x font-scale="1.2"></b-icon-x>
                            </b-button>
                        </div>
                        <div v-else 
                             class="upload-placeholder text-center p-3"
                             style="width: 120px; height: 120px; border: 2px dashed #ced4da; border-radius: 12px; background: #f8f9fa; cursor: pointer; transition: all 0.3s ease;"
                             @click="$refs.requestFileInput.click()"
                             @mouseenter="hovering = true"
                             @mouseleave="hovering = false"
                             :class="{'border-primary bg-light': hovering}"
                        >
                            <b-icon-image font-scale="3" variant="secondary" class="mb-2"></b-icon-image>
                            <div class="small text-muted">Click to upload</div>
                            
                        </div>
                    </div>
                </div>
                
                Upload Controls
                <div class="upload-controls flex-grow-1">
                    <div class="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <b-button 
                            variant="outline-primary" 
                            size="sm" 
                            @click="$refs.requestFileInput.click()"
                            :disabled="requestItem.imageUploading"
                            class="btn-upload"
                        >
                            <b-icon-upload class="mr-1"></b-icon-upload>
                            Choose File
                        </b-button>
                        
                        <b-button 
                            variant="outline-success" 
                            size="sm" 
                            @click="openRequestCamera"
                            :disabled="requestItem.imageUploading || !isCameraSupported"
                            class="btn-camera"
                            title="Take photo with camera"
                        >
                            <b-icon-camera class="mr-1"></b-icon-camera>
                            Take Photo
                        </b-button>
                        
                        <b-spinner small v-if="requestItem.imageUploading" variant="primary" class="ml-2"></b-spinner>
                        <span v-if="requestItem.imageUploading" class="text-muted small">Uploading...</span>
                    </div>
                    
                    Hidden file input for file upload
                    <input 
                        ref="requestFileInput"
                        type="file" 
                        accept="image/*" 
                        style="display: none" 
                        @change="handleRequestImageUpload"
                    />
                    
                    Hidden camera input (for mobile)
                    <input 
                        ref="requestCameraInput"
                        type="file" 
                        accept="image/*" 
                        capture="environment"
                        style="display: none" 
                        @change="handleRequestImageUpload"
                    />
                    
                    <div class="upload-info">
                        <small class="text-muted d-block">
                            <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                            Max size: 5MB • Supported formats: JPG, PNG, GIF
                        </small>
                        <small v-if="requestItem.imageUploaded" class="text-success d-block mt-1">
                            <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                            Image uploaded successfully
                        </small>
                        <small v-if="requestItem.imageError" class="text-danger d-block mt-1">
                            <b-icon-exclamation-circle class="mr-1"></b-icon-exclamation-circle>
                            {{ requestItem.imageError }}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <hr class="my-3">

        Form Fields
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <label class="form-label font-weight-bold mb-1">
                    SKU <span class="text-danger">*</span>
                </label>
                <b-input 
                    size="sm" 
                    v-model="requestItem.sku" 
                    placeholder="Enter SKU"
                    :state="requestItem.sku ? null : false"
                    class="border-warning"
                ></b-input>
                <small class="text-muted">Unique identifier for the item</small>
            </b-col>
            
            <b-col cols="12" md="6" class="mb-3">
                <label class="form-label font-weight-bold mb-1">
                    VENDOR <span class="text-danger">*</span>
                </label>
                <b-form-select 
                    :options="sortedVendors" 
                    v-model="requestItem.vendor" 
                    size="sm"
                    :state="requestItem.vendor ? null : false"
                    class="border-warning"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>Select Vendor</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="6" md="3" class="mb-3">
                <label class="form-label font-weight-bold mb-1">
                    QUANTITY <span class="text-danger">*</span>
                </label>
                <b-input 
                    size="sm" 
                    type="number" 
                    min="1" 
                    step="1"
                    v-model="requestItem.quantity"
                    :state="requestItem.quantity > 0 ? null : false"
                    class="border-warning"
                    placeholder="Qty"
                ></b-input>
            </b-col>

            <b-col cols="6" md="3" class="mb-3">
                <label class="form-label font-weight-bold mb-1">
                    PRICE <span class="text-danger">*</span>
                </label>
                <b-input-group size="sm" prepend="$">
                    <b-input 
                        size="sm" 
                        type="number" 
                        min="0.01" 
                        step="0.01"
                        v-model="requestItem.price"
                        :state="requestItem.price > 0 ? null : false"
                        class="border-warning"
                        placeholder="0.00"
                    ></b-input>
                </b-input-group>
            </b-col>
            
            <b-col cols="12" class="mb-3">
                <label class="form-label font-weight-bold mb-1">
                    NOTES <span class="text-muted">(Optional)</span>
                </label>
                <b-form-textarea
                    size="sm"
                    v-model="requestItem.notes"
                    placeholder="Any additional information for the admin (e.g., color, size, brand, special requirements)..."
                    rows="2"
                    class="border-warning"
                ></b-form-textarea>
            </b-col>
        </b-row>

        Validation Summary
        <div v-if="!canSubmitRequest" class="mt-3 p-3 bg-light rounded">
            <div class="text-muted small">
                <b-icon-exclamation-circle class="mr-1 text-warning"></b-icon-exclamation-circle>
                Please fill all required fields:
            </div>
            <ul class="mt-1 mb-0 pl-3">
                <li v-if="!requestItem.sku" class="text-danger">SKU is required</li>
                <li v-if="!requestItem.vendor" class="text-danger">Vendor is required</li>
                <li v-if="!requestItem.quantity || requestItem.quantity <= 0" class="text-danger">Quantity must be greater than 0</li>
                <li v-if="!requestItem.price || requestItem.price <= 0" class="text-danger">Price must be greater than 0</li>
            </ul>
        </div>

        Action Buttons
        <div class="d-flex justify-content-end mt-4 pt-3 border-top">
            <b-button 
                variant="secondary" 
                class="mr-2"
                @click="$bvModal.hide('modal-request-non-inventory')"
                :disabled="requestSubmitting"
            >
                Cancel
            </b-button>
            <b-button 
                variant="warning"
                @click="submitNonInventoryRequest"
                :disabled="!canSubmitRequest || requestSubmitting"
                class="px-2"
                size="sm"
            >
                <b-spinner small v-if="requestSubmitting"></b-spinner>
                <b-icon-envelope v-else class="mr-2"></b-icon-envelope>
                {{ requestSubmitting ? 'SENDING...' : 'SEND REQUEST TO ADMIN' }}
            </b-button>
        </div>
    </div>
</b-modal> -->
                        <b-card header="CHARGES" style="margin-top: 10px;">
                            <b-card-group v-if="invoice.edit == true" column>
                                <b-card>
                                    <div style="display: inline-block; margin: 3px;">
                                        Delivery
                                        <b-input size="sm" v-model="invoice.new_delivery_charges" style="width: 75px;"></b-input>
                                    </div>

                                    <div style="display: inline-block; margin: 3px;">
                                        Setup
                                        <b-input size="sm" v-model="invoice.new_setup_charges" style="width: 75px;"></b-input>
                                    </div>

                                    <div style="display: inline-block; margin: 3px;">
                                        Warranty
                                        <b-input size="sm" v-model="invoice.new_warranty_charges" style="width: 75px;"></b-input>
                                    </div>

                                </b-card>
                                <b-card>
                                <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Total Discnt: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                            {{ (getTotalDiscount()).toFixed(2) }}
                                        </div>
                                    </div>
                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Order Totl: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getOrderTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Totl Charges: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getChargesTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Subtotal: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getSubTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Taxable Subtotal: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ ( adjust_to_taxable_amount(getSubTotal())).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Sales Tax: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getSalesTax()).toFixed(2) }}
                                        </div>
                                    </div>
                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Special Discounts: </div>
                                        <div style="display: inline-block; background: #d4edda; padding: 3px; width: 150px; text-align: center; color: #155724;">
                                            {{ getTotalSpecialDiscounts().toFixed(2) }}
                                        </div>
                                    </div>


                                    <!-- <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Total: </div>
                                        <div style="display: inline-block; background: lightgreen; padding: 3px; width: 150px; text-align: center;">
                                            {{ (getSubTotal()  + getSalesTax()).toFixed(2) }}
                                        </div>
                                    </div> -->

                                <div style="display: block; margin-top: 3px;">
                                            <div style="display: inline-block; width: 150px;">Available Credit: </div>
                                            <div style="display: inline-block; background: #d4edda; padding: 3px; width: 150px; text-align: center; color: #155724;">
                                                {{ (getAvailableStoreCredit()).toFixed(2) }}
                                            </div>
                                        </div>

                                        <div style="display: block; margin-top: 3px;">
                                            <div style="display: inline-block; width: 150px;">Credit Applied: </div>
                                            <div style="display: inline-block; background: #e8f5e8; padding: 3px; width: 150px; text-align: center; color: green;">
                                                {{ (getStoreCreditApplied()).toFixed(2) }}
                                            </div>
                                        </div>

                                        <div style="display: block; margin-top: 3px;">
                                            <div style="display: inline-block; width: 150px;">Remaining Balance: </div>
                                            <div style="display: inline-block; background: #fff3cd; padding: 3px; width: 150px; text-align: center; color: #856404;">
                                                {{ (getRemainingStoreCredit()).toFixed(2) }}
                                            </div>
                                        </div>

                                        <div style="display: block; margin-top: 3px;">
                                            <div style="display: inline-block; width: 150px;">Grand Total: </div>
                                            <div style="display: inline-block; background: lightblue; padding: 3px; width: 150px; text-align: center;">
                                                {{ (getSubTotal()  + getSalesTax() - getStoreCreditApplied()).toFixed(2) }}
                                            </div>
                                        </div>

                                        <div style="display: block; margin-top: 3px;">
                                            <div style="display: inline-block; width: 150px;">Balance: </div>
                                            <div style="display: inline-block; background: lightyellow; padding: 3px; width: 150px; text-align: center;">
                                                {{ (getTotalBalanceWithCredit()).toFixed(2) }}
                                            </div>
                                        </div>


                                </b-card>
                            </b-card-group>

                            <b-card-group v-else-if="invoice.edit == false" column>
                                <b-card>
                                    <div style="display: inline-block; margin: 3px;">
                                        DELIVERY
                                        <b-input size="sm" v-model="invoice.delivery_charges" style="width: 75px;"></b-input>
                                    </div>

                                    <div style="display: inline-block; margin: 3px;">
                                        SETUP
                                        <b-input size="sm" v-model="invoice.setup_charges" style="width: 75px;"></b-input>
                                    </div>

                                    <div style="display: inline-block; margin: 3px;">
                                        WARRANTY
                                        <b-input size="sm" v-model="invoice.warranty_charges" style="width: 75px;"></b-input>
                                    </div>

                                    <div style="display: inline-block; margin: 3px; border: 1px solid; background: lightyellow; padding: 5px;">
                                        <div>LAYAWAY</div>
                                        <b-form-select size="sm" style="width: 75px;" :options="layaway_options" v-model="invoice.is_layaway" v-on:change="reset_pms_if_layaway"></b-form-select>
                                    </div>

                                </b-card>
                                <b-card>
                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Total Discnt: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getTotalDiscount()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Order Totl: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getOrderTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Totl Charges: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getChargesTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Subtotal: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getSubTotal()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Taxable Subtotal: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ ( adjust_to_taxable_amount(getSubTotal())).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Sales Tax: </div>
                                        <div style="display: inline-block; background: #efefef; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getSalesTax()).toFixed(2) }}
                                        </div>
                                    </div>
                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Special Discounts: </div>
                                        <div style="display: inline-block; background: #d4edda; padding: 3px; width: 150px; text-align: center; color: #155724;">
                                            {{ getTotalSpecialDiscounts().toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Grand Total: </div>
                                        <div style="display: inline-block; background: lightgreen; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getSubTotal()  + getSalesTax()).toFixed(2) }}
                                        </div>
                                    </div>

                                    <div style="display: block; margin-top: 3px;">
                                        <div style="display: inline-block; width: 150px;">Balance: </div>
                                        <div style="display: inline-block; background: lightyellow; padding: 3px; width: 150px; text-align: center;">
                                        {{ (getTotalBalance()).toFixed(2) }}
                                        </div>
                                    </div>


                                </b-card>
                            </b-card-group>
                        </b-card>

                        <!-- Add this near the bottom of your CHARGES card, before the PAYMENT INFORMATION card -->
                        <b-card v-if="!invoice.edit">
                            <div class="d-flex gap-2 flex-wrap">
                                <!-- Save Draft Button - ONLY SAVES, NO EMAIL -->
                                <b-button 
                                    variant="primary" 
                                    size="sm" 
                                    @click="saveDraftInvoice"
                                    :disabled="loading || !isPhoneNumberValid"
                                >
                                    <b-spinner small v-if="loading"></b-spinner>
                                    SAVE DRAFT INVOICE
                                </b-button>
                                
                                <!-- Send to Customer Button - SAVES AND SENDS EMAIL -->
                                <b-button 
                                    variant="info" 
                                    size="sm" 
                                    @click="sendDraftToCustomer"
                                    style="margin-left: 10px;"
                                    :disabled="loadingDraftSend || !isDraftSendEnabled"
                                >
                                    <b-spinner small v-if="loadingDraftSend"></b-spinner>
                                    
                                    SEND TO CUSTOMER
                                </b-button>
                            </div>
                            <small class="ml-2 text-muted d-block mt-2">
                                Save draft to complete later | Send to customer to share estimate
                            </small>
                        </b-card>
                            <!-- <b-card header="CHARGES" style="margin-top: 10px;">

  <div class="d-flex justify-content-end mb-3">
    <b-button
      variant="primary"
      size="sm"
      @click="openCustomerInfoModal"
      :disabled="invoice.items.length === 0"
    >
      <b-icon-person-check class="mr-1"></b-icon-person-check>
      CUSTOMER INFO & SIGNATURE
    </b-button>
  </div>


  <b-card-group v-if="invoice.edit == true" column>
  
  </b-card-group>

  <b-card-group v-else-if="invoice.edit == false" column>
  
  </b-card-group>
</b-card> -->
        <b-card 
    header="TERMS & CONDITIONS" 
    style="margin-top: 10px;" 

>
    <!-- Toggle Button for the entire card content -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <b-button 
            v-b-toggle.collapse-terms-full
            variant="outline-primary" 
            size="sm"
            :class="{'collapsed': !showTermsFull}"
        >
            <b-icon-chevron-down 
                :class="{'rotate-icon': showTermsFull}"
                style="transition: transform 0.2s; margin-right: 5px;"
            ></b-icon-chevron-down>
            {{ showTermsFull ? 'HIDE TERMS & CONDITIONS' : 'SHOW TERMS & CONDITIONS' }}
        </b-button>
        
        <!-- Language Toggle Buttons (always visible) -->
        <div class="btn-group btn-group-sm" role="group">
            <b-button 
                :variant="policyLanguage === 'en' ? 'primary' : 'outline-secondary'"
                @click="policyLanguage = 'en'"
                size="sm"
            >
                🇺🇸 English
            </b-button>
            <b-button 
                :variant="policyLanguage === 'es' ? 'primary' : 'outline-secondary'"
                @click="policyLanguage = 'es'"
                size="sm"
            >
                🇪🇸 Español
            </b-button>
        </div>
    </div>

    <!-- Collapsible wrapper for ALL content -->
    <b-collapse 
        id="collapse-terms-full" 
        v-model="showTermsFull"
        class="mt-2"
    >
        <!-- Policy Text Collapse (nested) -->
        <div class="mb-3">
            <b-button 
                v-b-toggle.collapse-policy 
                variant="link" 
                size="sm"
                class="p-0"
                style="text-decoration: none;"
            >
                <b-icon-chevron-right 
                    :class="{'rotate-90': showPolicy}"
                    style="transition: transform 0.2s; margin-right: 5px;"
                ></b-icon-chevron-right>
                {{ showPolicy ? (policyLanguage === 'es' ? 'OCULTAR POLÍTICA' : 'HIDE POLICY') : (policyLanguage === 'es' ? 'VER POLÍTICA' : 'VIEW POLICY') }}
            </b-button>
            
            <b-collapse id="collapse-policy" v-model="showPolicy" class="mt-2">
                <b-card-body style="padding: 15px; background: #f9f9f9; border-radius: 4px;">
                    <div v-html="currentPolicyText" class="policy-content"></div>
                </b-card-body>
            </b-collapse>
        </div>

        <!-- All Checkboxes -->
        <div class="mt-3" style="border-top: 1px solid #ddd; padding-top: 15px;">
            <!-- Terms & Conditions Checkbox - Bilingual -->
            <b-form-checkbox
                v-model="policyAgreed"
                size="md"
                class="mb-3"
            >
                <strong v-if="policyLanguage === 'es'">
                    He leído y acepto los Términos y Condiciones
                </strong>
                <strong v-else>
                    I have read and agree to the Terms & Conditions
                </strong>
            </b-form-checkbox>

            <!-- Customer Refused Warranties Checkbox -->
            <b-form-checkbox
                v-model="warrantyRefused"
                size="md"
                class="mb-3"
                :disabled="hasWarrantyCharges"
                :class="{'text-muted': hasWarrantyCharges}"
            >
                <strong v-if="policyLanguage === 'es'">
                    El cliente se negó a comprar garantías extendidas
                </strong>
                <strong v-else>
                    Customer refused to purchase extended warranties
                </strong>
                <small class="d-block text-muted" v-if="hasWarrantyCharges" v-html="policyLanguage === 'es' ? 
                    'Esta opción está deshabilitada porque los cargos de garantía (' + formatCurrency(getWarrantyTotal()) + ') están incluidos en esta venta' :
                    'This option is disabled because warranty charges (' + formatCurrency(getWarrantyTotal()) + ') are included in this sale'">
                </small>
                <small class="d-block text-muted" v-else v-html="policyLanguage === 'es' ?
                    'Marque esta casilla para confirmar que el cliente rechazó la cobertura de garantía' :
                    'Check this box to confirm customer declined warranty coverage'">
                </small>
            </b-form-checkbox>

            <!-- Delivery Waiver Checkbox -->
            <b-form-checkbox
                v-model="deliveryWaiverAgreed"
                size="md"
                class="mb-3"
            >
                <strong v-if="policyLanguage === 'es'">
                    Entiendo que la Entrega Estándar NO incluye la eliminación de cajas/embalajes.
                </strong>
                <strong v-else>
                    I understand that Standard Delivery does NOT include the removal of boxes/packaging.
                </strong>
            </b-form-checkbox>

            <!-- Space Preparation Checkbox -->
            <b-form-checkbox
                v-model="spacePreparationAgreed"
                size="md"
                class="mb-3"
            >
                <strong v-if="policyLanguage === 'es'">
                    Falla en la Preparación del Espacio: Si la habitación designada no está despejada y lista para la instalación al momento de la entrega, el equipo de entrega realizará solo una "Entrega sin instalación".
                </strong>
                <strong v-else>
                    Failure to Prepare Space: If the designated room is not cleared and ready for setup upon arrival, the delivery team will perform a "Drop-Off Delivery" only.
                </strong>
            </b-form-checkbox>

            <!-- Store Pickup Damage Waiver -->
            <b-form-checkbox
                v-if="hasStorePickupItem"
                v-model="deliveryDamageWaiverAgreed"
                size="md"
                class="mb-3"
            >
                <strong v-if="policyLanguage === 'es'">
                    Una vez que el mueble ha sido recogido y sale de la propiedad de la tienda, la tienda no se hace responsable de ningún daño que ocurra durante la carga, tránsito, descarga o montaje. Los clientes no pueden abrir ningún reclamo por daños físicos después de tomar posesión de los artículos.
                </strong>
                <strong v-else>
                    Once the furniture has been picked up and leaves the store property, the store is not responsible for any damages that occur during loading, transit, unloading, or assembly. Customers cannot open any claims for physical damage after taking possession of the items.
                </strong>
            </b-form-checkbox>

            <!-- Helper Text -->
            <small class="text-muted d-block mt-1" v-if="policyLanguage === 'es'">
                Debe aceptar los términos y condiciones para enviar esta venta
                <span v-if="!hasWarrantyCharges">y confirmar la negativa de garantía si corresponde</span>.
            </small>
            <small class="text-muted d-block mt-1" v-else>
                You must agree to the terms and conditions to submit this sale
                <span v-if="!hasWarrantyCharges">and confirm warranty refusal if applicable</span>.
            </small>
        </div>
    </b-collapse>
</b-card>

<div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;"  v-if="!invoice.edit && invoice.items.length > 0">
    <!-- Signature Button -->
    <b-button
        variant="outline-primary"
        size="sm"
        @click="openInvoiceSignatureModal"
        :disabled="invoice.has_signature"
        :title="invoice.has_signature ? 'Customer signature already captured' : 'Get customer signature'"
    >
        <span v-if="invoice.has_signature">✓ Customer Signed</span>
        <span v-else>✎ Customer Signature</span>
    </b-button>
</div>
                        <!--DONOT SHOW ANY PAYMENT INFORMATION FOR LAYAWAY INVOICES, EVEN WHEN THE INVOICE IS BEING EDITED.-->

                        <div >

                            <b-card header="PAYMENT INFORMATION *" style="margin-top: 10px;"  v-if="invoice.edit == true">

                                <b-alert style="padding: 2px;" show>PLEASE ADD NON-TAXABLE FORM OF PAYMENTS FIRST.</b-alert>
                                <div>
                                    <b-card-group columns>
                                        <b-card
                                            v-for="payment_method, pmidx in invoice.new_payment_methods"
                                            no-body
                                            style="max-width: 20rem;"
                                            border-variant="secondary"
                                            v-bind:key="payment_method.value"
                                        >
                                            <template v-slot:header>
                                                {{(payment_method.value || '').toUpperCase()}}
                                            </template>
                                            <b-card-body>
                                                <b-card-text>
                                                    <b-form-select
                                                        value-field="value"
                                                        text-field="text"
                                                        :options="new_payment_method_options"
                                                        v-model="invoice.new_payment_methods[pmidx].value"
                                                        size="sm"
                                                    ></b-form-select>
                                                </b-card-text>
                                            </b-card-body>

                                            <b-card-text>
                                                <!--CASH-->
                                                <b-list-group flush v-if="invoice.new_payment_methods[pmidx].value == 'cash'">
                                                    <b-list-group-item>
                                                        <div>Amount</div>
                                                        <div><b-input size="sm" type="number" v-model="invoice.new_payment_methods[pmidx].amount"></b-input></div>
                                                    </b-list-group-item>
                                                </b-list-group>

                                                <!--CC-->
                                                <b-list-group flush v-if="invoice.new_payment_methods[pmidx].value == 'cc'">
                                                    <b-list-group-item>
                                                        <div>Amount</div>
                                                        <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].amount" type="number"></b-input></div>
                                                    </b-list-group-item>

                                                    <b-list-group-item>
                                                        <div>Last 4 Digits</div>
                                                        <div><b-input size="sm"  v-model="invoice.new_payment_methods[pmidx].name"></b-input></div>
                                                    </b-list-group-item>
                                                </b-list-group>

                                                <!--FINANCE-->
                                            <b-list-group flush v-if="invoice.new_payment_methods[pmidx].value == 'finance'">
          <b-list-group-item>
        <div>Company</div>
        <b-form-select
            value-field="value"
            text-field="text"
            :options="finance_only_companies"
            v-model="invoice.new_payment_methods[pmidx].name"
            v-on:change="onFinanceCompanySelected(invoice.new_payment_methods[pmidx])"
            size="sm"
        >
            <template #first>
                <b-form-select-option :value="null" disabled>Select Finance Company</b-form-select-option>
            </template>
        </b-form-select>
    </b-list-group-item>




        <span v-if="invoice.new_payment_methods[pmidx].name != null">

            <b-list-group-item>
                <div>Approved Amount</div>
                <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].approved_amount" type="number" placeholder="Enter approved amount"></b-input></div>
            </b-list-group-item>

            <b-list-group-item>
                <div>Used Amount</div>
                <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].amount" type="number"></b-input></div>
            </b-list-group-item>



            <b-list-group-item>
                <div>Lease #</div>
                <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].lease_id"></b-input></div>
            </b-list-group-item>

            <b-list-group-item>
                <div>Misc Info</div>
                <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].misc_info"></b-input></div>
            </b-list-group-item>
        </span>
    </b-list-group>

    <!-- TAX EXEMPT - Fixed section for EDIT INVOICE payment methods -->
                <b-list-group flush v-if="invoice.new_payment_methods[pmidx].value == 'tax_exempt'">
                    <b-list-group-item>
                        <div>Tax Exempt Company</div>
                        <b-form-select
                            value-field="value"
                            text-field="text"
                            :options="tax_exempt_companies"
                            v-model="invoice.new_payment_methods[pmidx].name"
                            size="sm"
                            @change="checkTaxExemptPasswordRequirement(invoice.new_payment_methods[pmidx])"
                        >
                            <template #first>
                                <b-form-select-option :value="null" disabled>Select Tax Exempt Company</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-list-group-item>

                    <b-list-group-item v-if="invoice.new_payment_methods[pmidx].name">
                        <div>Amount</div>
                        <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].amount" type="number"></b-input></div>
                    </b-list-group-item>

                    <!-- Password Field for ALL Tax Exempt Companies -->
                    <b-list-group-item v-if="invoice.new_payment_methods[pmidx].name">
                        <div>PASSWORD <small class="text-muted">(Required for all tax exempt companies)</small></div>
                        <div>
                            <b-input
                                size="sm"
                                :type="invoice.new_payment_methods[pmidx].showPassword ? 'text' : 'password'"
                                v-model="invoice.new_payment_methods[pmidx].tax_exempt_password"
                                placeholder="Enter tax exempt company password"
                                :state="invoice.new_payment_methods[pmidx].passwordValid"
                                @blur="validateTaxExemptPassword(invoice.new_payment_methods[pmidx])"
                                :disabled="invoice.new_payment_methods[pmidx].passwordValid === true"
                            ></b-input>

                            <!-- Show Password Toggle -->
                            <div style="margin-top: 5px;">
                                <b-form-checkbox
                                    v-model="invoice.new_payment_methods[pmidx].showPassword"
                                    size="sm"
                                >
                                    Show password
                                </b-form-checkbox>
                            </div>

                            <b-form-invalid-feedback>
                                Invalid password for this tax exempt company
                            </b-form-invalid-feedback>
                            <b-form-valid-feedback>
                                Password validated successfully
                            </b-form-valid-feedback>
                        </div>
                    </b-list-group-item>

                    <b-list-group-item v-if="invoice.new_payment_methods[pmidx].name">
                        <div>Misc Info</div>
                        <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].misc_info" placeholder="Additional information"></b-input></div>
                    </b-list-group-item>
                </b-list-group>

                                                <!--SC-->
                                                <b-list-group flush v-if="invoice.new_payment_methods[pmidx].value == 'store_credit'">
                                                    <b-list-group-item>
                                                        <div>INVOICE #</div>
                                                        <div>
                                                            <b-input size="sm" placeholder="Enter Invoice ID" v-model="invoice.new_payment_methods[pmidx].store_credit_invoice_id"></b-input>

                                                            <b-button size="sm" style="margin-top: 10px;" variant="outline-primary" @click="apply_store_credit(pmidx)">GET REMAINING AMOUNT</b-button>
                                                        </div>
                                                    </b-list-group-item>

                                                    <div>
                                                        <b-list-group-item>
                                                            <div>AVAILABLE AMOUNT</div>
                                                            <div>
                                                                <b-input size="sm" v-model="invoice.new_payment_methods[pmidx].available_amount"
                                                                :disabled="true"
                                                            ></b-input>
                                                        </div>
                                                        </b-list-group-item>

                                                        <b-list-group-item v-if="invoice.new_payment_methods[pmidx].available_amount > 0">
                                                            <div>APPLY AMOUNT</div>
                                                            <div><b-input size="sm" v-model="invoice.new_payment_methods[pmidx].amount"
                                                            type="number"
                                                            ></b-input></div>
                                                            <sub>SHOULD BE LESS THAN AVAILABLE AMOUNT</sub>
                                                        </b-list-group-item>
                                                    </div>

                                                </b-list-group>
                                            </b-card-text>

                                            <b-card-text style="padding: 5px; text-align: center;">
                                                <b-button size="sm" variant="outline-danger" style="" @click="removePaymentMethod(pmidx)">Remove</b-button>
                                            </b-card-text>
                                        </b-card>
                                    </b-card-group>
                                </div>

                                <b-card-text>
                                    <b-button size="sm" variant="dark" @click="addPaymentMethod">Add Payment Method</b-button>
                                    <!-- <b-button size="sm" variant="info" @click="debugPaymentMethods" style="margin-left: 10px;">Debug Payment Methods</b-button> -->
                                </b-card-text>
                            </b-card>

                            <b-card header="PAYMENT INFORMATION" style="margin-top: 10px;"  v-if="invoice.edit != true">
                                <b-alert style="padding: 2px;" show>PLEASE ADD NON-TAXABLE FORM OF PAYMENTS FIRST.</b-alert>
                                <div>
                                    <b-card-group columns>
                                        <b-card
                                            v-for="payment_method, pmidx in invoice.payment_methods"
                                            no-body
                                            style="max-width: 20rem;"
                                            border-variant="secondary"
                                            v-bind:key="payment_method.value"
                                        >
                                            <template v-slot:header>
                                                {{(payment_method.value || '').toUpperCase()}}
                                            </template>
                                            <b-card-body>
                                                <b-card-text>
                                                    <b-form-select
                                                        value-field="value"
                                                        text-field="text"
                                                        :options="payment_method_options"
                                                        v-model="invoice.payment_methods[pmidx].value"
                                                        size="sm"
                                                    ></b-form-select>
                                                </b-card-text>
                                            </b-card-body>

                                            <b-card-text>
                                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'cash'">
                                                    <b-list-group-item>
                                                        <div>Amount</div>
                                                        <div><b-input size="sm" type="number" v-model="invoice.payment_methods[pmidx].amount"></b-input></div>
                                                    </b-list-group-item>
                                                </b-list-group>

                                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'cc'">
                                                    <b-list-group-item>
                                                        <div>Amount</div>
                                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount" type="number"></b-input></div>
                                                    </b-list-group-item>

                                                    <b-list-group-item>
                                                        <div>Last 4 Digits</div>
                                                        <div><b-input size="sm"  v-model="invoice.payment_methods[pmidx].name"></b-input></div>
                                                    </b-list-group-item>
                                                </b-list-group>

                                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'finance'">
                                                       <b-list-group-item>
        <div>Company</div>
        <b-form-select
            value-field="value"
            text-field="text"
            :options="finance_only_companies"
            v-model="invoice.payment_methods[pmidx].name"
            v-on:change="onFinanceCompanySelected(invoice.payment_methods[pmidx])"
            size="sm"
        >
            <template #first>
                <b-form-select-option :value="null" disabled>Select Finance Company</b-form-select-option>
            </template>
        </b-form-select>
    </b-list-group-item>


                                                    <span v-if="invoice.payment_methods[pmidx].name != null">

                                                    <b-list-group-item>
                                                        <div>Approved Amount</div>
                                                        <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].approved_amount" type="number" placeholder="Enter approved amount"></b-input></div>
                                                    </b-list-group-item>

                                                        <b-list-group-item>
                                                            <div>Used Amount</div>
                                                            <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount" type="number"></b-input></div>
                                                        </b-list-group-item>

                                                        <b-list-group-item>
                                                            <div>Lease #</div>
                                                            <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].lease_id"></b-input></div>
                                                        </b-list-group-item>

                                                        <b-list-group-item>
                                                            <div>Misc Info</div>
                                                            <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].misc_info"></b-input></div>
                                                        </b-list-group-item>
                                                    </span>
                                                </b-list-group>

                                                <!-- TAX EXEMPT - Fixed section for NEW INVOICE payment methods -->
                                             <!-- TAX EXEMPT - Fixed section for NEW INVOICE payment methods -->
                                        <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'tax_exempt'">
                                            <b-list-group-item>
                                                <div>Tax Exempt Company</div>
                                                <b-form-select
                                                    value-field="value"
                                                    text-field="text"
                                                    :options="tax_exempt_companies"
                                                    v-model="invoice.payment_methods[pmidx].name"
                                                    size="sm"
                                                    @change="checkTaxExemptPasswordRequirement(invoice.payment_methods[pmidx])"
                                                >
                                                    <template #first>
                                                        <b-form-select-option :value="null" disabled>Select Tax Exempt Company</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                            </b-list-group-item>

                                            <b-list-group-item v-if="invoice.payment_methods[pmidx].name">
                                                <div>Amount</div>
                                                <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount" type="number"></b-input></div>
                                            </b-list-group-item>

                                            <!-- Password Field for ALL Tax Exempt Companies -->
                                            <b-list-group-item v-if="invoice.payment_methods[pmidx].name">
                                                <div>PASSWORD <small class="text-muted">(Required for all tax exempt companies)</small></div>
                                                <div>
                                                    <b-input
                                                        size="sm"
                                                        :type="invoice.payment_methods[pmidx].showPassword ? 'text' : 'password'"
                                                        v-model="invoice.payment_methods[pmidx].tax_exempt_password"
                                                        placeholder="Enter tax exempt company password"
                                                        :state="invoice.payment_methods[pmidx].passwordValid"
                                                        @blur="validateTaxExemptPassword(invoice.payment_methods[pmidx])"
                                                        :disabled="invoice.payment_methods[pmidx].passwordValid === true"
                                                    ></b-input>

                                                    <!-- Show Password Toggle -->
                                                    <div style="margin-top: 5px;">
                                                        <b-form-checkbox
                                                            v-model="invoice.payment_methods[pmidx].showPassword"
                                                            size="sm"
                                                        >
                                                            Show password
                                                        </b-form-checkbox>
                                                    </div>

                                                    <b-form-invalid-feedback>
                                                        Invalid password for this tax exempt company
                                                    </b-form-invalid-feedback>
                                                    <b-form-valid-feedback>
                                                        Password validated successfully
                                                    </b-form-valid-feedback>
                                                </div>
                                            </b-list-group-item>

                                            <b-list-group-item v-if="invoice.payment_methods[pmidx].name">
                                                <div>Cheque#</div>
                                                <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].ein" placeholder="Enter Cheque number"></b-input></div>
                                            </b-list-group-item>

                                            <b-list-group-item v-if="invoice.payment_methods[pmidx].name">
                                                <div>Misc Info</div>
                                                <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].misc_info" placeholder="Additional information"></b-input></div>
                                            </b-list-group-item>
                                        </b-list-group>

                                                <b-list-group flush v-if="invoice.payment_methods[pmidx].value == 'store_credit'">
                                                    <b-list-group-item>
                                                        <div>Invoice #</div>
                                                        <div>
                                                            <b-input size="sm" placeholder="Enter Invoice ID" v-model="invoice.payment_methods[pmidx].store_credit_invoice_id"></b-input>

                                                            <b-button size="sm" style="margin-top: 10px;" variant="outline-primary" @click="apply_store_credit(pmidx)">GET REMAINING AMOUNT</b-button>
                                                        </div>
                                                    </b-list-group-item>

                                                    <div v-if="invoice.payment_methods[pmidx].available_amount">
                                                        <b-list-group-item>
                                                            <div>Available Amount</div>
                                                            <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].available_amount" :disabled="true"
                                                            ></b-input></div>
                                                        </b-list-group-item>

                                                        <b-list-group-item>
                                                            <div>Apply Amount</div>
                                                            <div><b-input size="sm" v-model="invoice.payment_methods[pmidx].amount" type="number"
                                                            ></b-input></div>
                                                            <sub>Should be less than available amount</sub>
                                                        </b-list-group-item>
                                                    </div>


                                                </b-list-group>
                                            </b-card-text>

                                            <b-card-text style="padding: 5px; text-align: center;">
                                                <b-button size="sm" variant="outline-danger" style="" @click="removePaymentMethod(pmidx)">Remove</b-button>
                                            </b-card-text>
                                        </b-card>

                                    </b-card-group>
                                </div>

                                <b-card-text>
                                    <b-button size="sm" variant="dark" @click="addPaymentMethod">Add Payment Method</b-button>
                                    <!-- <b-button size="sm" variant="info" @click="debugPaymentMethods" style="margin-left: 10px;">Debug Payment Methods</b-button> -->
                                </b-card-text>
                            </b-card>

         <b-card header="REFUND METHODS" style="margin-top: 10px;" v-if="invoice.edit" class="refund-methods-card">
    <!-- Alert Header with Summary -->
    <b-alert 
        show 
        variant="light" 
        class="refund-alert-header"
        style="padding: 16px; border-radius: 8px; border-left: 4px solid #ffc107;"
    >
        <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap: 15px;">
            <div class="d-flex align-items-center" style="gap: 20px;">
                <div class="text-center" style="min-width: 140px;">
                    <span class="text-muted small">STORE CREDIT REFUND AMOUNT</span>
                    <h3 class="mb-0" style="color: #28a745; font-weight: 600;">
                        ${{ getRemainingStoreCredit().toFixed(2) }}
                    </h3>
                </div>
                
                <div class="vr d-none d-md-block" style="height: 40px;"></div>
                
                <div>
                    <span class="text-muted small d-block">AVAILABLE BY PAYMENT METHOD</span>
                    <div class="d-flex flex-wrap gap-2 mt-1">
                        <div 
                            v-for="(amount, method) in available_refund_amounts" 
                            v-if="amount > 0"
                            :key="method"
                            class="payment-method-badge"
                            :class="`method-${method}`"
                        >
                            <span class="method-name">{{ method.toUpperCase() }}</span>
                            <span class="method-amount">${{ amount.toFixed(2) }}</span>
                        </div>
                        <div v-if="Object.keys(available_refund_amounts).filter(m => available_refund_amounts[m] > 0).length === 0" 
                             class="text-muted small">
                            No refund methods available
                        </div>
                    </div>
                </div>
            </div>
            
            <b-button 
                size="sm" 
                variant="outline-secondary"
                @click="refreshAvailableRefundAmounts"
                :disabled="!invoice.invoice_id"
                class="refresh-btn"
            >
                <b-icon-arrow-repeat class="mr-1"></b-icon-arrow-repeat>
                Refresh Limits
            </b-button>
        </div>
    </b-alert>

    <!-- Refund Methods Grid -->
    <div v-if="refund_methods.length > 0" class="refund-methods-grid">
        <b-card
            v-for="(refund_method, rmidx) in refund_methods"
            no-body
            class="refund-method-card"
            :class="[refund_method.value ? `method-${refund_method.value}` : 'method-pending']"
            v-bind:key="'refund-'+rmidx"
        >
            <!-- Card Header -->
            <div class="refund-method-header">
                <div class="header-left">
                    <b-icon-cash-stack v-if="refund_method.value === 'cash'" class="method-icon"></b-icon-cash-stack>
                    <b-icon-credit-card v-else-if="refund_method.value === 'cc'" class="method-icon"></b-icon-credit-card>
                    <b-icon-bank v-else-if="refund_method.value === 'finance'" class="method-icon"></b-icon-bank>
                    <b-icon-gift v-else-if="refund_method.value === 'store_credit'" class="method-icon"></b-icon-gift>
                    <b-icon-question-circle v-else class="method-icon"></b-icon-question-circle>
                    <h6 class="method-title mb-0">{{ (refund_method.value || 'Select Method').toUpperCase() }}</h6>
                </div>
                <b-button 
                    size="sm" 
                    variant="outline-danger" 
                    @click="removeRefundMethod(rmidx)"
                    class="remove-btn"
                    title="Remove refund method"
                >
                    <b-icon-x></b-icon-x>
                </b-button>
            </div>

            <!-- Card Body -->
            <div class="refund-method-body">
                <!-- Method Selection -->
                <div class="form-group">
                    <label class="form-label">Refund Method</label>
                    <b-form-select
                        :value="refund_method.value"
                        @input="val => { refund_method.value = val; updateRefundMethodDisplay(); }"
                        :options="[
                            { value: null, text: 'Select Refund Method', disabled: true },
                            ...getFilteredRefundMethodOptions().filter(opt => 
                                !refund_methods.some((rm, idx) => rm.value === opt.value && idx !== rmidx)
                            )
                        ]"
                        size="sm"
                        class="method-select"
                        :disabled="getFilteredRefundMethodOptions().length === 0"
                    >
                        <template #option="{ option }">
                            <div class="d-flex align-items-center">
                                <span class="method-option-dot" :class="`dot-${option.value}`"></span>
                                {{ option.text }}
                            </div>
                        </template>
                    </b-form-select>
                </div>

                <!-- Dynamic Fields Based on Method -->
                <template v-if="refund_method.value">
                    <!-- CASH REFUND -->
                    <template v-if="refund_method.value === 'cash'">
                        <div class="form-group">
                            <label class="form-label d-flex justify-content-between">
                                <span>Refund Amount</span>
                                <span class="available-badge">Available: ${{ getRemainingAmountForMethod('cash').toFixed(2) }}</span>
                            </label>
                            <b-input
                                size="sm"
                                type="number"
                                v-model="refund_method.amount"
                                :max="getRemainingAmountForMethod('cash')"
                                @input="validateRefundAmount(refund_method)"
                                :disabled="getRemainingAmountForMethod('cash') <= 0"
                                :state="refund_method.amount && !showRefundWarning(refund_method, 'cash')"
                                class="amount-input"
                            ></b-input>
                            <b-form-invalid-feedback :state="!showRefundWarning(refund_method, 'cash')">
                                Exceeds available cash refund amount (${{ getRemainingAmountForMethod('cash').toFixed(2) }})
                            </b-form-invalid-feedback>
                        </div>
                    </template>

                    <!-- CREDIT CARD REFUND -->
                    <template v-if="refund_method.value === 'cc'">
                        <div class="form-group">
                            <label class="form-label d-flex justify-content-between">
                                <span>Refund Amount</span>
                                <span class="available-badge">Available: ${{ getRemainingAmountForMethod('cc').toFixed(2) }}</span>
                            </label>
                            <b-input
                                size="sm"
                                type="number"
                                v-model="refund_method.amount"
                                :max="getRemainingAmountForMethod('cc')"
                                @input="validateRefundAmount(refund_method)"
                                :state="refund_method.amount && !showRefundWarning(refund_method, 'cc')"
                                class="amount-input"
                            ></b-input>
                            <b-form-invalid-feedback :state="!showRefundWarning(refund_method, 'cc')">
                                Exceeds available credit card refund amount
                            </b-form-invalid-feedback>
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Last 4 Digits</label>
                            <b-input
                                size="sm"
                                v-model="refund_method.name"
                                placeholder="Enter last 4 digits"
                                maxlength="4"
                                class="last4-input"
                            ></b-input>
                        </div>
                    </template>

                    <!-- FINANCE REFUND -->
                    <template v-if="refund_method.value === 'finance'">
                        <div class="form-group">
                            <label class="form-label d-flex justify-content-between">
                                <span>Refund Amount</span>
                                <span class="available-badge">Available: ${{ getRemainingAmountForMethod('finance').toFixed(2) }}</span>
                            </label>
                            <b-input
                                size="sm"
                                type="number"
                                v-model="refund_method.amount"
                                :max="getRemainingAmountForMethod('finance')"
                                @input="validateRefundAmount(refund_method)"
                                :state="refund_method.amount && !showRefundWarning(refund_method, 'finance')"
                                class="amount-input"
                            ></b-input>
                            <b-form-invalid-feedback :state="!showRefundWarning(refund_method, 'finance')">
                                Exceeds available finance refund amount
                            </b-form-invalid-feedback>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Finance Company</label>
                            <b-form-select
                                :options="finance_only_companies"
                                v-model="refund_method.name"
                                size="sm"
                                class="company-select"
                            >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>
                                        Select Finance Company
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div class="row g-2">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label">Lease #</label>
                                    <b-input size="sm" v-model="refund_method.lease_id" placeholder="Lease #"></b-input>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="form-label">Approved Amt</label>
                                    <b-input size="sm" type="number" v-model="refund_method.approved_amount" placeholder="Amount"></b-input>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Misc Info</label>
                            <b-input size="sm" v-model="refund_method.misc_info" placeholder="Additional info"></b-input>
                        </div>
                    </template>

                    <!-- STORE CREDIT REFUND -->
                    <template v-if="refund_method.value === 'store_credit'">
                        <div class="form-group">
                            <label class="form-label d-flex justify-content-between">
                                <span>Refund Amount</span>
                                <span class="available-badge">Available: ${{ getRemainingAmountForMethod('store_credit').toFixed(2) }}</span>
                            </label>
                            <b-input
                                size="sm"
                                type="number"
                                v-model="refund_method.amount"
                                :max="getRemainingAmountForMethod('store_credit')"
                                @input="validateRefundAmount(refund_method)"
                                :state="refund_method.amount && !showRefundWarning(refund_method, 'store_credit')"
                                class="amount-input"
                            ></b-input>
                            <b-form-invalid-feedback :state="!showRefundWarning(refund_method, 'store_credit')">
                                Exceeds available store credit
                            </b-form-invalid-feedback>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Notes (Optional)</label>
                            <b-input size="sm" v-model="refund_method.notes" placeholder="Add notes"></b-input>
                        </div>
                    </template>
                    <!-- TAX EXEMPT REFUND -->
<template v-if="refund_method.value === 'tax_exempt'">
    <div class="form-group">
        <label class="form-label d-flex justify-content-between">
            <span>Refund Amount</span>
            <span class="available-badge">Available: ${{ getRemainingAmountForMethod('tax_exempt').toFixed(2) }}</span>
        </label>
        <b-input
            size="sm"
            type="number"
            v-model="refund_method.amount"
            :max="getRemainingAmountForMethod('tax_exempt')"
            @input="validateRefundAmount(refund_method)"
            :state="refund_method.amount && !showRefundWarning(refund_method, 'tax_exempt')"
            class="amount-input"
        ></b-input>
        <b-form-invalid-feedback :state="!showRefundWarning(refund_method, 'tax_exempt')">
            Exceeds available tax exempt refund amount
        </b-form-invalid-feedback>
    </div>
    
    <div class="form-group">
        <label class="form-label">Company Name</label>
        <b-input
            size="sm"
            v-model="refund_method.name"
            placeholder="Enter tax exempt company name"
            class="last4-input"
        ></b-input>
    </div>
    
    <div class="form-group">
        <label class="form-label">EIN Number</label>
        <b-input
            size="sm"
            v-model="refund_method.ein"
            placeholder="Enter EIN number"
            class="last4-input"
        ></b-input>
    </div>
    
    <div class="form-group">
        <label class="form-label">Certificate Number</label>
        <b-input
            size="sm"
            v-model="refund_method.certificate"
            placeholder="Enter certificate number"
            class="last4-input"
        ></b-input>
    </div>
</template>
                </template>

                <!-- Summary for selected method -->
                <div v-if="refund_method.amount > 0" class="method-summary">
                    <small class="text-muted">Amount to refund:</small>
                    <strong class="summary-amount">${{ parseFloat(refund_method.amount).toFixed(2) }}</strong>
                </div>
            </div>
        </b-card>
    </div>

    <!-- Empty State -->
    <div v-else class="empty-state">
        <b-icon-cash-stack class="empty-icon"></b-icon-cash-stack>
        <h6>No Refund Methods Added</h6>
        <p class="text-muted small">Click the button below to add a refund method</p>
    </div>

    <!-- Actions -->
    <div class="refund-actions">
        <b-button 
            size="sm" 
            variant="outline-warning" 
            @click="addRefundMethod"
            class="add-method-btn"
        >
            <b-icon-plus class="mr-1"></b-icon-plus>
            Add Refund Method
        </b-button>
        
        <b-button
            size="sm"
            variant="success"
            @click="validateAndSubmitRefund"
            :disabled="!isRefundMethodsValid()"
            class="process-btn"
        >
            <b-icon-check-circle class="mr-1"></b-icon-check-circle>
            Process Refund
            <span v-if="getRemainingStoreCredit() > 0" class="btn-amount">
                (${{ getRemainingStoreCredit().toFixed(2) }})
            </span>
        </b-button>

        <!-- <b-button
        variant="info"
        size="sm"
        @click="printRefundReceipt"
        title="Print receipt and open cash drawer"
    >
        🖨️ PRINT REFUND RECEIPT
    </b-button> -->
    </div>

    <!-- Validation Summary -->
    <div v-if="refund_methods.length > 0 && !isRefundMethodsValid()" class="validation-summary">
        <b-icon-exclamation-triangle class="warning-icon"></b-icon-exclamation-triangle>
        <span class="small">
            Total allocated: ${{ refund_methods.reduce((sum, m) => sum + (parseFloat(m.amount) || 0), 0).toFixed(2) }} 
            (Required: ${{ getRemainingStoreCredit().toFixed(2) }})
        </span>
    </div>
</b-card>
                        </div>
                        <b-card  header="CUSTOMER IDENTIFICATION" style="margin-top:10px">
                             <div class= "">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <b-badge v-if="invoice.customer_id_card_url" variant="success" pill>
                <b-icon-check-circle></b-icon-check-circle> ID Uploaded
            </b-badge>
        </div>
        
        <!-- ID Card Type and Number Row -->
        <div class="row mb-3">
            <div class="col-md-4 mb-2 mb-md-0">
                <label class="small text-muted mb-1">ID Card Type</label>
                <b-form-select
                    v-model="invoice.customer_id_card_type"
                    :options="idCardOptions"
                    size="sm"
                    class="border-primary"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>Select ID Type</b-form-select-option>
                    </template>
                </b-form-select>
            </div>
            <div class="col-md-4">
                <label class="small text-muted mb-1">ID Card Number (Optional)</label>
                <b-input
                    size="sm"
                    v-model="invoice.customer_id_card_number"
                    placeholder="Enter ID number"
                    class="border-primary"
                ></b-input>
            </div>
        </div>
        
        <!-- ID Card Upload Area -->
        <div class="id-card-upload-area p-3 border rounded" style="background: #f8f9fa;">
            <div class="d-flex flex-wrap align-items-start gap-3">
                <!-- Preview Area -->
                <div class="upload-preview-container" style="width: 150px;">
                    <div v-if="getCustomerIdCardImage()" class="position-relative">
                        <div class="image-preview-card text-center p-2 bg-white rounded shadow-sm" 
                             style="cursor: pointer;"
                             @click="showFullIdCardImage()">
                            <img 
                                :src="getCustomerIdCardImage()"
                                style="max-width: 100%; max-height: 100px; object-fit: contain;"
                                alt="ID Card"
                            />
                            <div class="mt-1 small text-muted">Click to view</div>
                        </div>
                        <b-button 
                            variant="danger" 
                            size="sm" 
                            class="remove-id-btn"
                            style="position: absolute; top: -8px; right: -8px; width: 26px; height: 26px; padding: 0; border-radius: 50%;"
                            @click="removeIdCardImage"
                            title="Remove ID Card"
                        >
                            <b-icon-x font-scale="1"></b-icon-x>
                        </b-button>
                    </div>
                    
                    <!-- Upload Placeholder -->
                    <div v-else class="upload-placeholder text-center p-3 bg-white border rounded"
                         style="cursor: pointer;"
                         @click="$refs.idCardFileInput.click()">
                        <b-icon-card-image font-scale="2" class="mb-2 text-secondary"></b-icon-card-image>
                        <div class="small text-muted">Upload ID</div>
                        <div class="smaller text-muted">(Front)</div>
                    </div>
                </div>
                
                <!-- Upload Controls -->
                <div class="upload-controls flex-grow-1" style="margin-left: 10px;">
                    <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                        <b-button 
                            variant="outline-primary" 
                            size="sm" 
                            @click="$refs.idCardFileInput.click()"
                            :disabled="idCardUpload.uploading"
                            class="mr-2"
                        >
                            <b-icon-upload class="mr-1"></b-icon-upload>
                            Choose File
                        </b-button>
                        
                        <b-button 
                            variant="outline-success" 
                            size="sm" 
                            @click="openIdCardCamera"
                            :disabled="idCardUpload.uploading || !isCameraSupported"
                            title="Take photo with camera"
                        >
                            <b-icon-camera class="mr-1"></b-icon-camera>
                            Take Photo
                        </b-button>
                        
                        <b-spinner small v-if="idCardUpload.uploading" variant="primary"></b-spinner>
                    </div>
                    
                    <!-- Hidden file inputs -->
                    <input 
                        ref="idCardFileInput"
                        type="file" 
                        accept="image/*" 
                        style="display: none" 
                        @change="handleIdCardImageUpload"
                    />
                    
                    <input 
                        ref="idCardCameraInput"
                        type="file" 
                        accept="image/*" 
                        capture="environment"
                        style="display: none" 
                        @change="handleIdCardImageUpload"
                    />
                    
                    <small class="text-muted d-block">
                        <b-icon-info-circle class="mr-1" font-scale="0.9"></b-icon-info-circle>
                        Accepted: JPG, PNG (Max 5MB)
                    </small>
                    <small v-if="invoice.customer_id_card_url" class="text-success d-block mt-1">
                        <b-icon-check-circle class="mr-1"></b-icon-check-circle>
                        ID Card uploaded on {{ formatDate(invoice.customer_id_card_uploaded_at) }}
                    </small>
                </div>
            </div>
        </div>
    </div></b-card>

                        <b-card header="COMMENTS" style="margin-top: 10px;">
                            <b-form-textarea
                                v-model="invoice.comment_txt"
                                size="sm"
                                placeholder="COMMENTS (optional)"
                            ></b-form-textarea>
                   
  <!-- In your COMMENTS card, add this test button next to PRINT RECEIPT -->
<div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap;">
    <!-- Signature Button -->
    <!-- <b-button
        variant="outline-primary"
        size="sm"
        @click="openInvoiceSignatureModal"
        :disabled="invoice.has_signature"
        :title="invoice.has_signature ? 'Customer signature already captured' : 'Get customer signature'"
    >
        <span v-if="invoice.has_signature">✓ Customer Signed</span>
        <span v-else>✎ Customer Signature</span>
    </b-button> -->

    <!-- Print Receipt Button -->
    <!-- <b-button
        variant="info"
        size="sm"
        @click="printReceiptAndOpenDrawer"
        title="Print receipt and open cash drawer"
    >
        🖨️ PRINT RECEIPT
    </b-button>

    <b-button
    variant="warning"
    size="sm"
    @click="printExchangeReceipt"
    title="Test receipt generation"
>
    🧪 TEST RECEIPT
</b-button> -->

    <!-- TEST BUTTON - Add this for testing -->
    <!-- <b-button
        variant="warning"
        size="sm"
        @click="testCompleteFlow"
        title="Test printer and cash drawer"
    >
        🧪 TEST SYSTEM
    </b-button> -->

    <!-- Submit/Update Buttons -->
    <div v-if="!invoice.edit">
    <!-- <b-button  
    variant="info"
    size="sm"
    @click="testPdfGeneration"
    title="Test PDF generation without submitting sale"
    :disabled="invoice.items.length === 0"
>
    📄 TEST PDF GENERATION
</b-button> -->
        <b-button 
            variant="success" 
            size="sm" 
            @click="submitInvoice"
            :disabled="!isSubmitEnabled"
            :title="!policyAgreed ? 'You must agree to Terms & Conditions' : ''"
        >
            SUBMIT
        </b-button>
    </div>
    <div v-else>
        <b-button variant="success" size="sm" @click="handleUpdate">UPDATE</b-button>
    </div>
</div>
</b-card>

                        <b-modal id="modal-scanner" scrollable title="Scan Item" size="lg" hide-footer>
                            <SimpleScanner @scanCompleted="fetchScannedItem" />
                        </b-modal>
                    </div>
                </div>

                <!-- <div v-else>
                    <b-alert show variant="danger">THIS WAS A LAYAWAY INVOICE FOR WHICH A COMPLETE REFUND/RETURN HAS ALREADY BEEN COMPLETED. IT CANNOT BE MODIFIED.</b-alert>
                </div> -->
            </div>
        </div>

        <LoaderAnimation ref="loaderAnimation" />
        <SuccessAnimation 
    ref="successAnimation"
    :message="successMessage"
    :duration="2500"
/>
        </b-overlay>
        
    </template>

    <script>
        import moment from "moment"
        import global_vars from "@/utilities/global_vars"
        import Generic from "@/utilities/Generic"
        import Backer from "@/components/globals/Backer"
        import Requestor from "@/utilities/Requestor"
        import SimpleScanner from "@/components/importables/SimpleScanner"
        import Refundsummarysales from "@/components/importables/Refundsummarysales"
        import Deliveries from "@/components/importables/Deliveries"
        import SignaturePad from "@/components/importables/SignaturePad.vue";
        import QuaggaScanner from "@/components/importables/QuaggaScanner.vue";
        import DeliveryCalendar from '@/components/AdminTools/AdminToolsDeliveryCalendar.vue'
        import SuccessAnimation from "@/components/importables/SuccessAnimation.vue"
        import LoaderAnimation from "@/components/importables/LoaderAnimation.vue"
        // import flatPickr from 'vue-flatpickr-component';
        // import 'flatpickr/dist/flatpickr.css';

        import DatePicker from 'vue2-datepicker';
        import 'vue2-datepicker/index.css';

        import VuePhoneNumberInput from 'vue-phone-number-input';
        import 'vue-phone-number-input/dist/vue-phone-number-input.css';

        import VueSimpleSuggest from 'vue-simple-suggest'
        import 'vue-simple-suggest/dist/styles.css' // Optional CSS
    import { get } from "jquery"

        export default {
            name: "NewSale",
            props: ["viewdata"],
            components: {Backer, SimpleScanner, Deliveries, DatePicker, Refundsummarysales,VuePhoneNumberInput, VueSimpleSuggest,SignaturePad,  QuaggaScanner,DeliveryCalendar, SuccessAnimation, LoaderAnimation},
            data: function() {
                let out = {
                   policyText: '',
                   categories: [],
subcategories: [],
colorOptions: [{ value: null, text: 'Select Color' }],
sizeOptions: [{ value: null, text: 'Select Size' }],
//                    home_delivery_type_options: [
//     {value: 'inhouse', text: 'Inhouse'},
//     {value: 'thirdparty', text: 'Third Party'}
// ],
                   nonInventoryItem: {
    category_id: null,
    product_sku: null,
    product_name: null,
    vendor: null,
    quantity: null,
    selling_price: null,
    new_selling_price: null,
    discount_offered: 0.0,
    image_url: null
},
categories: [],
subcategories: [],
nonInventoryImage: {
    uploading: false,
    previewUrl: null,
    uploadedUrl: null
},
                      
           requestItem: {
            sku: null,
            vendor: null,
            quantity: null,
            price: null,
            notes: null,
            imagePreview: null,
            imageUploaded: false,
            imageUploading: false,
            imageError: null,
            imageData: null // Base64 image data
        },
         hovering: false,
        isCameraSupported: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
    
        requestSubmitting: false,
        pendingNonInventoryRequest: null,
        approvalCheckInterval: null,
                           searchCollapseOpen: true,  // Add this property
        hasSearched: false, 
        policyTextSpanish: '',
        showPolicy: false,
        policyLanguage: localStorage.getItem('policyLanguage') || 'en',
        policyAgreed: false,
        warrantyRefused: false,
                    isEditMode: false,
                      locationLoading: false,
                      floor_options: [
            { value: 'First Floor', text: 'First Floor' },
            { value: 'Second Floor', text: 'Second Floor' },
            { value: 'Third Floor', text: 'Third Floor' },
            { value: 'Fourth Floor', text: 'Fourth Floor' },
            { value: 'Other', text: 'Other' }
        ],
          idCardUpload: {
            uploading: false,
            previewUrl: null,
            uploadedUrl: null
        },
        
        idCardOptions: [
            { value: 'drivers_license', text: "Driver's License" },
            { value: 'state_id', text: "State ID" },
            { value: 'passport', text: "Passport" },
            { value: 'matricula', text: "Matricula Consular" },
            { value: 'other', text: "Other" }
        ],
        
        // Store the selected floor display value
        selected_floor_display: null,
              showSuccessAnimation: false,
        successMessage: '',
        
        // Store the numeric floor value
        selected_floor_number: null,
        
        // Show custom floor input when 'Other' is selected
        show_custom_floor: false,
        custom_floor_number: null,
        custom_floor_display: null,
           modalShowCustomFloor: false,
        modalCustomFloorDisplay: null,
        modalCustomFloorNumber: null,
        
                    loading: false,
                    is_as_is:false,
                    showTermsFull: false,
                    _loadingDraftSend: false,
                     deliveryWaiverAgreed: false,
        spacePreparationAgreed: false,
          barcodeInput: '',
        barcodeProcessing: false,
         scannerStream: null,
    scannerLoading: false,
    scannerError: null,
    currentCamera: 'environment',
        cameraActive: false,
cameraLoading: false,
cameraError: null,
capturedImage: null,
currentStream: null,
cameraFacing: 'environment', // 'environment' for back camera, 'user' for front
isCameraSupported: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
                        // Signature related data
                        nonInventoryImage: {
    uploading: false,
    previewUrl: null,
    uploadedUrl: null
},
     showSignatureModal: false,
    signatureItem: null,
    signatureUploading: false,
    signatureRequiredItems: [],
                    search_only_from_damages: false,
                     imageUpload: {
            uploading: false,
            currentItem: null,
            previewUrl: null
        },
        modalCustomer: {
      fullname: '',
      email: '',
      phone: '',
      phone_2: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: null,
      zipcode: '',
       floor_display: null,
    floor_custom: null,
    floor_number: null
    },
    modalPolicyLanguage: 'en',
    modalTermsAgreed: false,
    modalWarrantyRefused: false,
    deliveryDamageWaiverAgreed: false,
    signatureUploading: false,

                     currentFullSizeImage: null,
        currentProductName: null,
                    today_date: moment().format("MM-DD-YYYY"),
                    ts: moment().format("MM-DD-YYYY hh:MM A"),
                    global_vars: global_vars,
                    userDetails: {properties: {}},
                     original_payment_methods: [],
                     available_refund_amounts: {},// Store original payment methods from invoice
        used_refund_amounts: {},
                    packet: {},
                    items: [],
                    isDraft: false,
                    refund_methods: [],
                    payment_history: [],
            refund_method_options: [
                {value: "cash", text: "CASH"},
                  {value: "cc", text: "CREDIT CARD"},
                {value: "finance", text: "FINANCE"},
                {value: "tax_exempt", text: "TAX EXEMPT"},

            ],
                    refundsSummaryKey: 0,
                    refundsHistory: [],
                    searchitems: {
                        search_being_loaded: false,
                        keyword: null,
                        limit: 500,
                        result: [],
                        result2: [],
                    },
                  special_item: {
    product_id: null,
    product_sku: null,
    product_name: null,
    category_id: null,        // ← ADD THIS
    subcategory_id: null,     // ← ADD THIS
    color_id: null,           // ← ADD THIS
    size_id: null,            // ← ADD THIS
    quantity: null,
    selling_price: null,
    new_selling_price: null,
    discount_offered: 0.0,
    vendor: null,
},
specialSubcategories: [], 
                    allowed_states: [{'value': 'PA', 'text': 'PENNSYLVANIA'}, {'value': 'NJ', 'text': 'NEW JERSEY'}, {'value': 'DE', 'text': 'DELAWARE'}, {'value': 'AL', 'text': 'ALABAMA'}, {'value': 'AK', 'text': 'ALASKA'}, {'value': 'AS', 'text': 'AMERICAN SAMOA'}, {'value': 'AZ', 'text': 'ARIZONA'}, {'value': 'AR', 'text': 'ARKANSAS'}, {'value': 'CA', 'text': 'CALIFORNIA'}, {'value': 'CO', 'text': 'COLORADO'}, {'value': 'CT', 'text': 'CONNECTICUT'}, {'value': 'DC', 'text': 'DISTRICT OF COLUMBIA'}, {'value': 'FM', 'text': 'FEDERATED STATES OF MICRONESIA'}, {'value': 'FL', 'text': 'FLORIDA'}, {'value': 'GA', 'text': 'GEORGIA'}, {'value': 'GU', 'text': 'GUAM'}, {'value': 'HI', 'text': 'HAWAII'}, {'value': 'ID', 'text': 'IDAHO'}, {'value': 'IL', 'text': 'ILLINOIS'}, {'value': 'IN', 'text': 'INDIANA'}, {'value': 'IA', 'text': 'IOWA'}, {'value': 'KS', 'text': 'KANSAS'}, {'value': 'KY', 'text': 'KENTUCKY'}, {'value': 'LA', 'text': 'LOUISIANA'}, {'value': 'ME', 'text': 'MAINE'}, {'value': 'MH', 'text': 'MARSHALL ISLANDS'}, {'value': 'MD', 'text': 'MARYLAND'}, {'value': 'MA', 'text': 'MASSACHUSETTS'}, {'value': 'MI', 'text': 'MICHIGAN'}, {'value': 'MN', 'text': 'MINNESOTA'}, {'value': 'MS', 'text': 'MISSISSIPPI'}, {'value': 'MO', 'text': 'MISSOURI'}, {'value': 'MT', 'text': 'MONTANA'}, {'value': 'NE', 'text': 'NEBRASKA'}, {'value': 'NV', 'text': 'NEVADA'}, {'value': 'NH', 'text': 'NEW HAMPSHIRE'}, {'value': 'NM', 'text': 'NEW MEXICO'}, {'value': 'NY', 'text': 'NEW YORK'}, {'value': 'NC', 'text': 'NORTH CAROLINA'}, {'value': 'ND', 'text': 'NORTH DAKOTA'}, {'value': 'MP', 'text': 'NORTHERN MARIANA ISLANDS'}, {'value': 'OH', 'text': 'OHIO'}, {'value': 'OK', 'text': 'OKLAHOMA'}, {'value': 'OR', 'text': 'OREGON'}, {'value': 'PW', 'text': 'PALAU'}, , {'value': 'PR', 'text': 'PUERTO RICO'}, {'value': 'RI', 'text': 'RHODE ISLAND'}, {'value': 'SC', 'text': 'SOUTH CAROLINA'}, {'value': 'SD', 'text': 'SOUTH DAKOTA'}, {'value': 'TN', 'text': 'TENNESSEE'}, {'value': 'TX', 'text': 'TEXAS'}, {'value': 'UT', 'text': 'UTAH'}, {'value': 'VT', 'text': 'VERMONT'}, {'value': 'VI', 'text': 'VIRGIN ISLANDS'}, {'value': 'VA', 'text': 'VIRGINIA'}, {'value': 'WA', 'text': 'WASHINGTON'}, {'value': 'WV', 'text': 'WEST VIRGINIA'}, {'value': 'WI', 'text': 'WISCONSIN'}, {'value': 'WY', 'text': 'WYOMING'}
                    ],

                
                    order_types: [
                        {"value": "store_pickup", "text": "Store Pickup"},
                        {"value": "home_delivery", "text": "Home Delivery"},
                        {"value": "delivery_from_store", "text": "Delivery from Store"},  // NEW
                    ],
                    payment_method_options: [
                        {value: "cc", text: "CREDIT CARD"},
                        {value: "cash", text: "CASH"},
                        {value: "finance", text: "FINANCE"},
                        {value: "tax_exempt", text: "TAX EXEMPT"},
                        // {value: "store_credit", text: "STORE CREDIT"},
                    ],
                    new_payment_method_options: [
                        // {value: "store_credit", text: "STORE CREDIT"},
                        {value: "tax_exempt", text: "TAX EXEMPT"},
                        {value: "cc", text: "CREDIT CARD"},
                        {value: "cash", text: "CASH"},
                        {value: "finance", text: "FINANCE"},
                    ],
                    finance_companies: [],
                    finance_only_companies: [],
                    tax_exempt_companies: [],
                    all_loc_inventory_dict: {},
                    layaway_options: [
                        {value: false, text: "NO"},
                        {value: true, text: "YES"},
                    ],
                    scheduled_deliveries: [],
                    inventory_counts: {},
                    search_in_my_location: null,
                    sort_asc: false,
                    refund_items: [],
                    refund_charges: {
                        delivery_refunded_sofar: 0.0,
                        delivery_refunded_currently: 0.0,
                        setup_refunded_sofar: 0.0,
                        setup_refunded_currently: 0.0,
                        warranty_refunded_sofar: 0.0,
                        warranty_refunded_currently: 0.0,
                        tax_refunded_sofar: 0.0,
                        tax_refunded_currently: 0.0,
                        total_refunded_currently: 0.0,
                    },
                    current_refund_validated: false,
                    invoice: this.get_invoice_data(),
                    commonDeliveryDate: null

                }
                out.flatpickrConfig_a = {
                    dateFormat: "m-d-Y",
                    disable: [
                        function(date) {
                            return (date < moment().add(5,'days'))
                        }
                    ]
                }
                out.flatpickrConfig_b = {
                    dateFormat: "m-d-Y",
                    disable: [
                        function(date) {
                            return (date < moment().add(-1,'days'))
                        }
                    ]
                }

                out.zipcodes = [
                    {zip_code: "A", city: "AA", county: "AA", state: "AAAA"},
                    {zip_code: "B", city: "BB", county: "BBB", state: "BBBB"},

                ]

                out.refund_charges.delivery_refunded_sofar = out.invoice.total_refunded_delivery;
                out.refund_charges.setup_refunded_sofar = out.invoice.total_refunded_setup;
                out.refund_charges.warranty_refunded_sofar = out.invoice.total_refunded_warranty;
                out.refund_charges.tax_refunded_sofar = out.invoice.total_refunded_sales_tax;
                    if (out.invoice.items && out.invoice.items.length > 0) {
                            out.invoice.items.forEach(item => {
                                if (!item.hasOwnProperty('is_as_is')) {
                                    item.is_as_is = false;
                                }
                            });
                        }

                return out
            },
            watch: {
    policyLanguage(newVal) {
        localStorage.setItem('policyLanguage', newVal);
    },
      custom_floor_display() {
        this.updateCustomerFloorInfo();
    },
    custom_floor_number() {
        this.updateCustomerFloorInfo();
    },
    selected_floor_number() {
        this.updateCustomerFloorInfo();
    }
},
            computed: {
                 canAddNonInventoryItemToSale() {
        return (
            this.nonInventoryItem.category_id &&
            this.nonInventoryItem.product_sku &&
            this.nonInventoryItem.product_name &&
            this.nonInventoryItem.vendor &&
            this.nonInventoryItem.quantity > 0 &&
            this.nonInventoryItem.selling_price > 0
        );
    },
    
    // Format categories for select dropdown
categoryOptions() {
    // Check if categories exist
    if (!this.categories || !Array.isArray(this.categories) || this.categories.length === 0) {
        console.log("No categories available");
        return [];
    }
    
    // Map categories to the format expected by b-form-select
    const options = this.categories.map(cat => ({
        value: cat.category_id,
        text: cat.category_name || cat.category_code || 'Unnamed'
    }));
    
    console.log("Category options generated:", options);
    return options;
},
specialSubcategoryOptions() {
    if (!this.special_item.category_id) {
        return [{ value: null, text: 'Select Category First', disabled: true }];
    }
    const filteredSubcategories = this.subcategories.filter(subcat => 
        subcat.category_id == this.special_item.category_id
    );
    return [
        { value: null, text: 'Select Sub Category', disabled: true },
        ...filteredSubcategories.map(subcat => ({ 
            value: subcat.id, 
            text: subcat.subcategory || subcat.name || 'Unnamed' 
        }))
    ];
},
                 vendorName() {
        return (vendorId) => {
            if (!vendorId) return 'N/A';
            // Find vendor in the vendors list
            const vendor = this.packet.vendors.find(v => {
                // Check if vendor matches by value or id
                if (typeof vendor === 'object') {
                    return vendor.value == vendorId || vendor.id == vendorId;
                }
                return vendor == vendorId;
            });
            
            if (vendor) {
                return vendor.text || vendor.name || vendor.label || vendor;
            }
            return vendorId; // Fallback to showing the ID
        };
    },
                        isAdmin() {
            // Safely check if userDetails exists before accessing userrole
            if (this.userDetails && this.userDetails.userrole) {
                return ['admin'].includes(this.userDetails.userrole);
            }
            return false;
        },
                 canRequestNonInventoryItem() {
        return 
       
    },
    
    hasPendingNonInventoryRequest() {
        return this.pendingNonInventoryRequest !== null && 
               this.pendingNonInventoryRequest.status === 'pending';
    },
    
    canSubmitRequest() {
        return this.requestItem.sku &&
               this.requestItem.vendor &&
               this.requestItem.quantity > 0 &&
               this.requestItem.price > 0 &&
               !this.requestSubmitting;
    },
            isPaymentAmountValid() {
    const totalPayments = this.getTotalPayments();
    const grandTotal = this.getGrandTotal();
    
    // For layaway, allow payments to exceed grand total
    if (this.invoice.is_layaway) {
        return true;
    }
    
    // Add a small tolerance for floating-point precision issues (e.g., $0.01)
    const tolerance = 0.01;
    
    // For regular sales, payments should not exceed grand total (with tolerance)
    return totalPayments <= grandTotal + tolerance;
},
                  isDraftSendEnabled() {
        // Require at least one item and valid email
        return this.invoice.items.length > 0 && 
               this.isPhoneNumberValid && 
               this.invoice.customer.email && 
               this.invoice.customer.email.includes('@');
    },
    
    loadingDraftSend: {
        get() {
            return this._loadingDraftSend || false;
        },
        set(val) {
            this._loadingDraftSend = val;
        }
    },
             sortedVendors() {
        // Check if packet.vendors exists and is an array
        if (!this.packet.vendors || !Array.isArray(this.packet.vendors) || this.packet.vendors.length === 0) {
            return [];
        }
        
        // Helper function to get vendor text safely
        const getVendorText = (vendor) => {
            if (typeof vendor === 'string') return vendor;
            if (vendor && typeof vendor === 'object') {
                // Try different possible property names
                return vendor.text || vendor.name || vendor.label || vendor.value || '';
            }
            return '';
        };
        
        // Helper function to get vendor value safely (for select binding)
        const getVendorValue = (vendor) => {
            if (typeof vendor === 'string') return vendor;
            if (vendor && typeof vendor === 'object') {
                return vendor.value || vendor.id || vendor.text || vendor.name || '';
            }
            return '';
        };
        
        // Create a copy and transform if needed
        const vendors = [...this.packet.vendors];
        
        // Find the UNKNOWN vendor
        let unknownVendor = null;
        const otherVendors = vendors.filter(vendor => {
            const text = getVendorText(vendor);
            const isUnknown = text && text.toUpperCase() === 'UNKNOWN';
            if (isUnknown) {
                unknownVendor = vendor;
                return false;
            }
            return true;
        });
        
        // Sort other vendors alphabetically by their text
        otherVendors.sort((a, b) => {
            const textA = getVendorText(a).toUpperCase();
            const textB = getVendorText(b).toUpperCase();
            return textA.localeCompare(textB);
        });
        
        // Return UNKNOWN first (if found), then sorted vendors
        return unknownVendor ? [unknownVendor, ...otherVendors] : otherVendors;
    },
                 showLocationBreakdown() {
        return this.search_in_my_location === true;
    },
                  hasStorePickupItem() {
    // Check if any item (both existing and new) has order_type = 'store_pickup'
    return this.invoice.items.some(item => item.order_type === 'store_pickup');
  },
               currentPolicyText() {
        return this.policyLanguage === 'es' ? this.policyTextSpanish : this.policyText;
    },
      isPhoneNumberValid() {
    // Check if phone exists and has at least 10 digits
    const phone = this.invoice.customer.phone;
    if (!phone) return false;
    
    // Extract only digits from the phone number
    const digitsOnly = phone.replace(/\D/g, '');
    
    // Check if we have at least 10 digits
    return digitsOnly.length >= 10;
  },
            isSubmitEnabled() {
        // For new invoices, require policy agreement, signature, valid phone, and valid payments
        if (!this.invoice.edit) {
            const hasSignature = this.invoice.has_signature === true;
            
            // Check if phone is valid
            if (!this.isPhoneNumberValid) {
                return false;
            }
            
            // Check if payments exceed grand total
            if (!this.isPaymentAmountValid) {
                return false;
            }
            
            if (!this.hasWarrantyCharges) {
                return this.policyAgreed && this.warrantyRefused && hasSignature;
            }
            return this.policyAgreed && hasSignature;
        }
        return true;
    },
    hasWarrantyCharges() {
        return this.getWarrantyTotal() > 0;
    },
                 cachedFilteredRefundOptions() {
    // Re-run only when dependencies change
    let availableAmounts = this.calculateAvailableRefundAmounts();
    return this.refund_method_options.filter(method => {
      const methodType = method.value;
      const availableAmount = availableAmounts[methodType] || 0;
      return availableAmount > 0;
    });
  },
  
           hasDeliveredItems() {
    // Only check existing items, ignore new items
    return this.invoice.items.some(item => 
        item.existing && this.get_item_status(item) === 'delivered'
    );
},
                 hasAsIsItems() {
        return this.newItems.some(item => item.is_as_is);
    },
                  getItemSource() {
        return (item) => {
            // For new items, use the sourceContext
            if (item.sourceContext) {
                return item.sourceContext;
            }

            // For existing items, determine source based on available data
            if (item.existing) {
                // Check if item has location data that indicates it's from store
                if (item.locsub || item.source_location_id) {
                    return 'store';
                }
                // Default to warehouse for existing items without specific store location
                return 'warehouse';
            }

            // Default fallback
            return item.sourceContext || 'warehouse';
        };
    },
                   existingItems() {
        return this.invoice.items.filter(item => item.existing === true && this.show_item(item));
    },

    newItems() {
        return this.invoice.items.filter(item => item.existing !== true && this.show_item(item));
    },

    hasExistingItems() {
        return this.existingItems.length > 0;
    },

    hasNewItems() {
        return this.newItems.length > 0;
    },

                    filtered_order_types() {
                        const currentTypes = this.order_types;
                        // If user turned OFF 'Only in My Location'
                        if (!this.search_in_my_location) {
                            return currentTypes.filter(t => {
                                // Keep all except 'customer_takes', unless it's already selected in any line
                                return (
                                    t.value !== 'customer_takes' ||
                                    this.invoice.items.some(item => item.order_type === 'customer_takes')
                                );
                            });
                        }
                        return currentTypes;
                    }
                },

            methods: {
              validatePriceChange: function(item, event) {
    // Get the value from the input
    let newVal = event && event.target ? event.target.value : item.new_selling_price;
    
    // If empty, don't validate
    if (newVal === '' || newVal === null || newVal === undefined) {
        return true;
    }
    
    // Parse as float
    let enteredPrice = parseFloat(newVal);
    
    // If not a valid number, don't change
    if (isNaN(enteredPrice)) {
        return true;
    }
    
    // Get original price
    const originalPrice = parseFloat(item.selling_price) || 0;
    
    // Round to 2 decimal places
    enteredPrice = Math.round(enteredPrice * 100) / 100;
    
    // Check if price is being decreased
    if (enteredPrice < originalPrice) {
        item.new_selling_price = originalPrice;
        this.$bvToast.toast(
            `Price cannot be decreased. Original price: $${originalPrice.toFixed(2)}. Only increases are allowed.`,
            {title: "Price Restriction", autoHideDelay: 3000, variant: "warning"}
        );
        return false;
    }
    
    // Allow increase
    item.new_selling_price = enteredPrice;
    return true;
},

validateSpecialOrderPrice: function(item, newPrice) {
    const enteredPrice = parseFloat(newPrice) || 0;
    if (enteredPrice < 0) {
        item.selling_price = 0;
        this.$bvToast.toast(
            "Price cannot be negative.",
            {title: "Invalid Price", autoHideDelay: 2000, variant: "warning"}
        );
        return false;
    }
    return true;
},

// Add this method to properly set ship_locsub for delivery_from_store
setShipLocsubForDelivery: function(item) {
    // For delivery_from_store items, set ship_locsub based on locsub and drop_locsub
    if (item.order_type === 'delivery_from_store') {
        if (item.locsub && item.drop_locsub) {
            // If locsub equals drop_locsub, use drop_locsub, otherwise use a default shipping location
            if (item.locsub === item.drop_locsub) {
                item.ship_locsub = item.drop_locsub;
            } else {
                // Use a default shipping location (Mecca Shipping or store location)
                // You can customize this based on your business logic
                const defaultShipping = this.packet.locsubs.find(d => 
                    d.location_id === this.invoice.location_id && 
                    d.text.toLowerCase().includes('mecca shipping')
                );
                item.ship_locsub = defaultShipping ? defaultShipping.value : "47|130";
            }
        } else if (item.drop_locsub) {
            // If only drop_locsub is set, use it as ship_locsub
            item.ship_locsub = item.drop_locsub;
        } else {
            // Fallback - use a default location
            const defaultShipping = this.packet.locsubs.find(d => 
                d.location_id === this.invoice.location_id && 
                d.text.toLowerCase().includes('mecca shipping')
            );
            item.ship_locsub = defaultShipping ? defaultShipping.value : "47|130";
        }
        console.log(`Set ship_locsub for ${item.product_sku}: ${item.ship_locsub}`);
    }
},
validateDeliveryFromStoreLocations: function() {
    // Get all items that have delivery_from_store order type
    const deliveryItems = this.invoice.items.filter(item => 
        item.order_type === 'delivery_from_store' && 
        !item.existing
    );
    
    let hasError = false;
    
    deliveryItems.forEach(item => {
        // Get available delivery locations
        const locations = this.getDeliveryLocations(item);
        
        // Check if current drop_locsub is valid or null
        if (!item.drop_locsub || !locations.some(loc => loc.value === item.drop_locsub)) {
            // Auto-assign the first available location
            if (locations.length > 0) {
                item.drop_locsub = locations[0].value;
                console.log(`Auto-assigned drop_locsub for ${item.product_sku}: ${item.drop_locsub}`);
            } else {
                hasError = true;
                this.$bvToast.toast(
                    `No delivery locations available for ${item.product_sku}. Please check your store configuration.`,
                    {title: "Error", autoHideDelay: 3000, variant: "warning"}
                );
            }
        }
        
        // ✅ CRITICAL: Set ship_locsub after drop_locsub is set
        this.setShipLocsubForDelivery(item);
    });
    
    return !hasError;
},

                onSpecialCategoryChange(categoryId) {
    if (categoryId) {
        this.special_item.subcategory_id = null;
        // Subcategories are already loaded from your existing fetchSubcategories
    }
},


getDeliveryLocations: function(item) {
    const onlyLoc = this.search_in_my_location;
    const sourceContext = item.sourceContext;

    // Filter out floor locations (sublocation_type_id = 1) AND damage locations
    const nonFloorNonDamageLocations = this.packet.locsubs.filter(d => 
        d.sublocation_type_id !== 1 &&
        !this.isDamageLocation(d)
    );

    // For HOME DELIVERY - ONLY show Mecca Shipping Customer Deliveries
    if (item.order_type === 'home_delivery') {
        const meccaCustomerDeliveries = nonFloorNonDamageLocations.filter(d => {
            const text = d.text.toLowerCase();
            return text.includes('customer') && 
                   text.includes('deliveries') &&
                   (text.includes('mecca shipping') || text.includes('mecca delivery'));
        });
        
        console.log(`Home Delivery: Found ${meccaCustomerDeliveries.length} Mecca Customer Deliveries locations`);
        return meccaCustomerDeliveries;
    }

    // For STORE DELIVERY - Show Mecca Shipping Customer Deliveries + Store Locations
    if (item.order_type === 'delivery_from_store') {
        // Get Mecca Shipping Customer Deliveries locations
        const meccaCustomerDeliveries = nonFloorNonDamageLocations.filter(d => {
            const text = d.text.toLowerCase();
            return text.includes('customer') && 
                   text.includes('deliveries') &&
                   (text.includes('mecca shipping') || text.includes('mecca delivery'));
        });
        
        // Get Store Stock locations (non-floor, non-damage locations at the store)
        const storeStockLocations = nonFloorNonDamageLocations.filter(d => {
            const isCurrentStore = d.location_id === this.invoice.location_id;
            const isMeccaShipping = d.text.toLowerCase().includes('mecca shipping') ||
                                   d.text.toLowerCase().includes('mecca delivery');
            return isCurrentStore && !isMeccaShipping;
        });
        
        // Combine both sets
        let allLocations = [...meccaCustomerDeliveries];
        
        // Add store stock locations that aren't already included
        storeStockLocations.forEach(loc => {
            if (!allLocations.some(existing => existing.value === loc.value)) {
                allLocations.push(loc);
            }
        });
        
        // ✅ FIX: If no locations found, return ALL non-floor, non-damage locations as fallback
        if (allLocations.length === 0) {
            console.warn('No delivery locations found for delivery_from_store. Falling back to all available locations.');
            allLocations = nonFloorNonDamageLocations.filter(d => 
                d.location_id === this.invoice.location_id
            );
        }
        
        console.log(`Delivery from Store: Found ${meccaCustomerDeliveries.length} Mecca Customer Deliveries + ${storeStockLocations.length} Store Stock = ${allLocations.length} total`);
        return allLocations;
    }

    // Default - return non-floor, non-damage locations for current store
    return nonFloorNonDamageLocations.filter(d => 
        d.location_id === this.invoice.location_id
    );
},
// Get fulfill locations based on order type
getFulfillLocations: function(item) {
    const onlyLoc = this.search_in_my_location;
    const sourceContext = item.sourceContext;
    // ✅ Check if the item is damaged or as-is
    const isDamagedItem = item.is_damaged || item.is_as_is;

    // If user has turned OFF "only in my location"
    if (!onlyLoc) {
        if (item.locsub) {
            const existingLocation = this.packet.locsubs.find(d => d.value === item.locsub);
            // ✅ For damaged items, allow damage locations; for normal, exclude them
            if (existingLocation) {
                if (isDamagedItem) {
                    // For damaged items: allow any location
                    return [existingLocation];
                } else {
                    // For normal items: exclude damage locations
                    if (this.isDamageLocation(existingLocation)) {
                        return [];
                    }
                    return [existingLocation];
                }
            }
            return [];
        }
        return [];
    }

    // ✅ Get base locations based on item type
    let baseLocations = [];
    
    if (isDamagedItem) {
        // ✅ FOR DAMAGED ITEMS: Get ALL non-floor locations (including damage)
        baseLocations = this.packet.locsubs.filter(d => 
            d.location_id === this.invoice.location_id &&
            d.sublocation_type_id !== 1
        );
        
        // Separate damage and regular locations
        const damageLocations = baseLocations.filter(d => this.isDamageLocation(d));
        const regularLocations = baseLocations.filter(d => !this.isDamageLocation(d));
        
        // ✅ For Home Delivery with damaged items: Show damage locations FIRST
        if (item.order_type === 'home_delivery') {
            // Get Mecca Shipping locations (for regular delivery)
            const meccaShippingLocations = baseLocations.filter(d => {
                const text = d.text.toLowerCase();
                return text.includes('mecca shipping') || text.includes('mecca delivery');
            });
            
            // Get damage locations that are NOT Mecca Shipping
            const damageNotMecca = damageLocations.filter(d => {
                const text = d.text.toLowerCase();
                return !text.includes('mecca shipping') && !text.includes('mecca delivery');
            });
            
            // Combine: Damage locations FIRST, then Mecca Shipping
            let result = [...damageNotMecca];
            
            // Add Mecca Shipping locations that aren't already included
            meccaShippingLocations.forEach(loc => {
                if (!result.some(existing => existing.value === loc.value)) {
                    result.push(loc);
                }
            });
            
            // If no damage locations, show all Mecca Shipping
            if (result.length === 0) {
                result = meccaShippingLocations.length > 0 ? meccaShippingLocations : baseLocations;
            }
            
            return result;
        }
        
        // For other order types with damaged items: Show damage locations FIRST
        const result = [...damageLocations];
        regularLocations.forEach(loc => {
            if (!result.some(existing => existing.value === loc.value)) {
                result.push(loc);
            }
        });
        
        return result.length > 0 ? result : baseLocations;
        
    } else {
        // ✅ FOR NORMAL ITEMS: Only show regular locations (exclude damage)
        baseLocations = this.packet.locsubs.filter(d => 
            d.location_id === this.invoice.location_id &&
            d.sublocation_type_id !== 1 &&
            !this.isDamageLocation(d)
        );
    }

    // For HOME DELIVERY with normal items - only show Mecca Shipping locations
    if (item.order_type === 'home_delivery') {
        const meccaShippingLocations = baseLocations.filter(d => {
            const text = d.text.toLowerCase();
            return text.includes('mecca shipping') || text.includes('mecca delivery');
        });
        
        if (meccaShippingLocations.length === 0) {
            // Fallback to all stock locations
            return baseLocations;
        }
        
        return meccaShippingLocations;
    }

    // For STORE DELIVERY - show all stock locations
    if (item.order_type === 'delivery_from_store') {
        return baseLocations;
    }

    // Default - show all stock locations
    return baseLocations;
},

// Handle home_delivery_type change
onHomeDeliveryTypeChange: function(item) {
    // Clear previously selected locations when delivery type changes
    if (item.order_type === 'home_delivery') {
        // Reset drop_locsub and locsub when type changes
        // This ensures user selects new locations based on the new type
        if (item.drop_locsub) {
            // Check if the current drop_locsub is still valid for the new type
            const validLocations = this.getDeliveryLocations(item);
            const isValid = validLocations.some(loc => loc.value === item.drop_locsub);
            if (!isValid) {
                item.drop_locsub = null;
            }
        }
        
        if (item.locsub) {
            const validLocations = this.getFulfillLocations(item);
            const isValid = validLocations.some(loc => loc.value === item.locsub);
            if (!isValid) {
                item.locsub = null;
            }
        }
    }
},
  fetchAllHierarchyOptions: function(categoryId = null) {
        let path = "/api/product/get_hierarchy_options/";
        let data = categoryId ? { category_id: categoryId } : {};
        let that = this;
        
        let s = function(response) {
            if (response.data && !response.data.error && response.data.result) {
                const options = response.data.result;
                
                // Load color options
                that.colorOptions = [
                    { value: null, text: 'Select Color' },
                    ...(options.colors || []).map(color => ({ 
                        value: color.id, 
                        text: color.color_name || color.name || 'Unknown' 
                    }))
                ];
                
                // Load size options
                that.sizeOptions = [
                    { value: null, text: 'Select Size' },
                    ...(options.sizes || []).map(size => ({ 
                        value: size.id, 
                        text: size.size_name || size.name || 'Unknown' 
                    }))
                ];
                
                // Also load subcategories if needed
                that.subcategories = options.subcategories || [];
                
                console.log("Color options loaded:", that.colorOptions);
                console.log("Size options loaded:", that.sizeOptions);
                console.log("Subcategories loaded:", that.subcategories);
                
            } else {
                // If API fails, use empty defaults
                that.colorOptions = [{ value: null, text: 'Select Color' }];
                that.sizeOptions = [{ value: null, text: 'Select Size' }];
                that.$bvToast.toast(
                    "Error loading color/size options",
                    {title: "Warning", autoHideDelay: 1500, variant: "warning"}
                );
            }
        };
        
        let f = function(error) {
            console.error("Error loading hierarchy options:", error);
            that.colorOptions = [{ value: null, text: 'Select Color' }];
            that.sizeOptions = [{ value: null, text: 'Select Size' }];
        };
        
        Requestor.getSyncP(path, data, this, s, f);
    },
             fetchCategories: function() {
        let that = this;
        let path = "/api/category/get_all_categories/";
        let data = {};
        
        let s = function(response) {
            if (response.data && !response.data.error) {
                if (response.data.result && Array.isArray(response.data.result)) {
                    that.categories = response.data.result;
                    console.log("Categories loaded:", that.categories);
                    
                    // After categories load, fetch hierarchy options
                    that.fetchAllHierarchyOptions();
                } 
                else if (Array.isArray(response.data)) {
                    that.categories = response.data;
                    that.fetchAllHierarchyOptions();
                }
                else if (response.data.categories) {
                    that.categories = response.data.categories;
                    that.fetchAllHierarchyOptions();
                }
            } else {
                that.$bvToast.toast(
                    response.data.error || "Error loading categories",
                    {title: "Error", autoHideDelay: 1500, variant: "warning"}
                );
            }
        };
        
        let f = function(error) {
            console.error("Error loading categories:", error);
            that.$bvToast.toast(
                "Error loading categories. Please check console for details.",
                {title: "Error", autoHideDelay: 1500, variant: "warning"}
            );
        };
        
        Requestor.getSyncP(path, data, this, s, f);
    },
    fetchSubcategories: function(categoryId = null) {
    let that = this;
    let path = "/api/product/get_subcategories/";
    let data = categoryId ? { category_id: categoryId } : {};
    
    let s = function(response) {
        if (response.data && !response.data.error) {
            that.subcategories = response.data.result || [];
            console.log("Subcategories loaded:", that.subcategories);
        } else {
            that.$bvToast.toast(
                response.data.error || "Error loading subcategories",
                {title: "Error", autoHideDelay: 1500, variant: "warning"}
            );
        }
    };
    
    let f = function(error) {
        console.error("Error loading subcategories:", error);
    };
    
    Requestor.getSyncP(path, data, this, s, f);
},
    
    // Handle category change (if you need subcategories)
    onCategoryChange: function(categoryId) {
        if (categoryId) {
            this.fetchSubcategories(categoryId);
        }
    },
    
    // Fetch subcategories for a category
    fetchSubcategories: function(categoryId) {
        let that = this;
        let path = "/api/product/get_subcategories/";
        let data = { category_id: categoryId };
        
        let s = function(response) {
            if (response.data && !response.data.error) {
                that.subcategories = response.data.result || [];
                console.log("Subcategories loaded:", that.subcategories);
            } else {
                that.$bvToast.toast(
                    response.data.error || "Error loading subcategories",
                    {title: "Error", autoHideDelay: 1500, variant: "warning"}
                );
            }
        };
        
        let f = function(error) {
            console.error("Error loading subcategories:", error);
        };
        
        Requestor.postSyncP(path, data, this, s, f);
    },
    
    // Add non-inventory item to sale with flag
  addNonInventoryItemToSale: function() {
    if (!this.canAddNonInventoryItemToSale) return;
    
    const selectedCategory = this.categories.find(c => c.category_id === this.nonInventoryItem.category_id);
    const categoryName = selectedCategory ? selectedCategory.category_name : this.nonInventoryItem.category_id;
    
    // Get the vendor name as a string
    const vendorName = this.getVendorName(this.nonInventoryItem.vendor);
    
    const itemToAdd = {
        product_id: null,
        product_sku: this.nonInventoryItem.product_sku,
        product_name: this.nonInventoryItem.product_name,
        product_category: this.nonInventoryItem.category_id,
        product_category_name: categoryName,
        vendor: vendorName,  // ✅ CHANGE: Pass the vendor name as a string, not the ID
        quantity: parseInt(this.nonInventoryItem.quantity),
        selling_price: parseFloat(this.nonInventoryItem.selling_price),
        new_selling_price: parseFloat(this.nonInventoryItem.selling_price),
        discount_offered: 0.0,
        is_special: false,  // ✅ false for non-inventory
        is_non_inventory: true,
        sourceContext: 'store',
        source: 'store',
        image_url: this.nonInventoryImage.uploadedUrl || null,
        order_type: 'customer_takes',
        delivery_date: moment().format("MM-DD-YYYY"),
        existing: false,
        quantity_per_box: 1,
        non_inventory_metadata: {
            category_id: this.nonInventoryItem.category_id,
            category_name: categoryName,
            added_by: this.userDetails.username,
            added_at: new Date().toISOString(),
            vendor_name: vendorName  // Use the same vendor name
        }
    };
    
    this.addProduct(itemToAdd);
    this.resetNonInventoryForm();
    this.$root.$emit('bv::toggle::collapse', 'collapse-non-inventory');
    
    this.$bvToast.toast(
        `Non-inventory item ${itemToAdd.product_sku} added to sale!`,
        {title: "Success", autoHideDelay: 2000, variant: "success"}
    );
},
    
    // Reset non-inventory form
 resetNonInventoryForm() {
    this.special_item = {
        product_id: null,
        product_sku: null,
        product_name: null,
        category_id: null,
        subcategory_id: null,
        color_id: null,
        size_id: null,
        quantity: null,
        selling_price: null,
        new_selling_price: null,
        discount_offered: 0.0,
        vendor: null,
        sourceContext: 'store',
        source: 'store'
    };
    this.clearNonInventoryImage();
},
    // Clear non-inventory image
    clearNonInventoryImage: function() {
        this.nonInventoryImage = {
            uploading: false,
            previewUrl: null,
            uploadedUrl: null
        };
    },
    
    // Handle non-inventory image upload
    handleNonInventoryImageUpload: function(event) {
        const file = event.target.files[0];
        if (!file) return;
        
        if (!file.type.startsWith('image/')) {
            this.$bvToast.toast('Please select a valid image file', {
                title: 'Invalid File',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        if (file.size > 5 * 1024 * 1024) {
            this.$bvToast.toast('Image size should be less than 5MB', {
                title: 'File Too Large',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        this.nonInventoryImage.uploading = true;
        
        const reader = new FileReader();
        reader.onload = (e) => {
            this.nonInventoryImage.previewUrl = e.target.result;
            this.uploadNonInventoryImage();
        };
        reader.readAsDataURL(file);
        event.target.value = '';
    },
    
    // Upload non-inventory image
    uploadNonInventoryImage: function() {
        if (!this.nonInventoryImage.previewUrl) {
            this.nonInventoryImage.uploading = false;
            return;
        }
        
        const path = "/api/sales/upload_non_inventory_image/";
        const tempId = 'temp_' + Date.now();
        
        const data = {
            image_data: this.nonInventoryImage.previewUrl,
            temp_id: tempId,
            username: this.userDetails.username
        };
        
        const that = this;
        
        const success = function(response) {
            if (response.data.error) {
                that.$bvToast.toast(`Failed to upload image: ${response.data.error}`, {
                    title: 'Upload Failed',
                    variant: 'danger',
                    autoHideDelay: 3000
                });
                that.nonInventoryImage.previewUrl = null;
            } else {
                that.nonInventoryImage.uploadedUrl = response.data.result.image_url;
                that.$bvToast.toast('Image uploaded successfully', {
                    title: 'Success',
                    variant: 'success',
                    autoHideDelay: 2000
                });
            }
            that.nonInventoryImage.uploading = false;
        };
        
        const failure = function(error) {
            console.error('Image upload failed:', error);
            that.$bvToast.toast('Failed to upload image. Please try again.', {
                title: 'Upload Failed',
                variant: 'danger',
                autoHideDelay: 3000
            });
            that.nonInventoryImage.previewUrl = null;
            that.nonInventoryImage.uploading = false;
        };
        
        Requestor.postSyncP(path, data, this, success, failure);
    },
                 getVendorName(vendorId) {
        if (!vendorId) return 'N/A';
        
        // If vendorId is already a string (vendor name), return it
        if (typeof vendorId === 'string' && isNaN(vendorId)) {
            return vendorId;
        }
        
        // Try to find vendor in packet.vendors
        if (this.packet.vendors && Array.isArray(this.packet.vendors)) {
            const vendor = this.packet.vendors.find(v => {
                if (typeof v === 'object') {
                    return v.value == vendorId || v.id == vendorId || v.text == vendorId;
                }
                return v == vendorId;
            });
            
            if (vendor) {
                // Return the text/name from the vendor object
                if (typeof vendor === 'object') {
                    return vendor.text || vendor.name || vendor.label || vendor.value || vendorId;
                }
                return vendor;
            }
        }
        
        // If vendor not found, check if it's in the vendor list from the packet
        if (this.packet.vendors_text && this.packet.vendors_text[vendorId]) {
            return this.packet.vendors_text[vendorId];
        }
        
        // Fallback - return the ID
        return vendorId;
    },
                handleRequestImageUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        
        // Validate file type
        if (!file.type.startsWith('image/')) {
            this.requestItem.imageError = 'Please select a valid image file';
            this.$bvToast.toast(
                'Please select a valid image file',
                {title: 'Invalid File', variant: 'warning', autoHideDelay: 3000}
            );
            return;
        }
        
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            this.requestItem.imageError = 'Image size should be less than 5MB';
            this.$bvToast.toast(
                'Image size should be less than 5MB',
                {title: 'File Too Large', variant: 'warning', autoHideDelay: 3000}
            );
            return;
        }
        
        this.requestItem.imageUploading = true;
        this.requestItem.imageError = null;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            this.requestItem.imagePreview = e.target.result;
            this.requestItem.imageData = e.target.result;
            this.requestItem.imageUploaded = true;
            this.requestItem.imageUploading = false;
            
            this.$bvToast.toast(
                'Image uploaded successfully!',
                {title: 'Success', variant: 'success', autoHideDelay: 2000}
            );
        };
        
        reader.onerror = () => {
            this.requestItem.imageUploading = false;
            this.requestItem.imageError = 'Failed to read image file';
            this.$bvToast.toast(
                'Failed to read image file',
                {title: 'Error', variant: 'danger', autoHideDelay: 3000}
            );
        };
        
        reader.readAsDataURL(file);
        
        // Clear the file input
        event.target.value = '';
    },
    
    // Open camera for request
    openRequestCamera() {
        if (this.isMobileDevice()) {
            this.$refs.requestCameraInput.click();
        } else {
            this.$bvToast.toast(
                "Please use your phone's camera or upload an image file",
                {title: 'Info', variant: 'info', autoHideDelay: 3000}
            );
        }
    },
    
    // Remove request image
    removeRequestImage() {
        this.requestItem.imagePreview = null;
        this.requestItem.imageData = null;
        this.requestItem.imageUploaded = false;
        this.requestItem.imageError = null;
    },
    
    // Reset request modal
    resetRequestModal() {
        this.requestItem = {
            sku: null,
            vendor: null,
            quantity: null,
            price: null,
            notes: null,
            imagePreview: null,
            imageUploaded: false,
            imageUploading: false,
            imageError: null,
            imageData: null
        };
        this.requestSubmitting = false;
        this.hovering = false;
    },
          
                  openNonInventoryRequestModal() {
        this.requestItem = {
            sku: null,
            vendor: null,
            quantity: null,
            price: null
        };
        this.$bvModal.show('modal-request-non-inventory');
    },
    
    // Reset request modal
    resetRequestModal() {
        this.requestItem = {
            sku: null,
            vendor: null,
            quantity: null,
            price: null
        };
        this.requestSubmitting = false;
    },
    
    // Submit non-inventory item request
  submitNonInventoryRequest() {
        if (!this.canSubmitRequest) return;
        
        this.requestSubmitting = true;
        const that = this;
        
        const adminEmail = this.packet.location_admin_email || 
                          this.packet.default_admin_email || 
                          'hassaanraheel67@gmail.com';
        
        const data = {
            invoice_id: this.invoice.invoice_id || this.invoice.draft_id,
            sku: this.requestItem.sku,
            vendor: this.requestItem.vendor,
            quantity: this.requestItem.quantity,
            price: this.requestItem.price,
            notes: this.requestItem.notes || '',
            requested_by: this.userDetails.username,
            customer_email: this.invoice.customer.email,
            customer_name: this.invoice.customer.fullname,
            admin_email: adminEmail,
            location_id: this.invoice.location_id,
            location_name: this.invoice.short_name || 'Store Location',
            approval_url: this.buildApprovalUrl(),
            image_data: this.requestItem.imageData || null // Include image if uploaded
        };
        
        console.log('Submitting request with image:', !!data.image_data);
        
        const path = "/api/sales/request_non_inventory_approval/";
        
        const success = function(response) {
            if (response.data.error) {
                that.$bvToast.toast(
                    response.data.error,
                    {title: "Error", autoHideDelay: 3000, variant: "danger"}
                );
            } else {
                that.pendingNonInventoryRequest = response.data.result.request;
                
                that.$bvToast.toast(
                    `✅ Request sent to admin${adminEmail ? ' (' + adminEmail + ')' : ''}! You'll be notified when approved.`,
                    {title: "Request Sent", autoHideDelay: 4000, variant: "success"}
                );
                
                that.$bvModal.hide('modal-request-non-inventory');
                that.startApprovalPolling();
            }
            that.requestSubmitting = false;
        };
        
        const failure = function(error) {
            console.error("Request failed:", error);
            that.$bvToast.toast(
                "❌ Failed to submit request. Please try again.",
                {title: "Error", autoHideDelay: 3000, variant: "danger"}
            );
            that.requestSubmitting = false;
        };
        
        Requestor.postSyncP(path, data, this, success, failure);
    },
    
    // Build approval URL
  buildApprovalUrl() {
    // Get current domain
    const domain = window.location.origin;
    const invoiceId = this.invoice.invoice_id || this.invoice.draft_id;
    // Use hash mode routing
    return `${domain}/#/admin/approve-non-inventory/${invoiceId}`;
},
    // Check pending request status
 checkPendingRequestStatus() {
    if (!this.pendingNonInventoryRequest) return;
    
    const requestId = this.pendingNonInventoryRequest.id;
    
    if (!requestId) {
        console.error('No request ID available');
        return;
    }
    
    const that = this;
    const path = "/api/sales/check_non_inventory_request_status/";
    const data = {
        request_id: requestId
    };
    
    console.log('🔄 Checking status for request ID:', requestId);
    
    const success = function(response) {
        console.log('📡 Status check response:', response);
        
        if (response.data.error) {
            console.error('Error checking status:', response.data.error);
            return;
        }
        
        if (response.data.result) {
            const status = response.data.result;
            console.log('📊 Current status:', status.status);
            
            if (status.status === 'approved') {
                // Show toast notification
                that.$bvToast.toast(
                    `✅ Your request for ${status.product_sku} has been approved by ${status.approved_by || 'Admin'}! Click "Add to Sale" to add the item.`,
                    {title: "Approved!", autoHideDelay: 5000, variant: "success"}
                );
                
                // Update the pending request with the approved status
                that.pendingNonInventoryRequest = {
                    ...that.pendingNonInventoryRequest,
                    status: 'approved',
                    approved_by: status.approved_by,
                    approved_date: status.approved_date
                };
                
                // Stop polling since it's approved
                that.stopApprovalPolling();
                
            } else if (status.status === 'rejected') {
                that.$bvToast.toast(
                    `❌ Your request for ${status.product_sku} was rejected. Reason: ${status.rejection_reason || 'No reason provided'}`,
                    {title: "Rejected", autoHideDelay: 5000, variant: "danger"}
                );
                
                that.pendingNonInventoryRequest = null;
                that.stopApprovalPolling();
            }
        }
    };
    
    const failure = function(error) {
        console.error("❌ Error checking request status:", error);
    };
    
    Requestor.getSyncP(path, data, this, success, failure);
},

addApprovedNonInventoryItem() {
    if (!this.pendingNonInventoryRequest || this.pendingNonInventoryRequest.status !== 'approved') {
        return;
    }
    
    const that = this;
    const request = this.pendingNonInventoryRequest;
    
    // Create the item object with image
    const item = {
        product_id: null,
        product_sku: request.product_sku,
        vendor: request.vendor,
        quantity: parseInt(request.quantity) || 1,
        selling_price: parseFloat(request.selling_price) || 0,
        new_selling_price: parseFloat(request.selling_price) || 0,
        discount_offered: 0.0,
        is_special: true,
        is_non_inventory: true,
        sourceContext: 'store',
        source: 'store',
        product_name: request.product_sku,
        order_type: 'customer_takes',
        delivery_date: moment().format("MM-DD-YYYY"),
        existing: false,
        quantity_per_box: 1,
        // CRITICAL: Add the image URL
        image_url: request.image_url || null,
        as_is_image_url: null,
        is_damaged: false,
        damage_info: null
    };
    
    console.log('Adding approved item with image:', item.image_url);
    
    // Add the item using your existing addProduct method
    this.addProduct(item);
    
    // Clear the pending request
    this.pendingNonInventoryRequest = null;
    
    this.$bvToast.toast(
        `✅ Item ${request.product_sku} has been added to your sale!`,
        {title: "Item Added", autoHideDelay: 3000, variant: "success"}
    );
},
    // Start polling for approval status
  startApprovalPolling() {
    this.stopApprovalPolling(); // Clear any existing interval
    
    // Make sure we have a valid request ID
    if (!this.pendingNonInventoryRequest || !this.pendingNonInventoryRequest.id) {
        console.error('No valid request ID for polling');
        return;
    }
    
    console.log('🔍 Starting polling for request ID:', this.pendingNonInventoryRequest.id);
    
    // Check every 10 seconds
    this.approvalCheckInterval = setInterval(() => {
        this.checkPendingRequestStatus();
    }, 10000);
    
    // Also check after 30 seconds with a longer timeout
    setTimeout(() => {
        this.checkPendingRequestStatus();
    }, 30000);
},
    // Stop polling
    stopApprovalPolling() {
        if (this.approvalCheckInterval) {
            clearInterval(this.approvalCheckInterval);
            this.approvalCheckInterval = null;
        }
    },
    
    // Cancel pending request
    cancelNonInventoryRequest() {
        const that = this;
        this.$bvModal.msgBoxConfirm(
            'Are you sure you want to cancel this request?',
            {
                title: 'Cancel Request',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES, CANCEL',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                centered: true
            }
        ).then(value => {
            if (value) {
                const path = "/api/sales/cancel_non_inventory_request/";
                const data = {
                    request_id: that.pendingNonInventoryRequest.id
                };
                
                const success = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 3000, variant: "danger"}
                        );
                    } else {
                        that.$bvToast.toast(
                            "Request cancelled successfully.",
                            {title: "Cancelled", autoHideDelay: 2000, variant: "info"}
                        );
                        that.pendingNonInventoryRequest = null;
                        that.stopApprovalPolling();
                    }
                };
                
                const failure = function(error) {
                    console.error("Error cancelling request:", error);
                    that.$bvToast.toast(
                        "Failed to cancel request.",
                        {title: "Error", autoHideDelay: 3000, variant: "danger"}
                    );
                };
                
                Requestor.postSyncP(path, data, this, success, failure);
            }
        });
    },
    
    // Check if there's a pending request on component mount
   fetchPendingRequest() {
    const that = this;
    const path = "/api/sales/get_pending_non_inventory_request/";
    const data = {
        invoice_id: this.invoice.invoice_id || this.invoice.draft_id,
        username: this.userDetails.username
    };
    
    const success = function(response) {
        if (response.data.result) {
            that.pendingNonInventoryRequest = response.data.result;
            console.log('Fetched pending request:', that.pendingNonInventoryRequest);
            console.log('Request ID:', that.pendingNonInventoryRequest.id);
            if (that.pendingNonInventoryRequest.status === 'pending') {
                that.startApprovalPolling();
            }
        }
    };
    
    const failure = function(error) {
        console.error("Error fetching pending request:", error);
    };
    
    Requestor.getSyncP(path, data, this, success, failure);
},
    
    // Format date helper
    formatDate(date) {
        if (!date) return 'N/A';
        return new Date(date).toLocaleString();
    },
                   disablePreviousDates(date) {
        // Get today's date at midnight for comparison
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // Disable any date before today
        // Return true to disable the date, false to enable it
        return date < today;
    },
                isDeliveryDateValid(date) {
    if (!date) return false;
    
    // Parse the date (assuming format is MM-DD-YYYY)
    const parts = date.split('-');
    if (parts.length !== 3) return false;
    
    const deliveryDate = new Date(parts[2], parts[0] - 1, parts[1]);
    const today = new Date();
    
    // Reset time to beginning of day for fair comparison
    today.setHours(0, 0, 0, 0);
    deliveryDate.setHours(0, 0, 0, 0);
    
    // Check if delivery date is today or in the future
    return deliveryDate >= today;
  },
  
  // Validate all delivery dates in items
  validateAllDeliveryDates() {
    let hasInvalidDate = false;
    
    this.invoice.items.forEach(item => {
      if (item.delivery_date && !this.isDeliveryDateValid(item.delivery_date)) {
        hasInvalidDate = true;
        this.$bvToast.toast(
          `Item ${item.product_sku || item.product_name} has a delivery date from the past. Please update it.`,
          {title: "Invalid Date", autoHideDelay: 3000, variant: "warning"}
        );
      }
    });
    
    return !hasInvalidDate;
  },
  
  // Date picker change handler with validation
  onDeliveryDateChange(item, newDate) {
    if (newDate && !this.isDeliveryDateValid(newDate)) {
      this.$bvToast.toast(
        "Delivery date cannot be a previous date. Please select today or a future date.",
        {title: "Invalid Date", autoHideDelay: 3000, variant: "warning"}
      );
      // Reset to today's date or last valid date
      item.delivery_date = this.today_date;
      return false;
    }
      if (item.order_type === 'delivery_from_store') {
        this.validateDeliveryFromStoreLocations();
    }
    return true;
  },
                  onCollapseShown() {
        this.searchCollapseOpen = true;
    },
    onCollapseHidden() {
        this.searchCollapseOpen = false;
    },
                getSelectedLocationId() {
    if (!this.invoice.selected_locsub) return null;
    
    const parts = this.invoice.selected_locsub.split('|');
    if (parts.length >= 1) {
        return parseInt(parts[0]);
    }
    return null;
},

// Get selected location name for display
getSelectedLocationName() {
    if (!this.invoice.selected_locsub) return '';
    
    const selectedLoc = this.packet.locsubs.find(
        loc => loc.value === this.invoice.selected_locsub
    );
    
    if (selectedLoc && selectedLoc.text) {
        // Extract just the location name without the '|' part
        return selectedLoc.text.split('|')[0].trim();
    }
    
    return this.invoice.short_name || 'Selected Location';
},

// Open the delivery calendar modal
openDeliveryCalendar() {
    if (!this.invoice.selected_locsub) {
        this.$bvToast.toast(
            "Please select a location first to view the delivery calendar.",
            {title: "Location Required", autoHideDelay: 2000, variant: "warning"}
        );
        return;
    }
    
    this.$bvModal.show('modal-delivery-calendar');
},

// When modal is shown, optionally refresh the calendar with the current location
onDeliveryCalendarShown() {
    if (this.$refs.deliveryCalendar && this.invoice.selected_locsub) {
        // If the calendar component has a refresh method, call it
        if (typeof this.$refs.deliveryCalendar.refreshCalendar === 'function') {
            this.$refs.deliveryCalendar.refreshCalendar();
        }
    }
},
                   getCustomerIdCardImage() {
        if (this.invoice.customer_id_card_url && this.invoice.customer_id_card_url.trim() !== '') {
            // Handle Azure blob URLs that need proxying
            if (this.invoice.customer_id_card_url.includes('fmapi.myfurnituremecca.com')) {
                return `/api/image/image-proxy/?url=${encodeURIComponent(this.invoice.customer_id_card_url)}`;
            }
            return this.invoice.customer_id_card_url;
        }
        if (this.idCardUpload.previewUrl) {
            return this.idCardUpload.previewUrl;
        }
        return null;
    },
    
    // Handle ID card image upload
    handleIdCardImageUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        
        // Validate file type
        if (!file.type.startsWith('image/')) {
            this.$bvToast.toast('Please select a valid image file', {
                title: 'Invalid File',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            this.$bvToast.toast('Image size should be less than 5MB', {
                title: 'File Too Large',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        this.idCardUpload.uploading = true;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            this.idCardUpload.previewUrl = e.target.result;
            this.uploadIdCardImage();
        };
        reader.readAsDataURL(file);
        
        // Clear the file input
        event.target.value = '';
    },
    
    // Open camera for ID card
    openIdCardCamera() {
        if (this.isMobileDevice()) {
            this.$refs.idCardCameraInput.click();
        } else {
            // For desktop, show info message
            this.$bvToast.toast(
                "Please use your phone's camera or upload an image file",
                {title: "Info", autoHideDelay: 3000, variant: "info"}
            );
        }
    },
    
    // Upload ID card image to server
    async uploadIdCardImage() {
        if (!this.idCardUpload.previewUrl) {
            this.idCardUpload.uploading = false;
            return;
        }
        
        const path = "/api/sales/upload_customer_id_card/";
        
        const data = {
            image_data: this.idCardUpload.previewUrl,
            invoice_id: this.invoice.invoice_id || 'temp_' + Date.now(),
            card_type: this.invoice.customer_id_card_type,
            card_number: this.invoice.customer_id_card_number,
            username: this.userDetails.username
        };
        
        const that = this;
        
        const success = function(response) {
            if (response.data.error) {
                that.$bvToast.toast(`Failed to upload ID card: ${response.data.error}`, {
                    title: 'Upload Failed',
                    variant: 'danger',
                    autoHideDelay: 3000
                });
                that.idCardUpload.previewUrl = null;
            } else {
                // Store the uploaded URL
                that.invoice.customer_id_card_url = response.data.result.image_url;
                that.invoice.customer_id_card_uploaded_at = new Date().toISOString();
                that.idCardUpload.previewUrl = null;
                
                that.$bvToast.toast('Customer ID card uploaded successfully', {
                    title: 'Success',
                    variant: 'success',
                    autoHideDelay: 2000
                });
            }
            that.idCardUpload.uploading = false;
        };
        
        const failure = function(error) {
            console.error('ID card upload failed:', error);
            that.$bvToast.toast('Failed to upload ID card. Please try again.', {
                title: 'Upload Failed',
                variant: 'danger',
                autoHideDelay: 3000
            });
            that.idCardUpload.previewUrl = null;
            that.idCardUpload.uploading = false;
        };
        
        Requestor.postSyncP(path, data, this, success, failure);
    },
    
    // Remove ID card image
    async removeIdCardImage() {
        const confirmed = await this.$bvModal.msgBoxConfirm(
            'Are you sure you want to remove the customer ID card image?',
            {
                title: 'Remove ID Card',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'REMOVE',
                cancelTitle: 'CANCEL',
                footerClass: 'p-2',
                centered: true
            }
        );
        
        if (!confirmed) return;
        
        if (this.invoice.invoice_id && !this.invoice.invoice_id.toString().startsWith('temp_')) {
            const path = "/api/sales/remove_customer_id_card/";
            const data = {
                invoice_id: this.invoice.invoice_id,
                username: this.userDetails.username
            };
            
            const that = this;
            const success = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(response.data.error, {
                        title: 'Error',
                        variant: 'danger',
                        autoHideDelay: 3000
                    });
                } else {
                    that.invoice.customer_id_card_url = null;
                    that.invoice.customer_id_card_uploaded_at = null;
                    that.$bvToast.toast('ID card removed successfully', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000
                    });
                }
            };
            
            const failure = function(error) {
                console.error('Failed to remove ID card:', error);
                that.$bvToast.toast('Failed to remove ID card', {
                    title: 'Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                });
            };
            
            Requestor.postSyncP(path, data, this, success, failure);
        } else {
            // For new invoices, just clear local data
            this.invoice.customer_id_card_url = null;
            this.invoice.customer_id_card_uploaded_at = null;
            this.idCardUpload.previewUrl = null;
            this.$bvToast.toast('ID card removed', {
                title: 'Success',
                variant: 'success',
                autoHideDelay: 2000
            });
        }
    },
    
    // Show full size ID card image
    showFullIdCardImage() {
        const imageUrl = this.getCustomerIdCardImage();
        if (imageUrl) {
            this.$bvModal.show('modal-image-viewer');
            this.$nextTick(() => {
                this.currentFullSizeImage = imageUrl;
                this.currentProductName = 'Customer ID Card';
            });
        }
    },
    
    // Format date helper
    formatDate(date) {
        if (!date) return '';
        return moment(date).format('MM/DD/YYYY hh:mm A');
    },
    
    // Helper to detect mobile device
    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
                     onModalFloorDisplayChange(value) {
        if (value === 'other') {
            this.modalShowCustomFloor = true;
            this.modalCustomer.floor_number = null;
            this.modalCustomer.floor_display = null;
        } else {
            this.modalShowCustomFloor = false;
            const selectedOption = this.floor_options.find(opt => opt.value === value);
            if (selectedOption) {
                this.modalCustomer.floor_display = selectedOption.text;
            }
            this.modalCustomer.floor_number = parseInt(value);
        }
    },
  onFloorDisplayChange(value) {
    if (value === 'other') {
        this.show_custom_floor = true;
        this.selected_floor_number = null;
        this.selected_floor_display = null;
    } else {
        this.show_custom_floor = false;
        const selectedOption = this.floor_options.find(opt => opt.value === value);
        if (selectedOption) {
            this.selected_floor_display = selectedOption.text;
        }
        this.selected_floor_number = parseInt(value);
    }
    this.updateCustomerFloorInfo();
},

    
    onFloorNumberChange() {
        this.updateCustomerFloorInfo();
    },
    
    updateCustomerFloorInfo() {
    let floorDisplay = this.selected_floor_display;
    let floorNumber = this.selected_floor_number;
    
    if (this.show_custom_floor) {
        floorDisplay = this.custom_floor_display || null;
        floorNumber = this.custom_floor_number ? parseInt(this.custom_floor_number) : null;
    }
    
    // Only set if there's actual data
    if (floorDisplay && floorDisplay !== 'Select Floor') {
        this.invoice.customer.floor_display = floorDisplay;
        this.invoice.customer.floor_number = floorNumber;
        this.invoice.customer.floor_info = floorNumber ? `${floorDisplay} (Floor ${floorNumber})` : floorDisplay;
    } else if (floorNumber) {
        this.invoice.customer.floor_display = null;
        this.invoice.customer.floor_number = floorNumber;
        this.invoice.customer.floor_info = `Floor ${floorNumber}`;
    } else {
        this.invoice.customer.floor_display = null;
        this.invoice.customer.floor_number = null;
        this.invoice.customer.floor_info = null;
    }
},
    
    // Add this to load floor data when editing an invoice
    loadFloorDataFromCustomer(customer) {
        if (customer) {
            if (customer.floor_display) {
                // Check if it's one of the standard options
                const standardOption = this.floor_options.find(opt => opt.text === customer.floor_display);
                if (standardOption) {
                    this.selected_floor_display = standardOption.text;
                    this.selected_floor_number = parseInt(standardOption.value);
                    this.show_custom_floor = false;
                } else {
                    // It's a custom floor display
                    this.selected_floor_display = 'other';
                    this.custom_floor_display = customer.floor_display;
                    this.selected_floor_number = customer.floor_number;
                    this.custom_floor_number = customer.floor_number;
                    this.show_custom_floor = true;
                }
            }
        }
    },
              sendDraftToCustomer() {
    let that = this;
    
    // Validate before sending
    if (this.invoice.items.length === 0) {
        this.$bvToast.toast(
            "Please add at least one item before sending draft.",
            {title: "Info", autoHideDelay: 2000, variant: "warning"}
        );
        return;
    }
    
    if (!this.invoice.customer.email || !this.invoice.customer.email.includes('@')) {
        this.$bvToast.toast(
            "Please enter a valid customer email address.",
            {title: "Info", autoHideDelay: 2000, variant: "warning"}
        );
        return;
    }
    
    // Confirm before sending
    this.$bvModal.msgBoxConfirm(
        `Send estimate to ${this.invoice.customer.email}?`,
        {
            title: 'Send Estimate to Customer',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'SEND',
            cancelTitle: 'CANCEL',
            footerClass: 'p-2',
            centered: true
        }
    ).then(value => {
        if (value) {
            that.executeSendDraftToCustomer();
        }
    });
},

executeSendDraftToCustomer() {
    let that = this;
    
    // Use the generated invoice_id as the draft_id if it exists
    let draftId = this.invoice.invoice_id || this.invoice.draft_id;
    
    // Prepare draft data with ALL calculated values
    let draftData = {
        draft_id: draftId,
        username: this.userDetails.username,
        location_id: this.invoice.location_id,
        sublocation_id: this.invoice.sublocation_id,
        invoice_id: this.invoice.invoice_id,
        customer: this.invoice.customer,
        items: this.invoice.items,
        delivery_charges: this.invoice.delivery_charges,
        setup_charges: this.invoice.setup_charges,
        warranty_charges: this.invoice.warranty_charges,
        payment_methods: this.invoice.payment_methods,
        comment_txt: this.invoice.comment_txt,
        sold_from_state: this.invoice.sold_from_state,
        selected_locsub: this.invoice.selected_locsub,
        is_layaway: this.invoice.is_layaway,
        tax_perc: this.invoice.tax_perc,
        delivery_waiver_agreed: this.deliveryWaiverAgreed,
        space_preparation_agreed: this.spacePreparationAgreed,
        delivery_damage_waiver_agreed: this.deliveryDamageWaiverAgreed,
        terms_agreed: this.policyAgreed,
        warranty_refused: this.warrantyRefused,
        address_confirmation_agreed: this.invoice.address_confirmation_agreed,
        subtotal: this.getSubTotal(),
        taxable_subtotal: this.adjust_to_taxable_amount(this.getSubTotal()),
        sales_tax: this.getSalesTax(),
        total: this.getSubTotal() + this.getSalesTax(),
        order_total: this.getOrderTotal(),
        total_discount: this.getTotalDiscount(),
        charges_total: this.getChargesTotal(),
        grand_total: this.getGrandTotal(),
        balance: this.getTotalBalance(),
        total_special_discounts: this.getTotalSpecialDiscounts(),
        store_credit_applied: this.getStoreCreditApplied(),
        remaining_store_credit: this.getRemainingStoreCredit(),
        
        // IMPORTANT: Request email sending
        send_to_customer: true,
        customer_email: this.invoice.customer.email
    };
    
    let path = "/api/sales/save_draft_invoice/";
    
    let s = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 3000, variant: "warning"}
            );
        } else {
            // Update draft ID
            if (!that.invoice.draft_id && response.data.result.draft_id) {
                that.invoice.draft_id = response.data.result.draft_id;
                if (!that.invoice.invoice_id) {
                    that.invoice.invoice_id = response.data.result.draft_id;
                }
            }
            
            // Show success message with email status
            if (response.data.result.estimate_sent) {
                that.$bvToast.toast(
                    `Draft saved and estimate sent to ${response.data.result.estimate_sent_to}!`,
                    {title: "Success", autoHideDelay: 3000, variant: "success"}
                );
            } else {
                let errorMsg = response.data.result.estimate_error || "Unknown error";
                that.$bvToast.toast(
                    `Draft saved but email failed: ${errorMsg}`,
                    {title: "Warning", autoHideDelay: 4000, variant: "warning"}
                );
            }
        }
        that.loadingDraftSend = false;
    };
    
    let f = function(error) {
        console.error(error);
        that.$bvToast.toast(
            "Error saving or sending draft. Please try again.",
            {title: "Error", autoHideDelay: 3000, variant: "danger"}
        );
        that.loadingDraftSend = false;
    };
    
    this.loadingDraftSend = true;
    Requestor.postSyncP(path, draftData, this, s, f);
},
    
    sendDraftToCustomerAction() {
        let that = this;
        
        // Prepare draft data with ALL necessary information
        let draftData = {
            draft_id: this.invoice.draft_id || this.invoice.invoice_id,
            username: this.userDetails.username,
            location_id: this.invoice.location_id,
            sublocation_id: this.invoice.sublocation_id,
            
            // Customer info
            customer: this.invoice.customer,
            
            // Items
            items: this.invoice.items,
            
            // Charges
            delivery_charges: this.invoice.delivery_charges || 0,
            setup_charges: this.invoice.setup_charges || 0,
            warranty_charges: this.invoice.warranty_charges || 0,
            
            // Payment methods (if any)
            payment_methods: this.invoice.payment_methods || [],
            
            // Comments
            comment_txt: this.invoice.comment_txt,
            
            // Location info
            sold_from_state: this.invoice.sold_from_state,
            selected_locsub: this.invoice.selected_locsub,
            is_layaway: this.invoice.is_layaway || false,
            tax_perc: this.invoice.tax_perc || 0,
            
            // Agreement flags
            delivery_waiver_agreed: this.deliveryWaiverAgreed || false,
            space_preparation_agreed: this.spacePreparationAgreed || false,
            delivery_damage_waiver_agreed: this.deliveryDamageWaiverAgreed || false,
            terms_agreed: this.policyAgreed || false,
            warranty_refused: this.warrantyRefused || false,
            address_confirmation_agreed: this.invoice.address_confirmation_agreed || false,
            
            // Totals
            subtotal: this.getSubTotal(),
            taxable_subtotal: this.adjust_to_taxable_amount(this.getSubTotal()),
            sales_tax: this.getSalesTax(),
            total: this.getSubTotal() + this.getSalesTax(),
            order_total: this.getOrderTotal(),
            total_discount: this.getTotalDiscount(),
            charges_total: this.getChargesTotal(),
            grand_total: this.getGrandTotal(),
            balance: this.getTotalBalance(),
            total_special_discounts: this.getTotalSpecialDiscounts(),
            store_credit_applied: this.getStoreCreditApplied(),
            remaining_store_credit: this.getRemainingStoreCredit(),
            
            // Flag to indicate we want to send email
            send_to_customer: true,
            customer_email: this.invoice.customer.email
        };
        
        let path = "/api/sales/save_draft_invoice/";
        
        let s = function(response) {
            if (response.data.error) {
                that.$bvToast.toast(
                    response.data.error,
                    {title: "Error", autoHideDelay: 3000, variant: "warning"}
                );
            } else {
                // Update draft ID if this was a new draft
                if (!that.invoice.draft_id && response.data.result.draft_id) {
                    that.invoice.draft_id = response.data.result.draft_id;
                    if (!that.invoice.invoice_id) {
                        that.invoice.invoice_id = response.data.result.draft_id;
                    }
                }
                
                // Show success message with email status
                if (response.data.result.estimate_sent) {
                    that.$bvToast.toast(
                        `Draft saved and estimate sent to ${response.data.result.estimate_sent_to}!`,
                        {title: "Success", autoHideDelay: 3000, variant: "success"}
                    );
                } else {
                    let errorMsg = response.data.result.estimate_error || "Unknown error";
                    that.$bvToast.toast(
                        `Draft saved but email failed: ${errorMsg}`,
                        {title: "Warning", autoHideDelay: 4000, variant: "warning"}
                    );
                }
            }
            that.loadingDraftSend = false;
        };
        
        let f = function(error) {
            console.error(error);
            that.$bvToast.toast(
                "Error saving or sending draft. Please try again.",
                {title: "Error", autoHideDelay: 3000, variant: "danger"}
            );
            that.loadingDraftSend = false;
        };
        
        this.loadingDraftSend = true;
        Requestor.postSyncP(path, draftData, this, s, f);
    },
               
    openCameraScanner() {
    this.scannerError = null;
    this.$bvModal.show('modal-barcode-scanner');
  },

  startScanner() {
    // The QuaggaScanner component will handle starting automatically
    if (this.$refs.quaggaScanner) {
      this.$refs.quaggaScanner.startScanner();
    }
  },

async startBarcodeDetection() {
     if (!('BarcodeDetector' in window)) {
    this.scannerError = 'Camera barcode scanning not supported in this browser. Please use manual entry.';
    setTimeout(() => {
      this.stopScanner();
    }, 3000);
    return;
  }
  const video = this.$refs.scannerVideo;
  const canvas = this.$refs.scannerCanvas;
  const context = canvas.getContext('2d');
  
  // Set canvas dimensions to match video
  const updateCanvasSize = () => {
    if (video.videoWidth) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    }
  };
  
  video.addEventListener('loadedmetadata', updateCanvasSize);
  updateCanvasSize();
  
  // Clear any existing interval
  if (this.scanInterval) {
    clearInterval(this.scanInterval);
  }
  
  // Start scanning every 500ms
  this.scanInterval = setInterval(() => {
    if (!video.videoWidth || !video.videoHeight) return;
    
    // Capture frame
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    
    // Get image data for barcode detection
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    
    // Only detect if BarcodeDetector is available and not already processing
    if ('BarcodeDetector' in window && !this.barcodeProcessing) {
      this.detectBarcodeFromImage(imageData);
    }
  }, 500);
},
async detectBarcodeFromImage(imageData) {
  if (this.barcodeProcessing) return; // Prevent multiple scans
  
  try {
    const barcodeDetector = new BarcodeDetector({
      formats: ['code_128', 'ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_39', 'codabar']
    });
    const barcodes = await barcodeDetector.detect(imageData);
    
    if (barcodes && barcodes.length > 0) {
      this.barcodeProcessing = true; // Prevent multiple scans
      const barcodeValue = barcodes[0].rawValue;
      console.log('Detected barcode:', barcodeValue);
      
      // Stop scanning
      this.stopScanner();
      
      // Process using your existing method
      this.barcodeInput = barcodeValue;
      this.handleBarcodeScan();
    }
  } catch (error) {
    console.error('Barcode detection error:', error);
    // Don't call fallback - just log and continue scanning
  }
},


processScannedBarcode(barcodeValue) {
  // Process the scanned barcode
  this.barcodeInput = barcodeValue;
  this.handleBarcodeScan();
  
  this.$bvToast.toast(
    `Scanned: ${barcodeValue}`,
    {title: "Barcode Scanned", autoHideDelay: 1500, variant: "success"}
  );
},
 stopScanner() {
    if (this.$refs.quaggaScanner) {
      this.$refs.quaggaScanner.stopScanner();
    }
    this.$bvModal.hide('modal-barcode-scanner');
  },
   handleScannedBarcode(barcodeValue) {
    console.log('Scanned barcode:', barcodeValue);
    this.barcodeInput = barcodeValue;
    this.handleBarcodeScan();
    this.stopScanner();
    
    this.$bvToast.toast(
      `Scanned: ${barcodeValue}`,
      {title: "Barcode Scanned", autoHideDelay: 1500, variant: "success"}
    );
  },
      onFinanceCompanySelected: function(paymentMethod) {
    // Check if this finance company charges tax
    const chargesTax = this.check_finance_company_charges_tax(paymentMethod);
    
    // Set the flag on the payment method
    paymentMethod.charged_tax_itself = chargesTax;
    
    console.log(`Finance company ${paymentMethod.name} selected. Charges tax: ${chargesTax}`);
    
    // Force the tax to recalculate immediately
    this.$forceUpdate();
    
    // Show a toast notification
    if (chargesTax) {
        this.$bvToast.toast(
            `${paymentMethod.name} WILL collect and remit sales tax. Tax has been removed from this sale.`,
            {title: "Tax Notice", autoHideDelay: 3000, variant: "info"}
        );
    } else {
        this.$bvToast.toast(
            `${paymentMethod.name} does NOT collect tax. Store will collect sales tax.`,
            {title: "Tax Notice", autoHideDelay: 3000, variant: "warning"}
        );
    }
    
    // If there's an amount already entered, trigger an update to the taxable subtotal
    if (paymentMethod.amount && parseFloat(paymentMethod.amount) > 0) {
        this.$forceUpdate();
    }
},
                 handleGlobalEnter(event) {
        // Check if Enter was pressed and if barcode input is focused
        if (event.key === 'Enter' && document.activeElement === this.$refs.barcodeInput) {
            event.preventDefault();
            this.handleBarcodeScan();
        }
    },
                // Check if camera is supported
isCameraSupported() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
},

// Open camera (direct approach for mobile)
openCamera() {
    // On mobile, we can use the simple capture input
    if (this.isMobileDevice()) {
        this.$refs.cameraInput.click();
    } else {
        // On desktop, use the camera modal
        this.$bvModal.show('modal-camera');
        this.startCamera();
    }
},

// Detect if on mobile device
isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
},

// Start camera stream
async startCamera() {
    this.cameraLoading = true;
    this.cameraError = null;
    
    try {
        const constraints = {
            video: {
                facingMode: this.cameraFacing,
                width: { ideal: 1280 },
                height: { ideal: 720 }
            }
        };
        
        this.currentStream = await navigator.mediaDevices.getUserMedia(constraints);
        
        if (this.$refs.cameraVideo) {
            this.$refs.cameraVideo.srcObject = this.currentStream;
            this.cameraActive = true;
        }
    } catch (error) {
        console.error('Camera error:', error);
        this.cameraError = 'Unable to access camera. Please check permissions.';
    } finally {
        this.cameraLoading = false;
    }
},

// Stop camera stream
stopCamera() {
    if (this.currentStream) {
        this.currentStream.getTracks().forEach(track => track.stop());
        this.currentStream = null;
    }
    this.cameraActive = false;
    this.capturedImage = null;
    this.cameraError = null;
},

// Toggle between front and back camera
 toggleCamera() {
    this.currentCamera = this.currentCamera === 'environment' ? 'user' : 'environment';
    // The QuaggaScanner component will handle the restart via watcher
  },

// Retry camera access
retryCamera() {
    this.cameraError = null;
    this.startCamera();
},

// Capture photo from camera
capturePhoto() {
    if (!this.cameraActive || !this.$refs.cameraVideo) return;
    
    const video = this.$refs.cameraVideo;
    const canvas = this.$refs.cameraCanvas;
    
    // Set canvas dimensions to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    
    // Draw video frame to canvas
    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    
    // Get image as data URL
    this.capturedImage = canvas.toDataURL('image/jpeg', 0.8);
},

// Use the captured photo
useCapturedPhoto() {
    this.nonInventoryImage.previewUrl = this.capturedImage;
    this.uploadNonInventoryImage();
    this.$bvModal.hide('modal-camera');
},

// Retake photo
retakePhoto() {
    this.capturedImage = null;
},

// Update handleNonInventoryImageUpload to handle camera capture
handleNonInventoryImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
        this.$bvToast.toast('Please select a valid image file', {
            title: 'Invalid File',
            variant: 'warning',
            autoHideDelay: 3000
        });
        return;
    }
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
        this.$bvToast.toast('Image size should be less than 5MB', {
            title: 'File Too Large',
            variant: 'warning',
            autoHideDelay: 3000
        });
        return;
    }
    
    this.nonInventoryImage.uploading = true;
    
    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
        this.nonInventoryImage.previewUrl = e.target.result;
        this.uploadNonInventoryImage();
    };
    reader.readAsDataURL(file);
    
    // Clear the file input
    event.target.value = '';
},
           // Your existing handleBarcodeScan method
    handleBarcodeScan() {
           console.log("Scan button clicked!"); // Add this for debugging
    console.log("Barcode input value:", this.barcodeInput);
        if (!this.barcodeInput || this.barcodeInput.trim() === '') {
            this.$bvToast.toast(
                "Please scan or enter a barcode",
                {title: "Info", autoHideDelay: 1500, variant: "warning"}
            );
            return;
        }
        
        const scannedValue = this.barcodeInput.trim();
        console.log("Barcode scanned:", scannedValue);
        
        // Clear the input immediately for next scan
        this.barcodeInput = '';
        
        // Focus back on the input for continuous scanning
        this.$nextTick(() => {
            if (this.$refs.barcodeInput) {
                this.$refs.barcodeInput.focus();
            }
        });
        
        // Process the scanned barcode
        this.searchByBarcode(scannedValue);
    },

   searchByBarcode(barcodeValue) {
        this.barcodeProcessing = true;
        this.searchitems.search_being_loaded = true;
        
        let path = "/api/product/search_by_barcode/";
        let data = {
            barcode: barcodeValue,
            location_id: this.search_in_my_location ? this.invoice.location_id : null,
            include_sublocation_breakdown: true,
            include_damage_info: true
        };
        
        let that = this;
        let s = function(response) {
            that.barcodeProcessing = false;
            that.searchitems.search_being_loaded = false;
            
            if (response.data.error) {
                that.$bvToast.toast(
                    response.data.error,
                    {title: "Barcode Not Found", autoHideDelay: 1500, variant: "warning"}
                );
                // Focus back on input for next scan
                that.$nextTick(() => {
                    if (that.$refs.barcodeInput) {
                        that.$refs.barcodeInput.focus();
                    }
                });
            } else {
                if (response.data.result && response.data.result.length > 0) {
                    // Found product(s) by barcode
                    that.searchitems.result = response.data.result.map(item => {
                        // Set default quantity to 1 for quick addition
                        item.quantity = 1;
                        return item;
                    });
                    
                    // Optionally auto-add the first result if it's unique
                    if (response.data.result.length === 1) {
                        // Auto-add the product
                        that.addProduct(response.data.result[0]);
                        // Clear search results after adding
                        that.searchitems.result = [];
                        
                        that.$bvToast.toast(
                            `Added ${response.data.result[0].product_name || response.data.result[0].product_sku} to cart`,
                            {title: "Item Added", autoHideDelay: 1500, variant: "success"}
                        );
                    } else {
                        that.$bvToast.toast(
                            `Found ${response.data.result.length} products for barcode ${barcodeValue}. Please select one.`,
                            {title: "Multiple Matches", autoHideDelay: 2000, variant: "info"}
                        );
                    }
                } else {
                    that.$bvToast.toast(
                        `No product found with barcode: ${barcodeValue}`,
                        {title: "Not Found", autoHideDelay: 1500, variant: "warning"}
                    );
                }
            }
            
            // Always re-focus after search
            that.$nextTick(() => {
                if (that.$refs.barcodeInput) {
                    that.$refs.barcodeInput.focus();
                }
            });
        };
        
        let f = function(error) {
            console.error("Barcode search error:", error);
            that.barcodeProcessing = false;
            that.searchitems.search_being_loaded = false;
            that.$bvToast.toast(
                "Error searching by barcode. Please check the barcode and try again.",
                {title: "Error", autoHideDelay: 1500, variant: "danger"}
            );
            
            // Re-focus on error
            that.$nextTick(() => {
                if (that.$refs.barcodeInput) {
                    that.$refs.barcodeInput.focus();
                }
            });
        };
        
        Requestor.getSyncP(path, data, this, s, f);
    },
                // Handle non-inventory image upload
handleNonInventoryImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
        this.$bvToast.toast('Please select a valid image file', {
            title: 'Invalid File',
            variant: 'warning',
            autoHideDelay: 3000
        });
        return;
    }
    
    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
        this.$bvToast.toast('Image size should be less than 5MB', {
            title: 'File Too Large',
            variant: 'warning',
            autoHideDelay: 3000
        });
        return;
    }
    
    this.nonInventoryImage.uploading = true;
    
    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
        this.nonInventoryImage.previewUrl = e.target.result;
        this.uploadNonInventoryImage();
    };
    reader.readAsDataURL(file);
    
    // Clear the file input
    event.target.value = '';
},

// Upload non-inventory image to Azure
async uploadNonInventoryImage() {
    if (!this.nonInventoryImage.previewUrl) {
        this.nonInventoryImage.uploading = false;
        return;
    }
    
    const path = "/api/sales/upload_non_inventory_image/";
    
    // Generate a temporary ID for the image
    const tempId = 'temp_' + Date.now();
    
    const data = {
        image_data: this.nonInventoryImage.previewUrl,
        temp_id: tempId,
        username: this.userDetails.username
    };
    
    const that = this;
    
    const success = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(`Failed to upload image: ${response.data.error}`, {
                title: 'Upload Failed',
                variant: 'danger',
                autoHideDelay: 3000
            });
            that.nonInventoryImage.previewUrl = null;
        } else {
            // Store the uploaded URL
            that.nonInventoryImage.uploadedUrl = response.data.result.image_url;
            
            that.$bvToast.toast('Image uploaded successfully', {
                title: 'Success',
                variant: 'success',
                autoHideDelay: 2000
            });
        }
        that.nonInventoryImage.uploading = false;
    };
    
    const failure = function(error) {
        console.error('Image upload failed:', error);
        that.$bvToast.toast('Failed to upload image. Please try again.', {
            title: 'Upload Failed',
            variant: 'danger',
            autoHideDelay: 3000
        });
        that.nonInventoryImage.previewUrl = null;
        that.nonInventoryImage.uploading = false;
    };
    
    Requestor.postSyncP(path, data, this, success, failure);
},

// Clear non-inventory image
clearNonInventoryImage() {
    this.nonInventoryImage = {
        uploading: false,
        previewUrl: null,
        uploadedUrl: null
    };
},

// Check if non-inventory item can be added
canAddNonInventoryItem() {
    return (
        this.special_item.category_id &&
        this.special_item.subcategory_id && // Subcategory is now required
        this.special_item.product_sku &&
        this.special_item.product_name && // Added description requirement
        this.special_item.vendor &&
        this.special_item.quantity > 0 &&
        this.special_item.selling_price > 0
    );
},

// Add non-inventory item with image
addNonInventoryItem() {
    if (!this.canAddNonInventoryItem) return;
    
    // Get category and subcategory names for display
    const selectedCategory = this.categories.find(c => c.category_id === this.special_item.category_id);
    const selectedSubcategory = this.subcategories.find(s => s.id === this.special_item.subcategory_id);
    const selectedColor = this.colorOptions.find(c => c.value === this.special_item.color_id);
    const selectedSize = this.sizeOptions.find(s => s.value === this.special_item.size_id);
    
    // CRITICAL: Use the description field for product_name
    const description = this.special_item.product_name || this.special_item.product_sku;
    
    const itemToAdd = {
        product_id: null,
        product_sku: this.special_item.product_sku,
        product_name: description, // ← Use description field here
        product_category: this.special_item.category_id,
        product_category_name: selectedCategory ? selectedCategory.category_name : null,
        subcategory_id: this.special_item.subcategory_id,
        subcategory_name: selectedSubcategory ? selectedSubcategory.subcategory : null,
        color_id: this.special_item.color_id,
        color_name: selectedColor ? selectedColor.text : null,
        size_id: this.special_item.size_id,
        size_name: selectedSize ? selectedSize.text : null,
        vendor: this.special_item.vendor,
        vendor_name: this.getVendorName(this.special_item.vendor), // Store vendor name too
        quantity: parseInt(this.special_item.quantity),
        selling_price: parseFloat(this.special_item.selling_price),
        new_selling_price: parseFloat(this.special_item.selling_price),
        discount_offered: 0.0,
        is_special: true,  // This makes it a SPECIAL ORDER
        is_non_inventory: false,  // This MUST BE FALSE for special orders
        sourceContext: 'store',
        source: 'store',
        image_url: this.nonInventoryImage.uploadedUrl || null,
        order_type: 'customer_takes', // Default to customer takes
        delivery_date: moment().format("MM-DD-YYYY"),
        existing: false,
        quantity_per_box: 1,
        // =============================================
        // CRITICAL: Use 'special_order_metadata' for special orders
        // =============================================
        special_order_metadata: {
            category_id: this.special_item.category_id,
            category_name: selectedCategory ? selectedCategory.category_name : null,
            subcategory_id: this.special_item.subcategory_id,
            subcategory_name: selectedSubcategory ? selectedSubcategory.subcategory : null,
            color_id: this.special_item.color_id,
            color_name: selectedColor ? selectedColor.text : null,
            size_id: this.special_item.size_id,
            size_name: selectedSize ? selectedSize.text : null,
            vendor: this.special_item.vendor,
            vendor_name: this.getVendorName(this.special_item.vendor),
            description: description, // Store the description
            product_name: description, // Store description as product name
            added_by: this.userDetails.username,
            added_at: new Date().toISOString(),
            status: 'pending',
            notes: ''
        }
    };
    
    // DEBUG: Log what we're sending
    console.log("=== ADDING SPECIAL ORDER ITEM ===");
    console.log("Item:", itemToAdd);
    console.log("special_order_metadata:", itemToAdd.special_order_metadata);
    console.log("is_special:", itemToAdd.is_special);
    console.log("is_non_inventory:", itemToAdd.is_non_inventory);
    console.log("product_name:", itemToAdd.product_name);
    console.log("================================");
    
    this.addProduct(itemToAdd);
    this.resetNonInventoryForm();
    
    this.$bvToast.toast(
        `Special order item ${itemToAdd.product_sku} added to sale!`,
        {title: "Success", autoHideDelay: 2000, variant: "success"}
    );
},

// Reset non-inventory form
// Reset non-inventory form
resetNonInventoryForm() {
    this.special_item = {
        product_id: null,
        product_sku: null,
        product_name: null, // ← This will be cleared now
        category_id: null,
        subcategory_id: null,
        color_id: null,
        size_id: null,
        quantity: null,
        selling_price: null,
        new_selling_price: null,
        discount_offered: 0.0,
        vendor: null,
        sourceContext: 'store',
        source: 'store'
    };
    
    this.clearNonInventoryImage();
    
    // Collapse the section
    this.$root.$emit('bv::toggle::collapse', 'collapse-2');
},
            removeLayawayItemWithTracking: function(item) {
    let that = this;
    
    this.$bvModal.msgBoxConfirm(
        `Remove ${item.product_sku || item.product_name} from layaway?`,
        {
            title: 'Remove Item',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'REMOVE',
            cancelTitle: 'CANCEL'
        }
    ).then(value => {
        if (value) {
            // Add to refund_items array (with special flag for layaway removal)
            const itemCopy = JSON.parse(JSON.stringify(item));
            itemCopy.return_quantity = item.quantity; // Remove all quantity
            itemCopy.removal_type = 'layaway_removal'; // Mark as layaway removal
            itemCopy.original_removal = true;
            
            that.refund_items.push(itemCopy);
            
            // Remove from main items array
            const index = that.invoice.items.findIndex(i => 
                i.itemid === item.itemid && i.product_sku === item.product_sku
            );
            if (index !== -1) {
                that.invoice.items.splice(index, 1);
            }
            
            // Mark that validation is needed
            that.current_refund_validated = false;
            
            // Auto-validate if only removing (no refund)
            that.autoValidateLayawayRemoval();
        }
    });
},

autoValidateLayawayRemoval: function() {
    // Calculate the amount to remove (just item price, no refund)
    let removalAmount = 0;
    
    this.refund_items.forEach(item => {
        if (item.removal_type === 'layaway_removal') {
            removalAmount += (parseFloat(item.selling_price) * parseInt(item.return_quantity)) - 
                            (parseInt(item.return_quantity) * parseFloat(item.unit_discount_value || 0));
        }
    });
    
    if (removalAmount > 0) {
        this.refund_charges.total_refunded_currently = removalAmount;
        this.refund_charges.tax_refunded_currently = 0; // No tax refund for layaway removal
        this.current_refund_validated = true;
        
        this.$bvToast.toast(
            `Item(s) marked for removal. Total adjustment: $${removalAmount.toFixed(2)}`,
            {title: "Ready for Update", autoHideDelay: 2000, variant: "info"}
        );
    }
},
  canRemoveSpecificItem(item) {
        if (!this.invoice.edit || this.payment_history.length === 0) {
            return true;
        }
        
        const totalPaid = this.getTotalPaymentsFromHistory();
        const grandTotal = this.getGrandTotal();
        
        // If fully paid, no items can be removed
        if (totalPaid >= grandTotal) {
            return false;
        }
        
        // Optional: Check if this specific item's price is fully covered by payments
        // This would require tracking payments per item which is more complex
        
        return true;
    },
            removeLayawayItem: function(item) {
    let that = this;
    
    // Confirm with user
    this.$bvModal.msgBoxConfirm(
        `Are you sure you want to remove ${item.product_sku || item.product_name} from this layaway?`,
        {
            title: 'Remove Item from Layaway',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'REMOVE',
            cancelTitle: 'CANCEL',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        }
    ).then(value => {
        if (value) {
            // Proceed with removal
            that.loading = true;
            
            let path = "/api/sales/remove_layaway_item/";
            let data = {
                invoice_id: that.invoice.invoice_id,
                itemid: item.itemid,
                product_sku: item.product_sku,
                username: that.userDetails.username
            };
            
            let s = function(response) {
                if (response.data.error) {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 3000, variant: "warning"}
                    );
                } else {
                    that.$bvToast.toast(
                        `Item removed successfully!`,
                        {title: "Success", autoHideDelay: 2000, variant: "success"}
                    );
                    
                    // Remove the item from the local array
                    const index = that.invoice.items.findIndex(i => 
                        i.itemid === item.itemid && i.product_sku === item.product_sku
                    );
                    if (index !== -1) {
                        that.invoice.items.splice(index, 1);
                    }
                    
                    // Update invoice totals if returned from API
                    if (response.data.result && response.data.result.new_total) {
                        that.invoice.total = response.data.result.new_total;
                    }
                    
                    // Force refresh of computed totals
                    that.$forceUpdate();
                }
                that.loading = false;
            };
            
            let f = function(error) {
                console.log(error);
                that.$bvToast.toast(
                    "Error removing item. Please try again.",
                    {title: "Error", autoHideDelay: 3000, variant: "danger"}
                );
                that.loading = false;
            };
            
            Requestor.postSyncP(path, data, this, s, f);
        }
    });
},
            // Add to your methods section
// Add to your methods section
getFilteredSublocationBreakdown: function(product) {
    if (!product.sublocation_breakdown || product.sublocation_breakdown.length === 0) {
        return [];
    }
    
    // Filter to show only locations with available > 0 and format nicely
    return product.sublocation_breakdown
        .filter(loc => loc.available > 0)
        .map(loc => ({
            ...loc,
            // Keep original data
        }))
        .sort((a, b) => b.available - a.available); // Sort by highest available first
},

getShortLocationName: function(fullName) {
    if (!fullName) return 'Unknown';
    
    // Extract just the location type/name without the full path
    // Examples: "MAIN STORE | STOCK" -> "STOCK"
    //           "MAIN STORE | FLOOR" -> "FLOOR"
    //           "WAREHOUSE | AISLE 5" -> "AISLE 5"
    
    const parts = fullName.split('|');
    if (parts.length > 1) {
        // Return the last part after the last pipe, trimmed
        return parts[parts.length - 1].trim();
    }
    
    // If no pipe, return the whole name but truncated
    return fullName.length > 15 ? fullName.substring(0, 12) + '...' : fullName;
},

getLocationClass: function(locationName) {
    if (!locationName) return 'default';
    
    const name = locationName.toLowerCase();
    if (name.includes('stock')) return 'stock';
    if (name.includes('floor')) return 'floor';
    if (name.includes('damage') || name.includes('as is')) return 'damage';
    if (name.includes('warehouse')) return 'warehouse';
    if (name.includes('backorder')) return 'backorder';
    return 'default';
},
                openCustomerInfoModal() {
  // Pre-fill modal with existing customer data if available
  this.modalCustomer = {
    fullname: this.invoice.customer.fullname || '',
    email: this.invoice.customer.email || '',
    phone: this.invoice.customer.phone || '',
    phone_2: this.invoice.customer.phone_2 || '',
    address_line_1: this.invoice.customer.address_line_1 || '',
    address_line_2: this.invoice.customer.address_line_2 || '',
    city: this.invoice.customer.city || '',
    state: this.invoice.customer.state || null,
    zipcode: this.invoice.customer.zipcode || ''
  };
  
  this.modalTermsAgreed = false;
  this.modalWarrantyRefused = false;
  this.modalPolicyLanguage = this.policyLanguage;
  
  this.$bvModal.show('modal-customer-info');
  
  // Clear signature pad
  this.$nextTick(() => {
    if (this.$refs.modalSignaturePad) {
      this.$refs.modalSignaturePad.clearSignature();
    }
  });
},

// Reset modal state when closed
resetCustomerInfoModal() {
  this.signatureUploading = false;
  // Don't clear modalCustomer here - keep data for next time
},

// Set zipcode from suggestion
setModalZipcode(suggestion) {
  this.modalCustomer.zipcode = suggestion.zip_code;
  this.modalCustomer.city = suggestion.city;
  this.modalCustomer.state = suggestion.state;
},

// Clear signature
clearSignature() {
  if (this.$refs.modalSignaturePad) {
    this.$refs.modalSignaturePad.clearSignature();
  }
},

// Check if modal submit is enabled
isModalSubmitEnabled() {
  // Check required fields
  if (!this.modalCustomer.fullname || !this.modalCustomer.email || !this.modalCustomer.phone) {
    return false;
  }
  
  // Check terms agreement
  if (!this.modalTermsAgreed) {
    return false;
  }
  
  // Check warranty refusal if applicable
  if (!this.hasWarrantyCharges && !this.modalWarrantyRefused) {
    return false;
  }
  
  // Check signature
  if (!this.$refs.modalSignaturePad || this.$refs.modalSignaturePad.isEmpty()) {
    return false;
  }
  
  return true;
},

// Save customer info from modal
async saveCustomerInfo() {
  if (!this.isModalSubmitEnabled()) return;
  
  this.signatureUploading = true;
  
  try {
    // 1. Save customer info to invoice
    this.invoice.customer = {
      fullname: this.modalCustomer.fullname,
      email: this.modalCustomer.email,
      phone: this.modalCustomer.phone,
      phone_2: this.modalCustomer.phone_2,
      address_line_1: this.modalCustomer.address_line_1,
      address_line_2: this.modalCustomer.address_line_2,
      city: this.modalCustomer.city,
      state: this.modalCustomer.state,
      zipcode: this.modalCustomer.zipcode,
    floor: this.modalCustomer.floor
    };
    
    // 2. Set warranty refusal flag if applicable
    this.warrantyRefused = this.modalWarrantyRefused;
    
    // 3. Save signature
    if (this.$refs.modalSignaturePad && !this.$refs.modalSignaturePad.isEmpty()) {
      const signatureData = this.$refs.modalSignaturePad.getSignatureData();
      
      if (!this.invoice.edit) {
        // New invoice - store temporarily
        this.invoice.signature_temp_data = signatureData;
        this.invoice.has_signature = true;
        this.invoice.signature_uploaded_at = new Date().toISOString();
      } else {
        // Existing invoice - upload immediately
        const uploadData = {
          image_data: signatureData,
          invoice_id: this.invoice.invoice_id,
          signature_type: 'customer',
          customer_name: this.modalCustomer.fullname,
          username: this.userDetails.username
        };
        
        const response = await this.uploadSignature(uploadData);
        
        if (response && response.success) {
          this.invoice.has_signature = true;
          this.invoice.signature_url = response.url;
          this.invoice.signature_uploaded_at = response.uploaded_at;
        }
      }
    }
    
    // 4. Set policy agreed flag
    this.policyAgreed = true;
    
    this.$bvToast.toast(
      "Customer information and signature saved successfully!",
      {title: "Success", autoHideDelay: 2000, variant: "success"}
    );
    
    this.$bvModal.hide('modal-customer-info');
    
  } catch (error) {
    console.error("Error saving customer info:", error);
    this.$bvToast.toast(
      "Failed to save customer information: " + (error.message || "Unknown error"),
      {title: "Error", autoHideDelay: 3000, variant: "danger"}
    );
  } finally {
    this.signatureUploading = false;
  }
},
                // Add this method to test receipt generation without printing
testExchangeReceipt() {
    console.log("=== TESTING EXCHANGE RECEIPT GENERATION ===");
    console.log("Refund items:", this.refund_items);
    console.log("New items:", this.invoice.items.filter(item => !item.existing));
    console.log("Refund total calculated:", this.refund_items.reduce((sum, item) => {
        const price = parseFloat(item.selling_price) || 0;
        const qty = parseInt(item.return_quantity) || 0;
        const discount = parseFloat(item.unit_discount_value) || 0;
        return sum + (price * qty) - (discount * qty);
    }, 0));
    console.log("New items total:", this.invoice.items.filter(item => !item.existing).reduce((sum, item) => {
        const price = this.hasActiveDiscount(item) ? 
            parseFloat(item.special_discount_price) : 
            (parseFloat(item.new_selling_price) || parseFloat(item.selling_price) || 0);
        const qty = parseInt(item.quantity) || 1;
        const discount = parseFloat(item.discount_offered) || 0;
        return sum + (price * qty) - discount;
    }, 0));
    console.log("Charges total:", this.getChargesTotal());
    console.log("Sales tax:", this.getSalesTax());
    
    // Generate HTML and log a preview
    const html = this.generateExchangeReceiptHTML();
    console.log("Receipt HTML length:", html.length);
    console.log("Receipt preview:", html.substring(0, 500) + "...");
    
    this.$bvToast.toast(
        "Receipt test complete - check console for details",
        {title: "Test Complete", variant: "info"}
    );
},
         refreshAvailableRefundAmounts() {
    if (!this.invoice.invoice_id) {
        this.$bvToast.toast(
            "No invoice ID available",
            {title: "Error", autoHideDelay: 1500, variant: "warning"}
        );
        return;
    }
    
    // Reload payment methods and recalculate
    this.loadPaymentMethodsOnly();
    this.loadRefundsHistory();
    
    // Force recalculation after a short delay to ensure data is loaded
    setTimeout(() => {
        this.calculateAvailableRefundAmounts();
        this.$forceUpdate(); // Force re-render
        
        this.$bvToast.toast(
            "Available refund amounts updated",
            {title: "Success", autoHideDelay: 1500, variant: "success"}
        );
    }, 500);
},
                  getWarrantyTotal() {
        let warrantyTotal = 0;
        
        // Get warranty charges from invoice
        if (this.invoice.edit && this.refund_items.length <= 0) {
            warrantyTotal = parseFloat(this.invoice.new_warranty_charges) || 0;
        } else {
            warrantyTotal = parseFloat(this.invoice.warranty_charges) || 0;
        }
        
        // Also check individual items for warranty-related fields if needed
        // Add any additional warranty calculations here
        
        return warrantyTotal;
    },
    
    formatCurrency(value) {
        return '$' + parseFloat(value || 0).toFixed(2);
    },
            // Add to your methods
fetchPolicy: function() {
    let that = this;
    
    // Fetch English policy
    let pathEn = "/api/policy/get_policy/";
    let dataEn = {language: 'en'};
    
    let sEn = function(response) {
        if (response.data.result && response.data.result.length > 0) {
            that.policyText = response.data.result[0].text;
        } else {
            that.policyText = '<p>Please read and agree to our standard terms and conditions.</p>';
        }
    };
    
    // Fetch Spanish policy
    let pathEs = "/api/policy/get_policy/";
    let dataEs = {language: 'es'};
    
    let sEs = function(response) {
        if (response.data.result && response.data.result.length > 0) {
            that.policyTextSpanish = response.data.result[0].text;
        } else {
            // Fallback Spanish text
            that.policyTextSpanish = '<p>Por favor, lea y acepte nuestros términos y condiciones estándar.</p>';
        }
    };
    
    let f = function(error) {
        console.error("Error loading policy:", error);
        that.policyText = '<p>Please read and agree to our standard terms and conditions.</p>';
        that.policyTextSpanish = '<p>Por favor, lea y acepte nuestros términos y condiciones estándar.</p>';
    };
    
    Requestor.getAsyncP(pathEn, dataEn, this, sEn, f);
    Requestor.getAsyncP(pathEs, dataEs, this, sEs, f);
},

                printReceipt() {
    // Create a hidden iframe for printing
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    // Get the receipt HTML content
    const receiptContent = this.generateReceiptHTML();
    
    // Write to iframe and print
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(receiptContent);
    frameDoc.close();

    // Wait for content to load then print
    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            // Remove iframe after printing
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
},

generateReceiptHTML() {
    // Get location name from selected_locsub
     let locationName = this.invoice.location_address || '';
    if (!locationName && this.invoice.selected_locsub) {
        const loc = this.packet.locsubs.find(l => l.value === this.invoice.selected_locsub);
        locationName = loc ? loc.text : 'Store Location';
    } else if (!locationName) {
        locationName = 'FURNITURE MECCA';
    }

    // Format date
    const currentDate = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    // Get invoice number
    const invoiceNumber = this.invoice.invoice_id || this.invoice.draft_id || 'DRAFT';

    // Get salesperson name
    const salesperson = (this.invoice.username || this.userDetails.username || '').toUpperCase();

    // Get customer name
    const customerName = this.invoice.customer.fullname || 'Walk-in Customer';

    // Get items - filter out fully refunded items if in edit mode
    let items = this.invoice.items || [];
    if (this.invoice.edit) {
        items = items.filter(item => {
            if (item.existing) {
                const remainingQty = item.quantity - (item.refunded_so_far_quantity || 0);
                return remainingQty > 0;
            }
            return true;
        });
    }

    // Calculate totals using your existing methods
    const totalDiscount = this.getTotalDiscount();
    const orderTotal = this.getOrderTotal();
    const delivery = this.invoice.delivery_charges || 0;
    const setup = this.invoice.setup_charges || 0;
    const warranty = this.invoice.warranty_charges || 0;
    const subtotal = this.getSubTotal();
    const taxableSubtotal = this.adjust_to_taxable_amount(this.getSubTotal());
    const salesTax = this.getSalesTax();
    const specialDiscounts = this.getTotalSpecialDiscounts();
    const grandTotal = this.getGrandTotal();
    
    // FIXED: Calculate balance correctly for both new and existing invoices
    let balance = 0;
    const totalPayments = this.getTotalPayments();
    
    if (this.invoice.edit) {
        // For existing invoices, use getTotalBalance()
        balance = this.getTotalBalance();
    } else {
        // For new invoices, calculate balance as grand total minus payments
        balance = grandTotal - totalPayments;
    }
    
    // Round to 2 decimal places to avoid floating point issues
    balance = Math.round(balance * 100) / 100;

    // Get payment methods with details
    const paymentMethods = this.getPaymentMethods();

    // Build receipt HTML
    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Receipt - ${invoiceNumber}</title>
            <style>
                @page {
                    size: 80mm auto;
                    margin: 0;
                }
                body {
                    font-family: 'Courier New', monospace;
                    font-size: 12px;
                    width: 72mm;
                    margin: 0 auto;
                    padding: 2mm;
                    line-height: 1.3;
                }
                .header {
                    text-align: center;
                    font-weight: bold;
                    margin-bottom: 3mm;
                }
                .store-name {
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                .store-location {
                    font-size: 12px;
                    margin-top: 1mm;
                }
                .divider {
                    border-top: 1px dashed #000;
                    margin: 2mm 0;
                }
                .info-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .info-label {
                    font-weight: bold;
                }
                .items-header {
                    font-weight: bold;
                    border-bottom: 1px solid #000;
                    margin-top: 3mm;
                    padding-bottom: 1mm;
                }
                .item-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .item-desc {
                    max-width: 45mm;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-weight: bold;
                }
                .item-amount {
                    text-align: right;
                    font-weight: bold;
                    font-size: 13px;
                }
                .totals {
                    margin-top: 3mm;
                }
                .total-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .grand-total {
                    font-weight: bold;
                    font-size: 18px;
                    border-top: 1px solid #000;
                    border-bottom: 1px solid #000;
                    padding: 3mm 0;
                    margin: 3mm 0;
                }
                .balance {
                    font-weight: bold;
                    font-size: 14px;
                    background: #f0f0f0;
                    padding: 1mm;
                }
                .payment-detail {
                    font-size: 10px;
                    margin-left: 2mm;
                    color: #666;
                }
                .footer {
                    text-align: center;
                    margin-top: 5mm;
                    font-size: 10px;
                }
                .thank-you {
                    font-size: 18px;
                    font-weight: bold;
                    margin: 4mm 0;
                    letter-spacing: 1px;
                }
                .cut-line {
                    text-align: center;
                    margin-top: 5mm;
                    font-size: 10px;
                }
                .bold-text {
                    font-weight: bold;
                }
                /* Prominent text styles */
                .prominent-amount {
                    font-weight: bold;
                    font-size: 14px;
                    color: #000;
                }
                .prominent-id {
                    font-weight: bold;
                    font-size: 13px;
                    letter-spacing: 0.5px;
                }
                .prominent-name {
                    font-weight: bold;
                    font-size: 13px;
                    text-transform: uppercase;
                }
                .amount-value {
                    font-weight: bold;
                    font-size: 13px;
                }
                .invoice-number {
                    font-weight: bold;
                    font-size: 14px;
                    background: #f8f8f8;
                    padding: 1px 3px;
                }
                .salesperson-name {
                    font-weight: bold;
                    font-size: 13px;
                    color: #222;
                }
                .customer-name {
                    font-weight: bold;
                    font-size: 13px;
                    color: #222;
                    text-transform: uppercase;
                }
                /* Style for all monetary values */
                .monetary-value {
                    font-weight: bold;
                    font-size: 13px;
                }
                /* Right align for amounts */
                .amount-right {
                    text-align: right;
                    font-weight: bold;
                }
                /* SKU styling */
                .sku-text {
                    font-weight: bold;
                }
            </style>
        </head>
        <body>
            <div class="header">
                <div class="store-name">FURNITURE MECCA</div>
                <div class="store-location">${locationName}</div>
                <div class="store-location">${currentDate}</div>
            </div>

            <div class="divider"></div>

            <div class="info-row">
                <span class="info-label">INVOICE #:</span>
                <span class="invoice-number">${invoiceNumber}</span>
            </div>
            <div class="info-row">
                <span class="info-label">SALESPERSON:</span>
                <span class="salesperson-name">${salesperson}</span>
            </div>
            <div class="info-row">
                <span class="info-label">CUSTOMER:</span>
                <span class="customer-name">${customerName}</span>
            </div>

            <div class="items-header">ITEM DETAILS</div>
            
            ${items.map(item => {
                const price = this.hasActiveDiscount(item) ? 
                    parseFloat(item.special_discount_price) : 
                    (parseFloat(item.new_selling_price) || parseFloat(item.selling_price) || 0);
                const qty = parseInt(item.quantity) || 1;
                const discount = parseFloat(item.discount_offered) || 0;
                const itemTotal = (price * qty) - discount;
                const desc = item.product_name || item.product_sku || 'Item';
                const sku = item.product_sku || '';
                
                return `
                    <div class="item-row">
                        <span class=" bold-text item-desc sku-text">${sku}</span>
                        <span class="item-amount">$${itemTotal.toFixed(2)}</span>
                    </div>
                    <div style="font-size: 10px; margin-left: 2mm; margin-bottom: 1mm;">
                        <span class="bold-text">${desc.substring(0, 30)}${desc.length > 30 ? '...' : ''}</span><br>
                        <span class="monetary-value">$${price.toFixed(2)}</span> x ${qty} ${discount > 0 ? `(-<span class="monetary-value">$${discount.toFixed(2)}</span>)` : ''}
                        ${item.is_damaged ? ' ⚠️ AS-IS' : ''}
                    </div>
                `;
            }).join('')}

            <div class="divider"></div>

            <div class="totals">
                <div class="total-row">
                    <span class="bold-text">TOTAL DISCOUNT:</span>
                    <span class="monetary-value">$${totalDiscount.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">ORDER TOTAL:</span>
                    <span class="monetary-value">$${orderTotal.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">DELIVERY:</span>
                    <span class="monetary-value">$${delivery.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">SETUP:</span>
                    <span class="monetary-value">$${setup.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">WARRANTY:</span>
                    <span class="monetary-value">$${warranty.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">SUBTOTAL:</span>
                    <span class="monetary-value">$${subtotal.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">TAXABLE SUBTOTAL:</span>
                    <span class="monetary-value">$${taxableSubtotal.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">SALES TAX:</span>
                    <span class="monetary-value">$${salesTax.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span class="bold-text">SPECIAL DISCOUNTS:</span>
                    <span class="monetary-value">$${specialDiscounts.toFixed(2)}</span>
                </div>
                
                <div class="grand-total total-row">
                    <span class="bold-text">GRAND TOTAL:</span>
                    <span class="prominent-amount">$${grandTotal.toFixed(2)}</span>
                </div>
            </div>

            ${paymentMethods.length > 0 ? `
                <div class="divider"></div>
                <div class="bold-text" style="margin-bottom: 1mm;">PAYMENTS</div>
                ${paymentMethods.map(pm => {
                    let details = '';
                    if (pm.value === 'finance' && pm.name) {
                        details = `<div class="payment-detail"><span class="bold-text">COMPANY:</span> <span class="prominent-name">${pm.name}</span> ${pm.lease_id ? `(<span class="bold-text">LEASE:</span> <span class="prominent-id">${pm.lease_id}</span>)` : ''}</div>`;
                    } else if (pm.value === 'cc' && pm.name) {
                        details = `<div class="payment-detail"><span class="bold-text">CARD:</span> ****<span class="prominent-id">${pm.name}</span></div>`;
                    } else if (pm.value === 'tax_exempt' && pm.name) {
                        details = `<div class="payment-detail"><span class="bold-text">COMPANY:</span> <span class="prominent-name">${pm.name}</span></div>`;
                    }
                    
                    return `
                        <div class="total-row">
                            <span class="bold-text">${(pm.value || '').toUpperCase()}:</span>
                            <span class="monetary-value">$${(parseFloat(pm.amount) || 0).toFixed(2)}</span>
                        </div>
                        ${details}
                    `;
                }).join('')}
                
                <div class="total-row" style="font-weight: bold; margin-top: 2mm;">
                    <span class="bold-text">TOTAL PAID:</span>
                    <span class="prominent-amount">$${totalPayments.toFixed(2)}</span>
                </div>
            ` : ''}

            <div class="balance total-row">
                <span class="bold-text">BALANCE:</span>
                <span class="prominent-amount">$${balance.toFixed(2)}</span>
            </div>

            ${this.invoice.comment_txt ? `
                <div class="divider"></div>
                <div style="font-size: 10px;">
                    <span class="bold-text">COMMENTS:</span>
                    <div class="prominent-name">${this.invoice.comment_txt}</div>
                </div>
            ` : ''}

            <div class="footer">
                <div class="thank-you">THANK YOU FOR SHOPPING WITH US!</div>
               
                ${!this.invoice.invoice_id ? '✓ DRAFT - Not Final' : ''}
            </div>

            <div class="cut-line">- - - - - - - - - - - - - - - - - - - -</div>
        </body>
        </html>
    `;
},
configurePrinterSettings() {
    // This will be applied when printing
    const style = document.createElement('style');
    style.innerHTML = `
        @page {
            size: 80mm 297mm;
            margin: 0mm;
        }
        @media print {
            body {
                width: 72mm;
                margin: 0 auto;
            }
        }
    `;
    document.head.appendChild(style);
},

// Test printer connection
testPrinter() {
    // Simple test - try to print a test page
    const testFrame = document.createElement('iframe');
    testFrame.style.display = 'none';
    document.body.appendChild(testFrame);
    
    const testDoc = testFrame.contentWindow.document;
    testDoc.open();
    testDoc.write(`
        <html>
        <head>
            <style>@page { size: 80mm auto; }</style>
        </head>
        <body style="font-family: monospace; width: 72mm; padding: 2mm;">
            <div style="text-align: center;">
                <h3>PRINTER TEST</h3>
                <p>If you can read this, your printer is working!</p>
                <p>${new Date().toLocaleString()}</p>
            </div>
        </body>
        </html>
    `);
    testDoc.close();
    
    setTimeout(() => {
        testFrame.contentWindow.print();
        setTimeout(() => document.body.removeChild(testFrame), 1000);
    }, 500);
},
                    openInvoiceSignatureModal() {
        this.signatureItem = {
            type: 'invoice',
            invoice_id: this.invoice.invoice_id,
            customer_name: this.invoice.customer.fullname || 'Customer'
        };
        this.$bvModal.show('modal-signature');
        
        // Reset signature pad when modal opens
        this.$nextTick(() => {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature();
                
                // If invoice already has a signature, load it
                if (this.invoice.signature_url) {
                    this.$refs.signaturePad.loadSignatureFromUrl(this.invoice.signature_url);
                }
            }
        });
    },
                  // Check if signature pad has drawing
  // Check if signature pad has drawing
  hasSignature() {
    return this.$refs.signaturePad && !this.$refs.signaturePad.isEmpty();
  },
  
  // Open signature modal for specific item
  openSignatureModal(item) {
    this.signatureItem = item;
    this.$bvModal.show('modal-signature');
    
    // Reset signature pad when modal opens
    this.$nextTick(() => {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
        
        // If item already has a signature, load it
        if (item.signature_url) {
          this.$refs.signaturePad.loadSignatureFromUrl(item.signature_url);
        }
      }
    });
  },
  
  // Reset signature modal state
  resetSignatureModal() {
    this.signatureItem = null;
    this.signatureUploading = false;
    if (this.$refs.signaturePad) {
      this.$refs.signaturePad.clearSignature();
    }
  },
  
  // Save signature to Azure and update invoice_item
   async saveSignature() {
        if (!this.signatureItem || !this.$refs.signaturePad) return;
        
        // Check if signature is empty
        if (this.$refs.signaturePad.isEmpty()) {
            this.$bvToast.toast(
                "Please draw a signature first",
                {title: "Info", autoHideDelay: 2000, variant: "warning"}
            );
            return;
        }
        
        this.signatureUploading = true;
        
        try {
            // Get signature as base64 data
            const signatureData = this.$refs.signaturePad.getSignatureData();
            
            // For new invoices (no invoice_id yet), store temporarily
            if (!this.invoice.edit) {
                // Store signature temporarily
                this.invoice.signature_temp_data = signatureData;
                this.invoice.has_signature = true;
                this.invoice.signature_uploaded_at = new Date().toISOString();
                
                this.$bvToast.toast(
                    "Signature will be saved when invoice is submitted!",
                    {title: "Info", autoHideDelay: 2000, variant: "info"}
                );
                
                this.$bvModal.hide('modal-signature');
                return;
            }
            
            // Prepare data for upload
            const uploadData = {
                image_data: signatureData,
                invoice_id: this.invoice.invoice_id,
                signature_type: 'customer',
                customer_name: this.invoice.customer.fullname || 'Customer',
                username: this.userDetails.username
            };
            
            // Call API to upload signature
            const response = await this.uploadSignature(uploadData);
            
            if (response && response.success) {
                console.log("Signature uploaded successfully:", response);
                // Update the invoice with signature info
                this.invoice.has_signature = true;
                this.invoice.signature_url = response.url;
                this.invoice.signature_uploaded_at = response.uploaded_at;
                
                this.$bvToast.toast(
                    "Customer signature saved successfully!",
                    {title: "Success", autoHideDelay: 2000, variant: "success"}
                );
                
                // Close modal
                this.$bvModal.hide('modal-signature');
            }
        } catch (error) {
            console.error("Error saving signature:", error);
            this.$bvToast.toast(
                "Failed to save signature: " + (error.message || "Unknown error"),
                {title: "Error", autoHideDelay: 3000, variant: "danger"}
            );
        } finally {
            this.signatureUploading = false;
        }
    },
  
  // API call to upload signature
  async uploadSignature(data) {
    const path = "/api/sales/upload_signature/";
    
    return new Promise((resolve, reject) => {
      let that = this;
      
      let s = function(response) {
        if (response.data.error) {
          reject(new Error(response.data.error));
        } else {
          resolve(response.data.result);
        }
      };
      
      let f = function(error) {
        console.error("Signature upload error:", error);
        reject(error);
      };
      
      Requestor.postSyncP(path, data, this, s, f);
    });
  },
  
  // Process signatures when submitting invoice
  processSignaturesBeforeSubmit() {
    // Check if any items have temporary signature data
    const itemsWithTempSignature = this.invoice.items.filter(item => item.signature_temp_data);
    
    if (itemsWithTempSignature.length > 0) {
      // You could either:
      // 1. Warn user that signatures will be uploaded after invoice is created
      // 2. Block submission and ask them to upload signatures after invoice is created
      
      this.$bvToast.toast(
        `${itemsWithTempSignature.length} item(s) have signatures that will be uploaded after invoice creation.`,
        {title: "Info", autoHideDelay: 3000, variant: "info"}
      );
    }
    
    return true;
  },
                // Add to methods section
// In your methods section, update the loadDraftInvoice method:
loadDraftInvoice(draftId) {
    let that = this;
    let path = "/api/sales/get_draft_invoice/";
    let data = {draft_id: draftId};
    
    let s = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 3000, variant:"warning"}
            );
        } else {
            const draft = response.data.result;
            
            // Populate invoice with draft data
            that.invoice = {
                ...that.get_invoice_data(),
                ...draft.data,
                draft_id: draft.draft_id,
                // Use the stored invoice_id if available, otherwise use draft_id
                invoice_id: draft.data.invoice_id || draft.draft_id,
                location_id: draft.location_id,
                sublocation_id: draft.sublocation_id,
                edit: false,
                // CRITICAL: Set the username to the one who saved the draft
                username: draft.username || draft.data.username 
            };
            
            // RESTORE AGREEMENT FIELDS from draft data
            that.deliveryWaiverAgreed = draft.data.delivery_waiver_agreed || false;
            that.spacePreparationAgreed = draft.data.space_preparation_agreed || false;
            that.deliveryDamageWaiverAgreed = draft.data.delivery_damage_waiver_agreed || false; // NEW FIELD
            that.policyAgreed = draft.data.terms_agreed || false;
            that.warrantyRefused = draft.data.warranty_refused || false;
                 that.invoice.address_confirmation_agreed = draft.data.address_confirmation_agreed || false;
            
            that.$bvToast.toast(
                "Draft loaded successfully!",
                {title: "Success", autoHideDelay: 2000, variant:"success"}
            );
        }
        that.loading = false;
    };
    
    let f = function(error) {
        console.error(error);
        that.$bvToast.toast(
            "Error loading draft.",
            {title: "Error", autoHideDelay: 3000, variant:"danger"}
        );
        that.loading = false;
    };
    
    this.loading = true;
    Requestor.postSyncP(path, data, this, s, f);
},
     saveDraftInvoice() {
    let that = this;
    
    // Validate minimum data (at least items)
    if (this.invoice.items.length === 0) {
        this.$bvToast.toast(
            "Please add at least one item before saving as draft.",
            {title: "Info", autoHideDelay: 2000, variant: "warning"}
        );
        return;
    }
    
    // Use the generated invoice_id as the draft_id if it exists
    let draftId = this.invoice.invoice_id || this.invoice.draft_id;
    
    // Prepare draft data with ALL calculated values and agreement fields
    let draftData = {
        draft_id: draftId,
        username: this.userDetails.username,
        location_id: this.invoice.location_id,
        sublocation_id: this.invoice.sublocation_id,
        invoice_id: this.invoice.invoice_id,
        customer: this.invoice.customer,
        items: this.invoice.items,
        delivery_charges: this.invoice.delivery_charges,
        setup_charges: this.invoice.setup_charges,
        warranty_charges: this.invoice.warranty_charges,
        payment_methods: this.invoice.payment_methods,
        comment_txt: this.invoice.comment_txt,
        sold_from_state: this.invoice.sold_from_state,
        selected_locsub: this.invoice.selected_locsub,
        is_layaway: this.invoice.is_layaway,
        tax_perc: this.invoice.tax_perc,
        delivery_waiver_agreed: this.deliveryWaiverAgreed,
        space_preparation_agreed: this.spacePreparationAgreed,
        delivery_damage_waiver_agreed: this.deliveryDamageWaiverAgreed,
        terms_agreed: this.policyAgreed,
        warranty_refused: this.warrantyRefused,
        address_confirmation_agreed: this.invoice.address_confirmation_agreed,
        subtotal: this.getSubTotal(),
        taxable_subtotal: this.adjust_to_taxable_amount(this.getSubTotal()),
        sales_tax: this.getSalesTax(),
        total: this.getSubTotal() + this.getSalesTax(),
        order_total: this.getOrderTotal(),
        total_discount: this.getTotalDiscount(),
        charges_total: this.getChargesTotal(),
        grand_total: this.getGrandTotal(),
        balance: this.getTotalBalance(),
        total_special_discounts: this.getTotalSpecialDiscounts(),
        store_credit_applied: this.getStoreCreditApplied(),
        remaining_store_credit: this.getRemainingStoreCredit(),
        
        // IMPORTANT: Don't send email for regular save
        send_to_customer: false  // This flag tells backend NOT to send email
    };
    
    let path = "/api/sales/save_draft_invoice/";
    
    let s = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 3000, variant: "warning"}
            );
        } else {
            that.invoice.draft_id = response.data.result.draft_id;
            if (!that.invoice.invoice_id) {
                that.invoice.invoice_id = response.data.result.draft_id;
            }
            
            that.$bvToast.toast(
                "Draft invoice saved successfully!",
                {title: "Success", autoHideDelay: 2000, variant: "success"}
            );
        }
        that.loading = false;
    };
    
    let f = function(error) {
        console.error(error);
        that.$bvToast.toast(
            "Error saving draft. Please try again.",
            {title: "Error", autoHideDelay: 3000, variant: "danger"}
        );
        that.loading = false;
    };
    
    this.loading = true;
    Requestor.postSyncP(path, draftData, this, s, f);
},

// loadDraftInvoice(draftId) {
//     let that = this;
//     let path = "/api/sales/get_draft_invoice/";
//     let data = {draft_id: draftId};
    
//     let s = function(response) {
//         if (response.data.error) {
//             that.$bvToast.toast(
//                 response.data.error,
//                 {title: "Error", autoHideDelay: 3000, variant:"warning"}
//             );
//         } else {
//             const draft = response.data.result;
            
//             // Populate invoice with draft data
//             that.invoice = {
//                 ...that.get_invoice_data(),
//                 ...draft.data,
//                 draft_id: draft.draft_id,
//                 location_id: draft.location_id,
//                 sublocation_id: draft.sublocation_id,
//                 edit: false // Still in draft mode
//             };
            
//             that.$bvToast.toast(
//                 "Draft loaded successfully!",
//                 {title: "Success", autoHideDelay: 2000, variant:"success"}
//             );
//         }
//         that.loading = false;
//     };
    
//     let f = function(error) {
//         console.error(error);
//         that.$bvToast.toast(
//             "Error loading draft.",
//             {title: "Error", autoHideDelay: 3000, variant:"danger"}
//         );
//         that.loading = false;
//     };
    
//     this.loading = true;
//     Requestor.postSyncP(path, data, this, s, f);
// },
             

getDamageBadge(item) {
        if (item.is_damaged && item.damage_info && item.damage_info.damage_id) {
            return {
                id: item.damage_info.damage_id,
                variant: 'danger',
                text: `D-${item.damage_info.damage_id}`
            };
        }
        return null;
    },
           search_damaged_items: function(e) {
    if (e) {
        e.preventDefault();
    }
    
    let path = "/api/product/search_damaged_items/";
    let data = {
        keyword: this.searchitems.keyword,
        limit: this.searchitems.limit,
        location_id: this.search_in_my_location ? this.invoice.location_id : null
    };
    
    let that = this;
    let s = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        } else {
            // ✅ PROCESS DAMAGED ITEMS WITH PROPER METADATA
            that.searchitems.result = response.data.result.map(item => {
                // Ensure damage_info exists
                if (!item.damage_info) {
                    item.damage_info = {
                        damage_id: item.damage_id || null,
                        damage_grade: item.damage_grade || null,
                        damage_description: item.damage_description || '',
                        damage_images: item.damage_images || [],
                        is_damaged: true
                    };
                } else {
                    // Ensure is_damaged is set
                    item.damage_info.is_damaged = true;
                    
                    // Ensure damage_id is set
                    if (!item.damage_info.damage_id && item.damage_id) {
                        item.damage_info.damage_id = item.damage_id;
                    }
                }
                
                // Set flags
                item.is_damaged = true;
                item.source = 'damage';
                item.sourceContext = 'store';
                
                // Add damage badge for display
                if (item.damage_info.damage_id) {
                    item.display_damage_badge = `D-${item.damage_info.damage_id}`;
                }
                
                console.log(`🔴 Loaded damaged item from search: ${item.product_sku}, Damage ID: ${item.damage_info.damage_id}`);
                
                return item;
            });
            
            that.$bvToast.toast(
                `Found ${that.searchitems.result.length} damaged items`,
                {title: "Search Results", autoHideDelay: 1500, variant:"info"}
            );
        }
        that.searchitems.search_being_loaded = false;
    };

    let f = function(error) {
        console.error("Error searching damaged items:", error);
        that.$bvToast.toast(
            "Error occurred while searching damaged items.",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
        that.searchitems.search_being_loaded = false;
    };

    this.searchitems.search_being_loaded = true;
    this.searchitems.result = [];
    Requestor.getSyncP(path, data, this, s, f);
},
    
handleOnlyFromDamagesChange: function(isChecked) {
    if (isChecked && this.search_in_my_location) {
        // Both checkboxes are checked - search damages in user location
        this.search_damaged_items();
    } else if (isChecked && !this.search_in_my_location) {
        // Only damages checked but "Only in My Location" is not checked
        // Uncheck the AS IS checkbox and show warning
        this.search_only_from_damages = false;
        this.$vex.dialog.alert({
            message: "You must check 'ONLY IN MY LOCATION' first to search for AS IS items."
        });
    } else if (!isChecked) {
        // AS IS unchecked - clear results and show message
        this.searchitems.result = [];
        this.$bvToast.toast(
            "Showing regular inventory. Check 'AS IS' to search damaged items.",
            {title: "Info", autoHideDelay: 2000, variant:"info"}
        );
    }
},
    
    showDamagesModal: function() {
        // This will open a modal showing damaged items from all warehouses
        this.search_damaged_items();
        this.$bvModal.show('modal-damages-search');
    },
          handleAsIsChange(item) {
    if (item.is_as_is) {
        // When checked, ensure the as_is field is properly set
        console.log(`Item ${item.product_sku} marked as AS IS`);
        
        // Initialize as_is_image_url if not set
        if (!item.as_is_image_url) {
            item.as_is_image_url = null;
        }
        
        this.$bvToast.toast(
            `${item.product_sku} marked as "As Is"`,
            {title: "Item Status", autoHideDelay: 2000, variant:"info"}
        );
    } else {
        console.log(`Item ${item.product_sku} unmarked as AS IS`);
        // Optionally clear the image when unchecking
        // item.as_is_image_url = null;
    }
    
    // Force update to show/hide the image column
    this.$forceUpdate();
},
                  handleImageUpload(item, event) {
        const file = event.target.files[0];
        if (!file) return;
        
        // Validate file type
        if (!file.type.startsWith('image/')) {
            this.$bvToast.toast('Please select a valid image file', {
                title: 'Invalid File',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            this.$bvToast.toast('Image size should be less than 5MB', {
                title: 'File Too Large',
                variant: 'warning',
                autoHideDelay: 3000
            });
            return;
        }
        
        this.imageUpload.currentItem = item;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            this.imageUpload.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
        
        // Clear the file input for future uploads
        event.target.value = '';
    },
    getProductImagedamage(item) {
    if (!item) return null;

    // Check as_is_image_url first (uploaded images)
    if (item.as_is_image_url && item.as_is_image_url.trim() !== '') {
        console.log("Returning as-is image URL:", item.as_is_image_url);
        return item.as_is_image_url;
    }
    

    return null;
},
    // Upload image to backend
uploadItemImage() {
    if (!this.imageUpload.currentItem || !this.imageUpload.previewUrl) {
        return;
    }
    
    const item = this.imageUpload.currentItem;
    this.imageUpload.uploading = true;
    
    const path = "/api/sales/upload_item_image/";
    
    let invoiceId = this.invoice.invoice_id;
    if (!invoiceId) {
        invoiceId = 'temp_' + Date.now();
        item.temp_invoice_id = invoiceId;
    }
    
    const data = {
        image_data: this.imageUpload.previewUrl,
        invoice_id: invoiceId,
        product_sku: item.product_sku,
        is_as_is: true  // Mark this as an as-is image
    };
    
    const that = this;
    
    const success = function(response) {
        if (response.data.error) {
            that.$bvToast.toast(`Failed to upload image: ${response.data.error}`, {
                title: 'Upload Failed',
                variant: 'danger',
                autoHideDelay: 3000
            });
        } else {
            // Set as_is_image_url for as-is items
            item.as_is_image_url = response.data.result.image_url;
            that.$bvToast.toast('As-Is image uploaded successfully', {
                title: 'Success',
                variant: 'success',
                autoHideDelay: 2000
            });
            that.cancelImageUpload();
        }
        that.imageUpload.uploading = false;
    };
    
    const failure = function(error) {
        console.error('Image upload failed:', error);
        that.$bvToast.toast('Failed to upload image. Please try again.', {
            title: 'Upload Failed',
            variant: 'danger',
            autoHideDelay: 3000
        });
        that.imageUpload.uploading = false;
    };
    
    Requestor.postSyncP(path, data, this, success, failure);
},

// Update remove method to clear as_is_image_url
async removeItemImage(item) {
    try {
        const path = "/api/sales/remove_item_image/";
        const data = {
            invoice_id: this.invoice.invoice_id,
            product_sku: item.product_sku
        };
        
        const response = await this.$http.post(path, data);
        
        if (response.data.error) {
            throw new Error(response.data.error);
        }
        
        // Clear as_is_image_url instead of image_url
        item.as_is_image_url = null;
        
        this.$bvToast.toast('Image removed successfully', {
            title: 'Success',
            variant: 'success',
            autoHideDelay: 2000
        });
        
    } catch (error) {
        console.error('Image removal failed:', error);
        this.$bvToast.toast(`Failed to remove image: ${error.message}`, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 3000
        });
    }
},
    
    // Cancel image upload
    cancelImageUpload() {
        this.imageUpload = {
            uploading: false,
            currentItem: null,
            previewUrl: null
        };
    },
    
    // Remove image from item
   
                 hasActiveDiscount(product) {
        if (!product.special_discount_price || product.special_discount_price <= 0) {
            return false;
        }

        if (!product.special_discount_end_date) {
            return false;
        }

        const today = new Date();
        let endDate;

        // Parse the date based on the format
        if (product.special_discount_end_date.includes('-')) {
            const parts = product.special_discount_end_date.split('-');
            if (parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
                // MM-DD-YYYY format
                endDate = new Date(parts[2], parts[0] - 1, parts[1]);
            } else {
                // Try default parsing
                endDate = new Date(product.special_discount_end_date);
            }
        } else {
            endDate = new Date(product.special_discount_end_date);
        }

        endDate.setHours(23, 59, 59, 999); // End of the day

        return today <= endDate;
    },

    // Get display price (discounted or regular)
    getDisplayPrice(product) {
        if (this.hasActiveDiscount(product)) {
            return parseFloat(product.special_discount_price);
        }
        return parseFloat(product.selling_price);
    },

    // Calculate discount amount
    getDiscountAmount(product) {
        if (!this.hasActiveDiscount(product)) {
            return 0;
        }

        const originalPrice = parseFloat(product.selling_price) || 0;
        const discountPrice = parseFloat(product.special_discount_price) || 0;

        return Math.round((originalPrice - discountPrice) * 100) / 100;
    },

    // Calculate discount percentage
    getDiscountPercentage(product) {
        if (!this.hasActiveDiscount(product)) {
            return 0;
        }

        const originalPrice = parseFloat(product.selling_price) || 0;
        const discountPrice = parseFloat(product.special_discount_price) || 0;

        if (originalPrice <= 0) return 0;

        const percentage = ((originalPrice - discountPrice) / originalPrice) * 100;
        return Math.round(percentage * 10) / 10;
    },

    // Apply discount to items when adding to sale
     applyDiscountToItem(item) {
        if (this.hasActiveDiscount(item)) {
            // Set the selling price to the discounted price
            item.new_selling_price = parseFloat(item.special_discount_price);
            // Clear any manual discount
            item.discount_offered = 0.0;
        } else {
            // Use regular selling price
            item.new_selling_price = parseFloat(item.selling_price);
        }
        return item;
    },
   onDiscountChange(item) {
    if (this.hasActiveDiscount(item) && parseFloat(item.discount_offered) > 0) {
        this.$bvToast.toast(
            `Manual discount removed from ${item.product_sku} - item has special discount`,
            {title: "Discount Conflict", variant: "warning", autoHideDelay: 3000}
        );
        item.discount_offered = 0.0;
    } else {
        // Validate the discount amount
        this.validateDiscount(item);

        // Ensure discount doesn't make final price negative
        const price = parseFloat(item.new_selling_price || item.selling_price);
        const discount = parseFloat(item.discount_offered) || 0;

        if (discount > price) {
            item.discount_offered = price.toFixed(2);
        }
    }
},
debugImageInfo(item) {
    console.log('Image debug for:', item.product_sku, {
        image_url: item.image_url,
        has_image_url: !!item.image_url,
        trimmed: item.image_url ? item.image_url.trim() : 'none',
        type: typeof item.image_url
    });
},

getProductImage(item) {
    if (!item) return null;

    // Priority 1: Damage images for damaged items
    if (item.is_damaged && item.damage_info && item.damage_info.damage_images) {
        const damageImages = item.damage_info.damage_images;
        if (damageImages.length > 0 && damageImages[0].image_url) {
            const imageUrl = damageImages[0].image_url.trim();
            console.log('Using damage image for', item.product_sku, ':', imageUrl);
            return imageUrl;
        }
    }

    // Priority 2: As-is images
    if (item.as_is_image_url && item.as_is_image_url.trim() !== '') {
        console.log("Returning as-is image URL:", item.as_is_image_url);
        return item.as_is_image_url;
    }

    // Priority 3: Regular product images
    if (item.image_url && item.image_url.trim() !== '') {
        const imageUrl = item.image_url.trim();
        
        // If ORB blocking persists, use a proxy
        if (imageUrl.includes('fmapi.myfurnituremecca.com')) {
            return `/api/image/image-proxy/?url=${encodeURIComponent(imageUrl)}`;
        }

        return imageUrl;
    }

    return null;
},

handleImageError(event, item) {
    console.warn(`Image failed to load for ${item.product_sku}:`, event.target.src);

    const parent = event.target.parentElement;
    if (parent) {
        // Create a more robust fallback
        const existingFallback = parent.querySelector('.no-image-placeholder');
        if (!existingFallback) {
            parent.innerHTML = `
                <div class="no-image-placeholder" style="width: 60px; height: 50px; display: flex; flex-direction: column; align-items: center; justify-content: center; border: 1px dashed #ddd; border-radius: 4px; background: #f9f9f9;">
                    <div style="font-size: 20px; margin-bottom: 5px;">📷</div>
                    <div style="color: #999; font-size: 10px;">No Image</div>
                    <div style="color: #ccc; font-size: 8px; margin-top: 2px;">${item.product_sku}</div>
                </div>
            `;
        }
    }
    event.target.style.display = 'none';
},
showImagePlaceholder(imgElement) {
    if (!imgElement || !imgElement.parentElement) return;

    const parent = imgElement.parentElement;
    parent.innerHTML = '<div style="color: #999; font-size: 10px; padding: 10px;">No Image Available</div>';
},

handleImageLoad(event, item) {
    const sku = (item && item.product_sku) ? item.product_sku : 'unknown';
    console.log(`Image loaded successfully for ${sku}`);
},
//           getProductImage(item) {
//     if (!item) return null;

//     if (item.image_url && item.image_url.trim() !== '') {
//         console.log("Returning image URL:", item.image_url);
//         // Test if the image loads
//         this.testImageUrl(item.image_url);
//         return item.image_url;
//     }

//     return null;
// },
testImageUrl(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
},

async getProductImageWithFallback(item) {
    if (!item || !item.image_url) return null;

    try {
        const isValid = await this.testImageUrl(item.image_url);
        return isValid ? item.image_url : null;
    } catch (error) {
        console.warn('Error testing image URL:', error);
        return null;
    }
},

    // Safe method to show full size image
    showFullImage(item) {
        if (!item) return;

        const imageUrl = this.getProductImage(item);
        if (imageUrl) {
            this.$bvModal.show('modal-image-viewer');
            this.$nextTick(() => {
                this.currentFullSizeImage = imageUrl;
                this.currentProductName = item.product_name || item.product_sku || 'Product Image';
            });
        } else {
            this.$bvToast.toast(
                "No image available for this product",
                {title: "Info", autoHideDelay: 2000, variant:"info"}
            );
        }
    },

        showFullImagedamage(item) {
        if (!item) return;

        const imageUrl = this.getProductImagedamage(item);
        if (imageUrl) {
            this.$bvModal.show('modal-image-viewer');
            this.$nextTick(() => {
                this.currentFullSizeImage = imageUrl;
                this.currentProductName = item.product_name || item.product_sku || 'Product Image';
            });
        } else {
            this.$bvToast.toast(
                "No image available for this product",
                {title: "Info", autoHideDelay: 2000, variant:"info"}
            );
        }
    },

                 validateQuantityPerBox: function(item) {
        if (!item.quantity_per_box || item.quantity_per_box <= 1) {
            return true; // No validation needed if quantity_per_box is 1 or not set
        }

        const quantity = parseInt(item.quantity) || 0;
        const qtyPerBox = parseInt(item.quantity_per_box) || 1;

        if (quantity > 0 && quantity % qtyPerBox !== 0) {
            // Auto-correct to nearest valid multiple
            const nearestMultiple = Math.round(quantity / qtyPerBox) * qtyPerBox;
            const correctedQty = Math.max(qtyPerBox, nearestMultiple); // Ensure at least one box
            item.quantity = correctedQty;

            this.$bvToast.toast(
                `Quantity adjusted to ${correctedQty} (multiple of ${qtyPerBox})`,
                {title: "Quantity Adjusted", variant: "info", autoHideDelay: 2000}
            );
        }

        return true;
    },

    // Check if quantity has validation error
    hasQuantityError: function(item) {
        if (!item.quantity_per_box || item.quantity_per_box <= 1) {
            return false; // No validation needed
        }

        const quantity = parseInt(item.quantity) || 0;
        const qtyPerBox = parseInt(item.quantity_per_box) || 1;

        return quantity > 0 && quantity % qtyPerBox !== 0;
    },
   validateDiscount(item) {
    // Check if item already has an active special discount
    if (this.hasActiveDiscount(item)) {
        this.$bvToast.toast(
            `Cannot apply manual discount to ${item.product_sku} - item already has a special discount`,
            {title: "Discount Conflict", variant: "warning", autoHideDelay: 3000}
        );
        item.discount_offered = 0.0; // Reset manual discount
        return false;
    }

    if (!item.discount_offered || isNaN(parseFloat(item.discount_offered))) {
        return true;
    }

    const discount = parseFloat(item.discount_offered);
    const price = parseFloat(item.new_selling_price || item.selling_price);
    const quantity = parseInt(item.quantity) || 1;

    if (price <= 0) {
        return true; // Can't validate if price is invalid
    }

    // Calculate maximum allowed discount (10% of price × quantity)
    const maxAllowedDiscount = (price * quantity) * 0.10;
    const currentDiscount = discount;

    if (currentDiscount > maxAllowedDiscount) {
        // Show warning and auto-correct to max allowed
        this.$bvToast.toast(
            `Discount cannot exceed 10% of total price ($${maxAllowedDiscount.toFixed(2)}) for ${item.product_sku}`,
            {title: "Discount Limit", variant: "warning", autoHideDelay: 3000}
        );

        // Auto-correct to maximum allowed
        item.discount_offered = maxAllowedDiscount.toFixed(2);
        return false;
    }

    // Additional validation: discount cannot be more than total item price
    const totalPrice = price * quantity;
    if (currentDiscount > totalPrice) {
        this.$bvToast.toast(
            `Discount cannot exceed total item price ($${totalPrice.toFixed(2)}) for ${item.product_sku}`,
            {title: "Discount Limit", variant: "warning", autoHideDelay: 3000}
        );
        item.discount_offered = totalPrice.toFixed(2);
        return false;
    }

    return true;
},
    // Check if item can have manual discount applied
    canApplyManualDiscount(item) {
        return !this.hasActiveDiscount(item);
    },
   getFilteredRefundMethodOptions() {
    // Simply return the cached computed property
    return this.cachedFilteredRefundOptions;
  },
    refreshRefundOptions() {
    // Force recomputation by updating a dependent reactive property
    this.$forceUpdate(); // Or use a more targeted approach
  },
   calculateAvailableRefundAmounts: function() {
    let availableAmounts = {
        cash: 0,
        cc: 0,
        finance: 0,
        store_credit: 0,
        tax_exempt: 0,
        check: 0
    };

    // STEP 1: Get original payment methods from the invoice
    let originalPayments = [];
    
    // First priority: directly from payment_history
    if (this.payment_history && this.payment_history.length > 0) {
        originalPayments = this.payment_history;
        console.log("Using payment_history:", originalPayments);
    }
    // Second priority: from invoice.payment_methods
    else if (this.invoice.payment_methods && this.invoice.payment_methods.length > 0) {
        originalPayments = this.invoice.payment_methods;
        console.log("Using invoice.payment_methods:", originalPayments);
    }

    // Calculate total amounts per payment method from original payments
    originalPayments.forEach(pm => {
        if (pm.value && pm.amount) {
            const method = pm.value.toLowerCase();
            const amount = parseFloat(pm.amount) || 0;
            
            // FIX: Add support for tax_exempt
            if (availableAmounts.hasOwnProperty(method)) {
                availableAmounts[method] += amount;
                console.log(`Added ${amount} to ${method}, total now: ${availableAmounts[method]}`);
            }
        }
    });

    // STEP 2: Subtract amounts that have already been refunded
    if (this.refundsHistory && this.refundsHistory.length > 0) {
        this.refundsHistory.forEach(refund => {
            // For 'refund' type (actual cash refunds)
            if (refund.detail && refund.detail.type === 'refund' && refund.ritems) {
                refund.ritems.forEach(refundItem => {
                    const method = refundItem.value ? refundItem.value.toLowerCase() : null;
                    const refundedAmount = parseFloat(refundItem.amount) || 0;
                    
                    // FIX: Add support for tax_exempt
                    if (method && availableAmounts.hasOwnProperty(method)) {
                        availableAmounts[method] = Math.max(0, availableAmounts[method] - refundedAmount);
                        console.log(`Subtracted ${refundedAmount} from ${method}, remaining: ${availableAmounts[method]}`);
                    }
                });
            }
        });
    }

    // STEP 3: Add store credit from invoice.available_credit_value
    if (this.invoice.available_credit_value) {
        availableAmounts.store_credit = parseFloat(this.invoice.available_credit_value) || 0;
    }

    console.log("Final available refund amounts:", availableAmounts);
    this.available_refund_amounts = availableAmounts;
    return availableAmounts;
},

    // Get remaining amount for a specific payment method
    getRemainingAmountForMethod(method) {
        return this.available_refund_amounts[method] || 0;
    },

    // Validate refund method amounts
    validateRefundMethodAmounts() {
        let totalRefundRequested = 0;
        const methodTotals = {};

        // Calculate totals per method
        this.refund_methods.forEach(method => {
            if (method.value && method.amount) {
                const amount = parseFloat(method.amount) || 0;
                totalRefundRequested += amount;

                if (!methodTotals[method.value]) {
                    methodTotals[method.value] = 0;
                }
                methodTotals[method.value] += amount;
            }
        });

        // Validate against available amounts
        for (const [method, requestedAmount] of Object.entries(methodTotals)) {
            const availableAmount = this.getRemainingAmountForMethod(method);
            if (requestedAmount > availableAmount) {
                return {
                    valid: false,
                    error: `Cannot refund $${requestedAmount.toFixed(2)} via ${method.toUpperCase()}. Only $${availableAmount.toFixed(2)} available.`
                };
            }
        }

        return { valid: true };
    },

    // Update refund method template to show remaining amounts
    updateRefundMethodDisplay: function() {
    this.calculateAvailableRefundAmounts();
    // this.$forceUpdate(); // Force re-render to update dropdown options
},
 showRefundWarning: function(refundMethod, methodType) {
    if (!refundMethod.amount || !refundMethod.value) return false;
    const amount = parseFloat(refundMethod.amount) || 0;
    const available = this.getRemainingAmountForMethod(methodType);
    return amount > available;
},

loadRefundsHistory: function() {
    if (!this.invoice.invoice_id) return;

    let path = "/api/sales/get_refunds_history/";
    let data = {invoice_id: this.invoice.invoice_id};
    let that = this;

    Requestor.getSyncP(path, data, this,
        function(response) {
            if (response.data.error) {
                console.error("Error fetching refunds history:", response.data.error);
            } else {
                that.refundsHistory = response.data.result || [];
                console.log("Refunds history loaded:", that.refundsHistory);

                // Recalculate available amounts after loading history
                that.calculateAvailableRefundAmounts();

                that.$bvToast.toast(
                    "Refund history updated",
                    {title: "Success", autoHideDelay: 1500, variant:"success"}
                );
            }
        },
        function(error) {
            console.error("Error fetching refunds history:", error);
        }
    );
},


// Validate individual refund amount
validateRefundAmount: function(refundMethod) {
    if (!refundMethod.value || !refundMethod.amount) return true;

    const amount = parseFloat(refundMethod.amount) || 0;
    const available = this.getRemainingAmountForMethod(refundMethod.value);

    if (amount > available) {
        this.$bvToast.toast(
            `Refund amount ($${amount.toFixed(2)}) exceeds available ${refundMethod.value.toUpperCase()} amount ($${available.toFixed(2)})`,
            {title: "Validation Error", variant: "warning", autoHideDelay: 3000}
        );
        return false;
    }
    return true;
},

// Enhanced validation before submission
validateAndSubmitRefund() {
    // First validate payment method amounts
    const validation = this.validateRefundMethodAmounts();
    if (!validation.valid) {
        this.$vex.dialog.alert({
            message: validation.error
        });
        return;
    }

    // Then proceed with existing validation
    if (!this.isRefundMethodsValid()) {
        this.$vex.dialog.alert({
            message: "Please ensure all refund methods are properly configured and the total matches the available store credit amount."
        });
        return;
    }

    this.submitRefundWithMethods();
},
                  loadOriginalPaymentMethods() {
        if (!this.invoice.invoice_id) return;

        let path = "/api/sales/get_invoice/";
        let data = {invoice_id: this.invoice.invoice_id};
        let that = this;

        let s = function(response) {
            if (response.data.result) {
                const loadedInvoice = response.data.result;
                that.original_payment_methods = loadedInvoice.payment_methods || [];
                that.initializeUsedRefundAmounts();
            }
        };

        let f = function(error) {
            console.log("Error loading original payment methods:", error);
        };

        Requestor.postAsyncP(path, data, this, s, f);
    },
     initializeUsedRefundAmounts() {
        this.used_refund_amounts = {};
        this.original_payment_methods.forEach(pm => {
            this.used_refund_amounts[pm.value] = {
                original_amount: parseFloat(pm.amount) || 0,
                refunded_so_far: 0,
                remaining: parseFloat(pm.amount) || 0
            };
        });
    },

    // Calculate remaining refundable amount per payment method
    getRemainingRefundByMethod(paymentMethodType) {
        if (!this.used_refund_amounts[paymentMethodType]) {
            return 0;
        }
        return this.used_refund_amounts[paymentMethodType].remaining;
    },
      updateUsedRefundAmounts() {
        // Reset all used amounts
        Object.keys(this.used_refund_amounts).forEach(key => {
            this.used_refund_amounts[key].refunded_so_far = 0;
            this.used_refund_amounts[key].remaining = this.used_refund_amounts[key].original_amount;
        });

        // Calculate current refund allocations
        this.refund_methods.forEach(refundMethod => {
            const amount = parseFloat(refundMethod.amount) || 0;
            const methodType = refundMethod.value;

            if (this.used_refund_amounts[methodType]) {
                this.used_refund_amounts[methodType].refunded_so_far += amount;
                this.used_refund_amounts[methodType].remaining =
                    this.used_refund_amounts[methodType].original_amount -
                    this.used_refund_amounts[methodType].refunded_so_far;
            }
        });
    },

    // Validate refund method amounts against original payment methods
    validateRefundAgainstOriginalPayments() {
        let errors = [];

        this.refund_methods.forEach((refundMethod, index) => {
            const refundAmount = parseFloat(refundMethod.amount) || 0;
            const methodType = refundMethod.value;

            if (!this.used_refund_amounts[methodType]) {
                errors.push(`No original ${methodType.toUpperCase()} payment found to refund from`);
                return;
            }

            const remaining = this.getRemainingRefundByMethod(methodType);

            if (refundAmount > remaining) {
                errors.push(
                    `Cannot refund $${refundAmount.toFixed(2)} from ${methodType.toUpperCase()}. ` +
                    `Only $${remaining.toFixed(2)} remaining from original payment.`
                );
            }
        });

        return errors;
    },

    // Enhanced refund validation that includes payment method validation
    validate_refund_with_payment_methods() {
        // First run original validation
        let originalErrors = this.validate_refund();
        if (originalErrors) return;

        // Then validate against original payment methods
        let paymentErrors = this.validateRefundAgainstOriginalPayments();
        if (paymentErrors.length > 0) {
            this.$vex.dialog.alert({
                message: paymentErrors.join('\n')
            });
            return false;
        }

        return true;
    },
                getTotalPaymentsFromHistory: function() {
    return this.payment_history.reduce((total, pm) => {
        return total + (parseFloat(pm.amount) || 0.0);
    }, 0.0);
},
                   getExistingItemNumber(index) {
        return index + 1;
    },

    getNewItemNumber(index) {
        return index + 1;
    },

    getItemOriginalIndex(item) {
        return this.invoice.items.findIndex(i => i === item);
    },

    setCommonDeliveryDateForNewItems(selectedDate) {
        this.newItems.forEach(item => {
            item.delivery_date = selectedDate;
        });
    },
getPaymentMethods() {
    // For payment HISTORY (display only)
    if (this.invoice.edit && this.payment_history.length > 0) {
        return this.payment_history;
    }

    // For payment INFORMATION (form input) - only return for new invoices
    if (this.invoice.edit) {
        return []; // Return empty array when editing
    } else {
        return this.invoice.payment_methods || [];
    }
},

        getTotalPayments() {
    // For payment HISTORY (display only)
    if (this.invoice.edit && this.payment_history.length > 0) {
        return this.payment_history.reduce((total, pm) => {
            return total + (parseFloat(pm.amount) || 0.0);
        }, 0.0);
    }

    // For payment INFORMATION (form input) - for new invoices
    const paymentMethods = this.invoice.payment_methods || [];
    return paymentMethods.reduce((total, pm) => {
        return total + (parseFloat(pm.amount) || 0.0);
    }, 0.0);
},

    payment_ts_format(ts) {
        if (!ts) return 'PENDING';
        try {
            // Handle different timestamp formats
            if (typeof ts === 'string') {
                if (ts.includes('T')) {
                    let p = ts.split("T");
                    let p1 = p[0];
                    let p2 = p[1].split(".")[0];
                    return p1 + " " + p2;
                }
                return ts.toUpperCase();
            }
            // If it's a Date object or other format
            return new Date(ts).toLocaleString();
        } catch (error) {
            console.error('Error formatting timestamp:', error, ts);
            return 'PENDING';
        }
    },

getTotalBalance: function () {

    let grand_total = this.getGrandTotal();
 
    let payment_methods = this.invoice.payment_methods;

    if (this.invoice.edit && this.refund_items.length <= 0) {

        payment_methods = this.invoice.new_payment_methods;

    }
 
    let total_payments_applied = payment_methods

        .map(d => parseFloat(d.amount) || 0.0)

        .reduce((a, b) => a + b, 0);
 
    let balance = grand_total - total_payments_applied;
 
    // FIX floating point issues → round to 2 decimals

    balance = Math.round(balance * 100) / 100;
 
    return balance;

},

 

        getAvailableStoreCredit() {
            return parseFloat(this.invoice.available_credit_value) || 0.0;
        },
                validate_store_credit_refund: function() {
        let availableCredit = this.getAvailableStoreCredit();

        if (availableCredit <= 0) {
            this.$vex.dialog.alert({
                message: "No store credit available to refund."
            });
            return;
        }

        // Auto-populate refund methods with the available credit
        if (this.refund_methods.length === 0) {
            // Auto-add one refund method
            this.addRefundMethod();
        }

        // Set the first refund method to the available credit amount
        if (this.refund_methods.length > 0) {
            this.refund_methods[0].amount = availableCredit;
            this.refund_methods[0].value = 'store_credit'; // Default to store credit
        }

        this.$bvToast.toast(
            `Store credit validated: $${availableCredit.toFixed(2)} available for refund`,
            {title: "Success", autoHideDelay: 1500, variant:"success"}
        );
    },

handleUpdate: async function() {
    // Get balance with proper floating point handling
    let balance = this.getTotalBalance();
    
    // Round to 2 decimal places to avoid floating point issues
    balance = Math.round(balance * 100) / 100;
    
    console.log("Current balance before update (rounded):", balance);
    
    // Check if balance is greater than 0 (with proper tolerance)
    if (balance > 0.005 && !this.invoice.is_layaway) {  // Using 0.005 tolerance
        this.$vex.dialog.alert({
            message: `Cannot update invoice. Customer has a balance of $${balance.toFixed(2)}. Balance must be $0 to update.`
        });
        return;
    }

    // For layaway, show a warning but allow the update
    if (balance > 0.005 && this.invoice.is_layaway) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
            `This layaway has a remaining balance of $${balance.toFixed(2)}. Are you sure you want to update without collecting payment?`,
            {
                title: 'Layaway Update Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: 'YES, UPDATE',
                cancelTitle: 'CANCEL',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        );
        
        if (!confirmed) {
            return; // User cancelled
        }
    }

    this.loading = true;

    try {
        // FIX: Round remainingRefund to avoid floating point issues
        let remainingRefund = this.getRemainingStoreCredit();
        remainingRefund = Math.round(remainingRefund * 100) / 100;
        
        console.log("Remaining store credit (rounded):", remainingRefund);

        // Process refund first if there's remaining store credit (with tolerance)
        if (remainingRefund > 0.005 && this.refund_methods.length > 0 && this.isRefundMethodsValid()) {
            await new Promise((resolve, reject) => {
                this.submitRefundWithMethods()
                    .then(() => {
                        setTimeout(() => {
                            resolve();
                        }, 1000);
                    })
                    .catch(reject);
            });
        } else if (remainingRefund > 0.005 && this.refund_methods.length === 0) {
            // If there's store credit but no refund methods specified, ask user
            const result = await this.$bvModal.msgBoxConfirm(
                `You have $${remainingRefund.toFixed(2)} in store credit. Do you want to process a refund first?`,
                {
                    title: 'Store Credit Available',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'YES, PROCESS REFUND',
                    cancelTitle: 'NO, CONTINUE WITHOUT REFUND',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            );
            
            if (result) {
                // User wants to process refund - show refund methods
                this.$bvToast.toast(
                    "Please set up refund methods first",
                    {title: "Info", variant: "info"}
                );
                this.loading = false;
                return;
            }
            // If user cancels (chooses not to refund), continue with update
        }

        // Print exchange receipt
        console.log("Printing exchange receipt BEFORE updating sale...");
        this.printExchangeReceipt();
        
        // Wait a moment for the print job
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Update the invoice
        console.log("Now updating sale after receipt printed...");
        await this.updateInvoiceAsync();

    } catch (error) {
        console.error("Update process failed:", error);
        this.$bvToast.toast("Update failed: " + error.message,
            {title: "Error", variant: "danger"});
    } finally {
        this.loading = false;
    }
},
generateExchangeReceiptHTML() {
    // Get location name from selected_locsub
    let locationName = '';
    if (this.invoice.selected_locsub) {
        const loc = this.packet.locsubs.find(l => l.value === this.invoice.selected_locsub);
        locationName = loc ? loc.text : this.invoice.address || 'Store Location';
    } else {
        locationName = this.invoice.address || 'FURNITURE MECCA';
    }

    // Format date
    const currentDate = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    // Get invoice number
    const invoiceNumber = this.invoice.invoice_id || 'N/A';

    // Get salesperson name
    const salesperson = (this.invoice.username || this.userDetails.username || '').toUpperCase();

    // Get customer name
    const customerName = this.invoice.customer.fullname || 'Walk-in Customer';

    // Separate refunded items and new items
    const refundedItems = this.refund_items || [];
    const newItems = this.invoice.items.filter(item => !item.existing) || [];
    
    // Calculate totals
    const refundTotal = refundedItems.reduce((sum, item) => {
        const refundAmount = ((parseFloat(item.selling_price) || 0) * (parseInt(item.return_quantity) || 0)) - 
                            ((parseInt(item.return_quantity) || 0) * (parseFloat(item.unit_discount_value) || 0));
        return sum + refundAmount;
    }, 0);

    const newItemsTotal = this.getOrderTotal();
    const chargesTotal = this.getChargesTotal();
    const salesTax = this.getSalesTax();
    const grandTotal = newItemsTotal + chargesTotal + salesTax;
    
    // Store credit calculations
    const storeCreditAvailable = this.getAvailableStoreCredit();
    const storeCreditApplied = this.getStoreCreditApplied();
    const remainingBalance = this.getTotalBalanceWithCredit();
    
    // Net amount after store credit
    let netAmount = grandTotal - storeCreditApplied;
    let customerPaysAmount = 0;
    let refundDueAmount = 0;
    
    if (refundTotal > 0) {
        // This is an exchange with refund
        netAmount = grandTotal - refundTotal - storeCreditApplied;
        if (netAmount > 0) {
            customerPaysAmount = netAmount;
        } else if (netAmount < 0) {
            refundDueAmount = Math.abs(netAmount);
        }
    } else {
        // This is a purchase using store credit
        if (storeCreditApplied >= grandTotal) {
            // Fully covered by store credit
            customerPaysAmount = 0;
            refundDueAmount = 0;
        } else {
            // Partially covered by store credit
            customerPaysAmount = grandTotal - storeCreditApplied;
        }
    }

    // Determine transaction type
    let transactionType = '';
    let netAmountDisplay = '';
    
    if (refundTotal > 0 && grandTotal > 0) {
        if (netAmount > 0) {
            transactionType = 'EXCHANGE - CUSTOMER PAYS DIFFERENCE';
            netAmountDisplay = `CUSTOMER PAYS: $${netAmount.toFixed(2)}`;
        } else if (netAmount < 0) {
            transactionType = 'EXCHANGE - REFUND DUE TO CUSTOMER';
            netAmountDisplay = `REFUND AMOUNT: $${Math.abs(netAmount).toFixed(2)}`;
        } else {
            transactionType = 'EQUAL EXCHANGE';
            netAmountDisplay = 'NO MONEY EXCHANGED';
        }
    } else if (refundTotal > 0 && grandTotal === 0) {
        transactionType = 'FULL REFUND';
        netAmountDisplay = `REFUND AMOUNT: $${refundTotal.toFixed(2)}`;
    } else if (refundTotal === 0 && grandTotal > 0) {
        transactionType = 'ADDITIONAL PURCHASE';
        if (storeCreditApplied > 0) {
            netAmountDisplay = `BALANCE DUE: $${(grandTotal - storeCreditApplied).toFixed(2)}`;
        } else {
            netAmountDisplay = `TOTAL DUE: $${grandTotal.toFixed(2)}`;
        }
    }

    // Build receipt HTML
    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Exchange Receipt - ${invoiceNumber}</title>
            <style>
                @page {
                    size: 80mm auto;
                    margin: 0;
                }
                body {
                    font-family: 'Courier New', monospace;
                    font-size: 12px;
                    width: 72mm;
                    margin: 0 auto;
                    padding: 2mm;
                    line-height: 1.3;
                }
                .header {
                    text-align: center;
                    font-weight: bold;
                    margin-bottom: 3mm;
                }
                .store-name {
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                .transaction-type {
                    font-size: 16px;
                    font-weight: bold;
                    color: #2c5aa0;
                    text-align: center;
                    margin: 3mm 0;
                    padding: 2mm;
                    background: #f8f9fa;
                    border: 1px dashed #2c5aa0;
                }
                .divider {
                    border-top: 1px dashed #000;
                    margin: 2mm 0;
                }
                .info-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .info-label {
                    font-weight: bold;
                }
                .section-header {
                    font-weight: bold;
                    background: #f0f0f0;
                    padding: 2mm;
                    margin: 3mm 0 2mm 0;
                    text-align: center;
                }
                .items-header {
                    font-weight: bold;
                    border-bottom: 1px solid #000;
                    margin-top: 3mm;
                    padding-bottom: 1mm;
                }
                .item-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .item-desc {
                    max-width: 45mm;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .refund-row {
                    color: #dc3545;
                    background: #fff5f5;
                    padding: 1mm;
                    margin: 1mm 0;
                    border-left: 3px solid #dc3545;
                }
                .new-item-row {
                    color: #28a745;
                    background: #f0fff4;
                    padding: 1mm;
                    margin: 1mm 0;
                    border-left: 3px solid #28a745;
                }
                .store-credit-row {
                    color: #17a2b8;
                    background: #e3f2fd;
                    padding: 1mm;
                    margin: 1mm 0;
                    border-left: 3px solid #17a2b8;
                }
                .totals {
                    margin-top: 3mm;
                }
                .total-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .store-credit-total {
                    color: #17a2b8;
                    font-weight: bold;
                }
                .net-amount {
                    font-weight: bold;
                    font-size: 16px;
                    border-top: 2px solid #000;
                    border-bottom: 2px solid #000;
                    padding: 3mm 0;
                    margin: 3mm 0;
                    text-align: center;
                    background: #f8f9fa;
                }
                .footer {
                    text-align: center;
                    margin-top: 5mm;
                    font-size: 10px;
                }
                .thank-you {
                    font-size: 16px;
                    font-weight: bold;
                    margin: 4mm 0;
                    letter-spacing: 1px;
                }
                .bold-text {
                    font-weight: bold;
                }
                .payment-breakdown {
                    background: #fff;
                    padding: 2mm;
                    margin: 2mm 0;
                    border: 1px solid #dee2e6;
                    border-radius: 2mm;
                }
            </style>
        </head>
        <body>
            <div class="header">
                <div class="store-name">FURNITURE MECCA</div>
                <div class="store-location">${locationName}</div>
                <div class="store-location">${currentDate}</div>
            </div>

            <div class="transaction-type">
                ${transactionType}
            </div>

            <div class="divider"></div>

            <div class="info-row">
                <span class="info-label">INVOICE #:</span>
                <span class="bold-text">${invoiceNumber}</span>
            </div>
            <div class="info-row">
                <span class="info-label">SALESPERSON:</span>
                <span class="bold-text">${salesperson}</span>
            </div>
            <div class="info-row">
                <span class="info-label">CUSTOMER:</span>
                <span class="bold-text">${customerName}</span>
            </div>

            ${refundedItems.length > 0 ? `
                <div class="section-header">RETURNED / CANCELLED ITEMS</div>
                ${refundedItems.map(item => {
                    const price = parseFloat(item.selling_price) || 0;
                    const qty = parseInt(item.return_quantity) || 0;
                    const discount = parseFloat(item.unit_discount_value) || 0;
                    const itemTotal = (price * qty) - (discount * qty);
                    const desc = item.product_name || item.product_sku || 'Item';
                    
                    return `
                        <div class="refund-row item-row">
                            <span>${desc.substring(0, 25)}${desc.length > 25 ? '...' : ''}</span>
                            <span class="bold-text">-$${itemTotal.toFixed(2)}</span>
                        </div>
                        <div style="font-size: 10px; margin-left: 2mm; margin-bottom: 1mm; color: #666;">
                            SKU: ${item.product_sku} | Qty: ${qty} @ $${price.toFixed(2)}
                            ${discount > 0 ? ` | Disc: $${(discount * qty).toFixed(2)}` : ''}
                        </div>
                    `;
                }).join('')}
                
                <div class="total-row" style="margin-top: 2mm;">
                    <span class="bold-text">RETURN TOTAL:</span>
                    <span class="bold-text" style="color: #dc3545;">-$${refundTotal.toFixed(2)}</span>
                </div>
            ` : ''}

            ${newItems.length > 0 ? `
                <div class="section-header">NEW / EXCHANGE ITEMS</div>
                ${newItems.map(item => {
                    const price = this.hasActiveDiscount(item) ? 
                        parseFloat(item.special_discount_price) : 
                        (parseFloat(item.new_selling_price) || parseFloat(item.selling_price) || 0);
                    const qty = parseInt(item.quantity) || 1;
                    const discount = parseFloat(item.discount_offered) || 0;
                    const itemTotal = (price * qty) - discount;
                    const desc = item.product_name || item.product_sku || 'Item';
                    
                    return `
                        <div class="new-item-row item-row">
                            <span>${desc.substring(0, 25)}${desc.length > 25 ? '...' : ''}</span>
                            <span class="bold-text">+$${itemTotal.toFixed(2)}</span>
                        </div>
                        <div style="font-size: 10px; margin-left: 2mm; margin-bottom: 1mm; color: #666;">
                            SKU: ${item.product_sku} | Qty: ${qty} @ $${price.toFixed(2)}
                            ${discount > 0 ? ` | Disc: -$${discount.toFixed(2)}` : ''}
                            ${item.is_damaged ? ' | ⚠️ AS-IS' : ''}
                        </div>
                    `;
                }).join('')}
                
                <div class="total-row" style="margin-top: 2mm;">
                    <span class="bold-text">NEW ITEMS TOTAL:</span>
                    <span class="bold-text" style="color: #28a745;">+$${newItemsTotal.toFixed(2)}</span>
                </div>
            ` : ''}

            <div class="divider"></div>

            <!-- Payment Breakdown -->
            <div class="payment-breakdown">
                <div class="total-row">
                    <span>Merchandise Total:</span>
                    <span>$${newItemsTotal.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span>Delivery:</span>
                    <span>$${chargesTotal.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span>Sales Tax:</span>
                    <span>$${salesTax.toFixed(2)}</span>
                </div>
                <div class="total-row">
                    <span>GRAND TOTAL:</span>
                    <span class="bold-text">$${grandTotal.toFixed(2)}</span>
                </div>
                
                <div class="divider" style="margin: 2mm 0;"></div>
                
                <!-- Store Credit Applied -->
                <div class="store-credit-row total-row">
                    <span class="bold-text">STORE CREDIT APPLIED:</span>
                    <span class="bold-text">-$${storeCreditApplied.toFixed(2)}</span>
                </div>
                
                ${refundTotal > 0 ? `
                    <div class="refund-row total-row">
                        <span class="bold-text">RETURN CREDIT APPLIED:</span>
                        <span class="bold-text">-$${refundTotal.toFixed(2)}</span>
                    </div>
                ` : ''}
                
                <div class="divider" style="margin: 2mm 0;"></div>
                
                <!-- Final Balance -->
                <div class="net-amount">
                    <div class="bold-text" style="font-size: 14px;">
                        ${customerPaysAmount > 0 ? `BALANCE DUE: $${customerPaysAmount.toFixed(2)}` : ''}
                        ${refundDueAmount > 0 ? `REFUND DUE: $${refundDueAmount.toFixed(2)}` : ''}
                        ${customerPaysAmount === 0 && refundDueAmount === 0 ? 'PAID IN FULL' : ''}
                    </div>
                    ${storeCreditApplied > 0 ? `
                        <div style="font-size: 11px; color: #17a2b8; margin-top: 1mm;">
                            Remaining Store Credit: $${(storeCreditAvailable - storeCreditApplied).toFixed(2)}
                        </div>
                    ` : ''}
                </div>
            </div>

            ${this.refund_methods && this.refund_methods.length > 0 ? `
                <div class="section-header">REFUND METHOD${this.refund_methods.length > 1 ? 'S' : ''}</div>
                ${this.refund_methods.map(method => `
                    <div class="info-row">
                        <span class="bold-text">${(method.value || '').toUpperCase()}:</span>
                        <span class="bold-text">$${(parseFloat(method.amount) || 0).toFixed(2)}</span>
                    </div>
                    ${method.value === 'cc' && method.name ? `
                        <div style="font-size: 10px; margin-left: 2mm;">Card: ****${method.name}</div>
                    ` : ''}
                    ${method.value === 'finance' && method.name ? `
                        <div style="font-size: 10px; margin-left: 2mm;">Company: ${method.name}</div>
                        ${method.lease_id ? `<div style="font-size: 10px; margin-left: 2mm;">Lease: ${method.lease_id}</div>` : ''}
                    ` : ''}
                `).join('')}
            ` : ''}

            ${this.invoice.comment_txt ? `
                <div class="divider"></div>
                <div style="font-size: 10px;">
                    <span class="bold-text">COMMENTS:</span>
                    <div>${this.invoice.comment_txt}</div>
                </div>
            ` : ''}

            <div class="footer">
                <div class="thank-you">THANK YOU FOR YOUR BUSINESS!</div>
                <div style="font-size: 9px; margin-top: 2mm;">Exchange Receipt - Updated: ${currentDate}</div>
                ${storeCreditApplied > 0 ? `
                    <div style="font-size: 9px; color: #17a2b8; margin-top: 1mm;">
                        ✓ Store Credit Applied: $${storeCreditApplied.toFixed(2)}
                    </div>
                ` : ''}
            </div>

            <div class="cut-line" style="text-align: center; margin-top: 3mm;">- - - - - - - - - - - - - - - - - - - -</div>
        </body>
        </html>
    `;
},
printExchangeReceipt() {
    // Create a hidden iframe for printing
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    // Get the exchange receipt HTML content
    const receiptContent = this.generateExchangeReceiptHTML();
    
    // Write to iframe and print
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(receiptContent);
    frameDoc.close();

    // Wait for content to load then print
    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            // Remove iframe after printing
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
    
    // Also try to open cash drawer
  
},
printReceipt(isExchange = false) {
    if (isExchange) {
        this.printExchangeReceipt();
        return;
    }
    
    // Your existing regular receipt printing code
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    const receiptContent = this.generateReceiptHTML();
    
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(receiptContent);
    frameDoc.close();

    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
},
    submitRefundWithMethodsSimple: function(callback) {
        if (!this.isRefundMethodsValid()) {
            this.$vex.dialog.alert({
                message: "Please ensure all refund methods are properly configured."
            });
            this.loading = false;
            return;
        }

        let refundMethodsData = this.refund_methods.map(method => {
            return {
                value: method.value,
                amount: parseFloat(method.amount),
                name: method.name,
                check_number: method.check_number,
                notes: method.notes,
                issue_amount: parseFloat(method.amount)
            };
        });

        this.processRefundWithPaymentMethodsSimple(refundMethodsData, callback);
    },

    processRefundWithPaymentMethodsSimple: function(paymentMethods, callback) {
        let that = this;
        let data = {
            invoice_id: this.invoice.invoice_id,
            username: this.userDetails.username,
            pms: paymentMethods,
            amount: this.getRemainingStoreCredit()
        };

        let path = "/api/sales/issue_sc_out/";

        let s = function(response) {
            if (response.data.error) {
                that.$vex.dialog.alert({ message: response.data.error });
            } else {
                that.$bvToast.toast("Store credit refund processed successfully!",
                    {title: "Success", autoHideDelay: 1500, variant:"success"});

                that.refund_methods = [];
                that.current_refund_validated = false;
                that.reloadAllData();

                // Call the callback to continue with invoice update
                if (callback) callback();
            }
            that.loading = false;
        };

        let f = function(error) {
            console.log(error);
            that.$bvToast.toast("Error processing refund.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"});
            that.loading = false;
        };

        this.loading = true;
        Requestor.postAsyncP(path, data, this, s, f);
    },
        getTotalBalanceWithCredit: function() {
    let grand_total = this.getGrandTotal(); // This already includes store credit deduction
    
    // Get payment methods (new payment methods for edit mode, regular for new)
    let payment_methods = this.invoice.payment_methods;
    if (this.invoice.edit && this.refund_items.length <= 0) {
        payment_methods = this.invoice.new_payment_methods;
    }
    
    // Calculate total payments
    let total_payments = payment_methods
        .map(d => parseFloat(d.amount) || 0.0)
        .reduce((a, b) => a + b, 0);
    
    // Balance = grand total - payments
    let balance = grand_total - total_payments;
    
    // Round to 2 decimal places to avoid floating point issues
    return Math.max(0, Math.round(balance * 100) / 100);
},
   getStoreCreditApplied: function() {
    let grand_total_before_credit = this.getSubTotal() + this.getSalesTax();
    let effective_credit = this.getEffectiveStoreCredit();

    // Only apply store credit up to the grand total amount
    let applied = Math.min(effective_credit, grand_total_before_credit);
    
    // FIX: Round to 2 decimal places
    return Math.round(applied * 100) / 100;
},
    getNetStoreCreditForTransaction: function() {
        let currentRefundAmount = 0;

        // Calculate refund amount from current refund items
        if (this.refund_items.length > 0) {
            currentRefundAmount = this.refund_items.map(function(d){
                return ((parseInt(d.return_quantity) || 0) * parseFloat(d.selling_price) -
                    ((parseInt(d.return_quantity) || 0) * d.unit_discount_value));
            }).reduce((a, b) => a + b, 0);

            // Add refund charges
            currentRefundAmount += (
                parseFloat(this.refund_charges.delivery_refunded_currently) +
                parseFloat(this.refund_charges.setup_refunded_currently) +
                parseFloat(this.refund_charges.warranty_refunded_currently)
            );
        }

        return currentRefundAmount;
    },

  getEffectiveStoreCredit: function() {
    let existingCredit = this.getAvailableStoreCredit();
    let newCreditFromRefund = this.getNetStoreCreditForTransaction();
    let effective = existingCredit + newCreditFromRefund;
    
    // FIX: Round to 2 decimal places
    return Math.round(effective * 100) / 100;
},


   getRemainingStoreCredit: function() {
    let effective_credit = this.getEffectiveStoreCredit();
    let store_credit_applied = this.getStoreCreditApplied();

    let remaining = Math.max(0, effective_credit - store_credit_applied);
    
    // FIX: Round to 2 decimal places to avoid floating point issues
    return Math.round(remaining * 100) / 100;
},
                getAvailableStoreCredit: function() {
        return parseFloat(this.invoice.available_credit_value) || 0.0;
    },
    getRemainingRefundAmount: function() {
        let totalRefund = this.getRemainingStoreCredit(); // Use REMAINING, not available
        let allocatedRefund = this.refund_methods.reduce((sum, method) => {
            return sum + (parseFloat(method.amount) || 0.0);
        }, 0.0);

        return Math.max(0, totalRefund - allocatedRefund);
    },


                addRefundMethod: function() {
            this.refund_methods.push({
                value: null,
                amount: 0.0,
                name: null,
                check_number: null,
                notes: null,
                 lease_id: null,
        approved_amount: null,
        misc_info: null
            });
        },

        removeRefundMethod: function(rmidx) {
            this.refund_methods.splice(rmidx, 1);
        },



    isRefundMethodsValid: function() {
        if (this.refund_methods.length === 0) return false;

        let totalAllocated = this.refund_methods.reduce((sum, method) => {
            return sum + (parseFloat(method.amount) || 0.0);
        }, 0.0);

        let totalRefund = this.getRemainingStoreCredit(); // Use store credit amount

        // Check if allocated amount matches total refund amount
        if (Math.abs(totalAllocated - totalRefund) > 0.01) {
            return false;
        }

        // Validate individual refund methods
        for (let method of this.refund_methods) {
            if (!method.value || !method.amount || parseFloat(method.amount) <= 0) {
                return false;
            }

            // Additional validation for specific methods
            if (method.value === 'cc' && !method.name) {
                return false;
            }

            if (method.value === 'check' && !method.check_number) {
                return false;
            }
        }

        return true;
    },
submitRefundWithMethods: function() {
    return new Promise((resolve, reject) => {
        if (!this.isRefundMethodsValid()) {
            this.$vex.dialog.alert({
                message: "Please ensure all refund methods are properly configured and the total matches the available store credit amount."
            });
            reject(new Error("Refund methods not valid"));
            return;
        }

        let refundMethodsData = this.refund_methods.map(method => {
            let methodData = {
                value: method.value,
                amount: parseFloat(method.amount),
                name: method.name,
                check_number: method.check_number,
                notes: method.notes,
                issue_amount: parseFloat(method.amount)
            };
            
            if (method.value === 'finance') {
                methodData.lease_id = method.lease_id;
                methodData.approved_amount = parseFloat(method.approved_amount) || null;
                methodData.misc_info = method.misc_info;
            }

            return methodData;
        });

        this.processRefundWithPaymentMethods(refundMethodsData)
            .then((response) => {
                // SHOW SUCCESS ANIMATION FOR REFUND
                this.successMessage = 'Refund Processed!';
                if (this.$refs.successAnimation) {
                    this.$refs.successAnimation.show();
                }
                
                this.printRefundReceipt();
                resolve(response);
            })
            .catch(reject);
    });
},

  processRefundWithPaymentMethods: function(paymentMethods) {
    return new Promise((resolve, reject) => {
        let that = this;
        let data = {
            invoice_id: this.invoice.invoice_id,
            username: this.userDetails.username,
            pms: paymentMethods,
            amount: this.getRemainingStoreCredit()
        };

        let path = "/api/sales/issue_sc_out/";

        let s = function(response) {
            if (response.data.error) {
                that.$vex.dialog.alert({
                    message: response.data.error
                });
                reject(new Error(response.data.error));
            } else {
                that.$bvToast.toast(
                    "Refund processed successfully!",
                    {title: "Success", autoHideDelay: 1500, variant:"success"}
                );

                // Update local data without refreshing the whole page
                that.refund_methods = [];
                that.current_refund_validated = false;

                // Refresh only the necessary data
                that.refreshInvoiceData();

                // PRINT RECEIPT IS NOW CALLED FROM submitRefundWithMethods
                // after the promise resolves

                resolve(response.data);
            }
            that.loading = false;
        };

        let f = function(error) {
            console.log(error);
            that.$bvToast.toast(
                "Error processing refund. Please try again.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
            that.loading = false;
            reject(error);
        };

        this.loading = true;
        Requestor.postAsyncP(path, data, this, s, f);
    });
},

printRefundReceipt() {
    // Create a hidden iframe for printing
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    // Get the refund receipt HTML content
    const receiptContent = this.generateRefundReceiptHTML();
    
    // Write to iframe and print
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(receiptContent);
    frameDoc.close();

    // Wait for content to load then print
    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            // Remove iframe after printing
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
    
},

generateRefundReceiptHTML() {
    // Get location name
    let locationName = '';
    if (this.invoice.selected_locsub) {
        const loc = this.packet.locsubs.find(l => l.value === this.invoice.selected_locsub);
        locationName = loc ? loc.text : this.invoice.address || 'Store Location';
    } else {
        locationName = this.invoice.address || 'FURNITURE MECCA';
    }

    // Format date
    const currentDate = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    // Get invoice number
    const invoiceNumber = this.invoice.invoice_id || 'N/A';

    // Get salesperson name
    const salesperson = (this.invoice.username || this.userDetails.username || '').toUpperCase();

    // Get customer name
    const customerName = this.invoice.customer.fullname || 'Walk-in Customer';

    // Calculate refund totals
    const refundTotal = this.getRemainingStoreCredit() || 0;
    
    // Get refund methods
    const refundMethods = this.refund_methods || [];

    // Get refunded items
    const refundedItems = this.refund_items || [];

    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Refund Receipt - ${invoiceNumber}</title>
            <style>
                @page {
                    size: 80mm auto;
                    margin: 0;
                }
                body {
                    font-family: 'Courier New', monospace;
                    font-size: 12px;
                    width: 72mm;
                    margin: 0 auto;
                    padding: 2mm;
                    line-height: 1.3;
                }
                .header {
                    text-align: center;
                    font-weight: bold;
                    margin-bottom: 3mm;
                }
                .store-name {
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 1px;
                }
                .refund-header {
                    font-size: 18px;
                    font-weight: bold;
                    color: #dc3545;
                    text-align: center;
                    margin: 3mm 0;
                    padding: 2mm;
                    background: #fff5f5;
                    border: 2px dashed #dc3545;
                }
                .divider {
                    border-top: 1px dashed #000;
                    margin: 2mm 0;
                }
                .info-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .info-label {
                    font-weight: bold;
                }
                .items-header {
                    font-weight: bold;
                    background: #f0f0f0;
                    padding: 2mm;
                    margin: 3mm 0 2mm 0;
                    text-align: center;
                }
                .item-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 2mm 0;
                    padding: 1mm;
                    background: #fff5f5;
                    border-left: 3px solid #dc3545;
                }
                .item-desc {
                    max-width: 45mm;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .payment-section {
                    margin: 3mm 0;
                }
                .payment-method {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                    padding: 1mm;
                    background: #f8f9fa;
                    border-radius: 2mm;
                }
                .method-detail {
                    font-size: 10px;
                    color: #666;
                    margin-left: 2mm;
                }
                .total-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 1mm 0;
                }
                .refund-total {
                    font-weight: bold;
                    font-size: 18px;
                    color: #dc3545;
                    border-top: 2px solid #dc3545;
                    border-bottom: 2px solid #dc3545;
                    padding: 3mm 0;
                    margin: 3mm 0;
                    text-align: center;
                    background: #fff5f5;
                }
                .footer {
                    text-align: center;
                    margin-top: 5mm;
                    font-size: 10px;
                }
                .thank-you {
                    font-size: 14px;
                    font-weight: bold;
                    margin: 4mm 0;
                }
                .bold-text {
                    font-weight: bold;
                }
            </style>
        </head>
        <body>
            <div class="header">
                <div class="store-name">FURNITURE MECCA</div>
                <div class="store-location">${locationName}</div>
                <div class="store-location">${currentDate}</div>
            </div>

            <div class="refund-header">
                REFUND RECEIPT
            </div>

            <div class="divider"></div>

            <div class="info-row">
                <span class="info-label">INVOICE #:</span>
                <span class="bold-text">${invoiceNumber}</span>
            </div>
            <div class="info-row">
                <span class="info-label">SALESPERSON:</span>
                <span class="bold-text">${salesperson}</span>
            </div>
            <div class="info-row">
                <span class="info-label">CUSTOMER:</span>
                <span class="bold-text">${customerName}</span>
            </div>

            ${refundedItems.length > 0 ? `
                <div class="items-header">RETURNED ITEMS</div>
                ${refundedItems.map(item => {
                    const price = parseFloat(item.selling_price) || 0;
                    const qty = parseInt(item.return_quantity) || 0;
                    const discount = parseFloat(item.unit_discount_value) || 0;
                    const itemTotal = (price * qty) - (discount * qty);
                    const desc = item.product_name || item.product_sku || 'Item';
                    
                    return `
                        <div class="item-row">
                            <span class="item-desc">${desc.substring(0, 25)}${desc.length > 25 ? '...' : ''}</span>
                            <span class="bold-text">$${itemTotal.toFixed(2)}</span>
                        </div>
                        <div style="font-size: 10px; margin-left: 2mm; margin-bottom: 1mm;">
                            SKU: ${item.product_sku} | Qty: ${qty} @ $${price.toFixed(2)}
                            ${discount > 0 ? ` | Disc: -$${(discount * qty).toFixed(2)}` : ''}
                        </div>
                    `;
                }).join('')}
            ` : ''}

            <div class="divider"></div>

            <div class="payment-section">
                <div class="items-header">REFUND METHOD${refundMethods.length > 1 ? 'S' : ''}</div>
                ${refundMethods.map(method => {
                    let detail = '';
                    if (method.value === 'cc' && method.name) {
                        detail = `<div class="method-detail">Card: ****${method.name}</div>`;
                    } else if (method.value === 'finance' && method.name) {
                        detail = `<div class="method-detail">Company: ${method.name}${method.lease_id ? ` | Lease: ${method.lease_id}` : ''}</div>`;
                    } else if (method.value === 'store_credit') {
                        detail = `<div class="method-detail">Store Credit</div>`;
                    }
                    
                    return `
                        <div class="payment-method">
                            <span class="bold-text">${(method.value || '').toUpperCase()}</span>
                            <span class="bold-text">$${(parseFloat(method.amount) || 0).toFixed(2)}</span>
                        </div>
                        ${detail}
                    `;
                }).join('')}
            </div>

            <div class="refund-total">
                TOTAL REFUND: $${refundTotal.toFixed(2)}
            </div>

            ${this.invoice.comment_txt ? `
                <div class="divider"></div>
                <div style="font-size: 10px;">
                    <span class="bold-text">COMMENTS:</span>
                    <div>${this.invoice.comment_txt}</div>
                </div>
            ` : ''}

            <div class="footer">
                <div class="thank-you">THANK YOU FOR YOUR BUSINESS!</div>
                <div style="font-size: 9px; margin-top: 2mm;">Refund Processed: ${currentDate}</div>
            </div>

            <div class="cut-line" style="text-align: center; margin-top: 3mm;">- - - - - - - - - - - - - - - - - - - -</div>
        </body>
        </html>
    `;
},

testPdfGeneration: function() {
    let that = this;
    
    if (this.invoice.items.length === 0) {
        this.$bvToast.toast(
            "Please add at least one item to test PDF generation",
            {title: "Info", autoHideDelay: 2000, variant: "warning"}
        );
        return;
    }

    this.loading = true;
    console.log("=== TESTING PDF GENERATION ===");

    // Get location info
    let locationInfo = {};
    if (this.invoice.selected_locsub) {
        const loc = this.packet.locsubs.find(l => l.value === this.invoice.selected_locsub);
        locationInfo = {
            name: loc ? loc.text : this.invoice.short_name || 'Store Location',
            address: this.invoice.location_address || '',
            phone: this.invoice.location_phone || '',
            email: this.invoice.location_email || ''
        };
    }

    // Get customer data
    const customerData = this.invoice.customer || {};

    // Get current date
    const currentDate = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    // Get signature URL if available
    const signatureUrl = this.invoice.signature_url || null;

    // Get username
    const username = this.invoice.username || this.userDetails.username || 'Test';

    // Get items
    const items = this.invoice.items || [];

    // Get params (invoice data)
    const params = {
        invoice_id: this.invoice.invoice_id || 'TEST-' + Date.now(),
        location_id: this.invoice.location_id,
        sublocation_id: this.invoice.sublocation_id,
        customer: customerData,
        delivery_charges: this.invoice.delivery_charges || 0,
        setup_charges: this.invoice.setup_charges || 0,
        warranty_charges: this.invoice.warranty_charges || 0,
        sales_tax: this.getSalesTax(),
        subtotal: this.getSubTotal(),
        taxable_subtotal: this.adjust_to_taxable_amount(this.getSubTotal()),
        total: this.getSubTotal() + this.getSalesTax(),
        payment_methods: this.invoice.payment_methods || [],
        is_layaway: this.invoice.is_layaway || false,
        comment_txt: this.invoice.comment_txt || '',
        tax_perc: this.invoice.tax_perc || 0,
        sold_from_state: this.invoice.sold_from_state || '',
        policy_text: this.currentPolicyText,
        warranty_refused: this.warrantyRefused || false
    };

    console.log("Sending test PDF generation request...");

    // Use your existing Requestor pattern
    let path = "/api/sales/test_generate_pdfs/";
    let data = {
        params: params,
        items: items,
        location_info: locationInfo,
        customer_data: customerData,
        username: username,
        current_date: currentDate,
        signature_url: signatureUrl,
        invoice_id: params.invoice_id
    };

    let s = function(response) {
        that.loading = false;
        
        console.log("PDF generation response:", response.data);
        
        if (response.data.error) {
            that.$bvToast.toast(
                "PDF generation failed: " + response.data.error,
                {title: "Error", autoHideDelay: 3000, variant: "danger"}
            );
            return;
        }
        
        if (response.data.result && response.data.result.pdf_data_url) {
            // Open the PDF data URL in a new tab
            const pdfWindow = window.open();
            if (pdfWindow) {
                pdfWindow.document.write(`
                    <html>
                        <head>
                            <title>PDF Preview - ${params.invoice_id}</title>
                            <style>
                                body, html { margin: 0; padding: 0; height: 100%; }
                                embed { width: 100%; height: 100%; }
                            </style>
                        </head>
                        <body>
                            <embed src="${response.data.result.pdf_data_url}" type="application/pdf" width="100%" height="100%">
                        </body>
                    </html>
                `);
            } else {
                // Fallback - open directly
                window.open(response.data.result.pdf_data_url, '_blank');
            }
            
            that.$bvToast.toast(
                "PDF generated successfully!",
                {title: "Success", autoHideDelay: 2000, variant: "success"}
            );
        } else {
            that.$bvToast.toast(
                "PDF generated but no data URL returned",
                {title: "Info", autoHideDelay: 3000, variant: "info"}
            );
        }
    };

    let f = function(error) {
        console.error("PDF generation test failed:", error);
        that.loading = false;
        
        let errorMsg = "Unknown error";
        if (error.response && error.response.data && error.response.data.error) {
            errorMsg = error.response.data.error;
        } else if (error.message) {
            errorMsg = error.message;
        }
        
        that.$bvToast.toast(
            "PDF generation failed: " + errorMsg,
            {title: "Error", autoHideDelay: 3000, variant: "danger"}
        );
    };

    Requestor.postSyncP(path, data, this, s, f);
},

    refreshInvoiceData: function() {
        let that = this;

        // Refresh store credit amount
        let creditPath = "/api/sales/get_available_credit/";
        let creditData = {invoice_id: this.invoice.invoice_id};

        Requestor.postAsyncP(creditPath, creditData, this,
            function(response) {
                if (response.data.result && response.data.result.length > 0) {
                    that.invoice.available_credit_value = response.data.result[0].available_amount || 0;
                }
            },
            function(error) {
                console.error("Error refreshing store credit:", error);
            }
        );

        // Refresh refunds summary component
        this.refundsSummaryKey += 1;

        // Force re-computation of computed properties
        this.$forceUpdate();
    },
    validate_store_credit_refund: function() {
        let availableCredit = this.getAvailableStoreCredit();

        if (availableCredit <= 0) {
            this.$vex.dialog.alert({
                message: "No store credit available to refund."
            });
            return;
        }

        // Set the refund amount to the available store credit
        this.refund_charges.total_refunded_currently = availableCredit;
        this.current_refund_validated = true;

        // Auto-add one refund method when validated
        if (this.refund_methods.length === 0) {
            this.addRefundMethod();
        }

        this.$bvToast.toast(
            `Store credit refund validated: $${availableCredit.toFixed(2)} available`,
            {title: "Success", autoHideDelay: 1500, variant:"success"}
        );
    },
                summarize_refunds_history: function(refunds){
                    let total_refunded_value = 0.0;
                    for (var i=0; i<refunds.length; i++){
                        let refund = refunds[i];

                        if (refund.detail.type == 'return'){
                            let value = refund.detail.total_refunded_item_amount + refund.detail.total_refunded_sales_tax + refund.detail.total_refunded_delivery + refund.detail.total_refunded_setup + refund.detail.total_refunded_warranty;


                            total_refunded_value += (value || 0.0);
                        }
                    }
                    this.total_refunded_value = (total_refunded_value || 0.0);
                    ///this.invoice.total_refunded_value = this.total_refunded_value;
                },
    // getTotalBalanceWithCredit: function() {
    //     let grand_total_before_credit = this.getSubTotal() + this.getSalesTax();
    //     let store_credit_applied = this.getStoreCreditApplied();

    //     return Math.max(0, grand_total_before_credit - store_credit_applied);
    // },

                // Debug method to check payment method data
                debugPaymentMethods: function() {
                    console.log("All finance companies:", this.finance_companies);
                    console.log("Finance only companies:", this.finance_only_companies);
                    console.log("Tax exempt companies:", this.tax_exempt_companies);
                    console.log("Current payment methods:", this.invoice.payment_methods);
                    console.log("New payment methods:", this.invoice.new_payment_methods);
                },

                reset_pms_if_layaway: function(){
                    if (this.invoice.is_layaway){
                        this.invoice.payment_methods = [];
                    }
                },
   get_order_types(item) {
    // Base order types with "NA" option for delivery type
    const baseOrderTypes = [
        {"value": "store_pickup", "text": "Store Pickup"},
        {"value": "home_delivery", "text": "Home Delivery"},
        {"value": "delivery_from_store", "text": "Delivery from Store"},
    ];
    
    // Check if the item is sourced from store
    const isFromStore = item.sourceContext === 'store' || 
                       (item.existing && (item.locsub || item.source_location_id));
    
    // For store-sourced items, include "Take Home" option
    if (isFromStore) {
        return [
            {"value": "customer_takes", "text": "Take Home"},
            ...baseOrderTypes
        ];
    }
    
    // For warehouse-sourced items, only show store_pickup, home_delivery, and store_delivery
    return baseOrderTypes;
},
                        loadInvoiceData() {
            // Only load if we have an invoice_id (edit mode)
            if (!this.invoice.invoice_id) {
                console.log('No invoice ID - must be a new sale');
                return;
            }

            let path = "/api/sales/get_invoice/";
            let data = {invoice_id: this.invoice.invoice_id};
            let that = this;

            let s = function(response) {
                if (response.data.result) {
                    // Merge the loaded invoice data with current invoice data
                    const loadedInvoice = response.data.result;

                    // Preserve any unsaved changes in the current invoice
                    that.invoice = {
                        ...loadedInvoice, // Loaded data from API
                        edit: true, // Ensure edit mode stays true
                        // Preserve any current unsaved changes if needed
                        items: that.invoice.items || loadedInvoice.items,
                        customer: that.invoice.customer || loadedInvoice.customer,
                        // Add any other fields you want to preserve
                    };

                    console.log('Invoice data loaded:', that.invoice);

                    that.$bvToast.toast(
                        "Invoice data loaded successfully",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                } else {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                that.loading = false;
            };

            let f = function(error) {
                console.log(error);
                that.$bvToast.toast(
                    "Error loading invoice data",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                that.loading = false;
            };

            this.loading = true;
            Requestor.postAsyncP(path, data, this, s, f);
        },

      
 loadPaymentMethodsOnly: function() {
    if (!this.invoice.invoice_id) return;

    let path = "/api/sales/get_invoice/";
    let data = {invoice_id: this.invoice.invoice_id};
    let that = this;

    let s = function(response) {
        if (response.data.result) {
            const loadedInvoice = response.data.result;

            // Load into payment_history for display
            that.payment_history = loadedInvoice.payment_methods || [];
            that.original_payment_methods = loadedInvoice.payment_methods || [];
            
            // Store invoice payment methods for reference
            that.invoice.payment_methods = loadedInvoice.payment_methods || [];

            // Calculate available refund amounts
            that.calculateAvailableRefundAmounts();

            console.log('Payment history reloaded:', that.payment_history);
        }
        that.loading = false;
    };

    let f = function(error) {
        console.log(error);
        that.loading = false;
    };

    this.loading = true;
    Requestor.postAsyncP(path, data, this, s, f);
},
                get_invoice_data: function(){
                    if (this.viewdata){
                        console.log(this.viewdata[0])
                        return this.viewdata[0]
                    }
                    else {
                        this.isEditMode = false;
                        return {
                            edit: false,
                            
                            invoice_id: null,
                            username: null,
                            customer: {},
                            items: [],
                            delivery_charges: 0,
                            setup_charges: 0,
                            warranty_charges: 0,
                            payment_methods: [],
                            new_payment_methods: [],
                            location_id: null,
                            sublocation_id: null,
                            selected_locsub: null,
                            sales_tax: 0.0,
                            subtotal: 0.0,
                            taxable_subtotal: 0.0,
                            total: 0.0,
                            comment_txt: null,
                            available_credit_value: 0.0,
                            is_layaway: false,
                               has_signature: false,
                            signature_url: null,
                            signature_temp_data: null,
                            signature_uploaded_at: null,
                            address_confirmation_agreed: false,
                            customer_id_card_url: null,
                            customer_id_card_type: null,
                            customer_id_card_number: null,
                            customer_id_card_uploaded_at: null
                        }
                    }
                },
                set_zipcode_and_state_city: function(e) {
                    this.invoice.customer.zipcode = e.zip_code;
                    this.invoice.customer.city = e.city;
                    this.invoice.customer.state = e.state
                },
                filter_zipcodes: function(item, query){
                    return (
                        item.zip_code.toLowerCase().indexOf(query.toLowerCase()) > -1
                    )
                },
                show_item: function(item){
                    let status = false;
                    if (item.existing == false){
                        status = true;
                    }
                    else {
                        if (item.quantity - item.refunded_so_far_quantity == 0){
                            status = false
                        }
                        else {
                            status = true
                        }
                    }
                    return status
                },
check_finance_company_charges_tax: function(pmethod){
    if (pmethod.value == "finance"){
        let sold_from_state = this.invoice.sold_from_state;
        let finance_company_name = pmethod.name;
        let finance_company = this.finance_companies.filter(function(d){ 
            return d.value == finance_company_name
        });

        if (finance_company.length > 0){
            let k = finance_company[0];
            // Check if this finance company charges tax in the sold-from state
            let chargesTax = k.company_charges_tax_in_states && 
                            k.company_charges_tax_in_states.includes(sold_from_state);
            
            // Set charged_tax_itself to true if they DO charge tax
            pmethod.charged_tax_itself = chargesTax;
            
            console.log(`Finance company ${finance_company_name} charges tax in ${sold_from_state}: ${chargesTax}`);
            return chargesTax;
        }
    }
    return false;
},

               // Update your del_date_set or order type change handler
del_date_set: function(item) {
    if (item.order_type === "customer_takes") {
        item.delivery_date = moment().format("MM-DD-YYYY");
    }
    
    // For delivery_from_store, set ship_locsub
    if (item.order_type === 'delivery_from_store') {
        this.setShipLocsubForDelivery(item);
    }
    
    // Trigger validation
    this.$nextTick(() => {
        this.validateDeliveryFromStoreLocations();
    });
},
                format_date: function(item){

                    item.delivery_date = moment(item.delivery_date).format("MM-DD-YYYY")
                    console.log(typeof(item.delivery_date), item.delivery_date)
                },
                concater: function(items){
                    let out = items.join("|")
                    return out
                },
                apply_store_credit: function(pmidx){
                    let payment_methods = this.invoice.payment_methods;
                    if (this.invoice.edit == true){
                        payment_methods = this.invoice.new_payment_methods;
                    }

                    let store_credit_invoice_id = payment_methods[pmidx].store_credit_invoice_id;

                    if (!store_credit_invoice_id){
                        this.$vex.dialog.alert(
                            {message: "Please specify valid invoice id to find out its store credit balance."}
                        );
                        return
                    }
                    let path = "/api/sales/get_available_credit/";
                    let data = {invoice_id: store_credit_invoice_id};
                    let that = this;

                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            if (response.data.result.length > 0){
                                //console.log(response.data.result)
                                if (that.invoice.edit == true){
                                    that.invoice.new_payment_methods[pmidx].available_amount = response.data.result[0].available_amount;
                                    that.invoice.new_payment_methods[pmidx].name = store_credit_invoice_id;
                                }
                                else {

                                    that.invoice.payment_methods[pmidx].available_amount = response.data.result[0].available_amount;
                                    that.invoice.payment_methods[pmidx].name = store_credit_invoice_id;
                                }

                                if(response.data.result[0].available_amount > 0){
                                    that.$bvToast.toast(
                                        "Store credit retrieved.",
                                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                                    );
                                }
                                else {
                                    that.$bvToast.toast(
                                        "No Store credit available for "+store_credit_invoice_id,
                                        {title: "Notice", autoHideDelay: 1500, variant:"warning"}
                                    );
                                }
                            }
                            else {
                                that.$bvToast.toast(
                                    "No store credit found with the given invoice.",
                                    {title: "Not found", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        }
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error occurred while applying store credit.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    Requestor.postAsyncP(path, data, this, s, f);
                },



       addProduct: function(item) {
    let that = this;
    item = this.applyDiscountToItem(item);
    
    // =============================================
    // SEPARATE FLAG CHECKING
    // =============================================
    const isActuallyNonInventory = item.is_non_inventory === true;
    const isActuallySpecialOrder = item.is_special === true;
    
    // ✅ CRITICAL: PRESERVE DAMAGE METADATA FROM SEARCH RESULT
    let isDamaged = false;
    let damageInfo = null;
    let sourceValue = 'store';
    
    // Check if item has damage_info from search
    if (item.damage_info) {
        damageInfo = item.damage_info;
        isDamaged = item.damage_info.is_damaged || item.is_damaged || false;
        if (isDamaged) {
            sourceValue = 'damage';
        }
    } else if (item.is_damaged) {
        // If is_damaged is true but damage_info is missing, create it
        isDamaged = true;
        sourceValue = 'damage';
        damageInfo = {
            damage_id: item.damage_id || null,
            is_damaged: true,
            damage_grade: item.damage_grade || null,
            damage_description: item.damage_description || '',
            damage_images: item.damage_images || []
        };
    }
    
    // ✅ CRITICAL: Also check if the item already has damage metadata in the payload
    if (item.is_damaged === true || item.source === 'damage') {
        isDamaged = true;
        sourceValue = 'damage';
        if (!damageInfo) {
            damageInfo = item.damage_info || {
                damage_id: item.damage_id || null,
                is_damaged: true,
                damage_grade: item.damage_grade || null,
                damage_description: item.damage_description || '',
                damage_images: item.damage_images || []
            };
        }
    }
    
    // If the item has damage_id but no damage_info, create damage_info
    if (item.damage_id && !damageInfo) {
        isDamaged = true;
        sourceValue = 'damage';
        damageInfo = {
            damage_id: item.damage_id,
            is_damaged: true,
            damage_grade: item.damage_grade || null,
            damage_description: item.damage_description || '',
            damage_images: item.damage_images || []
        };
    }
    
    // ✅ LOG DAMAGE METADATA FOR DEBUGGING
    if (isDamaged) {
        console.log(`🟡 ADDING DAMAGED ITEM: ${item.product_sku} (Damage ID: ${damageInfo.damage_id || 'N/A'})`);
        console.log('Damage info:', damageInfo);
    }
    
    // ✅ Check if the item is damaged or as-is
    const isDamagedItem = isDamaged || item.is_as_is;
    
    if (this.hasQuantityError(item)) {
        this.$vex.dialog.alert({
            message: `Quantity must be a multiple of ${item.quantity_per_box}. Please adjust the quantity.`
        });
        return;
    }

    if (item.order_type === 'delivery_from_store') {
        this.setShipLocsubForDelivery(item);
    }
    
    if (!item.quantity || isNaN(parseInt(item.quantity)) ){
        this.$vex.dialog.alert({message: "Please specify valid count of item."});
        return;
    }
    
    if (item.discount_offered && parseFloat(item.discount_offered) > 0) {
        if (!this.validateDiscount(item)) {
            return;
        }
    }

    if (this.search_in_my_location && item.available !== undefined && parseInt(item.quantity) > parseInt(item.available)) {
        this.$vex.dialog.alert({
            message: `Cannot add ${item.quantity} items. Only ${item.available} available in stock.`
        });
        return;
    }

    const isNewItemAsIs = !!(isDamaged || item.is_as_is);
    
    const newItemsWithSameSku = this.invoice.items.filter(d => 
        !d.existing && d.product_sku === item.product_sku
    );
    
    if (newItemsWithSameSku.length > 0) {
        const hasSameAsIsStatus = newItemsWithSameSku.some(d => {
            const existingItemIsAsIs = !!(d.is_damaged || d.is_as_is);
            return existingItemIsAsIs === isNewItemAsIs;
        });
        
        if (hasSameAsIsStatus) {
            const statusText = isNewItemAsIs ? "AS-IS" : "NORMAL";
            this.$vex.dialog.alert({
                message: `A ${statusText} version of SKU ${item.product_sku} already exists in the RESELECTED ITEMS section. You cannot add another ${statusText} copy.`
            });
            return;
        }
    }

    if (!item.selling_price || isNaN(parseInt(item.selling_price)) ){
        this.$vex.dialog.alert({message: "Please specify selling price of item."});
        return;
    }

    if (!item.product_sku){
        this.$vex.dialog.alert({message: "Please specify valid sku of item."});
        return;
    }

    if (item.product_sku != item.product_sku.replaceAll(/\s/g, "")) {
        this.$vex.dialog.alert({message: "Please specify valid sku of item (without spaces)."});
        return;
    }

    item.quantity = parseInt(item.quantity);
    let is_special = ((item.product_id == null) ? true : false);

    if (is_special){
        if (!item.vendor){
            this.$vex.dialog.alert({message: "Please specify valid vendor for special item."});
            return;
        }
        item.new_selling_price = item.selling_price;
    }

    // FORCE STORE SOURCE FOR NON-INVENTORY/SPECIAL ITEMS
    let context;
    let orderType;
    let deliveryDate;
    let defaultLocsub = null;
    let defaultDropLocsub = null;
    let defaultShipLocsub = null;
    
    // Use the actual flags
    if (isActuallyNonInventory) {
        context = 'store';
        orderType = "customer_takes";
        deliveryDate = moment().format("MM-DD-YYYY");
        console.log("Non-inventory item detected - forcing store source and Take Home order type");
    } else if (isActuallySpecialOrder) {
        context = 'store';
        orderType = "customer_takes";
        deliveryDate = moment().format("MM-DD-YYYY");
        console.log("Special order item detected - forcing store source and Take Home order type");
    } else {
        context = this.search_in_my_location ? 'store' : 'warehouse';
        orderType = item.order_type || "home_delivery";
        deliveryDate = item.delivery_date;
    }
    
    // If order type is customer_takes, ensure delivery date is today
    if (orderType == 'customer_takes'){
        deliveryDate = moment().format("MM-DD-YYYY");
    }
    
    // =============================================
    // ✅ SET DEFAULT FULFILLMENT LOCATION
    // =============================================
    if (context === 'store' && this.invoice.location_id) {
        console.log("Setting default fulfillment location for store-sourced item");
        
        const allStoreLocations = this.packet.locsubs.filter(d => 
            d.location_id == this.invoice.location_id
        );
        
        // Separate damage and regular locations
        const damageLocations = allStoreLocations.filter(d => 
            this.isDamageLocation(d) && d.sublocation_type_id !== 1
        );
        
        const regularLocations = allStoreLocations.filter(d => 
            !this.isDamageLocation(d) && d.sublocation_type_id !== 1
        );
        
        // ✅ FOR DAMAGED ITEMS: Auto-select damage location
        if (isDamagedItem) {
            console.log(`🟡 Item ${item.product_sku} is damaged/as-is - looking for damage location`);
            
            // First priority: Find a damage location with "DAMAGE" or "AS IS" in the name
            let selectedDamageLocation = damageLocations.find(d => {
                const text = d.text.toLowerCase();
                return text.includes('damage') || text.includes('as is') || text.includes('defective');
            });
            
            // If no specific damage location found, use any damage location
            if (!selectedDamageLocation && damageLocations.length > 0) {
                selectedDamageLocation = damageLocations[0];
            }
            
            if (selectedDamageLocation) {
                defaultLocsub = selectedDamageLocation.value;
                defaultDropLocsub = selectedDamageLocation.value;
                defaultShipLocsub = selectedDamageLocation.value;
                console.log(`✅ Auto-selected damage location for ${item.product_sku}: ${selectedDamageLocation.text}`);
            } else {
                // Fallback: If no damage location exists, use regular stock
                console.log(`⚠️ No damage location found for ${item.product_sku}, falling back to regular stock`);
                const stockLocations = regularLocations.filter(d => d.sublocation_type_id !== 1);
                if (stockLocations.length > 0) {
                    const stockNamedLocation = stockLocations.find(d => 
                        d.text.toLowerCase().includes('stock')
                    );
                    defaultLocsub = stockNamedLocation ? stockNamedLocation.value : stockLocations[0].value;
                    defaultDropLocsub = defaultLocsub;
                    defaultShipLocsub = defaultLocsub;
                }
            }
        } else {
            // ✅ FOR NORMAL ITEMS: Only use regular locations
            console.log(`🟢 Item ${item.product_sku} is normal - using regular stock location`);
            
            const stockLocations = regularLocations.filter(d => d.sublocation_type_id !== 1);
            
            if (stockLocations.length > 0) {
                const stockNamedLocation = stockLocations.find(d => 
                    d.text.toLowerCase().includes('stock')
                );
                
                if (stockNamedLocation) {
                    defaultLocsub = stockNamedLocation.value;
                    console.log("Selected stock location for fulfillment:", stockNamedLocation.text);
                } else {
                    defaultLocsub = stockLocations[0].value;
                    console.log("Selected first available location for fulfillment:", stockLocations[0].text);
                }
            } else if (allStoreLocations.length > 0) {
                defaultLocsub = allStoreLocations[0].value;
                console.log("No stock locations found, using:", allStoreLocations[0].text);
            }
            
            // For non-inventory and special order items, set drop_locsub and ship_locsub to same as locsub
            if ((isActuallyNonInventory || isActuallySpecialOrder) && defaultLocsub) {
                defaultDropLocsub = defaultLocsub;
                defaultShipLocsub = defaultLocsub;
                console.log("Setting drop_locsub and ship_locsub to:", defaultLocsub);
            } else if (orderType === 'store_pickup' || orderType === 'home_delivery') {
                const availableLocations = regularLocations.filter(d => 
                    !defaultLocsub || d.value !== defaultLocsub
                );
                
                if (availableLocations.length > 0) {
                    defaultDropLocsub = availableLocations[0].value;
                } else if (regularLocations.length > 0) {
                    defaultDropLocsub = regularLocations[0].value;
                }
            }
        }
    }
    
    // ✅ FORCE SOURCE TO 'DAMAGE' IF ITEM IS DAMAGED
    let finalSourceValue = sourceValue;
    if (isDamaged) {
        finalSourceValue = 'damage';
        // For damaged items, force sourceContext to 'store'
        context = 'store';
    } else if (!finalSourceValue || finalSourceValue === 'unknown') {
        finalSourceValue = context;
    }
    
    // =============================================
    // ✅ BUILD THE ITEM OBJECT WITH DAMAGE METADATA
    // =============================================
    let invitem = {
        product_id: ((is_special) ? -1 : item.product_id),
        product_sku: item.product_sku,
        product_name: item.product_name,
        product_category: item.product_category,
        product_category_name: item.product_category_name,
        vendor: item.vendor,
        quantity: item.quantity,
        selling_price: item.selling_price,
        new_selling_price: item.new_selling_price,
        discount_offered: 0.0,
        is_group_item: !!(item.elements && item.elements.length > 0),
        children_count: item.elements ? item.elements.length : 0,
        children: item.elements,
        // CRITICAL: Use the actual flags
        is_special: isActuallySpecialOrder || false,
        is_non_inventory: isActuallyNonInventory || false,
        order_type: orderType,
        delivery_date: deliveryDate,
        locsub: defaultLocsub,
        drop_locsub: defaultDropLocsub,
        ship_locsub: defaultShipLocsub,
        state: ((!is_special) ? 1 : 2),
        merchandise_status: null,
        cubes: item.cubes,
        existing: false,
        sourceContext: context,
        // ✅ CRITICAL: PRESERVE DAMAGE SOURCE
        source: finalSourceValue,
        available: item.available,
        quantity_per_box: item.quantity_per_box || 1,
        image_url: item.image_url,
        home_delivery_type: null,
        is_as_is: item.is_as_is || false,
        // ✅ CRITICAL: PRESERVE DAMAGE METADATA
        is_damaged: isDamaged,
        damage_info: damageInfo,
        as_is_image_url: item.as_is_image_url,
        sublocation_breakdown: item.sublocation_breakdown || [],
        special_discount_price: item.special_discount_price,
        special_discount_end_date: item.special_discount_end_date,
        has_active_discount: this.hasActiveDiscount(item),
        non_inventory_metadata: item.non_inventory_metadata || null,
        special_order_metadata: item.special_order_metadata || null
    };
    
    // ✅ LOG DAMAGE METADATA FOR DEBUGGING
    if (isDamaged) {
        console.log(`🔴 DAMAGED ITEM ADDED:`, {
            sku: invitem.product_sku,
            damage_id: damageInfo.damage_id || 'N/A',
            grade: damageInfo.damage_grade || 'N/A',
            source: invitem.source,
            is_damaged: invitem.is_damaged
        });
        
        this.$bvToast.toast(
            `⚠️ ${item.product_sku} is marked as DAMAGED (ID: ${damageInfo.damage_id || 'N/A'}). This item CANNOT be returned or refunded.`,
            {title: "Damage Item", autoHideDelay: 5000, variant: "danger"}
        );
    }

    if (invitem.is_special){
        invitem.vendor = this.packet.vendors.filter(function(d){
            return d.value == invitem.vendor
        })[0].text;
    }

    this.invoice.items.push(invitem);
    
    // =============================================
    // ✅ SHOW TOAST WITH LOCATION INFO
    // =============================================
    const statusText = invitem.is_damaged || invitem.is_as_is ? "AS-IS" : "NORMAL";
    const typeText = invitem.is_non_inventory ? "NON-INVENTORY" : (invitem.is_special ? "SPECIAL ORDER" : "REGULAR");
    const sourceDisplay = invitem.sourceContext === 'store' ? 'STORE' : 'WAREHOUSE';
    const orderTypeDisplay = invitem.order_type === 'customer_takes' ? 'TAKE HOME' : 
                            (invitem.order_type === 'store_pickup' ? 'STORE PICKUP' : 'HOME DELIVERY');
    const fulfillmentDisplay = invitem.locsub ? this.getLocationName(invitem.locsub) : 'NOT SET';
    
    // Show damage location info in toast if applicable
    let damageLocationInfo = '';
    if (isDamagedItem && invitem.locsub) {
        const location = this.packet.locsubs.find(d => d.value === invitem.locsub);
        if (location && this.isDamageLocation(location)) {
            damageLocationInfo = ` (Damage Location: ${location.text})`;
        }
    }
    
    this.$nextTick(() => {
        this.validateDeliveryFromStoreLocations();
    });
    
    this.$bvToast.toast(
        `Added ${typeText} ${statusText} version of ${item.product_sku} (Source: ${sourceDisplay}, Type: ${orderTypeDisplay}, Fulfill From: ${fulfillmentDisplay}${damageLocationInfo})`,
        {title: "Success", autoHideDelay: 3000, variant:"success"}
    );
    
    console.log(`Added item with is_non_inventory: ${invitem.is_non_inventory}, is_special: ${invitem.is_special}, is_damaged: ${invitem.is_damaged}`, invitem);
},
                get_item_locsub: function(item) {
                    let quantity = item.quantity;
                    let locsub = null;
                    let that = this;
                    let exists = Object.keys(this.all_loc_inventory_dict).filter(function(d){
                            return (parseInt(d.split("|")[0]) == parseInt(item.product_id) && d.split("|")[1] == item.product_sku);
                    });

                    if (exists.length > 0){
                        //randomly pick one location where the item exists.

                        exists = exists.filter(function(d){
                            return that.all_loc_inventory_dict[d] >= quantity;
                        })

                        if (exists.length > 0){
                            locsub = exists[Math.min(parseInt(Math.ceil(Math.random() * exists.length)) , exists.length -1)];
                            locsub = locsub.split("|")[2]+"|"+locsub.split("|")[3]
                        }
                    }

                    // if (!locsub){
                    //     locsub = this.backorder_locsub;
                    // }
                    return locsub
                },
                get_item_status(item, is_special = false) {
                    //console.log("itemstatus", item);

                    let status = parseInt(item.state);
                    console.log("itemstate", status);
                    // 1 = delivered
                    if (status === 1) {
                        return 'delivered';
                    }

                    // not delivered → allow refund
                    return 'refundable';
                },
                get_merchandise_status: function(item, is_special){
                    // if (is_special){
                    //     //if special, then we will set it null
                    //     //because admin will do a special order from vendor and assign it a status = 2
                    //     return 2
                    // }
                    // else {
                    //     if (this.inventory_counts[this.concater([item.product_id, item.product_sku])] > 0) {
                    //         //its 1 if in stock
                    //         return 1
                    //     }
                    //     else {
                    //         //if regular and not in stock,
                    //         //the merchandise status will be null
                    //         //because admin will to backorder from vendor
                    //         return null
                    //     }

                    // }


                },
    set_location: async function(locsub) {
    // Get location name for the message
    const selectedLoc = this.packet.locsubs.find(loc => loc.value === locsub);
    const locationName = selectedLoc ? selectedLoc.text.split('|')[0].trim() : 'Location';
    
    // Show initial loader
    this.$refs.loaderAnimation.show(`Setting up ${locationName}...`);
    
    // Small delay to show first message (optional, for smoother UX)
    await new Promise(resolve => setTimeout(resolve, 300));
    
    // Update message to show progress
    this.$refs.loaderAnimation.show(`Loading ${locationName} details...`);
    
    let path = "/api/location/get_location_info/"
    let data = {locsub: locsub};
    let that = this;
    
    let s = function(response){
        if (response.data.error){
            that.$refs.loaderAnimation.hide();
            that.$bvToast.toast(
                "ERROR WHILE RETRIEVING LOCATION.",
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        }
        else {
            if (response.data.result.length == 0){
                that.$refs.loaderAnimation.hide();
                that.$vex.dialog.alert({message: "CANNOT FIND THE SALES LOCATION. PLEASE REFRESH YOUR BROWSER."})
            }
            else {
                // Update message to final stage
                that.$refs.loaderAnimation.show("Applying location settings...");
                
                setTimeout(() => {
                    console.log(response.data.result[0])
                    that.invoice.location_id = response.data.result[0].location_id;
                    that.invoice.sublocation_id = response.data.result[0].sublocation_id;
                    that.invoice.sold_from_state = response.data.result[0].state;
                    that.invoice.tax_perc = response.data.result[0].tax_perc;
                    that.invoice.short_name = response.data.result[0].short_name;
                    that.invoice.location_address = response.data.result[0].address || 
                                    response.data.result[0].full_address || 
                                    response.data.result[0].location_name;
                    
                    that.$bvToast.toast(
                        `Location loaded: ${that.invoice.short_name}`,
                        {title: "Location Set", autoHideDelay: 1000, variant:"success"}
                    );
                    
                    that.fetchInvoiceId(that.invoice.short_name);
                    that.isEditMode = false;
                    
                    that.invoice.items = [];
                    that.invoice.delivery_charges = 0.0;
                    that.invoice.setup_charges = 0.0;
                    that.invoice.warranty_charges = 0.0;
                    that.invoice.is_layaway = false;
                    
                    that.resetSaleData();
                    
                    // Hide loader with a slight delay to show completion
                    setTimeout(() => {
                        that.$refs.loaderAnimation.hide();
                    }, 500);
                }, 100);
            }
        }
        
        that.locationLoading = false;
        that.loading = false;
    }

    let f = function(error){
        that.$refs.loaderAnimation.hide();
        that.$bvToast.toast(
            "SYSTEM ERROR WHILE GETTING LOCATION INFO. TRY AGAIN.",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
        that.locationLoading = false;
        that.loading = false;
    }

    Requestor.getSync(path, data, s, f);
    
    // Reset search results and special item when location changes
    this.searchitems.result = [];
    this.searchitems.keyword = null;
    this.special_item = {
        product_id: null,
        product_sku: null,
        product_name: null,
        product_category: null,
        quantity: null,
        selling_price: null,
        new_selling_price: null,
        discount_offered: 0.0,
        vendor: null,
    };

    // Collapse the search panels
    this.$root.$emit('bv::toggle::collapse', 'collapse-1');
    this.$root.$emit('bv::toggle::collapse', 'collapse-2');
},
          fetchInvoiceId: function(shortName) {
    let that = this;
    let path = "/api/sales/generate_invoice_id/";
    let data = {short_name: shortName};
    
    Requestor.postAsyncP(path, data, this,
        function(response) {
            if (response.data.result && response.data.result.invoice_id) {
                that.invoice.invoice_id = response.data.result.invoice_id;
                console.log("Generated invoice_id:", that.invoice.invoice_id);
                
                // Initialize draft_id with the same value for consistency
                that.invoice.draft_id = that.invoice.invoice_id;
            }
        },
        function(error) {
            console.error("Error generating invoice_id:", error);
            // Fallback to frontend generation
            that.invoice.invoice_id = that.generateInvoiceId(shortName);
            that.invoice.draft_id = that.invoice.invoice_id;
        }
    );
},
generateInvoiceId: function(shortName) {
    const timestamp = Math.floor(Date.now() / 1000);
    const random = Math.floor(Math.random() * 1000);
    return `${shortName || 'NA'}-${timestamp}-${random}`;
},
//                 generateInvoiceId: function(shortName) {
//     const timestamp = Math.floor(Date.now() / 1000); // Unix timestamp in seconds
//     return `${shortName || 'NA'}-${timestamp}`;
// },
                resetSaleData: function() {
        // Create a fresh invoice object
        const freshInvoice = this.get_invoice_data();
        freshInvoice.location_id = this.invoice.location_id;
        freshInvoice.sublocation_id = this.invoice.sublocation_id;
        freshInvoice.sold_from_state = this.invoice.sold_from_state;
        freshInvoice.tax_perc = this.invoice.tax_perc;
        freshInvoice.short_name = this.invoice.short_name;
        freshInvoice.selected_locsub = this.invoice.selected_locsub;

        // Replace the entire invoice object
        this.invoice = freshInvoice;

        // Reset all other component state
        this.searchitems = {
            search_being_loaded: false,
            keyword: null,
            limit: 500,
            result: [],
            result2: [],
        };

        this.special_item = {
            product_id: null,
            product_sku: null,
            product_name: null,
            product_category: null,
            quantity: null,
            selling_price: null,
            new_selling_price: null,
            discount_offered: 0.0,
            vendor: null,
        };

        // Show success message
        this.$bvToast.toast(
            "Location changed. Starting fresh sale.",
            {title: "Success", autoHideDelay: 1500, variant:"success"}
        );
    },

                getLocationName(locsubValue) {
                if (!locsubValue) return '';

                const location = this.packet.locsubs.find(loc => loc.value === locsubValue);
                return location ? location.text : 'Unknown location';
            },

            // NEW: Handle change event for "Only In My Location" checkbox
  handleOnlyInMyLocationChange: function(isChecked) {
    if (!isChecked) {
        // When "ONLY IN MY LOCATION" is unchecked, automatically uncheck "AS IS"
        this.search_only_from_damages = false;
    }
    
    if (isChecked) {
        // When enabling "Only in My Location", auto-set fulfillment locations for existing items
        this.invoice.items.forEach(item => {
            if (!item.existing && !item.locsub && item.sourceContext === 'store') {
                // Auto-set fulfillment location
                const storeLocations = this.packet.locsubs.filter(d => 
                    d.location_id == this.invoice.location_id && 
                    d.sublocation_type_id !== 1
                );
                
                if (storeLocations.length > 0) {
                    item.locsub = storeLocations[0].value;
                }
                
                // Auto-set drop location for delivery/pickup items
                if (['store_pickup', 'home_delivery'].includes(item.order_type) && !item.drop_locsub) {
                    const nonFloorLocations = this.packet.locsubs.filter(d => d.sublocation_type_id !== 1);
                    const storePickupLocations = nonFloorLocations.filter(d => 
                        d.location_id == this.invoice.location_id
                    );
                    
                    if (storePickupLocations.length > 0) {
                        item.drop_locsub = storePickupLocations[0].value;
                    }
                }
            }
        });
        
        const itemsWithoutFulfillment = this.invoice.items.filter(item =>
            !item.existing &&
            item.order_type === 'customer_takes' &&
            !item.locsub &&
            item.sourceContext === 'store' // only enforce for store
        );

        if (itemsWithoutFulfillment.length > 0) {
            const missingSkus = itemsWithoutFulfillment
                .map(item =>
                    item.product_name
                        ? `${item.product_name} (${item.product_sku})`
                        : item.product_sku
                )
                .join(', ');

            this.$vex.dialog.alert({
                message: `Some store-sourced items need a fulfill from location selected. Please update them before proceeding.\n\nMissing: ${missingSkus}`
            });
        }

        // Extra check: prevent Take Home if source is warehouse
        const warehouseTakeHome = this.invoice.items.filter(item =>
            item.order_type === 'customer_takes' &&
            item.sourceContext === 'warehouse'
        );

        if (warehouseTakeHome.length > 0) {
            const badSkus = warehouseTakeHome
                .map(item =>
                    item.product_name
                        ? `${item.product_name} (${item.product_sku})`
                        : item.product_sku
                )
                .join(', ');

            this.$vex.dialog.alert({
                message: `Take Home option is not allowed for warehouse-sourced items.\n\nInvalid: ${badSkus}`
            });
        }

    } else {
        // When disabling "Only in My Location", DO NOT clear locations
        // Just allow warehouse sourcing without validation
        
        // Optional: Show informational message about store-sourced items keeping their locations
        const storeSourcedItems = this.invoice.items.filter(item =>
            !item.existing && item.sourceContext === 'store'
        );
        
        if (storeSourcedItems.length > 0) {
            const storeSkus = storeSourcedItems
                .map(item =>
                    item.product_name
                        ? `${item.product_name} (${item.product_sku})`
                        : item.product_sku
                )
                .join(', ');
            
            // Show informational toast instead of blocking
            this.$bvToast.toast(
                `Store-sourced items will retain their current fulfillment locations while warehouse items can be added.`,
                {title: "Info", autoHideDelay: 3000, variant: "info"}
            );
        }
        
        // The checkbox will now be successfully unchecked
        // No need to force re-check: this.search_in_my_location = true;
    }
},

                set_source_location: function(item) {
                    let locsub = item.source_locsub;
                    let splt = locsub.split("|")
                    item.source_location_id = +splt[0];
                    item.source_sublocation_id = +splt[1];
                    item.locsub = item.source_locsub;
                },
     search: function(e) {
    if (e) {
        e.preventDefault();
    }
    this.hasSearched = true;
    
    // If searching only from damages, use the damaged items search
    if (this.search_only_from_damages) {
        this.search_damaged_items();
        return;
    }
    
    let path = "/api/product/search_for_sale/"
    let data = {
        keyword: this.searchitems.keyword,
        limit: this.searchitems.limit,
        include_sublocation_breakdown: true,
        include_damage_info: true,  // Request damage info from API
        only_damaged: this.search_only_from_damages 
    };
    
    if (this.search_in_my_location){
        data.location_id = this.invoice.location_id;
    }
    
    let that = this;
    let s = function(response){
        if (response.data.error){
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        } else {
            // ✅ PRESERVE ALL DAMAGE METADATA
            that.searchitems.result = response.data.result.map(item => {
                // Check if item has damage info
                if (item.damage_info && item.damage_info.is_damaged) {
                    item.is_damaged = true;
                    item.source = 'damage';
                    
                    // Ensure damage_id is available
                    if (!item.damage_info.damage_id && item.damage_id) {
                        item.damage_info.damage_id = item.damage_id;
                    }
                    
                    console.log(`🔴 Found damaged item: ${item.product_sku}, Damage ID: ${item.damage_info.damage_id}`);
                } else {
                    item.is_damaged = false;
                    item.source = 'store';
                }
                return item;
            });
        }
        that.searchitems.search_being_loaded = false;
    }

    let f = function(error){
        that.$bvToast.toast(
            "Error occurred while searching product.",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
        that.searchitems.search_being_loaded = false;
    }

    this.searchitems.search_being_loaded = true;
    this.searchitems.result = []
    Requestor.getSyncP(path, data, this, s, f);
},
                search_my_location: function(e) {
                    if (e) {
                        e.preventDefault();
                    }
                    let path = "/api/product/search_for_sale_my_location/"
                    let data = {keyword: this.searchitems.keyword, limit: this.searchitems.limit, location_id: this.invoice.location_id};

                    let that = this;
                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            that.searchitems.result2 = response.data.result;
                        }
                        that.searchitems.search_being_loaded = false;
                    }

                    let f = function(error){
                        that.$bvToast.toast(
                            "Error occurred while searching product.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.searchitems.search_being_loaded = false;
                    }

                    this.searchitems.search_being_loaded = true;
                    Requestor.getSyncP(path, data, this, s, f);
                },
                initItemScan: function(e){
                    if (e){
                        e.preventDefault();
                    }
                    this.$bvModal.show("modal-scanner");
                },
                fetchScannedItem: function(result){
                    result = result.split("|");
                    let data = {product_sku: result[1], product_id: parseInt(result[2])}
                    let path = "/api/product/search_single_for_sale/"
                    let that = this;

                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            if (response.data.result.length > 0){
                                that.searchitems.result = response.data.result;
                            }
                        }
                        that.$bvModal.hide("modal-scanner");
                    }

                    let f = function(error){
                        that.$bvToast.toast(
                            "Error occurred while scanning product.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.$bvModal.hide("modal-scanner");
                    }
                    this.searchitems.search_being_loaded = false;
                    Requestor.postSyncP(path, data, this, s, f);
                },
updateInvoiceAsync: function() {
    return new Promise((resolve, reject) => {
        let invoice = JSON.parse(JSON.stringify(this.invoice));
        
        // Ensure source is set on all items
        invoice.items = invoice.items.map(item => {
            const sourceValue = item.source || item.sourceContext || 'unknown';
            return {
                ...item,
                source: sourceValue
            };
        });
        
        let newPaymentMethods = [];
        
        if (this.invoice.edit) {
            const existingPaymentsMap = new Map();
            
            this.payment_history.forEach(existingPm => {
                const key = this.getPaymentMethodKey(existingPm);
                existingPaymentsMap.set(key, existingPm);
            });
            
            newPaymentMethods = (invoice.new_payment_methods || []).filter(newPm => {
                if (!newPm.amount || parseFloat(newPm.amount) === 0) {
                    return false;
                }
                
                const newKey = this.getPaymentMethodKey(newPm);
                const exists = existingPaymentsMap.has(newKey);
                
                if (exists) {
                    const sameTypeAndAmount = Array.from(existingPaymentsMap.values()).some(existing => 
                        existing.value === newPm.value && 
                        Math.abs(parseFloat(existing.amount) - parseFloat(newPm.amount)) < 0.01
                    );
                    
                    if (sameTypeAndAmount) {
                        return false;
                    }
                }
                
                return !exists;
            });
        } else {
            newPaymentMethods = invoice.payment_methods || [];
        }
        
        if (this.invoice.edit) {
            invoice.new_payment_methods = newPaymentMethods;
        } else {
            invoice.payment_methods = newPaymentMethods;
        }
        
        invoice.warranty_charges = (+invoice.new_warranty_charges || 0.0);
        invoice.delivery_charges = (+invoice.new_delivery_charges || 0.0);
        invoice.setup_charges = (+invoice.new_setup_charges || 0.0);
        invoice.sales_tax = this.getSalesTax();
        invoice.subtotal = this.getSubTotal();
        invoice.taxable_subtotal = this.adjust_to_taxable_amount(this.getSubTotal());
        invoice.total = this.getSubTotal() + this.getSalesTax();

        let remainingStoreCredit = this.getRemainingStoreCredit();

        if (remainingStoreCredit > 0) {
            const errorMsg = `Cannot update invoice. Customer has $${remainingStoreCredit.toFixed(2)} remaining store credit that must be used first.`;
            this.$vex.dialog.alert({ message: errorMsg });
            reject(new Error(errorMsg));
            return;
        }

        let customer_error = this.validate_customer_info(invoice.customer);
        if (customer_error.length > 0){
            this.$vex.dialog.alert({message: customer_error[0]});
            reject(new Error(customer_error[0]));
            return;
        }

        let products_error = this.validate_products(invoice.items.filter(function(d){return d.existing == false}));
        if (products_error.length > 0){
            this.$vex.dialog.alert({message: products_error[0]});
            reject(new Error(products_error[0]));
            return;
        }

        let payments_error = this.validate_payment_methods(invoice.new_payment_methods);
        if (payments_error.length > 0){
            this.$vex.dialog.alert({message: payments_error[0]});
            reject(new Error(payments_error[0]));
            return;
        }

        invoice.new_payment_methods = invoice.new_payment_methods.map(function(d){
            d.amount = (+d.amount || 0.0); return d;
        });

        if ((this.packet.housetrucks || []).length > 0){
            invoice.housetruck = this.packet.housetrucks[0].value;
        } else {
            invoice.housetruck = null;
        }

        let that = this;
        let path = "/api/sales/update_sale/";
        let data = invoice;
        
        if (this.invoice.username) {
            data.username = this.invoice.username;
        } else {
            data.username = this.userDetails.username;
        }
        
        data.invoice_type = "INV";
        data.default_locsubs = this.default_locsubs;

        let s = function(response){
            if (response.data.error){
                that.$vex.dialog.alert({ message: response.data.error });
                reject(new Error(response.data.error));
            } else {
                // 🎉 SHOW SUCCESS ANIMATION FOR UPDATE
                that.successMessage = 'Sale Updated Successfully! 🎉';
                
                // Show the animation
                if (that.$refs.successAnimation) {
                    that.$refs.successAnimation.show();
                }
                
                that.$bvToast.toast(
                    "Invoice updated successfully!",
                    {title: "Success", autoHideDelay: 1500, variant:"success"}
                );
                
                // Wait for animation to complete before reload
                setTimeout(() => {
                    window.location.reload();
                }, 2500);
            }
            that.block_post_invoice = false;
            that.loading = false;
        };

        let f = function(error){
            console.log(error);
            that.$bvToast.toast(
                "An error occurred while updating sale. Please try again.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
            that.block_post_invoice = false;
            that.loading = false;
            reject(error);
        };

        this.block_post_invoice = true;
        this.loading = true;
        Requestor.postSyncP(path, data, this, s, f);
    });
},

// Helper method to create a unique key for a payment method
getPaymentMethodKey: function(payment) {
    if (!payment) return '';
    
    const value = payment.value || '';
    const amount = parseFloat(payment.amount || 0).toFixed(2);
    
    // Base key with value and amount
    let key = `${value}|${amount}`;
    
    // Add type-specific identifiers
    if (value === 'cc') {
        key += `|${payment.name || ''}`;
    } else if (value === 'finance') {
        key += `|${payment.name || ''}|${payment.lease_id || ''}`;
    } else if (value === 'tax_exempt') {
        key += `|${payment.name || ''}`;
    } else if (value === 'store_credit') {
        key += `|${payment.store_credit_invoice_id || ''}`;
    }
    
    return key;
},

markNewPaymentMethods: function() {
    if (!this.invoice.edit || !this.payment_history.length) {
        return;
    }
    
    // Add a flag to each payment method to track if it's new
    (this.invoice.new_payment_methods || []).forEach(newPm => {
        const exists = this.payment_history.some(existingPm => {
            if (existingPm.value !== newPm.value) return false;
            
            const existingAmount = parseFloat(existingPm.amount) || 0;
            const newAmount = parseFloat(newPm.amount) || 0;
            if (Math.abs(existingAmount - newAmount) > 0.01) return false;
            
            if (newPm.value === 'cc' && existingPm.name !== newPm.name) return false;
            if (newPm.value === 'finance' && existingPm.lease_id !== newPm.lease_id) return false;
            if (newPm.value === 'tax_exempt' && existingPm.name !== newPm.name) return false;
            
            return true;
        });
        
        // Add a flag to the payment method
        newPm._isNew = !exists;
    });
},
    getAvailableRefundAmount: function() {
        // Replace this with your actual logic to calculate available refund amount
        // This should be different from remainingStoreCredit
        // For example:
        return this.invoice.available_credit_value || 0.0;

        // Or if you have a specific calculation:
        // return this.calculateTotalRefundableAmount() - this.getUsedRefundAmount();
    },
                updateInvoice: function(e) {
                    if (e) {
                        e.preventDefault();
                    }
                    let invoice = JSON.parse(JSON.stringify(this.invoice));
                    invoice.warranty_charges = (+invoice.new_warranty_charges || 0.0);
                    invoice.delivery_charges = (+invoice.new_delivery_charges || 0.0);
                    invoice.setup_charges = (+invoice.new_setup_charges || 0.0);
                    invoice.sales_tax = this.getSalesTax();
                    //invoice.tax_perc = this.getSalesTaxPerc();
                    invoice.subtotal = this.getSubTotal();
                    invoice.taxable_subtotal = this.adjust_to_taxable_amount(this.getSubTotal());
                    invoice.total = this.getSubTotal() + this.getSalesTax();

                    //val # 1: confirm that user details are not empty
                    let customer_error = this.validate_customer_info(invoice.customer);
                    if (customer_error.length > 0){
                        this.$vex.dialog.alert({message: customer_error[0]})
                        return
                    }

                    //val # 2: confirm that products are not empty + product quanties are valid
                    let previous_items= invoice.items.filter(function(d){return d.existing==true});
                    //let itemids = previous_items.map(function(d){return d.itemid});
                    //invoice.max_itemid = Math.max(...itemids);

                    //invoice.items = invoice.items.filter(function(d){return d.existing == false});

                    let products_error = this.validate_products(invoice.items.filter(function(d){return d.existing == false}));
                    if (products_error.length > 0){
                        this.$vex.dialog.alert({message: products_error[0]})
                        return
                    }

                    //val # 3: confirm that the amounts specified in payment methods do add up the grand total.
                    let payments_error = this.validate_payment_methods(invoice.new_payment_methods);
                    if (payments_error.length > 0){
                        this.$vex.dialog.alert({message: payments_error[0]})
                        return
                    }
                    invoice.new_payment_methods = invoice.new_payment_methods.map(function(d){
                        d.amount = (+d.amount || 0.0); return d;
                    });

                    if ((this.packet.housetrucks || []).length > 0){
                        invoice.housetruck = this.packet.housetrucks[0].value;
                    }
                    else {
                        invoice.housetruck = null;
                    }

                    // invoice.items = invoice.items.map(function(d){
                    //     d.delivery_date = moment(d.delivery_date).format("MM-DD-YYYY");
                    //     return d;
                    // });

                    let that = this;
                    let path = "/api/sales/update_sale/"

                    let data = invoice;
                    data.username = this.userDetails.username;
                    // let loc = this.packet.locations.filter(function(d){
                    //     return d.value == data.location_id
                    // });
                    // if (loc.length > 0){
                    //     data.short_name = loc[0].short_name;
                    // }

                    data.invoice_type = "INV";
                    data.default_locsubs = this.default_locsubs;

                    let s = function(response){
                        if (response.data.error){
                            that.$vex.dialog.alert({
                                message: response.data.error
                            });
                        }
                        else {

                            window.location.reload();

                            // //this means its a new sale
                            // if (that.invoice.invoice_id){
                            //     let invoice_id = response.data.result.invoice_id;
                            //     if (invoice_id){
                            //         that.$router.push({path: "/sales/viewsale/"+invoice_id+"/"});

                            //     }
                            // }
                            // else {
                            //     that.$bvToast.toast(
                            //         "UPDATED INVOICE",
                            //         {title: "Success", autoHideDelay: 1500, variant:"success"}
                            //     );
                            // }

                        }
                        that.block_post_invoice=false;
                        that.loading=false;
                    }

                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "An error occurred while registering sale. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.block_post_invoice=false;
                        that.loading=false;
                    }
                    this.block_post_invoice = true;
                    this.loading = true;
                    //console.log(data);
                    Requestor.postSyncP(path, data, this, s, f);
                },
submitInvoice: async function(e) {
    if (e) e.preventDefault();

    // 1. START: Show the first loader animation
    this.$refs.loaderAnimation.show("Creating Receipt...");
    
    // Simulate a short delay for the receipt creation (replace with actual API call if needed)
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // 2. UPDATE: Show the second loader animation
    this.$refs.loaderAnimation.show("Sending Email to Customer...");
    
    // Simulate a short delay for the email sending (replace with actual API call if needed)
    await new Promise(resolve => setTimeout(resolve, 1500));

    // Your existing submit logic starts here. We'll keep the loader visible.
    // The loader will remain on screen while the main API call is being made.
    if (this.invoice.selected_locsub) {
        const [locationId, sublocationId] = this.invoice.selected_locsub.split('|');
        this.invoice.location_id = parseInt(locationId);
        this.invoice.sublocation_id = parseInt(sublocationId);
    }

    if (!this.policyAgreed) {
        this.$refs.loaderAnimation.hide(); // Hide loader on error
        this.$vex.dialog.alert({ message: "You must agree to the Terms & Conditions before submitting." });
        return;
    }

    this.processSignaturesBeforeSubmit();
    
    // Process items to ensure source is set
    let processedItems = this.invoice.items.map(item => {
        const sourceValue = item.source || item.sourceContext || 'unknown';
        return {
            ...item,
            source: sourceValue,
            as_is_image_url: item.as_is_image_url || null,
            image_url: item.image_url || null,
            is_as_is: item.is_as_is || false,
            damage_info: item.damage_info || null
        };
    });
    
    let invoice = JSON.parse(JSON.stringify(this.invoice));
    invoice.items = processedItems;
    invoice.policyAgreed = this.policyAgreed;
    invoice.warrantyRefused = this.warrantyRefused;
    invoice.delivery_waiver_agreed = this.deliveryWaiverAgreed;
    invoice.space_preparation_agreed = this.spacePreparationAgreed;
    invoice.delivery_damage_waiver_agreed = this.deliveryDamageWaiverAgreed;
    invoice.address_confirmation_agreed = this.invoice.address_confirmation_agreed;
    invoice.warranty_charges = (+invoice.warranty_charges || 0.0);
    invoice.delivery_charges = (+invoice.delivery_charges || 0.0);
    invoice.setup_charges = (+invoice.setup_charges || 0.0);
    invoice.sales_tax = this.getSalesTax();
    invoice.tax_perc = this.getSalesTaxPerc();
    invoice.subtotal = this.getSubTotal();
    invoice.taxable_subtotal = this.adjust_to_taxable_amount(this.getSubTotal());
    invoice.total = this.getSubTotal() + this.getSalesTax();
    invoice.customer_id_card_url = this.invoice.customer_id_card_url;
    invoice.customer_id_card_type = this.invoice.customer_id_card_type;
    invoice.customer_id_card_number = this.invoice.customer_id_card_number;
    invoice.customer_id_card_uploaded_at = this.invoice.customer_id_card_uploaded_at;

    if (this.invoice.draft_id) {
        invoice.draft_id = this.invoice.draft_id;
    }
    
    invoice.has_signature = this.invoice.has_signature;
    invoice.signature_url = this.invoice.signature_url;
    invoice.signature_uploaded_at = this.invoice.signature_uploaded_at;
    
    if (this.invoice.signature_temp_data) {
        invoice.signature_temp_data = this.invoice.signature_temp_data;
    }
    
    const draftIdFromRoute = this.$route.query.draft_id;
    if (draftIdFromRoute && !invoice.draft_id) {
        invoice.draft_id = draftIdFromRoute;
    }

    // Validation checks - stop if any fail
    let customer_error = this.validate_customer_info(invoice.customer);
    if (customer_error.length > 0){
        this.$refs.loaderAnimation.hide();
        this.$vex.dialog.alert({message: customer_error[0]})
        return
    }

    let products_error = this.validate_products(invoice.items);
    if (products_error.length > 0){
        this.$refs.loaderAnimation.hide();
        this.$vex.dialog.alert({message: products_error[0]})
        return
    }

    let payments_error = this.validate_payment_methods(invoice.payment_methods);
    if (payments_error.length > 0){
        this.$refs.loaderAnimation.hide();
        this.$vex.dialog.alert({message: payments_error[0]})
        return
    }
    
    invoice.payment_methods = invoice.payment_methods.map(function(d){
        d.amount = (+d.amount || 0.0); 
        return d;
    });

    if ((this.packet.housetrucks || []).length > 0){
        invoice.housetruck = this.packet.housetrucks[0].value;
    } else {
        invoice.housetruck = null;
    }

    let that = this;
    let path = "/api/sales/record_sale/"
    let data = invoice;
    
    const isFromDraft = this.invoice.draft_id || draftIdFromRoute;
    
    if (isFromDraft && this.invoice.username) {
        data.username = this.invoice.username;
    } else {
        data.username = this.userDetails.username;
    }
    
    data.invoice_type = "INV";
    data.default_locsubs = this.default_locsubs;

    let s = function(response) {
        if (response.data.error) {
            that.$refs.loaderAnimation.hide(); // Hide loader on error
            that.$vex.dialog.alert({ message: response.data.error });
        } else {
            let invoice_id = response.data.result.invoice_id;
            
            // Hide the loader animation before showing success
            that.$refs.loaderAnimation.hide();

            // 🎉 SHOW SUCCESS ANIMATION
            that.successMessage = isFromDraft ? 
                'Sale Processed Successfully!' : 
                'Sale Created Successfully! 🎉';
            
            if (that.$refs.successAnimation) {
                that.$refs.successAnimation.show();
            }

            if (isFromDraft) {
                that.$bvToast.toast(
                    `Sale recorded successfully! Processed by ${that.userDetails.username} on behalf of ${that.invoice.username}`,
                    {title: "Success", autoHideDelay: 4000, variant:"success"}
                );
            } else {
                that.$bvToast.toast(
                    "Sale recorded successfully! 🎉",
                    {title: "Success", autoHideDelay: 2000, variant:"success"}
                );
            }
            
            that.printReceiptAndOpenDrawer();
            
            if (invoice_id) {
                // ✅ FIXED: Use $router.push instead of window.location.href
                setTimeout(() => {
                    that.$router.push({ 
                        path: "/sales/viewsale/" + invoice_id + "/" 
                    });
                }, 2500);
            }
        }
        that.block_post_invoice = false;
        that.loading = false;
    }

    let f = function(error) {
        console.log(error);
        that.$refs.loaderAnimation.hide(); // Hide loader on error
        that.$bvToast.toast(
            "An error occurred while registering sale. Please try again.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.block_post_invoice = false;
        that.loading = false;
    }
    
    this.block_post_invoice = true;
    Requestor.postSyncP(path, data, this, s, f);
},
printReceiptAndOpenDrawer() {
    // First try to open the cash drawer
    
    // Then print the receipt after a short delay
    setTimeout(() => {
        this.printReceipt();
    }, 500);
},

// Open cash drawer using ESC/POS command
openCashDrawer() {
    // Create a hidden iframe specifically for the drawer command
    const drawerFrame = document.createElement('iframe');
    drawerFrame.style.position = 'absolute';
    drawerFrame.style.width = '0';
    drawerFrame.style.height = '0';
    drawerFrame.style.border = 'none';
    document.body.appendChild(drawerFrame);
    
    const drawerDoc = drawerFrame.contentWindow.document;
    drawerDoc.open();
    
    // ESC/POS command to open cash drawer (standard for Epson and compatible printers)
    // ESC p 0 25 250 - Opens drawer connected to port 0
    const openDrawerCommand = String.fromCharCode(27) + 'p' + String.fromCharCode(0) + String.fromCharCode(25) + String.fromCharCode(250);
    
    drawerDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Cash Drawer</title>
            <style>
                @page {
                    size: 80mm auto;
                    margin: 0;
                }
                @media print {
                    body {
                        width: 72mm;
                        margin: 0 auto;
                        font-family: 'Courier New', monospace;
                        visibility: hidden;
                    }
                    .drawer-command {
                        visibility: visible;
                        font-size: 0;
                        height: 0;
                    }
                }
            </style>
        </head>
        <body>
            <div class="drawer-command" style="font-size: 0; height: 0;">${openDrawerCommand}</div>
            <div style="text-align: center; margin-top: 10px; font-size: 12px; visibility: visible;">
                🔔 Opening cash drawer...
            </div>
        </body>
        </html>
    `);
    drawerDoc.close();
    
    // Print the drawer command
    drawerFrame.contentWindow.print();
    
    // Remove the drawer frame after printing
    setTimeout(() => {
        document.body.removeChild(drawerFrame);
    }, 1000);
    
    console.log("Cash drawer command sent");
},

// Update your existing printReceipt method to ensure it's optimized
printReceipt() {
    // Create a hidden iframe for printing
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    // Get the receipt HTML content
    const receiptContent = this.generateReceiptHTML();
    
    // Write to iframe and print
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(receiptContent);
    frameDoc.close();

    // Wait for content to load then print
    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            // Remove iframe after printing
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
},

// Alternative method that combines drawer and receipt in one print job
printReceiptWithDrawerCommand() {
    // Create a hidden iframe for printing
    const printFrame = document.createElement('iframe');
    printFrame.style.position = 'absolute';
    printFrame.style.width = '0';
    printFrame.style.height = '0';
    printFrame.style.border = 'none';
    document.body.appendChild(printFrame);

    // Get the receipt HTML content
    const receiptContent = this.generateReceiptHTML();
    
    // ESC/POS command to open cash drawer
    const openDrawerCommand = String.fromCharCode(27) + 'p' + String.fromCharCode(0) + String.fromCharCode(25) + String.fromCharCode(250);
    
    // Write to iframe with both drawer command and receipt
    const frameDoc = printFrame.contentWindow.document;
    frameDoc.open();
    frameDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <title>Receipt with Drawer</title>
            <style>
                @page {
                    size: 80mm auto;
                    margin: 0;
                }
                @media print {
                    body {
                        width: 72mm;
                        margin: 0 auto;
                        font-family: 'Courier New', monospace;
                    }
                    .drawer-command {
                        display: none;
                    }
                }
            </style>
        </head>
        <body>
            <!-- Hidden drawer command -->
            <div class="drawer-command" style="display: none;">${openDrawerCommand}</div>
            ${receiptContent}
        </body>
        </html>
    `);
    frameDoc.close();

    // Wait for content to load then print
    printFrame.onload = () => {
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            
            // Remove iframe after printing
            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 1000);
        }, 500);
    };
},
// Test the complete flow
testCompleteFlow() {
    this.$bvToast.toast(
        "Testing printer and cash drawer...",
        {title: "Test", autoHideDelay: 2000, variant: "info"}
    );
    
    // Test cash drawer
    this.openCashDrawer();
    
    // Test receipt printing
    setTimeout(() => {
        this.printReceipt();
    }, 1000);
    
    // Log test results
    console.log("=== COMPLETE FLOW TEST ===");
    console.log("1. Cash drawer command sent");
    console.log("2. Receipt print initiated");
    console.log("3. Test complete - check printer and drawer");
},
                getSubTotal: function(){
                    let order_total = this.getOrderTotal();
                    let total_charges = this.getChargesTotal();
                    let subtotal = (order_total || 0.0) + (total_charges || 0.0);
                    return subtotal;
                },
      getItemTotal: function(idx) {
    let item = this.invoice.items[idx];

    // Use the display price (which could be discounted)
    let sp = this.hasActiveDiscount(item) ?
        parseFloat(item.special_discount_price) :
        (+item.new_selling_price || 0.0);

    let qty = (+item.quantity || 1.0);
    let dsc = (+item.discount_offered || 0.0);

    // Ensure discount doesn't make total negative
    const subtotal = (sp * qty);
    const finalTotal = Math.max(0, subtotal - dsc);

    return finalTotal.toFixed(2);
},
getTotalSpecialDiscounts: function() {
    let total = 0.0;
    let items = this.invoice.items;

    if (this.invoice.edit == true && this.refund_items.length <= 0) {
        items = items.filter(function(d){ return d.existing == false });
    }

    for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (this.hasActiveDiscount(item)) {
            const regularPrice = parseFloat(item.selling_price) || 0;
            const discountPrice = parseFloat(item.special_discount_price) || 0;
            const quantity = (+item.quantity || 1.0);

            if (discountPrice < regularPrice) {
                total += (regularPrice - discountPrice) * quantity;
            }
        }
    }

    return total;
},
                getOrderTotal: function(){
                    var k = 0.0;
                    let items = this.invoice.items;
                    if (this.invoice.edit == true && this.refund_items.length <=0){
                        items=items.filter(function(d){return d.existing == false});
                    }
                    for (var i =0; i<items.length; i++){
                        let sp = (parseFloat(items[i].new_selling_price) || 0.0);
                        let qty = (+items[i].quantity || 1.0);
                        let dsc = (parseFloat(items[i].discount_offered) || 0.0);

                        //console.log(sp, qty, dsc, '3444')

                        k += ( (sp*qty) - dsc ) * 1.0;
                    }
                    //console.log(k, "2333939")
                    return k;
                },
                getChargesTotal: function(){
                    let delivery_charges = this.invoice.delivery_charges;
                    let setup_charges = this.invoice.setup_charges;
                    let warranty_charges = this.invoice.warranty_charges;

                    if (this.invoice.edit == true && this.refund_items.length <= 0){
                        delivery_charges = this.invoice.new_delivery_charges;
                        setup_charges = this.invoice.new_setup_charges;
                        warranty_charges = this.invoice.new_warranty_charges;
                    }

                    let dlv = (+delivery_charges || 0.0);
                    let stp = (+setup_charges || 0.0);
                    let wtp = (+warranty_charges || 0.0);
                    return (dlv + stp + wtp);
                },
                getSalesTaxPerc: function(){
                    // let location_id = this.invoice.location_id;
                    // let loc = this.packet.locations.filter(function(d){return d.value == location_id});
                    // let perc = 0.10;

                    // //console.log(loc)
                    // if (loc.length > 0){
                    //     perc = parseFloat(loc[0].sales_tax) / 100.0;
                    //     if (!perc){
                    //         perc = 0.10;
                    //     }
                    // }

                    let perc = parseFloat((this.invoice.tax_perc / 100.0).toFixed(2));
                    return perc;
                },
adjust_to_taxable_amount: function(subtotal) {
    // Start with the full subtotal
    let taxable_subtotal = subtotal;
    
    // Track which payment methods are non-taxable
    let nonTaxableAmounts = [];
    let totalNonTaxable = 0;
    
    // Get payment methods to check
    let paymentMethods = [];
    
    // For EDIT mode - check payment_history and new_payment_methods
    if (this.invoice.edit === true) {
        // Check original payment history (already processed payments)
        let originalPayments = this.payment_history || [];
        
        // Check for finance payments that charge tax themselves in history
        originalPayments.forEach(pm => {
            if (pm.value === "finance") {
                const financeCompany = this.finance_companies.find(fc => fc.value === pm.name);
                let companyChargesTax = false;
                if (financeCompany && financeCompany.company_charges_tax_in_states) {
                    companyChargesTax = financeCompany.company_charges_tax_in_states.includes(this.invoice.sold_from_state);
                }
                if (companyChargesTax) {
                    nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
                }
            }
            // Also check tax_exempt payments in history
            if (pm.value === "tax_exempt") {
                nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
            }
            // Store credit in history
            if (pm.value === "store_credit") {
                nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
            }
        });
        
        // Check new payment methods being added in edit mode
        if (this.invoice.new_payment_methods && this.invoice.new_payment_methods.length > 0) {
            this.invoice.new_payment_methods.forEach(pm => {
                if (pm.value === "finance") {
                    const financeCompany = this.finance_companies.find(fc => fc.value === pm.name);
                    let companyChargesTax = false;
                    if (financeCompany && financeCompany.company_charges_tax_in_states) {
                        companyChargesTax = financeCompany.company_charges_tax_in_states.includes(this.invoice.sold_from_state);
                    }
                    if (companyChargesTax) {
                        nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
                    }
                }
                if (pm.value === "tax_exempt") {
                    nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
                }
                if (pm.value === "store_credit") {
                    nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
                }
            });
        }
    } else {
        // For NEW invoice mode - check current payment_methods
        let payment_methods = this.invoice.payment_methods || [];
        
        payment_methods.forEach(pm => {
            if (pm.value === "finance") {
                const financeCompany = this.finance_companies.find(fc => fc.value === pm.name);
                let companyChargesTax = false;
                if (financeCompany && financeCompany.company_charges_tax_in_states) {
                    companyChargesTax = financeCompany.company_charges_tax_in_states.includes(this.invoice.sold_from_state);
                }
                if (companyChargesTax) {
                    nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
                }
            }
            if (pm.value === "tax_exempt") {
                nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
            }
            if (pm.value === "store_credit") {
                nonTaxableAmounts.push(parseFloat(pm.amount) || 0);
            }
        });
    }
    
    // Calculate total non-taxable amount
    totalNonTaxable = nonTaxableAmounts.reduce((a, b) => a + b, 0);
    
    // Subtract non-taxable amounts from taxable subtotal
    taxable_subtotal = Math.max(0, taxable_subtotal - totalNonTaxable);
    
    // Ensure no negative values
    taxable_subtotal = Math.max(0.0, taxable_subtotal);
    
    console.log(`Taxable subtotal: Original: ${subtotal}, Non-taxable: ${totalNonTaxable}, Final: ${taxable_subtotal}`);
    return taxable_subtotal;
},
                getSalesTax: function(){

                    if (this.invoice.is_layaway){
                        return 0.0;
                    }

                    let subtotal = this.getSubTotal();

                    //adjust this subtotal based on combination of state and combination of specific leasing company (if involved).
                    subtotal = this.adjust_to_taxable_amount(subtotal);
                    let perc = this.getSalesTaxPerc();
                    //(parseFloat(this.invoice.tax_perc) || this.getSalesTaxPerc());
                    let total_tax =  (subtotal) * perc;
                    return total_tax;
                },
                getTotalDiscount: function(){
                    var k = 0.0;

                    let items = this.invoice.items;
                    if (this.invoice.edit == true && this.refund_items.length <=0){
                        items = items.filter(function(d){return d.existing == false});
                    }
                    for (var i =0; i<items.length; i++){
                        let dsc = (+items[i].discount_offered || 0.0);
                        k += dsc;
                    }
                    return k;
                },
    getGrandTotal: function() {
    let subtotal = this.getSubTotal();
    let sales_tax = this.getSalesTax();
    let storeCreditApplied = this.getStoreCreditApplied();

    let grandTotal = (subtotal + sales_tax) - storeCreditApplied;
    
    // FIX: Round to 2 decimal places
    return Math.round(grandTotal * 100) / 100;
},
                // getTotalBalance: function(){
                //     let grand_total = this.getGrandTotal();

                //     let payment_methods = this.invoice.payment_methods;
                //     if (this.invoice.edit && this.refund_items.length <=0){
                //         payment_methods = this.invoice.new_payment_methods;
                //     }
                //     let total_payments_applied = payment_methods.map(function(d){return (parseFloat(d.amount) || 0.0) }).reduce(   function(a, b){
                //                 return a + b;
                //         }, 0);
                //     //console.log(grand_total, payment_methods, total_payments_applied);
                //     return grand_total - total_payments_applied
                // },
                addPaymentMethod: function(e){
                    if (e){
                        e.preventDefault();
                    }
                    let idx = this.invoice.payment_methods.length;
                    if (this.invoice.edit == true){
                        idx = this.invoice.new_payment_methods.length;
                    }


                    let new_payment_method = {
                        idx: idx,
                        value: null,
                        amount: null,
                        approved_amount: null,
                        properties: {},
                        name: null, //this is null for others but works out for finance company name (or in future cc type name like visa, etc.)
                        available_amount: 0.0,
                        store_credit_invoice_id: null,
                        charged_tax_itself: null,
                        ein: null, // EIN number for tax exempt
            certificate: null, // Certificate number for tax exempt
            lease_id: null, // Lease ID for finance (keep this for finance)
            misc_info: null, // Misc info for both
        tax_exempt_password: null,
        passwordValid: null,
        showPassword: false,
        }
                    if (this.invoice.edit == true){
                        this.invoice.new_payment_methods.push(new_payment_method);
                    }
                    else {
                        this.invoice.payment_methods.push(new_payment_method);
                    }
                },
         removeItem: function(idx){
    if (this.invoice.edit){
        let item = this.invoice.items[idx];
        if (item.existing == true){
            // Initialize return_quantity if not set
            if (!item.return_quantity) {
                item.return_quantity = item.quantity - item.refunded_so_far_quantity;
            }
            this.current_refund_validated = false;

            // Check if item is already in refund_items using itemid
            if(!this.refund_items.some(refundItem => refundItem.itemid === item.itemid)){
                // Create a deep copy including all properties
                const itemToRefund = JSON.parse(JSON.stringify(item));
                this.refund_items.push(itemToRefund);
            }
        }
        else {
            this.invoice.items.splice(idx, 1);
        }
    }
    else {
        this.invoice.items.splice(idx, 1);
    }
},
                removePaymentMethod: function(pmidx){
                    if (this.invoice.edit == true){
                        this.invoice.new_payment_methods.splice(pmidx, 1);
                    }
                    else {
                        this.invoice.payment_methods.splice(pmidx, 1);
                    }
                },
                validate_customer_info: function(customer_information){
                    let errors = [];
                    if (!customer_information.fullname){
                        errors.push("Please enter customer name.")
                    }
                    if (!customer_information.email){
                        errors.push("Please enter customer email.")
                    }
                    if (!customer_information.phone){
                        errors.push("Please enter customer phone.")
                    }
                    if (!customer_information.zipcode){
                        errors.push("Please enter customer zipcode.")
                    }

                    return errors;
                },
 validate_products: function(products) {
    let errors = []
    // if (products.length <= 0) {
    //     errors.push("No products added to the sale.");
    // }
    if (products.map(function(d){return (d.quantity || 0)}).indexOf(0) >= 0 ) {
        errors.push("Product quantity should be > 0.");
    }

    // FIXED: Only validate price if there's no active special discount
    const priceViolations = products.filter(item => {
        // Skip validation for items with active special discounts
        if (this.hasActiveDiscount(item)) {
            return false;
        }
        return (parseFloat(item.new_selling_price) < parseFloat(item.selling_price));
    });

    // if (priceViolations.length > 0) {
    //     errors.push("New sale price for product should not be less than the original price.");
    // }

    // Enhanced discount validation
    const discountConflicts = products.filter(item =>
        this.hasActiveDiscount(item) && parseFloat(item.discount_offered) > 0
    );

    if (discountConflicts.length > 0) {
        const conflictSkus = discountConflicts.map(item => item.product_sku).join(', ');
        errors.push(`Cannot apply manual discounts to specially discounted items: ${conflictSkus}`);
    }

    // Validate discount amounts for non-specially discounted items - UPDATED FOR PRICE × QUANTITY
    const invalidDiscounts = products.filter(item => {
        // Skip validation for specially discounted items
        if (this.hasActiveDiscount(item)) return false;

        if (!item.discount_offered || parseFloat(item.discount_offered) === 0) return false;

        const price = parseFloat(item.new_selling_price || item.selling_price);
        const quantity = parseInt(item.quantity) || 1;
        const discount = parseFloat(item.discount_offered);
        const maxAllowed = (price * quantity) * 0.10; // CHANGED: price × quantity × 0.10

        return discount > maxAllowed;
    });

    if (invalidDiscounts.length > 0) {
        const invalidSkus = invalidDiscounts.map(item => {
            const price = parseFloat(item.new_selling_price || item.selling_price);
            const quantity = parseInt(item.quantity) || 1;
            const maxAllowed = (price * quantity) * 0.10;
            return `${item.product_sku} (max: $${maxAllowed.toFixed(2)})`;
        }).join(', ');
        errors.push(`Discount amounts exceed 10% limit for: ${invalidSkus}`);
    }

    for (var i=0; i<products.length; i++) {
        let order_type = products[i].order_type;
        let delivery_date = products[i].delivery_date;
        let locsub = products[i].locsub;
        let drop_locsub = products[i].drop_locsub;
        let discount_offered = parseFloat(products[i].discount_offered);
        let quantity = parseInt(products[i].quantity);
        let product_sku = products[i].product_sku;
        let is_special = products[i].is_special;
        const only = this.search_in_my_location;
        let sourceContext = products[i].sourceContext;

        if (!order_type){
            errors.push("Please indicate order type for all items.");
        }

        // Validation only if source is STORE
        if (
        only &&
        ['customer_takes','store_pickup','home_delivery'].includes(order_type) &&
        sourceContext === 'store'
        ) {
            if (!locsub) {
                errors.push(
                    `Please select a 'Fulfill From' location for ${
                        order_type==='customer_takes'? 'Take Home'
                    : order_type==='store_pickup'  ? 'Store Pickup'
                    :                           'Home Delivery'
                    } items when 'Only In My Location' is checked and source is Store.`
                )
            }
        }

        // Prevent customer_takes when source is warehouse
        if (sourceContext === 'warehouse' && order_type === 'customer_takes') {
            errors.push("Take Home option is not allowed when source is Warehouse.");
        }

        if (order_type === 'store_pickup' && !drop_locsub) {
            errors.push(
                "Please select a 'Customer Pickup From' location for all Store Pickup items."
            )
        }

        if (!delivery_date){
            errors.push("Please indicate pickup or delivery date for for all items.");
        }

        if (product_sku.split(" ").length > 1){
            errors.push("Product sku cannot have spaces in it.");
        }
          if (this.hasStorePickupItem && !this.deliveryDamageWaiverAgreed) {
    errors.push("You must agree to the store pickup damage waiver for items with Store Pickup order type.");
  }
    }

    // Additional pass for Only In My Location rule
    const onlyInMyLocation = this.search_in_my_location;
    if (onlyInMyLocation) {
        for (var i = 0; i < products.length; i++) {
            const order_type = products[i].order_type;
            const locsub = products[i].locsub;
            const sourceContext = products[i].sourceContext;

            if (order_type === 'customer_takes' && !locsub && sourceContext === 'store') {
                errors.push("Please select a 'Fulfill From' location for all 'Take Home' items when 'Only In My Location' is checked and source is Store.");
            }
        }
    }

    return errors
},
      checkTaxExemptPasswordRequirement(paymentMethod) {
        if (paymentMethod.name) {
            // Reset password validation state when company changes
            paymentMethod.tax_exempt_password = null;
            paymentMethod.passwordValid = null;
            paymentMethod.showPassword = false;
        }
    },

    // Validate tax exempt password with backend
    validateTaxExemptPassword(paymentMethod) {
        if (!paymentMethod.name || !paymentMethod.tax_exempt_password) {
            paymentMethod.passwordValid = false;
            return;
        }

        let path = "/api/finance_company/validate_tax_exempt_password/";
        let data = {
            company_name: paymentMethod.name,
            password: paymentMethod.tax_exempt_password
        };

        let that = this;

        let s = function(response) {
            if (response.data.error) {
                paymentMethod.passwordValid = false;
                that.$bvToast.toast(
                    response.data.error,
                    {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                );
            } else {
                paymentMethod.passwordValid = response.data.result.valid;
                if (response.data.result.valid) {
                    that.$bvToast.toast(
                        "Password validated successfully",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    // Disable the password field after successful validation
                    paymentMethod.showPassword = false;
                } else {
                    that.$bvToast.toast(
                        "Invalid password for this tax exempt company",
                        {title: "Validation Failed", autoHideDelay: 3000, variant:"warning"}
                    );
                }
            }
        };

        let f = function(error) {
            console.error("Error validating tax exempt password:", error);
            paymentMethod.passwordValid = false;
            that.$bvToast.toast(
                "Error validating password",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
        };

        Requestor.postSyncP(path, data, this, s, f);
    },

    validate_payment_methods: function(payment_methods){
    let errors = [];
    var s = 0;
    var gt = parseFloat(this.getGrandTotal().toFixed(2));
    
    // CRITICAL FIX: For edit mode, use new_payment_methods instead of the passed payment_methods
    let methodsToValidate = payment_methods;
    if (this.invoice.edit && this.refund_items.length <= 0) {
        methodsToValidate = this.invoice.new_payment_methods || [];
    }

    for (var i=0; i<methodsToValidate.length; i++){
        // Skip validation for empty payment methods
        if (!methodsToValidate[i].value || methodsToValidate[i].amount === null || methodsToValidate[i].amount === undefined || isNaN(parseFloat(methodsToValidate[i].amount))) {
            continue; // Skip invalid payment methods instead of erroring
        }
        
        const amount = parseFloat(methodsToValidate[i].amount);
        if (amount < 0) {
            errors.push("Payment amount cannot be negative.")
            continue;
        }

        s += amount;

        if (methodsToValidate[i].value == "cash"){
            methodsToValidate[i].name = "N/A"
        }

        if (methodsToValidate[i].value == "cc"){
            if (!(methodsToValidate[i].name)){
                errors.push("All credit card payments should include their last 4 digits for identity.")
            }

            if (!(parseInt(methodsToValidate[i].name))){
                errors.push("All credit card payments should include their valid last 4 digits.")
            }

            if ((methodsToValidate[i].name || "").replaceAll(/\s/g, "").length < 4){
                errors.push("All credit card payments should include their valid last 4 digits without spaces.")
            }
            if (methodsToValidate[i].approved_amount && parseFloat(methodsToValidate[i].approved_amount) < 0) {
                errors.push("Approved amount cannot be negative.")
            }
        }

        if (methodsToValidate[i].value == "finance"){
            if (!(methodsToValidate[i].lease_id)){
                errors.push("All finance related sales should include their lease/finance id.")
            }
            if (!(methodsToValidate[i].name)){
                errors.push("All finance related sales should include their lease/finance company name.")
            }
        }

        if (methodsToValidate[i].value == "tax_exempt"){
            if (!methodsToValidate[i].name){
                errors.push("All tax exempt payments should include the company name.")
            }

            if (methodsToValidate[i].name) {
                if (!methodsToValidate[i].tax_exempt_password) {
                    errors.push(`Password is required for tax exempt company: ${methodsToValidate[i].name}`);
                } else if (methodsToValidate[i].passwordValid === false) {
                    errors.push(`Invalid password for tax exempt company: ${methodsToValidate[i].name}`);
                } else if (methodsToValidate[i].passwordValid === null) {
                    errors.push(`Please validate the password for tax exempt company: ${methodsToValidate[i].name}`);
                }
            }
        }

        if (methodsToValidate[i].value == "store_credit"){
            if (methodsToValidate[i].amount > methodsToValidate[i].available_amount) {
                errors.push("All the store credit amounts should be less or equal to available credit amount.")
            }

            if (isNaN(parseFloat(methodsToValidate[i].available_amount)) || parseFloat(methodsToValidate[i].available_amount) == 0.0){
                errors.push("No store credit can be applied with given information.")
            }
        }
    }

    if (this.invoice.is_layaway == false){
        s = parseFloat(s.toFixed(2));
        gt = parseFloat(gt.toFixed(2));
        
        // Add tolerance for floating point precision
        const difference = Math.abs(s - gt);
        const tolerance = 0.01;
        
        if (difference > tolerance) {
            errors.push(`Total payment amount ($${s.toFixed(2)}) should match the grand total ($${gt.toFixed(2)}). Difference: $${difference.toFixed(2)}`);
        }
    }
    return errors
},
                dateDisabled: function(ymd, date){
                    return date <= moment()
                },
                setup_inventory_count: function(){
                    let that = this
                    let dictionary = this.all_loc_inventory_dict;
                    if (this.all_loc_inventory_dict){
                        Object.keys(dictionary).forEach(function(key) {
                            let pidsku = key.split("|").slice(0, 2).join("|")
                            if (pidsku in that.inventory_counts){
                                that.inventory_counts[pidsku] += dictionary[key];
                            }
                            else {
                                that.inventory_counts[pidsku] = dictionary[key];
                            }

                        });
                    }
                },
                fetch_prereqs: function(){
                    let that = this;
                    let prereqs = [
                        {
                            path:  "/api/sales/get_default_locsubs/",
                            data: {},
                            type: "",
                            executable: Requestor.getAsync,
                            s: function(response) {
                                console.log(response )
                                if (response.data.result){

                                    console.log(response.data.result)
                                    that.default_locsubs = response.data.result;
                                }
                                else {

                                    that.$bvToast.toast(
                                        response.data.error,
                                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                    );
                                }
                            },
                            f: function(error) {
                                console.log(error, 'B')
                                that.$bvToast.toast(
                                    "Error loading default location.",
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        {
                            path:  "/api/inventory/get_all_loc_inventory_dict/",
                            data: {},
                            type: "",
                            executable: Requestor.getAsync,
                            s: function(response) {
                                if (response.data.result){
                                    that.all_loc_inventory_dict = response.data.result;
                                    that.setup_inventory_count();

                                }
                                else {
                                    that.$bvToast.toast(
                                        response.data.error,
                                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                    );
                                }
                            },
                            f: function(error) {
                                console.log(error, 'A')
                                that.$bvToast.toast(
                                    "Error loading inventory.",
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                       {
    path: "/api/finance_company/get_all_finance_companies/",
    data: {},
    type: "secure",
    executable: Requestor.getAsyncP,
    s: function(response) {
        if (response.data.result){
            // Filter to ONLY active companies first
            const activeCompanies = response.data.result.filter(company => company.is_active === true);
            
            that.finance_companies = activeCompanies.map(function(d){
                return {
                    "value": d.finance_company_name,
                    "text": d.finance_company_name,
                    "phone_number": d.finance_company_phone_number,
                    "company_charges_tax_in_states": d.finance_company_charges_tax_in_states,
                    "company_type": d.company_type,
                    "is_active": d.is_active,  // Include this for reference if needed
                }
            });

            // Filter for FINANCE ONLY companies (and ensure they're active)
            that.finance_only_companies = that.finance_companies.filter(d =>
                (d.company_type === 'finance' || !d.company_type) && d.is_active === true
            );

            // Filter for TAX EXEMPT companies (and ensure they're active)
            that.tax_exempt_companies = that.finance_companies.filter(d =>
                d.company_type === 'tax_exempt' && d.is_active === true
            );

            console.log("Loaded active finance companies:", that.finance_companies.length);
            console.log("Active finance only companies:", that.finance_only_companies.length);
            console.log("Active tax exempt companies:", that.tax_exempt_companies.length);
        }
        else {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        }
    },
    f: function(error) {
        console.log(error, 'C')
        that.$bvToast.toast(
            "Error loading finance companies.",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
        );
    }
},
                        {
                            path:  "/api/sales/get_all_zipcodes",
                            data: {},
                            type: "",
                            executable: Requestor.getAsync,
                            s: function(response) {
                                if (response.data.result){
                                    that.zipcodes = response.data.result;

                                }
                                else {
                                    that.$bvToast.toast(
                                        response.data.error,
                                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                    );
                                }
                            },
                            f: function(error) {
                                console.log(error, 'C')
                                that.$bvToast.toast(
                                    "Error loading zipcodes.",
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                    ];


                    for (var i=0; i<prereqs.length; i++){
                        let path = prereqs[i]["path"];
                        let data = prereqs[i]["data"];
                        let s = prereqs[i]["s"];
                        let f = prereqs[i]["f"];
                        let type = prereqs[i]["type"];
                        if (type == "secure"){
                            prereqs[i]["executable"](path, data, this, s, f);
                        }
                        else {
                            prereqs[i]["executable"](path, data, s, f);
                        }
                    }


                },
                get_scheduled_deliveries: function(){
                    let path = "/api/sales/get_deliveries_by_dates/"
                    let data = {};
                    let that = this
                    let s = function(response){
                        if (response.data.result){
                            that.scheduled_deliveries = response.data.result;
                            that.$bvModal.show("modal-deliveries");
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }

                    }
                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading scheduled deliveries.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    Requestor.getAsync(path, data, s, f);
                },
                sortby: function(key){
                    if (this.sort_asc){
                        this.searchitems.result = Requestor.sort(this.searchitems.result, key)
                    }
                    else {
                        this.searchitems.result = Requestor.sort_reverse(this.searchitems.result, key)
                    }
                    this.sort_asc = !this.sort_asc;
                },
                sum: function(items){
                    return items.reduce((pv, cv) => pv + cv, 0.0) * 1.0;
                },
                validate_refund_products: function(refund_items){
                    let errors = [];
                    if (refund_items.length > 0){
                        for (var i=0; i<refund_items.length; i++){
                            let refund_item = refund_items[i];
                            let refunded_so_far_quantity = refund_item.refunded_so_far_quantity;
                            let return_quantity = parseInt(refund_item.return_quantity);
                            let remaining_quantity = refund_item.quantity;

                            if (return_quantity < 0){
                                errors.push({"message": "NO RETURN QUANTITY SHOULD BE LESS THAN 0"})
                                break
                            }

                            if (refunded_so_far_quantity + return_quantity > remaining_quantity){
                            errors.push({"message": "SOME OF THE RETURNED ITEM QUANTITY IS GREATER THAN BOUGHT ITEM. PLEASE REVIEW."})
                                break
                            }

                        }
                    }
                    // else {
                    //     let delivery_being_refunded = (parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0);

                    //     let warranty_being_refunded = (parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0);

                    //     let setup_being_refunded = (parseFloat(this.refund_charges.setup_refunded_currently) || 0.0);

                    //     if ((delivery_being_refunded +  warranty_being_refunded + setup_being_refunded) <= 0){
                    //         errors.push({"message": "NOTHING TO REFUND"});
                    //     }
                    // }
                    return errors
                },
                validate_refund_charges: function(refund_charges){
                    let errors = [];
                    let delivery_refunds_allowed = this.invoice.delivery_charges - parseFloat(refund_charges.delivery_refunded_sofar);
                    let setup_refunds_allowed = this.invoice.setup_charges - parseFloat(refund_charges.setup_refunded_sofar);
                    let warranty_refunds_allowed = this.invoice.warranty_charges - parseFloat(refund_charges.warranty_refunded_sofar);

                    let delivery_refunded_currently = (parseFloat(refund_charges.delivery_refunded_currently) ||  0.0);

                    let setup_refunded_currently = (parseFloat(refund_charges.setup_refunded_currently) ||  0.0);

                    let warranty_refunded_currently = (parseFloat(refund_charges.warranty_refunded_currently) ||  0.0);


                    if (delivery_refunded_currently < 0 || setup_refunded_currently < 0 || warranty_refunded_currently < 0 ){
                        errors.push({"message": "ALL THE REFUND VALUES SHOULD BE GREATER THAN 0"})
                    }


                    if (delivery_refunded_currently > delivery_refunds_allowed){

                        if (delivery_refunds_allowed == 0){
                            errors.push({"message": "REFUND ON DELIVERY CHARGES NOT ALLOWED."})
                        }
                        else{
                            errors.push({"message": "DELIVERY CHARGES REFUND SHOULD BE UNDER $"+(delivery_refunds_allowed || 0.0).toFixed(2) });
                        }
                    }

                    if (setup_refunded_currently > setup_refunds_allowed){

                        if (setup_refunds_allowed == 0){
                            errors.push({"message": "REFUND ON SETUP CHARGES NOT ALLOWED."})
                        }
                        else{
                            errors.push({"message": "SETUP CHARGES REFUND SHOULD BE UNDER $"+(setup_refunds_allowed || 0.0).toFixed(2) });
                        }
                    }

                    if (warranty_refunded_currently > warranty_refunds_allowed){

                        if (warranty_refunds_allowed == 0){
                            errors.push({"message": "WARRANTY REFUND NOT ALLOWED."})
                        }
                        else{
                            errors.push({"message": "WARRANTY REFUND SHOULD BE UNDER $"+(warranty_refunds_allowed || 0.0).toFixed(2) });
                        }
                    }

                    // if ((delivery_refunded_currently +  warranty_refunded_currently + setup_refunded_currently) <= 0){
                    //     errors.push({"message": "NOTHING TO REFUND"});
                    // }
                    return errors
                },
                validate_refund: function(){
                    // if (this.invoice.is_layaway){
                    //     let refunded_items_count = this.refund_items.length;
                    //     let invoice_items_count = this.invoice.items.length;

                    //     let refunded_items_qty = this.refund_items.map(function(d){
                    //         return (parseInt(d.return_quantity) || 0) }).reduce((partialSum, a) => partialSum + a, 0);

                    //     let invoice_items_qty = this.invoice.items.map(function(d){return (parseInt(d.quantity) || 0) }).reduce((pSum, a) => pSum + a, 0);

                    //     let refunded_charges = (parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0)
                    //             +(parseFloat(this.refund_charges.setup_refunded_currently) || 0.0)
                    //             +(parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0)

                    //     let invoice_charges = (this.invoice.delivery_charges || 0.0) + (this.invoice.setup_charges || 0.0) + (this.invoice.warranty_charges || 0.0);

                    //     console.log(this.invoice)
                    //     console.log(refunded_items_count, invoice_items_count);
                    //     console.log(refunded_items_qty, invoice_items_qty);
                    //     console.log(refunded_charges, invoice_charges);

                    //     if (refunded_items_count != invoice_items_count || refunded_items_qty != invoice_items_qty || refunded_charges != invoice_charges) {
                    //         this.$vex.dialog.alert({message: "AN IN-PROCESS LAYAWAY INVOICE CANNOT MAKE PARTIAL REFUNDS/CANCELLATION OF ITEMS OR CHARGES. PLEASE ADD ALL THE ITEMS AND CHARGES IN THE INVOICE IN RETURN SO THAT A STORE CREDIT CAN BE GRANTED."});
                    //         return
                    //     }
                    // }

                    let refund_items = this.refund_items;
                    let refund_charges = this.refund_charges;
                    let tax_perc = this.tax_perc;

                    let refund_items_validation = this.validate_refund_products(refund_items);
                    if (refund_items_validation.length > 0){
                        this.$vex.dialog.alert(
                            {message: refund_items_validation[0].message}
                        );
                        return
                    }

                    let charges_validation = this.validate_refund_charges(refund_charges)
                    if (charges_validation.length > 0){
                        this.$vex.dialog.alert(
                            {message: charges_validation[0].message}
                        );
                        return
                    }

                    let refund_amount = 0.0;
                    if (refund_items.length > 0) {
                        refund_amount = refund_items.map(function(d){
                            return (parseInt(d.return_quantity) || 0) * parseFloat(d.selling_price) - ((parseInt(d.return_quantity) || 0) * d.unit_discount_value) ;
                        }).reduce((a, b) => a + b);
                    }

                    refund_amount = refund_amount + (
                        parseFloat(this.refund_charges.delivery_refunded_currently)
                        +parseFloat(this.refund_charges.setup_refunded_currently)
                        +parseFloat(this.refund_charges.warranty_refunded_currently)
                    )

                    if (refund_amount == 0) {
                        this.$vex.dialog.alert(
                            {message: "NOTHING TO REFUND"}
                        );
                        return
                    }

                    let current_tax_return = 0.0;
                    if(this.invoice.sales_tax){
                        //how much tax we originally took from the customer?
                        let original_tax_amount = this.invoice.sales_tax;
                        let original_invoice_total_minus_st = this.invoice.total - original_tax_amount;
                        let weight = refund_amount / original_invoice_total_minus_st;
                        current_tax_return = weight * original_tax_amount;

                        //current_tax_return = this.getSalesTaxPerc() * refund_amount;
                    }
                    this.refund_charges.total_refunded_currently = this.roundTo(current_tax_return + refund_amount, 2);
                    this.refund_charges.tax_refunded_currently = this.roundTo(current_tax_return, 2);
                    this.current_refund_validated = true;
                    if (this.refund_methods.length === 0) {
                            this.addRefundMethod();
                        }
                    // if (this.invoice.is_layaway){
                    //     this.refund_charges.total_refunded_currently = this.invoice.payment_methods.map(function(d){return (parseFloat(d.amount) || 0.0)}).reduce((partialSum, a) => partialSum + a, 0);
                    // }
                    let newItemsTotal = this.getOrderTotal() + this.getChargesTotal() + this.getSalesTax();
                        let refundAmount = this.getNetStoreCreditForTransaction();

                        if (refundAmount > 0 && newItemsTotal > 0) {
                            let netAmount = newItemsTotal - refundAmount;
                            this.$bvToast.toast(
                                `Net transaction: $${netAmount.toFixed(2)} (New: $${newItemsTotal.toFixed(2)} - Refund: $${refundAmount.toFixed(2)})`,
                                {title: "Transaction Summary", autoHideDelay: 3000, variant: "info"}
                            );
                        }

                    return
                },
                roundTo: function(n, digits) {
                    var negative = false;
                    if (digits === undefined) {
                        digits = 0;
                    }
                    if (n < 0) {
                        negative = true;
                        n = n * -1;
                    }
                    var multiplicator = Math.pow(10, digits);
                    n = parseFloat((n * multiplicator).toFixed(11));
                    n = (Math.round(n) / multiplicator).toFixed(digits);
                    if (negative) {
                        n = (n * -1).toFixed(digits);
                    }
                    return n;
                },
            submit_refund_wrapper: function(){
        let invoice_id = this.invoice.invoice_id;
        let data = {invoice_id: invoice_id};
        let that = this;

        let path = "/api/sales/find_if_refund_allowed/"
        let s = function(response){
            if (response.data.error){
                if (response.data.reason){
                    that.$vex.dialog.alert(
                        {message: response.data.reason}
                    );
                }
                else {
                    that.$bvToast.toast(
                        response.data.error,
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
            }
            else {
                if (response.data.refund_allowed){
                    that.submit_refund();
                } else {
                    that.$bvToast.toast(
                        "Refund not allowed",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
            }
            that.loading = false;
        }
        let f = function(error){
            console.log(error)
            that.$bvToast.toast(
                "Error checking refund eligibility. Please try again.",
                {title: "Error", autoHideDelay: 1500, variant:"danger"}
            );
            that.loading = false;
        }
        this.loading = true;
        Requestor.getSync(path, data, s, f);
    },
        getRefundsHistory: function() {
        let invoice_id = this.invoice.invoice_id;
        if (!invoice_id) {
            console.error("No invoice ID available");
            return;
        }

        let path = "/api/sales/get_refunds_history/";
        let data = {invoice_id: invoice_id};
        let that = this;

        Requestor.getSyncP(path, data, this,
            function(response) {
                if (response.data.error) {
                    console.error("Error fetching refunds history:", response.data.error);
                    that.$bvToast.toast(
                        "Error loading refund history",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                } else {
                    console.log("Refunds history:", response.data.result);
                    // Store the refunds history in your component data
                    that.refundsHistory = response.data.result;

                    // You can also show a toast notification
                    that.$bvToast.toast(
                        "Refund history loaded",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                }
            },
            function(error) {
                console.error("Error fetching refunds history:", error);
                that.$bvToast.toast(
                    "Error loading refund history",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            }
        );
    },
//    submit_refund: function(){
//     let that = this;
//     let data = {
//         invoice_id: this.invoice.invoice_id,
//         created_by: this.userDetails.username,
//         is_layaway: this.invoice.is_layaway,
//         approved: false,
//         total_refunded_item_amount: (
//             this.refund_charges.total_refunded_currently - (
//                 parseFloat(this.refund_charges.delivery_refunded_currently)
//                 +parseFloat(this.refund_charges.setup_refunded_currently)
//                 +parseFloat(this.refund_charges.warranty_refunded_currently)
//                 +parseFloat(this.refund_charges.tax_refunded_currently)
//             )
//         ),
//         total_refunded_sales_tax: this.refund_charges.tax_refunded_currently,
//         total_refunded_delivery: (parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0),
//         total_refunded_setup: (parseFloat(this.refund_charges.setup_refunded_currently) || 0.0),
//         total_refunded_warranty: (parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0),
//         refund_methods: [],
//         refund_items: this.refund_items.map(function(d){
//             return {
//                 refund_id: null,
//                 invoice_id: that.invoice.invoice_id,
//                 product_id: -1,
//                 itemid: d.itemid,
//                 product_sku: d.product_sku,
//                 return_quantity: parseInt(d.return_quantity),
//                 selling_price: ( (parseInt(d.return_quantity) || 0) * d.selling_price - ((parseInt(d.return_quantity) || 0) * d.unit_discount_value) ),
//                 refunded_at_state: 0,
//                 reason: null,
//                 note: null,
//                 is_delivered: false,
//                 return_locsub: null
//             }
//         })
//     }

//     if (this.invoice.is_layaway){
//         data.total_refunded_item_amount = this.invoice.payment_methods.map(function(d){return (parseFloat(d.amount) || 0.0)}).reduce((partialSum, a) => partialSum + a, 0);
//         data.total_refunded_sales_tax = 0.0;
//         data.total_refunded_delivery = 0.0;
//         data.total_refunded_setup = 0.0;
//         data.total_refunded_warranty = 0.0;
//     }

//     let path = "/api/sales/record_refund/"
//     let s = function(response){
//         if (response.data.error){
//             that.$vex.dialog.alert(
//                 {message: response.data.error}
//             );
//             that.loading = false;
//         }
//         else {
//             that.$bvToast.toast(
//                 "REFUND RECORDED - Refreshing data...",
//                 {title: "Success", autoHideDelay: 1500, variant:"success"}
//             );

           
//             setTimeout(() => {
//                 that.reloadAllData();
//             }, 1000);
//         }
//         that.loading = false;
//     }
//     let f = function(error){
//         console.log(error)
//         that.$bvToast.toast(
//             "Error registering refund. Please try again.",
//             {title: "Error", autoHideDelay: 1500, variant:"danger"}
//         );
//         that.loading = false;
//     }

//     this.loading = true;
//     Requestor.postAsyncP(path, data, this, s, f);
// },

// submit_refund: function(){
//     let that = this;
    
//     // Calculate the refund items with CORRECT per-unit prices
//     let refundItemsData = this.refund_items.map(function(d){
//         // Get the per-unit price (already correct from removeItem)
//         let perUnitPrice = parseFloat(d.selling_price) || 0;
//         let returnQty = parseInt(d.return_quantity) || 0;
//         let unitDiscount = parseFloat(d.unit_discount_value) || 0;
        
//         return {
//             refund_id: null,
//             invoice_id: that.invoice.invoice_id,
//             product_id: -1,
//             itemid: d.itemid,
//             product_sku: d.product_sku,
//             return_quantity: returnQty,
//             // CRITICAL: Send PER-UNIT price, NOT the total!
//             selling_price: perUnitPrice,
//             refunded_at_state: 0,
//             reason: null,
//             note: null,
//             is_delivered: false,
//             return_locsub: null
//         };
//     });
    
//     // Calculate total item refund amount (for the total_refunded_item_amount field)
//     const totalItemRefund = refundItemsData.reduce((sum, item) => {
//         return sum + (item.return_quantity * item.selling_price);
//     }, 0);
    
//     let data = {
//         invoice_id: this.invoice.invoice_id,
//         created_by: this.userDetails.username,
//         is_layaway: this.invoice.is_layaway,
//         approved: false,
//         total_refunded_item_amount: totalItemRefund,
//         total_refunded_sales_tax: this.refund_charges.tax_refunded_currently,
//         total_refunded_delivery: (parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0),
//         total_refunded_setup: (parseFloat(this.refund_charges.setup_refunded_currently) || 0.0),
//         total_refunded_warranty: (parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0),
//         refund_methods: [],
//         refund_items: refundItemsData
//     };

//     console.log('Submitting refund data:', data);
//     console.log('Total item refund:', totalItemRefund);

//     let path = "/api/sales/record_refund/"
//     let s = function(response){
//         if (response.data.error){
//             that.$vex.dialog.alert(
//                 {message: response.data.error}
//             );
//             that.loading = false;
//         }
//         else {
//             that.$bvToast.toast(
//                 "REFUND RECORDED - Refreshing data...",
//                 {title: "Success", autoHideDelay: 1500, variant:"success"}
//             );

//             setTimeout(() => {
//                 that.reloadAllData();
//             }, 1000);
//         }
//         that.loading = false;
//     }
//     let f = function(error){
//         console.log(error)
//         that.$bvToast.toast(
//             "Error registering refund. Please try again.",
//             {title: "Error", autoHideDelay: 1500, variant:"danger"}
//         );
//         that.loading = false;
//     }

//     this.loading = true;
//     Requestor.postAsyncP(path, data, this, s, f);
// },

// submit_refund: function(){
//     let that = this;
    
//     // Calculate the refund items with CORRECT per-unit prices and actual states
//     let refundItemsData = this.refund_items.map(function(d){
//         // Get the per-unit price (already correct from removeItem)
//         let perUnitPrice = parseFloat(d.selling_price) || 0;
//         let returnQty = parseInt(d.return_quantity) || 0;
        
//         // Find the original item in the invoice to get its current state
//         let originalItem = that.invoice.items.find(function(item) {
//             return item.itemid === d.itemid;
//         });
        
//         // Get the current state from the invoice item, default to 0 if not found
//         let currentState = originalItem ? originalItem.state : 0;
        
//         return {
//             refund_id: null,
//             invoice_id: that.invoice.invoice_id,
//             product_id: -1,
//             itemid: d.itemid,
//             product_sku: d.product_sku,
//             return_quantity: returnQty,
//             // CRITICAL: Send PER-UNIT price, NOT the total!
//             selling_price: perUnitPrice,
//             // CRITICAL: Send the ACTUAL current state of the item!
//             refunded_at_state: currentState,
//             reason: null,
//             note: null,
//             is_delivered: false,
//             return_locsub: null
//         };
//     });
    
//     // Calculate total item refund amount (for the total_refunded_item_amount field)
//     const totalItemRefund = refundItemsData.reduce((sum, item) => {
//         return sum + (item.return_quantity * item.selling_price);
//     }, 0);
    
//     let data = {
//         invoice_id: this.invoice.invoice_id,
//         created_by: this.userDetails.username,
//         is_layaway: this.invoice.is_layaway,
//         approved: false,
//         total_refunded_item_amount: totalItemRefund,
//         total_refunded_sales_tax: this.refund_charges.tax_refunded_currently,
//         total_refunded_delivery: (parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0),
//         total_refunded_setup: (parseFloat(this.refund_charges.setup_refunded_currently) || 0.0),
//         total_refunded_warranty: (parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0),
//         refund_methods: [],
//         refund_items: refundItemsData
//     };

//     console.log('Submitting refund data:', data);
//     console.log('Total item refund:', totalItemRefund);
//     console.log('Item states being sent:', refundItemsData.map(item => ({
//         sku: item.product_sku,
//         itemid: item.itemid,
//         state: item.refunded_at_state,
//         qty: item.return_quantity
//     })));

//     let path = "/api/sales/record_refund/"
//     let s = function(response){
//         if (response.data.error){
//             that.$vex.dialog.alert(
//                 {message: response.data.error}
//             );
//             that.loading = false;
//         }
//         else {
//             that.$bvToast.toast(
//                 "REFUND RECORDED - Refreshing data...",
//                 {title: "Success", autoHideDelay: 1500, variant:"success"}
//             );

//             setTimeout(() => {
//                 that.reloadAllData();
//             }, 1000);
//         }
//         that.loading = false;
//     }
//     let f = function(error){
//         console.log(error)
//         that.$bvToast.toast(
//             "Error registering refund. Please try again.",
//             {title: "Error", autoHideDelay: 1500, variant:"danger"}
//         );
//         that.loading = false;
//     }

//     this.loading = true;
//     Requestor.postAsyncP(path, data, this, s, f);
// }, 

submit_refund: function(){
    let that = this;
    
    // Calculate the refund items with CORRECT per-unit prices and unit discounts
    let refundItemsData = this.refund_items.map(function(d){
        // Get the per-unit price (already correct from removeItem)
        let perUnitPrice = parseFloat(d.selling_price) || 0;
        let returnQty = parseInt(d.return_quantity) || 0;
        let unitDiscountValue = parseFloat(d.unit_discount_value) || 0;
        
        // Find the original item in the invoice to get its current state
        let originalItem = that.invoice.items.find(function(item) {
            return item.itemid === d.itemid;
        });
        
        // Get the current state from the invoice item, default to 0 if not found
        let currentState = originalItem ? originalItem.state : 0;
        
        // Calculate the per-unit refund amount (price - discount)
        let perUnitRefundAmount = perUnitPrice - unitDiscountValue;
        
        return {
            refund_id: null,
            invoice_id: that.invoice.invoice_id,
            product_id: -1,
            itemid: d.itemid,
            product_sku: d.product_sku,
            return_quantity: returnQty,
            // CRITICAL: Send PER-UNIT price, NOT the total!
            selling_price: perUnitPrice,
            // CRITICAL: Send the unit discount value
            unit_discount_value: unitDiscountValue,
            // Send the calculated per-unit refund amount (optional but helpful)
            per_unit_refund_amount: perUnitRefundAmount,
            // CRITICAL: Send the ACTUAL current state of the item!
            refunded_at_state: currentState,
            reason: null,
            note: null,
            is_delivered: false,
            return_locsub: null
        };
    });
    
    // Calculate total item refund amount using the per-unit refund amounts
    const totalItemRefund = refundItemsData.reduce((sum, item) => {
        // Calculate: (quantity * price) - (quantity * discount_per_unit)
        return sum + (item.return_quantity * item.per_unit_refund_amount);
    }, 0);
    
    // Alternatively, calculate using the original method but with discount:
    // const totalItemRefund = refundItemsData.reduce((sum, item) => {
    //     return sum + (item.return_quantity * item.selling_price) - (item.return_quantity * item.unit_discount_value);
    // }, 0);
    
    // Round to 2 decimal places to avoid floating point issues
    const roundedTotalItemRefund = Math.round(totalItemRefund * 100) / 100;
    
    // Get current tax refund amount
    let taxRefund = this.refund_charges.tax_refunded_currently || 0;
    let deliveryRefund = parseFloat(this.refund_charges.delivery_refunded_currently) || 0.0;
    let setupRefund = parseFloat(this.refund_charges.setup_refunded_currently) || 0.0;
    let warrantyRefund = parseFloat(this.refund_charges.warranty_refunded_currently) || 0.0;
    
    // Calculate total refund amount including all charges
    let totalRefund = roundedTotalItemRefund + taxRefund + deliveryRefund + setupRefund + warrantyRefund;
    totalRefund = Math.round(totalRefund * 100) / 100;
    
    let data = {
        invoice_id: this.invoice.invoice_id,
        created_by: this.userDetails.username,
        is_layaway: this.invoice.is_layaway || false,
        approved: false,
        total_refunded_item_amount: roundedTotalItemRefund,
        total_refunded_sales_tax: taxRefund,
        total_refunded_delivery: deliveryRefund,
        total_refunded_setup: setupRefund,
        total_refunded_warranty: warrantyRefund,
        refund_methods: [],  // Will be populated if using refund methods
        refund_items: refundItemsData
    };

    console.log('=== REFUND SUBMISSION DATA ===');
    console.log('Total item refund (with discounts):', roundedTotalItemRefund);
    console.log('Tax refund:', taxRefund);
    console.log('Delivery refund:', deliveryRefund);
    console.log('Setup refund:', setupRefund);
    console.log('Warranty refund:', warrantyRefund);
    console.log('GRAND TOTAL REFUND:', totalRefund);
    console.log('Refund items details:', refundItemsData.map(item => ({
        sku: item.product_sku,
        itemid: item.itemid,
        qty: item.return_quantity,
        price: item.selling_price,
        discount: item.unit_discount_value,
        per_unit_refund: item.per_unit_refund_amount,
        total_refund: item.return_quantity * item.per_unit_refund_amount,
        state: item.refunded_at_state
    })));
    console.log('===============================');

    let path = "/api/sales/record_refund/"
    let s = function(response){
        if (response.data.error){
            that.$vex.dialog.alert({
                message: response.data.error
            });
            that.loading = false;
        }
        else {
            that.$bvToast.toast(
                "REFUND RECORDED - Refreshing data...",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            
            // Clear refund items after successful submission
            that.refund_items = [];
            that.current_refund_validated = false;
            
            // Reset refund charges
            that.refund_charges = {
                delivery_refunded_sofar: 0.0,
                delivery_refunded_currently: 0.0,
                setup_refunded_sofar: 0.0,
                setup_refunded_currently: 0.0,
                warranty_refunded_sofar: 0.0,
                warranty_refunded_currently: 0.0,
                tax_refunded_sofar: 0.0,
                tax_refunded_currently: 0.0,
                total_refunded_currently: 0.0,
            };
            
            // Refresh the invoice data after a delay
            setTimeout(() => {
                that.reloadAllData();
                // Refresh store credit
                that.refreshStoreCredit();
            }, 1000);
        }
        that.loading = false;
    }
    
    let f = function(error){
        console.log('Refund submission error:', error);
        that.$bvToast.toast(
            "Error registering refund. Please try again.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.loading = false;
    }

    this.loading = true;
    Requestor.postAsyncP(path, data, this, s, f);
},
getItemUniqueKey(item) {
    return item.itemid || `${item.product_sku}-${item.existing ? 'existing' : 'new'}-${item.id || Math.random()}`;
},
 
reloadAllData: function() {
    let that = this;
    that.loading = true;

    console.log("Starting data reload...");

    // Reset all refund-related data
    that.refund_items = [];
    that.current_refund_validated = false;
    that.refund_charges = {
        delivery_refunded_sofar: 0.0,
        delivery_refunded_currently: 0.0,
        setup_refunded_sofar: 0.0,
        setup_refunded_currently: 0.0,
        warranty_refunded_sofar: 0.0,
        warranty_refunded_currently: 0.0,
        tax_refunded_sofar: 0.0,
        tax_refunded_currently: 0.0,
        total_refunded_currently: 0.0,
    };

    // Use the existing reload method that was working
    that.reload_edit_invoice();

    // Force refresh of RefundsSummary component
    that.refundsSummaryKey += 1;

    // Show success message
    that.$bvToast.toast(
        "Refund processed successfully. Data refreshed.",
        {title: "Success", autoHideDelay: 2000, variant:"success"}
    );

    that.loading = false;
},
refreshStoreCredit: function() {
    let that = this;
    let path = "/api/sales/get_available_credit/";
    let data = {invoice_id: this.invoice.invoice_id};

    Requestor.postAsyncP(path, data, this,
        function(response) {
            if (response.data.result && response.data.result.length > 0) {
                that.invoice.available_credit_value = response.data.result[0].available_amount || 0;
                console.log("Store credit updated to:", that.invoice.available_credit_value);
            }
        },
        function(error) {
            console.error("Error refreshing store credit:", error);
        }
    );
},
 reload_edit_invoice: function(){
    console.log("=== STARTING reload_edit_invoice ===");
    let path = "/api/sales/load_existing_invoice_for_edit/"
    let data = {invoice_id: this.invoice.invoice_id, include_damage_info: true}
    let that = this;
    let s = function(response){
        console.log("=== RESPONSE RECEIVED ===");
        if (response.data.result){
            that.invoice = response.data.result[0];
            console.log("Loaded invoice data:", that.invoice);
            
            // Log agreement fields from backend
            console.log("Backend values:", {
                delivery_waiver_agreed: that.invoice.delivery_waiver_agreed,
                space_preparation_agreed: that.invoice.space_preparation_agreed,
                terms_agreed: that.invoice.terms_agreed,
                warranty_refused: that.invoice.warranty_refused,
                address_confirmation_agreed: that.invoice.address_confirmation_agreed
            });
            
            that.invoice.edit = true;
            that.isEditMode = true;
            that.invoice.new_payment_methods = [];
            that.invoice.payment_methods = [];
            
            // ✅ CRITICAL: Set the component properties
            console.log("Setting component properties...");
            that.deliveryWaiverAgreed = that.invoice.delivery_waiver_agreed === true;
            that.spacePreparationAgreed = that.invoice.space_preparation_agreed === true;
            that.deliveryDamageWaiverAgreed = that.invoice.delivery_damage_waiver_agreed === true;
            that.policyAgreed = that.invoice.terms_agreed === true;
            that.warrantyRefused = that.invoice.warranty_refused === true;
            that.invoice.address_confirmation_agreed = that.invoice.address_confirmation_agreed === true;
            
            // Log after setting
            console.log("Component properties after setting:", {
                deliveryWaiverAgreed: that.deliveryWaiverAgreed,
                spacePreparationAgreed: that.spacePreparationAgreed,
                policyAgreed: that.policyAgreed,
                warrantyRefused: that.warrantyRefused
            });
            
            // ✅ CRITICAL: Populate damage metadata for existing items
            that.invoice.items.forEach(item => {
                // Preserve damage metadata
                if (item.damage_info) {
                    item.is_damaged = item.damage_info.is_damaged || true;
                    item.source = 'damage';
                    console.log(`🔴 Loaded existing damaged item: ${item.product_sku}, Damage ID: ${item.damage_info.damage_id}`);
                } else {
                    // Check if the item has damage flags from the database
                    if (item.is_damaged === true) {
                        // If is_damaged is true but damage_info is missing, create it
                        item.damage_info = {
                            damage_id: item.damage_id || null,
                            is_damaged: true,
                            damage_grade: item.damage_grade || null,
                            damage_description: item.damage_description || '',
                            damage_images: item.damage_images || []
                        };
                        item.source = 'damage';
                        console.log(`🔴 Created damage_info for existing item: ${item.product_sku}`);
                    }
                }
                
                // Populate sourceContext for existing items
                if (item.existing) {
                    if (item.locsub || item.source_location_id) {
                        item.sourceContext = 'store';
                    } else {
                        item.sourceContext = 'warehouse';
                    }
                }
                
                // Ensure source is set
                if (!item.source) {
                    item.source = item.is_damaged ? 'damage' : (item.sourceContext || 'store');
                }
            });

            that.refund_items = [];
            that.refund_charges = {
                delivery_refunded_sofar: 0.0,
                delivery_refunded_currently: 0.0,
                setup_refunded_sofar: 0.0,
                setup_refunded_currently: 0.0,
                warranty_refunded_sofar: 0.0,
                warranty_refunded_currently: 0.0,
                tax_refunded_sofar: 0.0,
                tax_refunded_currently: 0.0,
                total_refunded_currently: 0.0,
            };
            that.current_refund_validated = false;

            that.refresh_available_store_credit();
            that.loadPaymentMethodsOnly();
            
            // Force Vue to re-render
            that.$forceUpdate();
            
            console.log("=== reload_edit_invoice COMPLETE ===");
        }
        else {
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
        }
        that.loading = false;
    }
    let f = function(error){
        console.log(error)
        that.$bvToast.toast(
            "Error loading invoice. Please try again later.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.loading = false;
    }
    this.loading=true;
    Requestor.getAsyncP(path, data, this, s, f);
},
                refresh_available_store_credit: function(){
                    let invoice_id = this.invoice.invoice_id;

                    let path = "/api/sales/get_available_credit/"
                    let data = {"invoice_id": invoice_id}
                    console.log('peepee')

                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {

                            that.invoice.available_credit_value = response.data.result[0].available_credit_value;
                        }
                    }
                    let f = function(error){

                        that.$bvToast.toast(
                            "Error loading available credit. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                },
                // get_loctions was same as get_pickup_locations (I have made it get_pickup_locations). we changed get_locations to only return locations for the current store for all order types as instructed by Aqeel Sb on 14 July 2025.
get_locations(item) {
    const onlyLoc = this.search_in_my_location;
    const sourceContext = item.sourceContext;
    const orderType = item.order_type;
    
    // ✅ CRITICAL: Check if the item is damaged or as-is
    // Log the item to debug
    console.log('🔍 get_locations() - Item:', {
        sku: item.product_sku,
        is_damaged: item.is_damaged,
        is_as_is: item.is_as_is,
        isDamagedItem: item.is_damaged || item.is_as_is,
        hasDamageInfo: !!item.damage_info,
        damageInfo: item.damage_info
    });
    
    const isDamagedItem = item.is_damaged || item.is_as_is || (item.damage_info && item.damage_info.is_damaged);

    // never allow warehouse-sourced items
    if (item.sourceContext === 'warehouse') {
        return [];
    }

    // if user has turned OFF "only in my location"...
    if (!onlyLoc) {
        if (item.locsub) {
            const existingLocation = this.packet.locsubs.find(d => d.value === item.locsub);
            if (existingLocation) {
                // For damaged items, allow any location; for normal, exclude damage
                if (!isDamagedItem && this.isDamageLocation(existingLocation)) {
                    return [];
                }
                return [existingLocation];
            }
            return [];
        }
        return [];
    }

    // For store-sourced items
    if (sourceContext === 'store') {
        // Get all non-floor locations for this store
        let allStoreLocations = this.packet.locsubs.filter(d =>
            d.location_id === this.invoice.location_id &&
            d.sublocation_type_id !== 1
        );

        // Separate damage and regular locations
        let damageLocations = allStoreLocations.filter(d => this.isDamageLocation(d));
        let regularLocations = allStoreLocations.filter(d => !this.isDamageLocation(d));

        console.log(`📍 Damage locations: ${damageLocations.map(d => d.text).join(', ')}`);
        console.log(`📍 Regular locations: ${regularLocations.map(d => d.text).join(', ')}`);

        let filteredLocations = [];

        // ✅ FOR DAMAGED ITEMS: Only show damage locations
        if (isDamagedItem) {
            console.log(`🔴 ${item.product_sku} is DAMAGED - showing only damage locations`);
            
            // CRITICAL: For damaged items, ONLY show damage locations
            if (damageLocations.length > 0) {
                filteredLocations = damageLocations;
                console.log(`✅ Showing ${damageLocations.length} damage locations for ${item.product_sku}`);
            } else {
                // If no damage locations, show all locations as fallback
                filteredLocations = allStoreLocations;
                console.log(`⚠️ No damage locations found for ${item.product_sku}, showing all locations`);
            }
            
            // ✅ AUTO-SELECT: Select the FIRST damage location
            if (filteredLocations.length > 0) {
                const firstDamageLocation = filteredLocations.find(d => this.isDamageLocation(d));
                if (firstDamageLocation) {
                    item.locsub = firstDamageLocation.value;
                    console.log(`✅ Auto-selected damage location for ${item.product_sku}: ${firstDamageLocation.text}`);
                } else if (!item.locsub) {
                    item.locsub = filteredLocations[0].value;
                }
            }

        } else {
            // ✅ FOR NORMAL ITEMS: Only show regular locations (exclude damage)
            console.log(`🟢 ${item.product_sku} is NORMAL - showing only regular locations`);
            
            // CRITICAL: For normal items, ONLY show regular locations
            if (regularLocations.length > 0) {
                filteredLocations = regularLocations;
                console.log(`✅ Showing ${regularLocations.length} regular locations for ${item.product_sku}`);
            } else {
                // If no regular locations, show all locations as fallback
                filteredLocations = allStoreLocations;
                console.log(`⚠️ No regular locations found for ${item.product_sku}, showing all locations`);
            }
            
            // ✅ AUTO-SELECT: Select the FIRST regular location
            if (filteredLocations.length > 0 && !item.locsub) {
                const firstRegularLocation = filteredLocations.find(d => !this.isDamageLocation(d));
                if (firstRegularLocation) {
                    item.locsub = firstRegularLocation.value;
                    console.log(`✅ Auto-selected regular location for ${item.product_sku}: ${firstRegularLocation.text}`);
                } else {
                    item.locsub = filteredLocations[0].value;
                }
            }
        }

        // Ensure the currently selected location is included
        if (item.locsub && !filteredLocations.some(d => d.value === item.locsub)) {
            const currentLocation = this.packet.locsubs.find(d => d.value === item.locsub);
            if (currentLocation) {
                // For damaged items, allow any location; for normal, only non-damage
                if (!isDamagedItem && this.isDamageLocation(currentLocation)) {
                    // Skip adding damage location for normal items
                    console.log(`⚠️ Skipping damage location for normal item: ${currentLocation.text}`);
                } else {
                    filteredLocations.unshift(currentLocation);
                }
            }
        }

        console.log(`📋 Final locations for ${item.product_sku}: ${filteredLocations.map(d => d.text).join(', ')}`);
        return filteredLocations;
    }

    // Original fallback logic
    if (orderType === 'store_pickup') {
        return this.packet.locsubs.filter(d =>
            d.location_id === this.invoice.location_id &&
            !this.isDamageLocation(d)
        );
    }

    return this.packet.locsubs.filter(d =>
        d.location_id === this.invoice.location_id &&
        d.sublocation_type_id !== 1 &&
        !this.isDamageLocation(d)
    );
},
isDamageLocation: function(location) {
    if (!location || !location.text) return false;
    
    const locationText = location.text.toLowerCase();
    const damageKeywords = [
        'damage', 'damages', 'as is', 'defective', 'broken', 
        'scratch', 'dent', 'cosmetic', 'imperfect', 'clearance'
    ];
    
    // Check if location text contains any damage keyword
    return damageKeywords.some(keyword => locationText.includes(keyword));
},

// Also check for damage locations in the value/text property

isLocationNameDamage: function(locationName) {
    if (!locationName) return false;
    
    const name = locationName.toLowerCase();
    const damageKeywords = [
        'damage', 'damages', 'as is', 'defective', 'broken', 
        'scratch', 'dent', 'cosmetic', 'imperfect', 'clearance'
    ];
    
    return damageKeywords.some(keyword => name.includes(keyword));
},
get_pickup_locations: function(item) {
    let order_type = item.order_type;
    let output = [];
    let that = this;
    const onlyLoc = this.search_in_my_location;
    const sourceContext = item.sourceContext;

    // Filter out floor locations (sublocation_type_id = 1) AND damage locations
    const nonFloorNonDamageLocations = this.packet.locsubs.filter(d => 
        d.sublocation_type_id !== 1 &&
        !this.isDamageLocation(d)
    );

    // Check if Online Sales is selected
    const isOnlineStoreSelected = this.isOnlineStoreLocation();

    if (!onlyLoc && sourceContext === 'store') {
        if (item.locsub) {
            const existingLocation = this.packet.locsubs.find(d => d.value === item.locsub);
            if (existingLocation && !this.isDamageLocation(existingLocation)) {
                return [existingLocation];
            }
            return [];
        }
        return [];
    }

    if (order_type == 'customer_takes') {
        output = nonFloorNonDamageLocations.filter(function(d) {
            return d.location_id == that.invoice.location_id;
        });
        return output;
    }

    if (order_type == 'store_pickup') {
        // 🔥 FIXED: For warehouse-sourced items, show ONLY TWO options
        if (sourceContext === 'warehouse') {
            const storeLocationId = that.invoice.location_id;
            
            // Option 1: Store Location Stock (current store's stock)
            const storeStock = nonFloorNonDamageLocations.filter(function(d) {
                return d.location_id === storeLocationId && 
                       d.sublocation_type_id !== 1 &&
                       !that.isDamageLocation(d) &&
                       // Exclude Mecca Shipping locations from store stock
                       !d.text.toLowerCase().includes('mecca shipping') &&
                       !d.text.toLowerCase().includes('mecca delivery');
            });
            
            // Option 2: Mecca Shipping Customer Pickup ONLY
            const meccaCustomerPickup = nonFloorNonDamageLocations.filter(function(d) {
                const locationText = (d.text || '').toLowerCase();
                const sublocationName = (d.sublocation_name || '').toLowerCase();
                
                // MUST be "Mecca Shipping" location
                const isMeccaShipping = locationText.includes('mecca shipping') || 
                                       locationText.includes('mecca delivery');
                
                // MUST have "Customer Pickup" as sublocation
                // Using the exact name from your data: "CUSTOMER PICK UP"
                const isCustomerPickup = sublocationName === 'customer pick up' ||
                                        sublocationName.includes('customer pick up') ||
                                        sublocationName === 'customer pickup' ||
                                        sublocationName.includes('customer pickup');
                
                // EXCLUDE "TRANSFER CUSTOMER PICK UP" - must NOT contain TRANSFER
                const isTransfer = sublocationName.includes('transfer');
                
                // ONLY include if ALL conditions match
                return isMeccaShipping && isCustomerPickup && !isTransfer;
            });
            
            // Combine both options
            output = [...storeStock, ...meccaCustomerPickup];
            
            // 🔥 DEBUG: Log what was found
            console.log('🏚️ Store Stock locations:', storeStock.map(l => l.text));
            console.log('🏚️ Mecca Customer Pickup locations:', meccaCustomerPickup.map(l => l.text));
            console.log('🏚️ Total pickup locations:', output.length);
            
            // If no Mecca Customer Pickup found, check if we have any Mecca locations at all
            if (meccaCustomerPickup.length === 0) {
                console.log('⚠️ No Mecca Customer Pickup found. Checking all Mecca locations...');
                
                // Find all Mecca Shipping locations
                const allMeccaLocations = nonFloorNonDamageLocations.filter(function(d) {
                    const locationText = (d.text || '').toLowerCase();
                    return locationText.includes('mecca shipping') || 
                           locationText.includes('mecca delivery');
                });
                
                console.log('📍 All Mecca locations found:', allMeccaLocations.map(l => ({
                    text: l.text,
                    sublocation_name: l.sublocation_name,
                    sublocation_id: l.sublocation_id
                })));
                
                // Filter for sublocation_id 162 (CUSTOMER PICK UP from your data)
                const customerPickupBySublocationId = allMeccaLocations.filter(function(d) {
                    return d.sublocation_id === 162;
                });
                
                // Filter by sublocation_name containing 'CUSTOMER PICK'
                const customerPickupByName = allMeccaLocations.filter(function(d) {
                    const name = (d.sublocation_name || '').toUpperCase();
                    return name.includes('CUSTOMER PICK');
                });
                
                // Combine both attempts
                const foundLocations = [...customerPickupBySublocationId, ...customerPickupByName];
                
                // Remove duplicates
                const uniqueLocations = [];
                const seenValues = new Set();
                foundLocations.forEach(loc => {
                    if (!seenValues.has(loc.value)) {
                        seenValues.add(loc.value);
                        uniqueLocations.push(loc);
                    }
                });
                
                if (uniqueLocations.length > 0) {
                    output = [...storeStock, ...uniqueLocations];
                    console.log('📍 Found by sublocation_id/name:', uniqueLocations.map(l => l.text));
                } else {
                    console.log('⚠️ No Customer Pickup found. Showing all non-floor locations as fallback.');
                    output = nonFloorNonDamageLocations.filter(function(d) {
                        return d.location_id == that.invoice.location_id;
                    });
                }
            }
            
            // If still no locations, show all available for this store
            if (output.length === 0) {
                console.log('⚠️ No locations found, showing all available...');
                output = nonFloorNonDamageLocations.filter(function(d) {
                    return d.location_id == that.invoice.location_id;
                });
            }
            
            return output;
        }

        // 🔥 FIXED: Online Store → Show ONLY "CUSTOMER PICK UP" (exclude TRANSFER)
        if (isOnlineStoreSelected) {
            output = nonFloorNonDamageLocations.filter(function(d) {
                const sublocationName = (d.sublocation_name || '').toUpperCase();
                return (sublocationName.includes('CUSTOMER PICK UP') ||
                        sublocationName.includes('CUSTOMER PICKUP') ||
                        sublocationName.includes('CUSTOMER PICK-UP')) &&
                       !sublocationName.includes('TRANSFER');
            });
            
            if (output.length === 0) {
                console.log('⚠️ No exact "CUSTOMER PICK UP" found, trying broader match...');
                output = nonFloorNonDamageLocations.filter(function(d) {
                    const sublocationName = (d.sublocation_name || '').toUpperCase();
                    return (sublocationName.includes('CUSTOMER') && 
                            sublocationName.includes('PICK')) &&
                           !sublocationName.includes('TRANSFER');
                });
            }
            
            if (output.length === 0) {
                console.log('⚠️ Using direct sublocation_id match...');
                output = nonFloorNonDamageLocations.filter(function(d) {
                    return d.sublocation_id === 162;
                });
            }
            
            console.log(`📦 Online Store → Customer Pick Up locations found: ${output.length}`);
            return output;
        }

        // Regular store pickup - show all locations for this store
        output = nonFloorNonDamageLocations.filter(function(d) {
            const isMeccaShipping = d.text.toLowerCase().includes('mecca shipping') ||
                                   d.text.toLowerCase().includes('mecca delivery');
            
            // For store-sourced items, exclude Mecca Shipping
            if (sourceContext === 'store' && isMeccaShipping) {
                return false;
            }
            
            return d.location_id == that.invoice.location_id;
        });
        return output;
    }

    if (order_type == 'home_delivery') {
        // Home Delivery → Show "CUSTOMER DELIVERIES"
        output = nonFloorNonDamageLocations.filter(function(d) {
            const sublocationName = (d.sublocation_name || '').toUpperCase();
            return (sublocationName.includes('CUSTOMER DELIVERIES') ||
                    sublocationName.includes('CUSTOMER DELIVERY')) &&
                   !sublocationName.includes('TRANSFER');
        });
        return output;
    }

    if (order_type == 'delivery_from_store') {
        // Store Delivery → Show both Customer Pickup and Customer Deliveries
        const customerPickup = nonFloorNonDamageLocations.filter(function(d) {
            const sublocationName = (d.sublocation_name || '').toUpperCase();
            return (sublocationName.includes('CUSTOMER PICK UP') ||
                    sublocationName.includes('CUSTOMER PICKUP')) &&
                   !sublocationName.includes('TRANSFER');
        });
        
        const customerDeliveries = nonFloorNonDamageLocations.filter(function(d) {
            const sublocationName = (d.sublocation_name || '').toUpperCase();
            return (sublocationName.includes('CUSTOMER DELIVERIES') ||
                    sublocationName.includes('CUSTOMER DELIVERY')) &&
                   !sublocationName.includes('TRANSFER');
        });
        
        output = [...customerPickup];
        customerDeliveries.forEach(function(loc) {
            if (!output.some(existing => existing.value === loc.value)) {
                output.push(loc);
            }
        });
        return output;
    }

    return output;
},
isOnlineStoreLocation: function() {
    if (!this.invoice.selected_locsub) return false;
    
    const selectedLoc = this.packet.locsubs.find(loc => loc.value === this.invoice.selected_locsub);
    if (!selectedLoc || !selectedLoc.text) return false;
    
    const locText = selectedLoc.text.toLowerCase();
    
    // Check for Online Store variations
    return locText.includes('online store') || 
           locText.includes('online sales') || 
           locText.includes('ecommerce') ||
           locText.includes('e-commerce') ||
           locText.includes('web store') ||
           locText.includes('online') && locText.includes('store');
},

isOnlineSalesLocation: function() {
    if (!this.invoice.selected_locsub) return false;
    
    // Get the selected location text
    const selectedLoc = this.packet.locsubs.find(loc => loc.value === this.invoice.selected_locsub);
    if (!selectedLoc || !selectedLoc.text) return false;
    
    // Check if location name contains "Online Sales" or similar
    const locText = selectedLoc.text.toLowerCase();
    return locText.includes('online sales') || 
           locText.includes('online') || 
           locText.includes('ecommerce') ||
           locText.includes('e-commerce');
},
                setCommonDeliveryDate: function(selectedDate) {
                    this.invoice.items.forEach(item => {
                        if (!item.existing) {
                            item.delivery_date = selectedDate;
                        }
                    });
                },
               shouldShowBackorder(item) {
    if (item.sourceContext !== 'warehouse') {
        return false;
    }

    // First try to use stored availability if it exists
    if (item.available !== undefined) {
        return Number(item.available) <= 0;
    }

    // Fallback to search results
    if (Array.isArray(this.searchitems.result) && this.searchitems.result.length > 0) {
        const product = this.searchitems.result.find(
            p => p.product_id === item.product_id && p.product_sku === item.product_sku
        );

        if (product) {
            return Number(product.available) <= 0;
        }
    }

    return false;
}
            },

       created: function() {
    let userDetails = localStorage.userDetails;
    let packet = localStorage.packet;
    this.fetchPolicy();
    if (userDetails) {
        this.userDetails = JSON.parse(userDetails);
        if (packet) {
            this.packet = JSON.parse(packet);
            this.fetch_prereqs();
            this.fetchCategories();
             this.fetchSubcategories();
        }
    }
    if (this.invoice.invoice_id) {
        console.log("Invoice ID in created:", this.invoice.invoice_id);
        this.$nextTick(() => {
            this.loadPaymentMethodsOnly();
            this.loadOriginalPaymentMethods();
            this.loadRefundsHistory();
            this.reload_edit_invoice(); // ✅ Add this line
        });
    }
},
   mounted() {
    // Check if there's a draft_id in the route query
    const draftId = this.$route.query.draft_id;
    if (draftId) {
        this.loadDraftInvoice(draftId);
    }
    
    if (this.invoice.invoice_id) {
        console.log("Invoice ID found, calling reload_edit_invoice");
        this.$nextTick(() => {
            this.loadPaymentMethodsOnly();
            this.loadOriginalPaymentMethods();
            this.loadRefundsHistory();
            this.reload_edit_invoice(); // ✅ Make sure this is called
        });
    }
},
    beforeDestroy() {
    // Clean up event listener to prevent memory leaks
    document.removeEventListener('keydown', this.handleGlobalEnter);
},
        }
    </script>

    <style scoped>
    /* Special Order Tab Styles */
.special-order-image-section {
    background: #f8f9fa;
    padding: 10px 15px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.image-preview-wrapper {
    transition: all 0.2s ease;
    position: relative;
}

.image-preview-wrapper:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.upload-placeholder {
    transition: all 0.2s ease;
}

.upload-placeholder:hover {
    border-color: #007bff !important;
    background: #f0f7ff !important;
}

/* Make selects and inputs more compact */
.special-order-tab .form-control-sm,
.special-order-tab .custom-select-sm {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
    height: calc(1.5em + 0.4rem + 2px);
}

.special-order-tab .input-group-sm > .form-control {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
    height: calc(1.5em + 0.4rem + 2px);
}

.special-order-tab .input-group-text {
    font-size: 0.8rem;
    padding: 0.2rem 0.4rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .special-order-image-section .d-flex {
        flex-direction: column;
        align-items: flex-start !important;
    }
    
    .image-upload-wrapper {
        margin: 0 auto !important;
    }
}

@media (max-width: 576px) {
    .special-order-image-section {
        padding: 10px;
    }
    
    .upload-controls .d-flex {
        flex-wrap: wrap;
        justify-content: center;
    }
}
    /* Image Upload Styles */
.image-upload-section {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 12px;
    border: 1px solid #e9ecef;
}

.image-upload-area {
    transition: all 0.3s ease;
}

.upload-placeholder {
    transition: all 0.3s ease;
}

.upload-placeholder:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.upload-placeholder.border-primary {
    border-color: #ffc107 !important;
}

.image-preview-container {
    position: relative;
    transition: all 0.3s ease;
}

.image-preview-container:hover {
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}

.remove-image-btn {
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.remove-image-btn:hover {
    transform: scale(1.1);
}

.upload-controls {
    padding: 5px 0;
}

.btn-upload, .btn-camera {
    border-radius: 20px;
    transition: all 0.3s ease;
}

.btn-upload:hover, .btn-camera:hover {
    transform: translateY(-2px);
}

.upload-info {
    margin-top: 5px;
}

.gap-2 {
    gap: 8px;
}

/* Responsive */
@media (max-width: 576px) {
    .image-upload-section .d-flex {
        flex-direction: column;
        align-items: center !important;
    }
    
    .image-upload-area {
        width: 100% !important;
        max-width: 200px;
        margin: 0 auto;
    }
    
    .upload-placeholder,
    .image-preview-container {
        width: 100% !important;
        max-width: 200px;
        margin: 0 auto;
    }
    
    .upload-controls {
        width: 100%;
        text-align: center;
    }
    
    .upload-controls .d-flex {
        justify-content: center;
    }
}
    /* Pending Request Card Styles */
.pending-request-card {
    animation: slideDown 0.4s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.request-card {
    border-radius: 12px !important;
    overflow: hidden;
    transition: all 0.3s ease;
}

.request-card:hover {
    box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important;
}

.card-pending {
    border-left: 4px solid #ffc107 !important;
}

.card-approved {
    border-left: 4px solid #28a745 !important;
}

.request-card-header {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.header-pending {
    background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
}

.header-approved {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.status-badge {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

/* Request Details */
.request-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.detail-row {
    display: flex;
    align-items: center;
    padding: 4px 0;
    border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
    border-bottom: none;
}

.detail-label {
    min-width: 100px;
    font-size: 13px;
    color: #6c757d;
    font-weight: 500;
}

.detail-value {
    font-size: 14px;
    color: #2d3748;
}

.price-tag {
    font-size: 18px;
    font-weight: 700;
    color: #2c5aa0;
}

.approved-info .detail-value {
    color: #28a745 !important;
}

/* Status Section */
.status-section {
    padding: 15px;
    border-radius: 8px;
    min-height: 150px;
}

.status-indicator {
    width: 100%;
}

.status-indicator.pending {
    background: #fff8e1;
    border-radius: 8px;
    padding: 20px;
}

.status-indicator.approved {
    background: #e8f5e9;
    border-radius: 8px;
    padding: 20px;
}

.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Add to Sale Button */
.add-to-sale-btn {
    border-radius: 25px;
    padding: 8px 30px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.add-to-sale-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

/* Cancel Button */
.cancel-btn {
    border-radius: 20px;
    transition: all 0.3s ease;
}

.cancel-btn:hover {
    background: #dc3545;
    color: white !important;
}

/* Action Footer */
.action-footer {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 10px 15px;
}

/* Responsive */
@media (max-width: 768px) {
    .request-card-header {
        flex-direction: column;
        align-items: flex-start !important;
        gap: 10px;
    }
    
    .detail-row {
        flex-direction: column;
        align-items: flex-start;
        padding: 8px 0;
    }
    
    .detail-label {
        min-width: auto;
        font-size: 12px;
    }
    
    .detail-value {
        font-size: 14px;
    }
    
    .status-section {
        margin-top: 15px;
    }
    
    .price-tag {
        font-size: 16px;
    }
}
    /* Clean Product Search Loading Animation */
.search-loading-overlay >>> .bv-overlay {
    background: rgba(255, 255, 255, 0.98) !important;
}

.product-search-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.loader-card {
    background: white;
    border-radius: 12px;
    padding: 32px 48px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8ecf0;
}

.loader-icon {
    margin-bottom: 20px;
    display: inline-block;
    animation: iconPulse 1.2s ease-in-out infinite;
}

.loader-text {
    font-size: 14px;
    font-weight: 500;
    color: #2c5aa0;
    margin-bottom: 20px;
    letter-spacing: 0.3px;
}

.loader-progress {
    width: 180px;
    height: 2px;
    background: #e8ecf0;
    border-radius: 2px;
    overflow: hidden;
}

.loader-progress-bar {
    width: 40%;
    height: 100%;
    background: #2c5aa0;
    border-radius: 2px;
    animation: progressMove 1s ease-in-out infinite;
}

@keyframes iconPulse {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
}

@keyframes progressMove {
    0% {
        transform: translateX(-100%);
        width: 40%;
    }
    50% {
        transform: translateX(0);
        width: 70%;
    }
    100% {
        transform: translateX(100%);
        width: 40%;
    }
}

/* Optional: Subtle shimmer for the whole overlay */
.search-loading-overlay >>> .bv-overlay:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #2c5aa0, transparent);
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
}
    .text-muted {
    color: #6c757d;
    font-size: 0.875em;
}

.mb-3 {
    margin-bottom: 1rem;
}

/* Style for disabled checkbox */
.custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d;
    cursor: not-allowed;
}

/* Add visual indicator for required checkboxes */
.required-checkbox .custom-control-label::after {
    content: '*';
    color: #dc3545;
    margin-left: 4px;
    font-weight: bold;
}
.policy-content {
    max-height: 716px;
    overflow-y: auto;
    padding: 10px;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
}

.policy-content p {
    margin-bottom: 10px;
}

.policy-content h1, 
.policy-content h2, 
.policy-content h3 {
    margin-top: 15px;
    margin-bottom: 10px;
    color: #2c5aa0;
}

/* Style for the checkbox */
.custom-control-label {
    font-weight: bold;
    cursor: pointer;
}

/* Disabled state */
.custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d;
    cursor: not-allowed;
}
    .product-thumbnail {
        transition: transform 0.2s ease-in-out;
        border: 2px solid #dee2e6;
    }

    .product-thumbnail:hover {
        transform: scale(1.05);
        border-color: #007bff;
    }

    .product-image-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
    }

    /* Ensure table cells with images have proper spacing */
    .ipt_tdr {
        vertical-align: middle;
    }
        td {
            font-size: 13px;
            background: inherit;
            border: 1px solid black;
        }

        .default-input {
            padding: 0px !important;
        }


        .rtdh {
            border: 1px solid black;
            background: black;
            color: white;
            padding: 5px;
            text-align: center;
        }

        .rtd {
            border: 1px solid black;
            background: white;
            color: black;
            padding: 5px;
        }

        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }

        /* Firefox */
        input[type=number] {
        -moz-appearance: textfield;
        }
        .image-container {
    position: relative;
    display: inline-block;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
    font-size: 16px;
    width:auto;
}

.image-container:hover .image-overlay {
    opacity: 1;
}

.no-image-placeholder {
    width: 115px;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed #ddd;
    border-radius: 4px;
    background: #f9f9f9;
}

.product-image {
    transition: transform 0.2s ease;
}

.product-image:hover {
    transform: scale(1.05);
}
.discount-disabled {
    background-color: #e9ecef !important;
    border-color: #ced4da !important;
    color: #6c757d !important;
    cursor: not-allowed !important;
}

/* Visual indicator for specially discounted items */
.special-discount-item {
    background-color: #f8f9fa !important;
    border-left: 3px solid #28a745 !important;
}

.discount-badge {
    font-size: 10px;
    padding: 2px 5px;
    margin-left: 5px;
}
.discount-disabled {
    background-color: #e9ecef !important;
    border-color: #ced4da !important;
    color: #6c757d !important;
    cursor: not-allowed !important;
}

.discount-warning {
    border-color: #ffc107 !important;
    background-color: #fff3cd !important;
}

.discount-error {
    border-color: #dc3545 !important;
    background-color: #f8d7da !important;
}
.image-upload-preview {
    text-align: center;
}

.upload-actions {
    display: flex;
    gap: 5px;
    justify-content: center;
}

.no-image-placeholder {
    width: 115px;
    height: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed #ddd;
    border-radius: 4px;
    background: #f9f9f9;
}

.image-container {
    position: relative;
    display: inline-block;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    cursor: pointer;
    font-size: 16px;
}

.image-container:hover .image-overlay {
    opacity: 1;
}
@media (max-width: 768px) {
    .table-responsive-mobile {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
    
    /* Stack table rows on mobile */
    .mobile-stack td {
        display: block;
        width: 100%;
        text-align: left;
    }
    
    /* Add labels for mobile view */
    .mobile-stack td::before {
        content: attr(data-label);
        font-weight: bold;
        display: inline-block;
        width: 100px;
        color: #666;
    }
}

/* Bootstrap responsive breakpoints */
/* xs: <576px, sm: ≥576px, md: ≥768px, lg: ≥992px, xl: ≥1200px */

/* Ensure table doesn't break on very small screens */
table {
    min-width: 800px;
}

/* Better spacing for mobile */
@media (max-width: 576px) {
    .ipt_tdr, .ipt_tdhr {
        padding: 4px 2px;
        font-size: 12px;
    }
    
    .product-image {
        max-height: 50px;
    }
    
    .no-image-placeholder {
        width: 80px;
        height: 50px;
    }
}

/* Hide AS IS column completely when no items have it */
.as-is-column-hidden {
    display: none !important;
}
/* Refund Methods Card */
.refund-methods-card {
    border: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.refund-alert-header {
    background: linear-gradient(to right, #f8f9fa, #ffffff);
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.payment-method-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    gap: 6px;
}

.payment-method-badge.method-cash {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.payment-method-badge.method-cc {
    background: #cce5ff;
    color: #004085;
    border: 1px solid #b8daff;
}

.payment-method-badge.method-finance {
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffeeba;
}

.payment-method-badge .method-name {
    font-weight: 600;
}

.payment-method-badge .method-amount {
    background: rgba(0,0,0,0.05);
    padding: 2px 6px;
    border-radius: 12px;
}

.refresh-btn {
    border-radius: 20px;
    font-size: 12px;
}

/* Refund Methods Grid */
.refund-methods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
    margin: 20px 0;
}

.refund-method-card {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.2s ease;
    background: white;
}

.refund-method-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transform: translateY(-2px);
}

.refund-method-card.method-cash {
    border-top: 3px solid #28a745;
}

.refund-method-card.method-cc {
    border-top: 3px solid #007bff;
}

.refund-method-card.method-finance {
    border-top: 3px solid #ffc107;
}

.refund-method-card.method-store_credit {
    border-top: 3px solid #17a2b8;
}

.refund-method-card.method-pending {
    border-top: 3px solid #6c757d;
}

.refund-method-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.method-icon {
    font-size: 18px;
    color: #495057;
}

.method-title {
    font-weight: 600;
    color: #495057;
}

.remove-btn {
    padding: 4px 8px;
    border-radius: 20px;
}

.refund-method-body {
    padding: 15px;
}

/* Form Elements */
.form-group {
    margin-bottom: 15px;
}

.form-label {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 4px;
    display: block;
}

.available-badge {
    font-size: 11px;
    color: #28a745;
    background: #d4edda;
    padding: 2px 8px;
    border-radius: 12px;
}

.method-select,
.company-select,
.amount-input,
.last4-input {
    border-radius: 8px;
    border: 1px solid #dee2e6;
    font-size: 13px;
}

.method-select:focus,
.amount-input:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.method-option-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
}

.method-option-dot.dot-cash { background: #28a745; }
.method-option-dot.dot-cc { background: #007bff; }
.method-option-dot.dot-finance { background: #ffc107; }
.method-option-dot.dot-store_credit { background: #17a2b8; }

/* Method Summary */
.method-summary {
    margin-top: 15px;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.summary-amount {
    color: #28a745;
    font-size: 16px;
    font-weight: 600;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 40px 20px;
    background: #f8f9fa;
    border-radius: 12px;
    margin: 20px 0;
}

.empty-icon {
    font-size: 48px;
    color: #dee2e6;
    margin-bottom: 15px;
}

/* Actions */
.refund-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.add-method-btn {
    border-radius: 20px;
    padding: 8px 20px;
    font-weight: 500;
}

.process-btn {
    border-radius: 20px;
    padding: 8px 25px;
    font-weight: 600;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
}

.process-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #218838 0%, #1eaa7a 100%);
    transform: scale(1.02);
}

.btn-amount {
    margin-left: 5px;
    opacity: 0.9;
    font-size: 12px;
}

/* Validation Summary */
.validation-summary {
    margin-top: 15px;
    padding: 10px 15px;
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 8px;
    color: #856404;
    display: flex;
    align-items: center;
    gap: 8px;
}

.warning-icon {
    color: #856404;
    font-size: 16px;
}

/* Responsive */
@media (max-width: 768px) {
    .refund-methods-grid {
        grid-template-columns: 1fr;
    }
    
    .refund-actions {
        flex-direction: column;
    }
    
    .add-method-btn,
    .process-btn {
        width: 100%;
    }
}
.customer-info-modal {
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 5px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 8px;
  margin-bottom: 15px;
}

.section-header h6 {
  margin-bottom: 0;
  color: #495057;
  font-weight: 600;
}

.products-summary {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.products-summary table {
  margin-bottom: 0;
  font-size: 12px;
}

.products-summary th {
  position: sticky;
  top: 0;
  background: #f8f9fa;
  z-index: 1;
}

.charges-summary {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 13px;
}

.total-row {
  border-top: 2px solid #dee2e6;
  margin-top: 8px;
  padding-top: 8px;
  font-size: 15px;
}

.policy-scroll-box {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
  font-size: 12px;
}

.signature-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  background: #ffffff;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #dee2e6;
  padding-top: 15px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .products-summary {
    max-height: 150px;
  }
  
  .policy-scroll-box {
    max-height: 120px;
  }
}
/* Location Breakdown Column Styling */
.location-breakdown-cell {
    padding: 8px 5px !important;
    min-width: 180px;
    max-width: 250px;
}

.location-breakdown-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 11px;
    line-height: 1.3;
}

.location-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px 6px;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 2px solid transparent;
    transition: all 0.2s ease;
}

.location-item:hover {
    background: #e9ecef;
    transform: translateX(2px);
}

.location-name {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
    color: #495057;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
}

.location-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
    flex-shrink: 0;
}

/* Location dot colors */
.location-dot.stock {
    background: #28a745;
    box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);
}

.location-dot.floor {
    background: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.location-dot.warehouse {
    background: #ffc107;
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.2);
}

.location-dot.damage {
    background: #dc3545;
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
}

.location-dot.backorder {
    background: #6c757d;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2);
}

.location-dot.default {
    background: #17a2b8;
    box-shadow: 0 0 0 2px rgba(23, 162, 184, 0.2);
}

.location-dot.out-of-stock {
    background: #dc3545;
    opacity: 0.5;
}

.location-dot.unknown {
    background: #6c757d;
    opacity: 0.5;
}

.location-quantity {
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 12px;
    background: white;
    color: #28a745;
    font-size: 11px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    min-width: 30px;
    text-align: center;
}

.location-quantity.low-stock {
    color: #dc3545;
    background: #fff5f5;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
    100% {
        opacity: 1;
    }
}

.no-stock-message {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #999;
    font-style: italic;
    padding: 4px 6px;
    background: #f8f9fa;
    border-radius: 4px;
    font-size: 11px;
}

.no-location-data {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #999;
    padding: 8px 6px;
    background: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 11px;
    border: 1px dashed #dee2e6;
}

/* Tooltip for full location name on hover */
.location-name {
    position: relative;
}

.location-name:hover::after {
    content: attr(data-fullname);
    position: absolute;
    bottom: 100%;
    left: 0;
    background: #333;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 10px;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

/* Responsive adjustments */
@media (max-width: 1200px) {
    .location-breakdown-cell {
        min-width: 150px;
    }
    
    .location-name {
        max-width: 80px;
    }
}

@media (max-width: 992px) {
    .location-breakdown-cell {
        min-width: 130px;
    }
    
    .location-name {
        max-width: 60px;
    }
}
/* Non-Inventory Section Styles */
.non-inventory-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.form-label {
    font-size: 13px;
    color: #495057;
    margin-bottom: 4px;
}

.image-upload-area {
    transition: all 0.2s ease;
}

.upload-placeholder {
    transition: all 0.2s ease;
}

.upload-placeholder:hover {
    border-color: #007bff !important;
    background: #f0f7ff !important;
}

.image-preview-container {
    position: relative;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.remove-image-btn {
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    transition: all 0.2s ease;
}

.remove-image-btn:hover {
    transform: scale(1.1);
    background-color: #dc3545 !important;
}

/* Input field focus states */
.border-primary:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

/* Grid gap utility */
.gap-4 {
    gap: 1.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .non-inventory-section .d-flex {
        flex-direction: column;
        align-items: flex-start !important;
    }
    
    .image-upload-area {
        margin-right: 0 !important;
        width: 100%;
    }
    
    .upload-placeholder,
    .image-preview-container {
        width: 100% !important;
        max-width: 200px;
        margin: 0 auto;
    }
    
    .upload-controls {
        width: 100%;
        text-align: center;
    }
}

/* Animation for collapse */
.collapse-enter-active,
.collapse-leave-active {
    transition: all 0.3s ease;
}

.collapse-enter,
.collapse-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* Button hover effect */
.btn-success {
    transition: all 0.2s ease;
}

.btn-success:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(40, 167, 69, 0.2);
}

/* Input group styling */
.input-group-text {
    background: #f8f9fa;
    border-right: none;
}

.input-group .form-control {
    border-left: none;
}

.input-group .form-control:focus {
    border-left: 1px solid #80bdff;
    margin-left: -1px;
}

/* Required field indicator */
.text-danger {
    font-weight: bold;
}

/* Validation list styling */
ul {
    list-style-type: none;
    padding-left: 0;
}

ul li {
    margin-bottom: 2px;
    font-size: 12px;
}

/* Card header button styling */
.btn-primary.mb-2 {
    border-radius: 20px;
    padding: 8px 16px;
    font-weight: 500;
    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
    border: none;
}

.btn-primary.mb-2:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0,123,255,0.3);
}

/* Icon spacing */
.mr-1 {
    margin-right: 0.25rem;
}

.mr-2 {
    margin-right: 0.5rem;
}

.mr-3 {
    margin-right: 1rem;
}

.mb-1 {
    margin-bottom: 0.25rem;
}

.mb-2 {
    margin-bottom: 0.5rem;
}

.mb-3 {
    margin-bottom: 1rem;
}

.mb-4 {
    margin-bottom: 1.5rem;
}

.mt-1 {
    margin-top: 0.25rem;
}

.mt-3 {
    margin-top: 1rem;
}
/* Add to your <style> section */
.rotate-icon {
    transform: rotate(180deg);
}

.rotate-90 {
    transform: rotate(90deg);
}

/* Transition for smooth collapse */
.collapse-enter-active,
.collapse-leave-active {
    transition: all 0.3s ease;
}

.collapse-enter,
.collapse-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* Button styling */
.btn-link:hover {
    text-decoration: none !important;
    color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/components/Sales/NewSale.vue